import { h } from 'preact';
import { useState, useEffect,useRef } from 'preact/hooks';
import axios from 'axios';
import { route } from 'preact-router';
import { getItem, setItem, removeAll } from '../../lib/myStore';
import CONSTANTS from '../../lib/constants';
import { startLoader, stopLoader, formatDateTime, getFormattedAmount, applyAclForFeedAndChat, modelMapping, blockInvalidNumberChar, getCitiesOfStateWithExtras } from '../../../src/lib/utils';
import { CountryCode } from '../../components/countryCode';
import { Popup, PopupBody } from '../../components/popup';
import { rateSystem } from '../../lib/rating';
import PDFSTYLE from "../../lib/pdfGenerationConfig";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import hyundaiLogo from "../../assets/images/hyundai_logo_check.jpeg"
import hyundaiX from "../../assets/images/hyundaiX.jpeg"
import Axios from 'axios';
import { css } from 'jquery';
import {EditorState,Plugin} from "prosemirror-state";
import {EditorView,Decoration, DecorationSet} from "prosemirror-view";
import { Briefcase, Plus } from '../../components/svgs';
import {Schema, DOMParser} from "prosemirror-model";
import {schema} from "prosemirror-schema-basic";
import {addListNodes} from "prosemirror-schema-list";
import {exampleSetup} from "prosemirror-example-setup";
import toastr from "toastr";
import moment from "moment";
var pincodeDirectory = require('india-pincode-lookup');
import Covers from '../../../src/assets/images/creta-seat-covers.jpg';
import Creta from '../../../src/assets/images/Hyundai-Creta.jpeg';
import { State, City }  from 'country-state-city';
import creta from "../../assets/images/Hyundai-Creta.jpeg";
import alcazar from "../../assets/images/alcazer.jpg";
import santro from "../../assets/images/santro.jpg";
import aura from "../../assets/images/aura.jpg";
import venue from "../../assets/images/venue.jpeg";
import nextGenVerna from "../../assets/images/verna.jpg";
import allNewi20 from "../../assets/images/i20.jpg";
import elantra from "../../assets/images/verna.jpg";
import grandi10Nios from "../../assets/images/i10.jpg";
import i20Nline from "../../assets/images/i20NLine.jpg";
import hyundaikona from "../../assets/images/kona.jpeg";
import tucson from "../../assets/images/tuscon.jpg";
import HyundaiXcent from "../../assets/images/xcentprime.png";
import carLogo from "../../assets/images/car.png";

let awsBucketLink = "https://price-list-kdms-v1-tech.s3.ap-south-1.amazonaws.com";
/*
  Modification: change CSS
  By: komal wable
  Date: 15/02/2023
*/
const Createvisitmodal = (props) => {
  // const ref = useRef();
  const userInfo = getItem('userinfo');
  // let eventsMinDistance = 60;
  const imageTypeExtension = ['png', 'jpg', 'jpeg'];
  let [assignUserList, setAssignUserList] = useState([])
  let [usersList, setUsersList] = useState([])
  let [allUserList, setAllUserList] = useState([])
  let [fileObj, setFileObj] = useState({})
  let [mainTabOptions, setMainTabOptions] = useState([]);
  let [dataset, setDataSet] = useState([]);
  let [isFeedbackPopupOpen, setFeedbackPopupVisibility] = useState(false);
  let [isAssignModalOpen, setAssignModalOpen] = useState(false);
  let [isCustomerProfileOpen, setCustomerProfileVisibility] = useState(false);
  let [isNonCommercialCustomerProfileOpen, setNonCommercialCustomerProfileVisibility] = useState(false);
  let [docketFor, setDocketFor] = useState('');
  let [typeOfDocket, setTypeOfDocket] = useState('');
  let [customerType, setCustomerType] = useState('');
  let [firstName, setFirstName] = useState('')
  let [lastName, setLastName] = useState('')
  let [gender, setGender] = useState('')
  let [age, setAge] = useState('')
  let [email, setEmail] = useState('')
  let [phoneNumber, setPhoneNumber] = useState(null)
  let [alternativePhoneNumber, setAlternativePhoneNumber] = useState(null)
  let [address, setAddress] = useState('')
  let [city, setCity] = useState('')
  let [isSearchCustomerPopupOpen, setSearchCustomerPopupVisibility] = useState(false);
  let [isVisitPopupOpen, setVisitPopupVisibility] = useState(true);
  let [isDisplayCarsPopupOpen, setDisplayCarsPopupVisibility] = useState(false);
  let [isTestDriveCarsPopupOpen, setTestDriveCarsPopupVisibility] = useState(false);
  let [isAddDocket, setAddDocket] = useState(false);
  let [countryCode, setCountryCode] = useState("+91");
  let [isOTPSend, setOTPSend] = useState(false);
  let [isOTPValid, setOTPValid] = useState(false);
  let [isOTPSubmitted, setOTPSubmitted] = useState(false);
  let [isResendOTP, setResendOTP] = useState(false);
  let [isOTP, setOTP] = useState('');
  let [isUserFound, setUserFound] = useState(false);
  let [isExistingUserCaseSelection, setExistingCaseSelection] = useState(false);
  let [isDefaultForm, setDefaultForm] = useState(true);
  let [mobNumber, setMobNumber] = useState("0");
  let [activePageTabItem, setActivePageTabItem] = useState('CREATE SHOWROOM VISIT');
  let [currentTab, setCurrentTab] = useState(0);
  let [leadScheduleOptions, setLeadScheduleOptions] = useState([]);
  let [leadScheduleOptionsPositions, setLeadScheduleOptionsPositions] = useState({});
  let [isTaskEditModalOpen, setIsTaskEdit] = useState(false);
  let [isModelCasePopupOpen, setModelCasePopup] = useState(false);
  let [isFloatingPopupOpen, setFloatingPopup] = useState(false);
  let [activeFilter, setActiveFilter] = useState('');
  let [activeFilterForCommerical, setActiveFilterForCommerical] = useState('OPEN');
  let [activeFilterForNonCommerical, setActiveFilterForNonCommerical] = useState('OPEN');
  let [visitData, setVisitData] = useState([])
  let [areaList, setAreaList] = useState([])
  let [noOfVisitors, setNoOfVisitors] = useState(1);
  let [noOfAdditionalVehicles, setNoOfAdditionalVehicles] = useState(0);
  // let [contactData, setContactData] = useState([])
  let [visitCount, setVisitCount] = useState(0)
  let [timeForm, settimeForm] = useState(false);
  let [activeTab, setActiveTab] = useState('list');
  let [isEdit, setIsEditable] = useState(false);
  let [isCaseEdit, setIsCaseEditable] = useState(false);
  let [isTodaysReport, setIsTodaysReport] = useState(false);
  let [isMonthlyReport, setIsMonthlyReport] = useState(false);
  let [financeOption, setFinanceOption] = useState('no');
  let [exchangeOption, setExchangeOption] = useState('no');
  let [extraDiscOption, setExtraDiscOption] = useState('no');
  let [accessoriesOption, setAccessoriesOption] = useState('no');
  let [isMobileVerified, setIsMobileVerified] = useState(true)
  let [isAadharVerified, setIsAadharVerified] = useState(false);
  let [isPanVerified, setIsPanVerified] = useState(false);
  let [salesConsultant, setSalesConsultant] = useState('');
  let [isVisitorTheBuyer, setIsVisitorTheBuyer] = useState(true);
  let [outcome, setTaskOutcome] = useState('');
  let [taskTabOptions, setTaskTabOptions] = useState([]);
  let [taskActiveTab, setTaskActiveTab] = useState(activePageTabItem === "Leads" ? "Assign SC" : "Follow up");
  let [otherActiveTab, setOtherActiveTab] = useState("Summary");
  let [activePageDetailsTabItem, setActivePageDetailsTabItem] = useState('General');
  let [checkedList, setCheckedList] = useState([]);
  let [isNDMSPopupOpen, setNDMSPopup] = useState(false);
  let [isEdit2, setIsEditable2] = useState(false);
  let [selectedMode, setSelectedMode] = useState("Full");
  let [mainModalSize, setMainModalSize] = useState("is-full-height");
  let [isEditDocket, setIsEditDocket] = useState(false);
  let [isHandoverDocket, setIsHandoverDocket] = useState(false);
  let isMobileView = window.screen.availWidth <= 425 ? true : false;
  let [currentRow, setCurrentRow] = useState({});
  let [contactData, setContactData] = useState({})
  let [createdContactID, setCreatedContactID] = useState('')
  let [visitList,setVisitList]= useState([])
  let [commericalDataSetCount, setCommericalDataSetCount] = useState(null)
  let [nonCommericalDataSetCount, setNonCommericalDataSetCount] = useState(null)
  let [commercialVisitDataSet, setCommercialVisitDataSet] = useState({columns: [],rows: []});
  let [nonCommercialVisitDataSet, setNonCommercialVisitDataSet] = useState({columns: [],rows: []});
  let [isNextDisable, setIsNextDisable] = useState(true)
  let [visitType, setVisitType] = useState('');
  let [source, setSource] = useState('');
  let [subSources, setSubSources] = useState([]);
  let [subSubSources, setSubSubSources] = useState([]);
  let [leadSubTypes, setLeadSubTypes] = useState([]);
  let [subSource, setSubSource] = useState('');
  let [subSubSource, setSubSubSource] = useState('');
  let [employee, setEmployee] = useState('');
  let [assignedTo, setAssignedTo] = useState('');
  let [assignResposiblePerson, setAssignResposiblePerson] = useState('');
  let [leadType, setLeadType] = useState('');
  let [leadSubType, setLeadSubType] = useState('');
  let [model, setModel] = useState('');
  let [preownedModel, setPreownedModel] = useState('');
  let [specifications, setSpecifications] = useState('');
  let [customerReferralNumber, setCustomerReferralNumber] = useState('');
  let [typeofBuyer, setTypeOfBuyer] = useState('')
  let [typeOfFuel, setTypeOfFuel] = useState('')
  let [variant, setVariant] = useState('')
  let [car, setCar] = useState('')
  let [exteriorColor, setExteriorColor] = useState('')
  let [interiorColor, setInteriorColor] = useState('')
  let [purpose, setPurpose] = useState('')
  let [previousVisitDetails, setPreviousVisitDetails] = useState({})
  let [contactCreatedUuid, setContactCreatedUuid] = useState('')
  let [resendBtn, setResendBtn] = useState(true)
  let [commericalDataSet, setCommericalDataSet] = useState([])
  let [commericalUnassingedDataSet, setCommericalUnassingedDataSet] = useState([])
  let [commericalOpenDataSet, setCommericalOpenDataSet] = useState([])
  let [commericalClosedDataSet, setCommericalClosedDataSet] = useState([])
  let [nonCommericalDataSet, setNonCommericalDataSet] = useState([])
  let [nonCommericalOpenDataSet, setNonCommericalOpenDataSet] = useState([])
  let [nonCommericalClosedDataSet, setNonCommericalClosedDataSet] = useState([])
  let [unassigedCommercialVisitDataTableData,setUnassigedCommercialVisitDataTableData] = useState({columns: [],rows: []});
  let [openCommercialVisitDataTableData,setOpenCommercialVisitDataTableData] = useState({columns: [],rows: []});
  let [closedCommercialVisitDataTableData,setClosedCommercialVisitDataTableData] = useState({columns: [],rows: []});
  let [openNonCommercialVisitDataTableData,setOpenNonCommercialVisitDataTableData] =  useState({columns: [],rows: []});
  let [closedNonCommercialVisitDataTableData,setClosedNonCommercialVisitDataTableData] =  useState({columns: [],rows: []});
  let [selectedVisitUuid, setSelectedVisitUuid] = useState('')
  let [selectedVisitDetails, setSelectedVisitDetails] = useState({})
  let [visitOutTime, setVisitOutTime] = useState('')
  let [commentForClosedVisit, setCommentForClosedVisit] = useState('')
  let [contactList,setContactList]=useState([])
  let [dealershipList,setDealershipList]=useState([])
  let [allTaskData, setAllTaskData] = useState([])
  let [taskToDo, setTaskToDo] = useState({ columns: [], rows: [] });
  let [taskToDoDaily, setTaskToDoDaily] = useState({ columns: [], rows: [] });
  let [taskToDoFollow, setTaskToDoFollow] = useState({ columns: [], rows: [] });
  let [taskToDoCourier, setTaskToDoCourier] = useState({ columns: [], rows: [] });
  let [taskToDoEscalatedTasks, setTaskToDoEscalatedTasks] = useState({ columns: [], rows: [] });
  let [taskToDoCalls, setTaskToDoCalls] = useState({ columns: [], rows: [] });
  let [taskToTrack, setTaskToTrack] = useState({ columns: [], rows: [] });
  let [taskToTrackDaily, setTaskToTrackDaily] = useState({ columns: [], rows: [] });
  let [taskToTrackFollow, setTaskToTrackFollow] = useState({ columns: [], rows: [] });
  let [taskToTrackCourier, setTaskToTrackCourier] = useState({ columns: [], rows: [] });
  let [taskToTrackEscalatedTasks, setTaskToTrackEscalatedTasks] = useState({ columns: [], rows: [] });
  let [taskToTrackCalls, setTaskToTrackCalls] = useState({ columns: [], rows: [] });
  let [completedTask, setCompletedTask] = useState({ columns: [], rows: [] });
  let [completedTaskDaily, setCompletedTaskDaily] = useState({ columns: [], rows: [] });
  let [completedTaskFollow, setCompletedTaskFollow] = useState({ columns: [], rows: [] });
  let [completedTaskCourier, setCompletedTaskCourier] = useState({ columns: [], rows: [] });
  let [taskData, setTasksData] = useState([])
  let [courierData, setCourierData] = useState({})
  let [departmentList, setDepartmentList] = useState([]);
  let [courierDataSet, setCourierDataSet] = useState({
    columns: [],
    rows: []
  });
  let [importantsCourierDataSet, setImportantCourierDataSet] = useState({
    columns: [],
    rows: []
  });
  let [courierActionButton, setCourierActionButton] = useState('Save')
  let [courierImgDelete, setCourierImgDelete] = useState(false)
  let [todayDate, setTodayDate] = useState('')
  let [uploadImgArray, setUploadImgArry] = useState([])
  let [catalogoueItemList,setCatalogoueItemList]=useState([])

  let [variantList ,setVariantList]=useState([])
  let [fuelTypes ,setFuelTypes]=useState(['Petrol','Diesel','CNG', 'EV'])
  let [selectedVariant,setSelectedVariant]= useState([])
  let [taskResponseStatus, setTaskResponseStatus] = useState(false);
  let [snackbarTaskStatus, setSnackbarTaskStatus] = useState(false);
  let [snackbarBgcolor, setSnackbarBgcolor] = useState('');
  let [snackbarPositon, setSnackbarPositon] = useState('');
  let [snackBarMsg, setSnackBarMsg] = useState('');
  let [isRightDropdownOpen,setRightDropdown]= useState(false);
  let [isFullSizeView,setFullSizeView]= useState(false);
  let [editorView, setEditorView] = useState();
  let [editorText, setEditorText] = useState("");
  let [editorImages, setEditorImages] = useState([]);
  let [inboxTasks, setInboxTasks] = useState("Task1");
  let [inboxChatFilterList, setInboxChatFilterList] = useState([]);
  let [isSubmitDisable,setIsSubmitDisable] = useState(true);
  let [isLoader,setIsLoader] = useState(false);
  let [stateList, setStateList] = useState(State.getStatesOfCountry('IN'));
  let [cityList, setCityList] = useState([]);
  //ModifiedBy: Vihang Kalee
  // Date: 09/06/2022
  // Modification: variables states for pricelist pdf
  let [modelVariantName, setModelVariantName] = useState('');
  let [catalogueCarVariant, setCatalogueCarVariant] = useState([]);
  let [catalogueCarVariantDiesel, setCatalogueCarVariantDiesel] = useState([]);
  let [catalogueCarVariantCNG, setCatalogueCarVariantCNG] = useState([]);
  let [carVariantTableData, setCarVariantTableData] = useState([{text:"PARTICULARS",bold:false}]);
  let [exShowroomTableData, setExShowroomTableData] = useState([{text:"EX - SHOWROOM PRICE",bold:false}]);
  let [tcsExShowroomTableData, setTcsExShowroomTableData] = useState([{text:"TCS 1% EX-SHOWROOM",bold:false}]);
  let [insuranceTableData, setInsuranceTableData] = useState([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)",bold:false}]);
  let [rtoBHPassingTableData, setRtoBHPassingTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing',bold:false}]);
  let [rtoBHPassingCNGTableData, setRtoBHPassingCNGTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing',bold:false}]);
  let [rtoBHPassingDieselTableData, setRtoBHPassingDieselTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing',bold:false}]);
  let [rtoCompanyTableData, setRtoCompanyTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company',bold:false}]);
  let [rtoIndividualTableData, setRtoIndividualTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual',bold:false}]);
  let [fourFifthExtendedWarrantyTableData, setFourFifthExtendedWarrantyTableData] = useState([{text:'4th & 5th YEAR EXTENDED WARRANTY',bold:false}]);
  let [rmkTableData, setRmkTableData] = useState([{text:'RMK',bold:false}]);
  let [basicAccessoriesKitTableData, setBasicAccessoriesKitTableData] = useState([{text:'BASIC ACCESSORIES KIT',bold:false}]);
  let [rsaTableData, setRsaTableData] = useState([{text:'RSA',bold:false}]);
  let [additionalPremiumForEngineProtectionTableData, setAdditionalPremiumForEngineProtectionTableData] = useState([{text:'ADDL PREMIUM FOR ENGINE PROTECTION',bold:false}]);
  let [additionalPremiumforReturnToInvoiceTableData, setAdditionalPremiumforReturnToInvoiceTableData] = useState([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)',bold:false}]);
  let [totalIndividualTableData, setTotalIndividualTableData] = useState([{text:'TOTAL INDIVIDUAL',bold:false}]);
  let [totalCompanyTableData, setTotalCompanyTableData] = useState([{text:'TOTAL COMPANY',bold:false}]);
  let [sheildOfTrustTableData, setSheildOfTrustTableData] = useState([{text:'T5 YR/60K SHIELD OF TRUST',bold:false}]);
  let [priceListForPmc, setPriceListForPmc] = useState([{text:'PRICE LIST FOR ' + (contactData && contactData.firstName ? contactData.firstName : '') + " " + (contactData && contactData.lastName ? contactData.lastName : ''), fontSize:18,bold:false,alignment:"center"}]);
  let [allnewi20tableHeader, setAllNewi20TableHeader] = useState([
    {text:'',alignment:"center",fontSize:18,bold:false}]);
  let [solidColourTableHeader, setSolidColourTableHeader] = useState([{text:'COLOUR : SOLID COLOUR = ',bold:false}]);
  let [solidColourDieselTableData, setSolidColourDieselTableData] = useState([{text:'COLOUR : SOLID COLOUR = ',bold:false}]);
  let [solidColourCNGTableData, setSolidColourCNGTableData] = useState([{text:'COLOUR : SOLID COLOUR = ',bold:false}]);
  let [noCashPaymentTableHeader,setNoCashPaymentTableHeader] = useState([{text:'Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED',bold:false}]);
  let [termsAndConitionsTableHeader,setTermsAndConitionsTableHeader] = useState([{text:'Terms & Conditions Details Overleaf',bold:false}]);
  let [termsAndConditionsTableData,setTermsAndConitionsTableData] = useState([{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi',bold:false}]);
  let [termsAndConditionsDetailsTableData,setTermsAndConitionsDetailsTableData] = useState([{
    bold:false,
    fontSize:12,
    ol: [
      'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
      "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
      "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
      "Model specifiction, features & Colours are subject to change without prior notice.",
      "Delivery - Subject to realisation of  DD / Cheque.",
      "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
      "Subject to jurisdiction of Pune Court only",
      "Two schemes cannot be clubbed together.",
      "Basic Accessories Kit Not Included Labour Charges",
      "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
      "Force majeure clause would be applicable to all deliveries.",
      "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
      "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
      "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
      "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
      "Income tax Pan no and address proof in original are necessary at the time of Booking.",
      "Purchase of Insurance Policy and Accessories from Dealer are optional.",
      "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
      "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
      "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
    ]

  }]);
  let [ShowroomITableData,setShowroomITableData] = useState([{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.',bold:false}]);
  let [ShowroomIITableData,setShowroomIITableData] = useState([{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.',bold:false}]);
  let [ShowroomIIITableData,setShowroomIIITableData] = useState([{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100',bold:false}]);
  let [ShowroomIVTableData,setShowroomIVTableData] = useState([{text:'Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525',bold:false}]);
  let [ShowroomVTableData,setShowroomVTableData] = useState([{text:"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205",bold:false}]);
  let [ShowroomVITableData,setShowroomVITableData] = useState([{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}]);
  let [work1TableData,setWork1TableData] = useState([{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96',bold:false}]);
  let [work2TableData,setWork2TableData] = useState([{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ',bold:false}]);
  let [work3TableData,setWork3TableData] = useState([{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506',bold:false}]);
  let [work4TableData,setWork4TableData] = useState([{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ',bold:false}]);
  let [depotTableData,setDepotTableData] = useState([{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ',bold:false}]);
  let [carVariantDieselTableData, setCarVariantDieselTableData] = useState([{text:"PARTICULARS",bold:false}]);
  let [exShowroomDieselTableData, setExShowroomDieselTableData] = useState([{text:"EX - SHOWROOM PRICE",bold:false}]);
  let [tcsExShowroomDieselTableData, setTcsExShowroomDieselTableData] = useState([{text:"TCS 1% EX-SHOWROOM",bold:false}]);
  let [insuranceDieselTableData, setInsuranceDieselTableData] = useState([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)",bold:false}]);
  let [rtoCompanyDieselTableData, setRtoCompanyDieselTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company',bold:false}]);
  let [rtoIndividualDieselTableData, setRtoIndividualDieselTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual',bold:false}]);
  let [fourFifthExtendedWarrantyDieselTableData, setFourFifthExtendedWarrantyDieselTableData] = useState([{text:'4th & 5th YEAR EXTENDED WARRANTY',bold:false}]);
  let [rmkDieselTableData, setRmkDieselTableData] = useState([{text:'RMK',bold:false}]);
  let [basicAccessoriesKitDieselTableData, setBasicAccessoriesKitDieselTableData] = useState([{text:'BASIC ACCESSORIES KIT',bold:false}]);
  let [rsaDieselTableData, setRsaDieselTableData] = useState([{text:'RSA',bold:false}]);
  let [additionalPremiumForEngineProtectionDieselTableData, setAdditionalPremiumForEngineProtectionDieselTableData] = useState([{text:'ADDL PREMIUM FOR ENGINE PROTECTION',bold:false}]);
  let [additionalPremiumforReturnToInvoiceDieselTableData, setAdditionalPremiumforReturnToInvoiceDieselTableData] = useState([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)',bold:false}]);
  let [totalIndividualDieselTableData, setTotalIndividualDieselTableData] = useState([{text:'TOTAL INDIVIDUAL',bold:false}]);
  let [totalCompanyDieselTableData, setTotalCompanyDieselTableData] = useState([{text:'TOTAL COMPANY',bold:false}]);
  let [sheildOfTrustDieselTableData, setSheildOfTrustDieselTableData] = useState([{text:'T5 YR/60K SHIELD OF TRUST',bold:false}]);
  let [modelDieseltableHeader, setModelDieselTableHeader] = useState([{text:'',alignment:"center",fontSize:18,bold:false}]);
  let [carVariantCNGTableData, setCarVariantCNGTableData] = useState([{text:"PARTICULARS",bold:false}]);
  let [exShowroomCNGTableData, setExShowroomCNGTableData] = useState([{text:"EX - SHOWROOM PRICE",bold:false}]);
  let [tcsExShowroomCNGTableData, setTcsExShowroomCNGTableData] = useState([{text:"TCS 1% EX-SHOWROOM",bold:false}]);
  let [insuranceCNGTableData, setInsuranceCNGTableData] = useState([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)",bold:false}]);
  let [rtoCompanyCNGTableData, setRtoCompanyCNGTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company',bold:false}]);
  let [rtoIndividualCNGTableData, setRtoIndividualCNGTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual',bold:false}]);
  let [fourFifthExtendedWarrantyCNGTableData, setFourFifthExtendedWarrantyCNGTableData] = useState([{text:'4th & 5th YEAR EXTENDED WARRANTY',bold:false}]);
  let [rmkCNGTableData, setRmkCNGTableData] = useState([{text:'RMK',bold:false}]);
  let [basicAccessoriesKitCNGTableData, setBasicAccessoriesKitCNGTableData] = useState([{text:'BASIC ACCESSORIES KIT',bold:false}]);
  let [rsaCNGTableData, setRsaCNGTableData] = useState([{text:'RSA',bold:false}]);
  let [additionalPremiumForEngineProtectionCNGTableData, setAdditionalPremiumForEngineProtectionCNGTableData] = useState([{text:'ADDL PREMIUM FOR ENGINE PROTECTION',bold:false}]);
  let [additionalPremiumforReturnToInvoiceCNGTableData, setAdditionalPremiumforReturnToInvoiceCNGTableData] = useState([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)',bold:false}]);
  let [totalIndividualCNGTableData, setTotalIndividualCNGTableData] = useState([{text:'TOTAL INDIVIDUAL',bold:false}]);
  let [totalCompanyCNGTableData, setTotalCompanyCNGTableData] = useState([{text:'TOTAL COMPANY',bold:false}]);
  let [sheildOfTrustCNGTableData, setSheildOfTrustCNGTableData] = useState([{text:'T5 YR/60K SHIELD OF TRUST',bold:false}]);

  let [catalogueCarVariantEV, setCatalogueCarVariantEV] = useState([]);
  let [modelEVtableHeader, setModelEVTableHeader] = useState([{text:'',alignment:"center",fontSize:18,bold:false}]);
  let [carVariantEVTableData, setCarVariantEVTableData] = useState([{text:"PARTICULARS",bold:false}]);
  let [exShowroomEVTableData, setExShowroomEVTableData] = useState([{text:"EX - SHOWROOM PRICE",bold:false}]);
  let [tcsExShowroomEVTableData, setTcsExShowroomEVTableData] = useState([{text:"TCS 1% EX-SHOWROOM",bold:false}]);
  let [insuranceEVTableData, setInsuranceEVTableData] = useState([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)",bold:false}]);
  let [rtoCompanyEVTableData, setRtoCompanyEVTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company',bold:false}]);
  let [rtoIndividualEVTableData, setRtoIndividualEVTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual',bold:false}]);
  let [rtoBHPassingEVTableData, setRtoBHPassingEVTableData] = useState([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing',bold:false}]);
  let [fourFifthExtendedWarrantyEVTableData, setFourFifthExtendedWarrantyEVTableData] = useState([{text:'4th & 5th YEAR EXTENDED WARRANTY',bold:false}]);
  let [rmkEVTableData, setRmkEVTableData] = useState([{text:'RMK',bold:false}]);
  let [basicAccessoriesKitEVTableData, setBasicAccessoriesKitEVTableData] = useState([{text:'BASIC ACCESSORIES KIT',bold:false}]);
  let [rsaEVTableData, setRsaEVTableData] = useState([{text:'RSA',bold:false}]);
  let [additionalPremiumForEngineProtectionEVTableData, setAdditionalPremiumForEngineProtectionEVTableData] = useState([{text:'ADDL PREMIUM FOR ENGINE PROTECTION',bold:false}]);
  let [additionalPremiumforReturnToInvoiceEVTableData, setAdditionalPremiumforReturnToInvoiceEVTableData] = useState([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)',bold:false}]);
  let [totalIndividualEVTableData, setTotalIndividualEVTableData] = useState([{text:'TOTAL INDIVIDUAL',bold:false}]);
  let [totalCompanyEVTableData, setTotalCompanyEVTableData] = useState([{text:'TOTAL COMPANY',bold:false}]);
  let [sheildOfTrustEVTableData, setSheildOfTrustEVTableData] = useState([{text:'T5 YR/60K SHIELD OF TRUST',bold:false}]);


  let [modelCNGtableHeader, setModelCNGTableHeader] = useState([{text:'',alignment:"center",fontSize:18,bold:false}]);
  let [isPriceListModalOpen,setIsPriceListModalOpen] = useState(false);
  let [disablePDFButton,setDisablePDFButton] = useState(true);
  let [PDFCarImages,setPDFCarImages] = useState("");
  let [pdfWidthForCarVariant,setPdfWidthForCarVariant] = useState([]);
  let [pdfWidthForCarVariantDiesel,setPdfWidthForCarVariantDiesel] = useState([]);
  let [pdfWidthForCarVariantCNG,setPdfWidthForCarVariantCNG] = useState([]);
  let [pdfWidthForCarVariantEV,setPdfWidthForCarVariantEV] = useState([]);
  let [petrolCarVariant,setPetrolCarVariant] = useState(false);
  let [dieselCarVariant,setDieselCarVariant] = useState(false);
  let [CNGCarVariant,setCNGCarVariant] = useState(false);
  let [cases, setCases] = useState([]);
  let [selectedCase, setSelectedCase] = useState({});
  let [reopenedFromTaskID, setReopenFromTaskID] = useState('');
  let [showDetailView, setShowDetailView] = useState(false);
  let [isOTPSkipped, setIsOTPSkipped] = useState(false);
  let [trueCallerData, setTrueCallerData] = useState([]);
  let [isOtpSend, setIsOTPSend] = useState(false);
  let [isTruecallerDataShown, setIsTruecallerDataShown] = useState(false);

  let [termsAndConditionsData, setTermsAndConditionsData] = useState([]);
  let [termsAndConditionsDataCNG, setTermsAndConditionsDataCNG] = useState([]);
  let [termsAndConditionsDataDiesel, setTermsAndConditionsDataDiesel] = useState([]);
  let [termsAndConditionsDataEV, setTermsAndConditionsDataEV] = useState([]);
  let [effectiveDateFrom , setEffectiveDateFrom] = useState([{text:'Effective Date From',bold:false}]);
  let [effectiveDateCNGFrom , setEffectiveDateCNGFrom] = useState([{text:'Effective Date From',bold:false}]);
  let [effectiveDateDieselFrom , setEffectiveDateDieselFrom] = useState([{text:'Effective Date From',bold:false}]);

  const [effectivePriceListDate, setEffectivePriceListDate] = useState('');

  let placeholderPlugin = new Plugin({
    state: {
      init() { return DecorationSet.empty; },
      apply(tr, set) {
        set = set.map(tr.mapping, tr.doc);
        let action = tr.getMeta(this);
        if (action && action.add) {
          let widget = document.createElement("placeholder");
          let deco = Decoration.widget(action.add.pos, widget, {id: action.add.id});
          set = set.add(tr.doc, [deco]);
        } else if (action && action.remove) {
          set = set.remove(set.find(null, null,
            spec => spec.id == action.remove.id));
        }
        return set;
      }
    },
    props: {
      decorations(state) { return this.getState(state); }
    }
  });


  // Professions
  let listOfProfessions = [
    "Self Employeed",
    "Other",
    "Academic librarian",
    "Accountant",
    "Accounting technician",
    "Actuary",
    "Adult nurse",
    "Advertising account executive",
    "Advertising account planner",
    "Advertising copywriter",
    "Advice worker",
    "Advocate (Scotland)",
    "Aeronautical engineer",
    "Agricultural consultant",
    "Agricultural manager",
    "Aid worker/humanitarian worker",
    "Air traffic controller",
    "Airline cabin crew",
    "Amenity horticulturist",
    "Analytical chemist",
    "Animal nutritionist",
    "Animator",
    "Archaeologist",
    "Architect",
    "Architectural technologist",
    "Archivist",
    "Armed forces officer",
    "Aromatherapist",
    "Art therapist",
    "Arts administrator",
    "Auditor",
    "Automotive engineer",
    "Barrister",
    "Barrister’s clerk",
    "Bilingual secretary",
    "Biomedical engineer",
    "Biomedical scientist",
    "Biotechnologist",
    "Brand manager",
    "Broadcasting presenter",
    "Building control officer/surveyor",
    "Building services engineer",
    "Building surveyor",
    "Camera operator",
    "Careers adviser (higher education)",
    "Careers adviser",
    "Careers consultant",
    "Cartographer",
    "Catering manager",
    "Chartered Accountant",
    "Cost Accountant",
    "Charities administrator",
    "Charities fundraiser",
    "Chemical (process) engineer",
    "Child psychotherapist",
    "Children's nurse",
    "Chiropractor",
    "Civil engineer",
    "Civil Service administrator",
    "Clinical biochemist",
    "Clinical cytogeneticist",
    "Clinical microbiologist",
    "Clinical molecular geneticist",
    "Clinical research associate",
    "Clinical scientist - tissue typing",
    "Clothing and textile technologist",
    "Colour technologist",
    "Commercial horticulturist",
    "Commercial/residential/rural surveyor",
    "Commissioning editor",
    "Commissioning engineer",
    "Commodity broker",
    "Communications engineer",
    "Community arts worker",
    "Community education officer",
    "Community worker",
    "Company secretary",
    "Computer sales support",
    "Computer scientist",
    "Conference organiser",
    "Consultant",
    "Consumer rights adviser",
    "Control and instrumentation engineer",
    "Corporate banker",
    "Corporate treasurer",
    "Counsellor",
    "Courier/tour guide",
    "Court reporter/verbatim reporter",
    "Credit analyst",
    "Crown Prosecution Service lawyer",
    "Crystallographer",
    "Curator",
    "Customs officer",
    "Cyber security specialist",
    "Dance movement therapist",
    "Data analyst",
    "Data scientist",
    "Data visualisation analyst",
    "Database administrator",
    "Debt/finance adviser",
    "Dental hygienist",
    "Dentist",
    "Design engineer",
    "Dietitian",
    "Diplomatic service",
    "Doctor (general practitioner, GP)",
    "Doctor (hospital)",
    "Dramatherapist",
    "Economist",
    "Editorial assistant",
    "Education administrator",
    "Electrical engineer",
    "Electronics engineer",
    "Employment advice worker",
    "Energy conservation officer",
    "Engineering geologist",
    "Environmental education officer",
    "Environmental health officer",
    "Environmental manager",
    "Environmental scientist",
    "Equal opportunities officer",
    "Equality and diversity officer",
    "Ergonomist",
    "Estate agent",
    "European Commission administrators",
    "Exhibition display designer",
    "Exhibition organiser",
    "Exploration geologist",
    "Facilities manager",
    "Field trials officer",
    "Financial manager",
    "Firefighter",
    "Fisheries officer",
    "Fitness centre manager",
    "Food scientist",
    "Food technologist",
    "Forensic scientist",
    "Geneticist",
    "Geographical information systems manager",
    "Geomatics/land surveyor",
    "Government lawyer",
    "Government research officer",
    "Graphic designer",
    "Health and safety adviser",
    "Health and safety inspector",
    "Health promotion specialist",
    "Health service manager",
    "Health visitor",
    "Herbalist",
    "Heritage manager",
    "Higher education administrator",
    "Higher education advice worker",
    "Homeless worker",
    "Horticultural consultant",
    "Hotel manager",
    "Housing adviser",
    "Human resources officer",
    "Hydrologist",
    "Illustrator",
    "Immigration officer",
    "Immunologist",
    "Industrial/product designer",
    "Information scientist",
    "Information systems manager",
    "Information technology/software trainers",
    "Insurance broker",
    "Insurance claims inspector",
    "Insurance risk surveyor",
    "Insurance underwriter",
    "Interpreter",
    "Investment analyst",
    "Investment banker - corporate finance",
    "Investment banker – operations",
    "Investment fund manager",
    "IT consultant",
    "IT support analyst",
    "Journalist",
    "Laboratory technician",
    "Land-based engineer",
    "Landscape architect",
    "Learning disability nurse",
    "Learning mentor",
    "Lecturer (adult education)",
    "Lecturer (further education)",
    "Lecturer (higher education)",
    "Legal executive",
    "Leisure centre manager",
    "Licensed conveyancer",
    "Local government administrator",
    "Local government lawyer",
    "Logistics/distribution manager",
    "Magazine features editor",
    "Magazine journalist",
    "Maintenance engineer",
    "Management accountant",
    "Manufacturing engineer",
    "Manufacturing shine operator",
    "Manufacturing toolmaker",
    "Marine scientist",
    "Market research analyst",
    "Market research executive",
    "Marketing account manager",
    "Marketing assistant",
    "Marketing executive",
    "Marketing manager (social media)",
    "Materials engineer",
    "Materials specialist",
    "Mechanical engineer",
    "Media analyst",
    "Media buyer",
    "Media planner",
    "Medical physicist",
    "Medical representative",
    "Mental health nurse",
    "Metallurgist",
    "Meteorologist",
    "Microbiologist",
    "Midwife",
    "Mining engineer",
    "Mobile developer",
    "Multimedia programmer",
    "Multimedia specialists",
    "Museum education officer",
    "Museum/gallery exhibition officer",
    "Music therapist",
    "Nanoscientist",
    "Nature conservation officer",
    "Naval architect",
    "Network administrator",
    "Nurse",
    "Nutritional therapist",
    "Nutritionist",
    "Occupational therapist",
    "Oceanographer",
    "Office manager",
    "Operational researcher",
    "Orthoptist",
    "Outdoor pursuits manager",
    "Packaging technologist",
    "Paediatric nurse",
    "Paramedic",
    "Patent attorney",
    "Patent examiner",
    "Pension scheme manager",
    "Personal assistant",
    "Petroleum engineer",
    "Pharmacist",
    "Pharmacologist",
    "Pharmacovigilance officer",
    "Photographer",
    "Physiotherapist",
    "Picture researcher",
    "Planning and development surveyor",
    "Planning technician",
    "Plant breeder",
    "Police officer",
    "Political party agent",
    "Political party research officer",
    "Practice nurse",
    "Press photographer",
    "Press sub-editor",
    "Prison officer",
    "Private music teacher",
    "Probation officer",
    "Product development scientist",
    "Production manager",
    "Programme researcher",
    "Project manager",
    "Psychologist (clinical)",
    "Psychologist (educational)",
    "Psychotherapist",
    "Public affairs consultant (lobbyist)",
    "Public affairs consultant (research)",
    "Public house manager",
    "Public librarian",
    "Public relations (PR) officer",
    "QA analyst",
    "Quality assurance manager",
    "Quantity surveyor",
    "Records manager",
    "Recruitment consultant",
    "Recycling officer",
    "Regulatory affairs officer",
    "Research chemist",
    "Research scientist",
    "Restaurant manager",
    "Retail banker",
    "Retail buyer",
    "Retail manager",
    "Retail merchandiser",
    "Retail pharmacist",
    "Sales executive",
    "Sales manager",
    "Scene of crime officer",
    "Secretary",
    "Seismic interpreter",
    "Site engineer",
    "Site manager",
    "Social researcher",
    "Social worker",
    "Software developer",
    "Soil scientist",
    "Solicitor",
    "Speech and language therapist",
    "Sports coach",
    "Sports development officer",
    "Sports therapist",
    "Statistician",
    "Stockbroker",
    "Structural engineer",
    "Systems analyst",
    "Systems developer",
    "Tax inspector",
    "Teacher (nursery/early years)",
    "Teacher (primary)",
    "Teacher (secondary)",
    "Teacher (special educational needs)",
    "Teaching/classroom assistant",
    "Technical author",
    "Technical sales engineer",
    "TEFL/TESL teacher",
    "Television production assistant",
    "Test automation developer",
    "Tour operator",
    "Tourism officer",
    "Tourist information manager",
    "Town and country planner",
    "Toxicologist",
    "Trade union research officer",
    "Trader",
    "Trading standards officer",
    "Training and development officer",
    "Translator",
    "Transportation planner",
    "Travel agent",
    "TV/film/theatre set designer",
    "UX designer",
    "Validation engineer",
    "Veterinary nurse",
    "Veterinary surgeon",
    "Video game designer",
    "Video game developer",
    "Volunteer work organiser",
    "Warehouse manager",
    "Waste disposal officer",
    "Water conservation officer",
    "Water engineer",
    "Web designer",
    "Web developer",
    "Welfare rights adviser",
    "Writer",
    "Youth worker"
];
  useEffect(()=>{
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": true,
      "progressBar": true,
      "positionClass": "toast-bottom-left",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "900",
      "hideDuration": "1500",
      "timeOut": "9000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "slideDown",
      "hideMethod": "slideUp"
    };
  },[]);


   function getRowsListForVisit(data) {
    const colList = [{
      label: 'Name',
      field: 'displayName',
      width: '200px',
      sort: 'asc'
    },
    {
      label: 'Purpose',
      field: 'purpose',
      sort: 'asc'
    },
    {
      label: 'Time of Visit',
      field: 'visitTime',
      sort: 'asc'
    },
    {
      label: 'Status',
      field: 'typeOfVisit',
      sort: 'asc'
    },
    {
      label: 'Responsible Person',
      field: 'responsiblePerson',
      sort: 'asc'
    }, {
      label: 'Action',
      field: 'extraModalForNotification',
      sort: 'asc'
    }, {
      label: 'Case ID',
      field: 'caseID',
      sort: 'asc'
    }];

    const rowList = data.map((p) => {
      let obej = p
      return obej;
    });
    const listObj = {
      columns: colList, rows: rowList
    };
    return listObj;
  }

  // useEffect(async () => {
  //   getVisitListForLoginDealer();
  // }, [isEdit]);

  //top menu

  //  useEffect(async () => {
  //   await getContactList();
  // }, []);

  useEffect(async () => {
    await getUsersList()
    // getVisitListForLoginDealer()
    // await getContactList();
    getDealershipList();
    setLeadScheduleOptionsPositions(leadScheduleOptionsPositions);

    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;

    let today = year + "-" + month + "-" + day
    await setTodayDate(today)
  }, []);

  useEffect(async()=>{
    // getBothVisitsCounts()
    // getListOfVisitsCommercial()
    // getListOfVisitsNonCommercial()
    // let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue`);
    let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/models/catalogue?brandType=Hyundai&isForInsurance=false&status=Active`);
    let array = catalogoueItemResponse.data
    const result = [];
    const map = new Map();
    for (const item of array) {
      if (!map.has(item.displayName)) {
        map.set(item.displayName, true);    // set any value to Map
        result.push({
           ...item
        });
      }
    }
    await setCatalogoueItemList(result);
  },[visitList])

  // useEffect(() => {
  //   const checkIfClickedOutside = e => {
  //     // If the isRightDropdownOpen is open and the clicked target is not within the isRightDropdownOpen,
  //     // then close the isRightDropdownOpen
  //     if (isRightDropdownOpen && ref.current && !ref.current.contains(e.target)) {
  //       setRightDropdown(false);
  //     }
  //   };
  //
  //   document.addEventListener("mousedown", checkIfClickedOutside);
  //   return () => {
  //     // Cleanup the event listener
  //     document.removeEventListener("mousedown", checkIfClickedOutside);
  //   };
  // }, [isRightDropdownOpen]);

  useEffect(() => {
    showTab(0)
  },[])

  useEffect(() => {
    setContactCreatedUuid(contactCreatedUuid);
    //showTab(0)
  },[isDefaultForm])
  async function getContactList() {
    let responseContact = await Axios.get(`${CONSTANTS.API_URL}/api/v1/contact`);
    let contactList = responseContact.data
    setContactList(contactList)
  }

  async function getDealershipList() {
    let responseDealer = await axios.get(`${CONSTANTS.API_URL}/api/v1/getDealership`);
     setDealershipList(responseDealer.data)
  }

  async function getVisitListForLoginDealer() {
    await getContactList();
    await getDealershipList();
    let responseVisit = await axios.get(`${CONSTANTS.API_URL}/api/v1/visit?dealershipCode=${userInfo.dealership}`);
    visitList = responseVisit.data;
    await setVisitList(visitList);
  }
  async function getRowsListForCurier(data) {
    const colList = [{
      label: 'Received From',
      field: 'receivedFrom',
      width: '250px',
      sort: 'asc'
    }, {
      label: 'Receiving Date',
      field: 'receivedFormatedDate',
      sort: 'asc'
    }, {
      label: 'Description',
      field: 'courierDescription',
      sort: 'asc'
    }, {
      label: 'To Whom',
      field: 'whomTo',
      sort: 'asc'
    }, {
      label: 'Department',
      field: 'departmentDisplayName',
      sort: 'asc'
    }, {
      label: 'Handed over to',
      field: 'handOverToUserName',
      sort: 'asc'
    }, {
      label: 'Action',
      field: 'extraModalForNotification',
      sort: 'asc'
    }];

    const rowList = data.map((p) => {
      let caseID = p.caseID ? p.caseID : "COUR #133"
      let receivedFormatedDate = p.receivedDate ? p.receivedDate.split('T')[0] : p.receivedFormatedDate
      let obej = { receivedFormatedDate, caseID, ...p };
      return obej;
    });
    const listObj = {
      columns: colList, rows: rowList
    };
    return listObj;
  }
  async function changeVisitType(e) {
    e.target.value ? setIsNextDisable(false) : setIsNextDisable(true)
    if (isUserFound && e.target.value === "Commercial") {
      let cases = await axios.get(`${CONSTANTS.API_URL}/api/v1/userCases?mobile=${mobNumber}`);
      if (cases.data.length) {
        setCases(cases.data);
      } else {
        setCases([]);
      }
    }
    setVisitType(e.target.value);
  }
  function changeSource(val) {
    let subSources = {
      'Walk-in': ["Hyundai Website", "Employee Referral", "Print Ad", "Radio Ad", "Referral", "Walkin", "Inter Branch"],
      'CRM':  ["Car Wale", "CarDekho", "Dealer's Website", "Google Ads", "HMIL Call Center", "HyBuy", "Just Dial", "Lost Recovered", "Online", "SMS", "Social Media", "HMI Social Media", "Hyper Local", "Website", "Chatbot", "Click to Buy"],
      'Field Generation': ["Cold Call", "Float Activity", "Free Car Care Clinic", "Loan/Exchange Mela", "Sales & Service Camp", "Sales promotion", "SC own source", "Special Days Camps", "Corpoare Activity"],
      'Incoming Call': ["Digital Medium/Web", "Print Ad", "Radio Ad", "TV Ad", "Incoming Call"],
      'Referrals': ["Customer Referral", "DSA", "Employee Referral", "Finance Referral", "Happiness Checklist", "Referral", "Workshop Referral"]
    };
    setSource(val);
    setSubSources(subSources[val]);
  }
  function changeSubSource(val) {
    setSubSource(val);
    setSubSubSources(["Employee Referral", "Customer Referral", "Finance Referral", "Service Referral", "Other"]);
  }
  function changeLeadType(val) {
    let subTypes = {
      Vehicle: ["New Vehicle", "Pre-owned Vehicle", "Upcoming Vehicle"],
      Insurance: ["New Insurance", "Insurance Renewal"],
      Finance: ["New Vehicle Finance", "Pre-owned Vehicle Finance"],
      Service: ["Body Shop", "Road Side Assistance", "Vehicle Breakdown", "Scheduled Free", "Scheduled Paid", "Service Query"],
      Accessories: ["Third Party", "Dealership"],
      Other: ["3M", "Vehicle Wash"]
    };
    setLeadType(val);
    setLeadSubTypes(subTypes[val]);
  }
  //function to toggle the popup
  async function toggleSearchCustomerPopupVisibility() {
    setSearchCustomerPopupVisibility(!isSearchCustomerPopupOpen);
    setDefaultForm(true);
    setOTPSend(false);
  }
  async function toggleVisitPopupVisibility() {
    setMobNumber('0')
    setIsNextDisable(false)
    setUserFound(false)
    showTab(0);
    setCurrentTab(0)
    setActivePageTabItem('CREATE SHOWROOM VISIT');
    setActiveFilter('');
    setVisitPopupVisibility(true);
    setOTPSubmitted(false);
    setResendOTP(false);
    setOTPValid(false);
    // setOTP('');
  }
  //function to set coutry code
  let passCountryCode = (val) => {
    setCountryCode(val);
  };


  //function to search customer
  let searchCustomer = async () => {
      await setIsNextDisable(true)
      //setIsLoader(true)
      let response = await axios.get(`${CONSTANTS.API_URL}/api/v1/contact?mobile=${mobNumber}&typeOfCase=Sales&isOTPverified=true`);
      console.log(response,'-----------responseeeeeeeeeeeeeee');
      
      // let registeredNumberData = await contactList.find((contact) => contact.mobile == mobNumber);
      let registeredNumberData = response.data.length > 0 ? response.data[0] : null;
      if (registeredNumberData && registeredNumberData.isOTPverified === false) {
        await setContactCreatedUuid(registeredNumberData.uuid)
        let uuidContact = {
          contactID: registeredNumberData.uuid
        }
        // let responseSendOtp = await Axios.put(`${CONSTANTS.API_URL}/api/v1/sendTOTPOnSms`, uuidContact)
        // if (responseSendOtp.status === 200) {
        //   setTimeout(() => {
        //     setResendBtn(false)
        //   }, 20000)
        //
        // }
        setDefaultForm(false);
        setUserFound(false);
        return
      }
      await setContactData(registeredNumberData);
      if (registeredNumberData && registeredNumberData.pincode) { await getAreaByPincode(registeredNumberData.pincode)};
      if (registeredNumberData && registeredNumberData.state) { await getCityList(registeredNumberData.state)};
      if (registeredNumberData) {
        await setIsNextDisable(false);
        await setContactCreatedUuid(registeredNumberData.uuid);
        await setUserFound(true);
        await setDefaultForm(false);
        let responseVisit = await axios.get(`${CONSTANTS.API_URL}/api/v1/visit?contactID=${registeredNumberData.uuid}&sortBy=dateCreated`);
        let salesConsultant
        if (responseVisit.data.length !== 0) {
          let responseUser = await axios.get(`${CONSTANTS.API_URL}/api/v1/users`);
          if (responseVisit.data[0].assignUser) {
            var assignedUserData = responseUser.data.find((user) => user.uuid === responseVisit.data[0].assignUser)
          }

          if (assignedUserData) {
            salesConsultant = assignedUserData.displayName ? assignedUserData.displayName : ""
          }
          let customerName

          //ModifiedBy: Vihang Kalee
          // Date: 04/04/2022
          // Modification: first name and last name is shown on previous details
          if (registeredNumberData.type === "Corporate") {
            customerName = (registeredNumberData && registeredNumberData.firstName) ? registeredNumberData.firstName :""
          } else if (registeredNumberData.firstName) {
            customerName = (registeredNumberData.firstName ? registeredNumberData.firstName : '') + " " + (registeredNumberData.lastName ? registeredNumberData.lastName :"")
          } else {
            customerName = registeredNumberData.lastName ? registeredNumberData.lastName :""
          }

          setVisitType(responseVisit.data[0].type)
          setPurpose(responseVisit.data[0].purpose)
          setEmployee(responseVisit.data[0].employee)
          setTypeOfBuyer(responseVisit.data[0].typeOfBuyer)
          changeSource(responseVisit.data[0].source)
          changeSubSource(responseVisit.data[0].subSource)
          setSubSubSource(responseVisit.data[0].subSubSource)
          setCustomerReferralNumber(responseVisit.data[0].referralCustomerNumber)
          changeLeadType(responseVisit.data[0].leadType)
          setLeadSubType(responseVisit.data[0].subLeadType)
          setModel(responseVisit.data[0].model)
          // getVariantForSelectedModel(responseVisit.data[0].model)
          getFuelTypesForSelectedModel(responseVisit.data[0].model)
          setVariant(responseVisit.data[0].variant)
          setTypeOfFuel(responseVisit.data[0].fuleType)
          if (responseVisit.data[0].variant) {
            getVariantDetails(responseVisit.data[0].variant)
          }
          setCar(responseVisit.data[0].car)
          setInteriorColor(responseVisit.data[0].interiorColor)
          setExteriorColor(responseVisit.data[0].exteriorColor)
          setSpecifications(responseVisit.data[0].specifications)

          let registeredPerson = {
            customerName,
            salesConsultant,
            typeOfVisit: responseVisit.data[0].type ? responseVisit.data[0].type : "",
            purpose: responseVisit.data[0].purpose ? responseVisit.data[0].purpose : "",
            source: responseVisit.data[0].source ? responseVisit.data[0].source : "",
            model: responseVisit.data[0].model ? responseVisit.data[0].model : "",
            lastVisitedAt: responseVisit.data[0].dealershipLocation ? responseVisit.data[0].dealershipLocation : "",
            lastVisitOn: responseVisit.data[0].createdAt ? responseVisit.data[0].createdAt : "",
            variant: responseVisit.data[0].variant ? responseVisit.data[0].variant : "",
            leadType: responseVisit.data[0].leadType ? responseVisit.data[0].leadType : "",
            leadSubType: responseVisit.data[0].leadSubType ? responseVisit.data[0].leadSubType : "",
            fuleType: responseVisit.data[0].fuleType ? responseVisit.data[0].fuleType : "",
            remarks: responseVisit.data[0].remarks ? responseVisit.data[0].remarks : "",
          }
          await setPreviousVisitDetails(registeredPerson)
          //await setIsLoader(false);

        } else {

          //ModifiedBy: Vihang Kalee
          // Date: 04/04/2022
          // Modification: first name and last name is shown on previous details
          let customerName
          if (registeredNumberData.type === "Corporate") {
            customerName = (registeredNumberData && registeredNumberData.firstName) ? registeredNumberData.firstName :""
          } else if (registeredNumberData.firstName) {
            customerName = (registeredNumberData.firstName ? registeredNumberData.firstName : '') + " " + (registeredNumberData.lastName ? registeredNumberData.lastName :"")
          } else {
            customerName = registeredNumberData.lastName ? registeredNumberData.lastName :""
          }

          let registeredPerson = {
            customerName,
          }
          await setPreviousVisitDetails(registeredPerson)
          setDefaultForm(true);
          setUserFound(true);
          //await setIsLoader(false);

        }

      } else {
        let obj = {
          mobile: mobNumber,
          /*
            Bug: T1818 -  BG_FN: Insurance-Contacts Page- Total counter Sales and Insurance Tabs counters and filters not working
            Modification: Added typeOfCase for contact distinction from sales and insurance
            By: Devang
            Date: 01/06/2024
          */
          typeOfCase: "Sales"
        }
        let responseCreateContact = await Axios.post(`${CONSTANTS.API_URL}/api/v1/contact`, obj);
        let uuidContact = {
          contactID: responseCreateContact.data.uuid
        }
        await setContactCreatedUuid(responseCreateContact.data.uuid);
        await setContactData(responseCreateContact.data);
        // let responseSendOtp = await Axios.put(`${CONSTANTS.API_URL}/api/v1/sendTOTPOnSms`, uuidContact)
        // if (responseSendOtp.status === 200) {
        //   await setContactCreatedUuid(responseCreateContact.data.uuid)
        //   setTimeout(() => {
        //     setResendBtn(false)
        //   }, 20000)
        //
        // }
        await setDefaultForm(false);
        await setUserFound(false);
        await setIsNextDisable(true);
        await setIsLoader(false);
      }
  };

  //function to show verify OTP field
  let showOTPfield = (e) => {
    e.preventDefault();
    setOTPSend(true);
  };

  let inputOTP = (e) => {
    setOTP(e.target.value);
  };

  let keyupOTP = (e) => {
    if (e.target.value.length >= 6) return;
  }

  //function to verify OTP
  let verifyOTP = async () => {
    {
      await setResendOTP(false);
      // e.preventDefault();
      let obj = {
        totp: isOTP,
        contactID: contactCreatedUuid
      }

      try {
        let responseVerifyOtp = await Axios.put(`${CONSTANTS.API_URL}/api/v1/verifyTOTPSmsAuthenticator`, obj)
        if (responseVerifyOtp.status === 200) {
          let obj = {
            isOTPverified: true
          }
          let responseVerifyOTP = await axios.put(`${CONSTANTS.API_URL}/api/v1/contact/${contactCreatedUuid}`, obj);
          await setContactCreatedUuid(responseVerifyOTP.data.uuid)
          setOTPValid(true);
          setIsNextDisable(false)
        }
      } catch (error) {
        setOTPSubmitted(true)
        setOTPValid(false);
        setResendBtn(false)
        setOTP('');
      }

    }
  };

  //function to resend OTP
  let resendOTP = async () => {
    setOTPSubmitted(false)
    let uuidContact = {
      contactID: contactCreatedUuid
    }
    let responseSendOtp = await Axios.put(`${CONSTANTS.API_URL}/api/v1/sendTOTPOnSms`, uuidContact)
    await setResendBtn(true)
    if (responseSendOtp.status === 200) {
      setTimeout(() => {
        setResendBtn(false)
        if (!isOTPSkipped) {
          setResendOTP(false);
        }
      }, 20000)
    }
    setOTPValid(false);
    setResendOTP(true);
  }
  let sendOTP = async () => {
    setOTPSubmitted(false)
    let uuidContact = {
      contactID: contactCreatedUuid
    }
    let responseSendOtp = await Axios.put(`${CONSTANTS.API_URL}/api/v1/sendTOTPOnSms`, uuidContact)
    if (responseSendOtp.status === 200) {
      toastr.success('Verification code has been sent on ' + mobNumber)
      setTimeout(() => {
        setResendBtn(false)
        if (!isOTPSkipped) {
          setIsOTPSend(!isOtpSend)
        }
      }, 2000)
    }
    setOTPValid(false);
  }

  let skipOTP = async () => {
    setIsOTPSkipped(true);
    setIsNextDisable(false);
  }
  //function to mask the mobile number
  let inputMask = (e) => {
    /*
      By: Yashvi
      On: 25th April 2024
      T1740: BG_FN: Add New Case - Mobile Number - Should be in Indian Format
      Changed the format to normal Indian Format
    */
    /*
    let x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    let withoutMaskNumber = e.target.value.replace(/\D/g, '');
    */
    /*
      Bug: T1863 - Add New Case, Visit - Enter Mobile Number - Mobile Validation is missing
      Modification: added regex for mobile validation.
      By: Arun Singh
      Date: 20/05/2024
    */
    let withoutMaskNumber = e.target.value;
    const regex = /^(?!([0-9])\1{9})[2-9]\d{9}$/;
    let customerPhoneNumber = document.getElementById("customerPhoneNumber");
    if (withoutMaskNumber.length === 10 && regex.test(withoutMaskNumber)) {
      setIsNextDisable(false);
      setMobNumber(withoutMaskNumber);
      customerPhoneNumber.style.borderBottom = "1px solid #9e9e9e";
      } else {
      setIsNextDisable(true);
      customerPhoneNumber.style.borderBottom = "2px solid red";
    }
  };

  //function to show the default search form popup
  let goToDefaultForm = (e) => {
    e.preventDefault();
    setDefaultForm(true);
    setCountryCode("+91");
    setOTPSend(false);
  };

  // async function getBothVisitsCounts() {
  //   let responseCommerical = visitList.filter((visit)=>visit.type === "Commercial")
  //   let responseNon_Commerical = visitList.filter((visit)=>visit.type === "Non-Commercial")
  //   setCommericalDataSetCount(responseCommerical.length)
  //   setNonCommericalDataSetCount(responseNon_Commerical.length)
  //   if (document.getElementById("commerical_bar")) {
  //     document.getElementById("commerical_bar").style['width'] = (((responseCommerical.length) / (responseCommerical.length + responseNon_Commerical.length)) * 100 + "%")
  //   }
  //   if (document.getElementById("non_commerical_bar")) {
  //     document.getElementById("non_commerical_bar").style['width'] = (((responseNon_Commerical.length) / (responseCommerical.length + responseNon_Commerical.length)) * 100 + "%")
  //   }
  // }


  // async function getListOfVisitsCommercial() {
  //   if (visitList.length !==0 && contactList.length !==0 && dealershipList.length !==0 ) {
  //     let commericalData = visitList.filter((visit)=> visit.type ==="Commercial")
  //     Promise.all(commericalData.map(async (visit) => {
  //     let customerName
  //     let responsiblePerson
  //     let responsiblePersonRole
  //     let userDealershipDisplayName
  //     let conatctUserDetails = allUserList.find((user) => user.uuid === visit.updatedBy)
  //
  //     if (conatctUserDetails) {
  //       responsiblePersonRole = conatctUserDetails.roleName
  //       responsiblePerson = conatctUserDetails.displayName
  //       if (conatctUserDetails.dealershipID) {
  //         let userDealership = dealershipList.find((dealer) => dealer.uuid === conatctUserDetails.dealershipID)
  //           if (userDealership) {
  //             userDealershipDisplayName = userDealership.displayName ? userDealership.displayName : userDealership.name
  //           }
  //       }
  //     }
  //
  //     let assignUserName
  //     let assignUserRole
  //     if (visit.assignUser) {
  //       let userDetails = allUserList.find((user) => user.uuid === visit.assignUser)
  //       if (userDetails) {
  //         assignUserName = userDetails.displayName ? userDetails.displayName : userDetails.name
  //         assignUserRole = userDetails.roleName ? userDetails.roleName : 'No role'
  //       }
  //     }
  //
  //     let conatctDetails = {}
  //     let caseIDs
  //     if (visit.contactID) {
  //       await Promise.all(contactList.filter((contact) => {
  //         if (contact.uuid === visit.contactID)
  //           return contact
  //       })).then((res)=>{
  //         conatctDetails =  res[0]
  //         if (conatctDetails) {
  //           customerName = conatctDetails.firstName ? conatctDetails.firstName : ''  + " " + conatctDetails.lastName ? conatctDetails.lastName :''
  //           if (conatctDetails.caseID && visit.caseID) {
  //             caseIDs = "CASE" + " " + conatctDetails.caseID + ' ' + visit.caseID
  //           } else {
  //             caseIDs = "CASE #KH157 #Q160"
  //           }
  //         }else{
  //           conatctDetails={}
  //         }
  //       }).catch((err)=> console.log(err))
  //
  //     }
  //
  //     //"CASE #KH157 #Q160"
  //     delete visit.caseID
  //     delete visit.purpose
  //
  //     let timeFromDate = visit.date.split(" ")[0].split(":")
  //     let timeinFromatHH = timeFromDate[0] < 10 ? "0" + timeFromDate[0] : timeFromDate[0]
  //     let timeinFromatMM = timeFromDate[1]
  //     let inTime = `${timeinFromatHH}:${timeinFromatMM}`
  //
  //     let objVisit = {
  //       displayName: customerName,
  //       purpose: visit.type,
  //       typeOfVisit: visit.assignUser ? "Open" : "Unassigned",
  //       caseID: caseIDs,
  //       visitTime: visit.date,
  //       responsiblePerson,
  //       extraModalName: visit.assignUser ? "View Status" : "Assign SC",
  //       uuid: visit.uuid,
  //       responsiblePersonRole,
  //       userDealershipDisplayName,
  //       ...visit,
  //       assignUserName,
  //       assignUserRole,
  //       inTime,
  //       personalDetails: conatctDetails
  //     }
  //     return   objVisit
  //   })).then(async(res)=>{
  //     // let visitDataArray = res
  //     // let unassignedCommericaldata = await getRowsListForVisit(visitDataArray.filter((visit) => visit.typeOfVisit === "Unassigned"))
  //     // unassigedCommercialVisitDataTableData = unassignedCommericaldata
  //     // await setUnassigedCommercialVisitDataTableData(unassigedCommercialVisitDataTableData)
  //     // let openCommericaldata = await getRowsListForVisit(visitDataArray.filter((visit) => visit.typeOfVisit === "Open"))
  //     // await setOpenCommercialVisitDataTableData(openCommericaldata)
  //     // let closedCommericaldata = await getRowsListForVisit(visitDataArray.filter((visit) => visit.status === "Closed"))
  //     // await setClosedCommercialVisitDataTableData(closedCommericaldata)
  //     // setCommercialData(activeFilterForCommerical)
  //   }).catch((err)=>console.log(err))
  //
  //   }
  // }


  // async function getListOfVisitsNonCommercial() {
  //   let nonCommericalData = await visitList.filter((visit)=> visit.type ==="Non-Commercial")
  //   let visitNonDataArray = []
  //   nonCommericalData.map(async (visit) => {
  //     let customerName
  //     let responsiblePerson
  //     let responsiblePersonRole
  //     let userDealershipDisplayName
  //     let conatctUserDetails = allUserList.find((user) => user.uuid === visit.updatedBy)
  //     if (conatctUserDetails) {
  //       responsiblePersonRole = conatctUserDetails.roleName
  //       responsiblePerson = conatctUserDetails.displayName ? conatctUserDetails.displayName :''
  //       if (conatctUserDetails.dealershipID) {
  //         let userDealership = dealershipList.find((dealer) => dealer.uuid === conatctUserDetails.dealershipID)
  //         if (userDealership) {
  //           userDealership.displayName ? userDealershipDisplayName = userDealership.displayName : userDealershipDisplayName = userDealership.name
  //         }
  //       }
  //     }
  //       let conatctDetails
  //       let caseIDs
  //       if (visit.contactID) {
  //         conatctDetails = contactList.find((contact) => contact.uuid === visit.contactID)
  //         if (conatctDetails) {
  //           customerName = conatctDetails.firstName ? conatctDetails.firstName : "" + " " + conatctDetails.lastName
  //           caseIDs = `CASE ${conatctDetails.caseID ? conatctDetails.caseID : '#KH157'}${' '}${'#NC-'}${visit.caseID ? visit.caseID : ' #Q160'}`
  //         }
  //       }
  //       let assignUserName
  //       let assignUserRole
  //       if (visit.assignUser) {
  //         let userDetails = allUserList.find((user) => user.uuid === visit.assignUser)
  //         if (userDetails) {
  //           assignUserName = userDetails.displayName ? userDetails.displayName : userDetails.name
  //           assignUserRole = userDetails.roleName ? userDetails.roleName : 'No role'
  //         }
  //       }
  //       delete visit.caseID
  //       let timeFromDate = visit.date.split(" ")[0].split(":")
  //       let timeinFromatHH = timeFromDate[0] < 10 ? "0" + timeFromDate[0] : timeFromDate[0]
  //       let timeinFromatMM = timeFromDate[1]
  //       let inTime = `${timeinFromatHH}:${timeinFromatMM}`
  //
  //       let objVisit = {
  //         displayName: customerName,
  //         purpose: visit.type,
  //         typeOfVisit: visit.status,
  //         caseID: caseIDs,
  //         visitTime: visit.date,
  //         responsiblePerson,
  //         extraModalName: "Details",
  //         uuid: visit.uuid,
  //         responsiblePersonRole,
  //         userDealershipDisplayName,
  //         ...visit,
  //         assignUserName,
  //         assignUserRole,
  //         inTime
  //       }
  //       await visitNonDataArray.push(objVisit)
  //   })
  //
  //   // let openNonCommercial = getRowsListForVisit(visitNonDataArray.filter((visit) => visit.status === "Open"))
  //   // openNonCommercialVisitDataTableData = openNonCommercial
  //   // await setOpenNonCommercialVisitDataTableData(openNonCommercialVisitDataTableData)
  //   // let closedNonCommercial =  getRowsListForVisit(visitNonDataArray.filter((visit) => visit.status === "Closed"))
  //   // closedNonCommercialVisitDataTableData = closedNonCommercial
  //   // await setClosedNonCommercialVisitDataTableData(closedNonCommercialVisitDataTableData)
  //   // getBothVisitsCounts()
  //   // setNonCommercialData(activeFilterForNonCommerical)
  // }
  // async function changeActiveDetailsTab(tabName) {
  //   setActivePageDetailsTabItem(tabName);
  // }
  // function changeDetailsStage(e) {
  //   let name = e.target.getAttribute('name');
  //
  //   for (let i = 0; i < 3; i++) {
  //     document.getElementById(`case-${i + 1}`).classList.remove(document.getElementById(`case-${i + 1}`).classList[1]);
  //   }
  //   document.getElementById(`${e.target.id}`).classList.add(name);
  // }



  async function showTab(n, isUserFound) {
    setCurrentTab(n);
    // This function will display the specified tab of the form...
    let x = document.getElementsByClassName("wizard-tab");
    if (x && x[n]) {
      x[n].style.display = "block";
      x[n].scrollTop = 0;
    }
    setTimeout(() => {
      const container = document.getElementById("formModalContainer") || document.querySelector(".formModalContainer");
      if (container) {
        container.scrollTop = 0;
      }
    }, 50);
    //... and fix the Previous/Next buttons:
    /*
      modified : Ashutosh G
      modified : 04/11/2023
      modification : if currentTab is 2 the remove previos button (KDMS_BG_256 Bug-ID)
    */
    if (n === 0 || n === 2) {
      document.getElementById("prevBtn").style.display = "none";
    } else {
      document.getElementById("prevBtn").style.display = "inline";
    }
    if ((n === (x.length - 1)) || ((n === 4) && isUserFound)) {
      if (document.getElementById("nextBtn")) document.getElementById("nextBtn").style.display = "none";
      if (document.getElementById("submitBtn")) document.getElementById("submitBtn").style.display = "block";
    } else {
      if (document.getElementById("nextBtn")) document.getElementById("nextBtn").style.display = "block";
      if (document.getElementById("submitBtn")) document.getElementById("submitBtn").style.display = "none";
    }
    //... and run a function that will display the correct step indicator:
     // await fixStepIndicator(n);
  }

  //ModifiedBy: Vihang Kalee
  // Date: 04/04/2022
  // Modification: circle stepper removed

  function fixStepIndicator(n) {
    // This function removes the "active" class of all steps...

    let i, x = document.getElementsByClassName("step-check");
    console.log(x,"steppppppppppppppppppp");
    //let y = document.getElementsByClassName("step-current-content");
    for (let i = 0; i < x.length; i++) {
      x[i].className = x[i].className.replace(" active", "");
      //y[i].className = y[i].className.replace(" active", "");
    }
    //... and adds the "active" class on the current step:
    x[n].className += " active";
    //y[n].className += ` step-inner-${n}`;
  }

  async function nextPrev(n,e) {
    e.preventDefault();
    // This function will figure out which wizard-tab to display
    let x = document.getElementsByClassName("wizard-tab");
    // Exit the function if any field in the current tab is invalid:
    // if (n === 1 && !validateForm()) return false;
    // Hide the current tab:

    //Modified By: Vihang Kalee
    // Date: 10/05/2022
    // Modification: formValidation for visitmodal
    // make visit tab disable if visitType is empty
    let isFormValid = true;
    if (currentTab === 4 && visitType === "Non-Commercial") {
      try {

        //ModifiedBy: Vihang Kalee
    // Date: 04/04/2022
    // Modification: no of visitors removed as it was not neede here
        let contactUUID = contactCreatedUuid
        delete contactData.uuid
        delete contactData.createdAt
        delete contactData._id
        delete contactData.__v
        delete contactData.updatedAt
        delete contactData.updatedBy
        delete contactData.createdBy
        delete contactData.deletedAt
        delete contactData.caseID
        delete contactData.noOfVisitors
        let response = await axios.put(`${CONSTANTS.API_URL}/api/v1/contact/${contactUUID}`, contactData);
        if (response.status === 200) {
          var createdContactIDs = response.data.uuid
          await setContactData({})
          await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: 'Update contact', email: userInfo.email });
        }
      } catch (HTTPException) {
        await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: 'error contact', typeOfVisit: 'error', errorCode: HTTPException.response.data.statusCode, errorMessage: HTTPException.response.data.message, email: userInfo.email });
      }

      //clearc enter mobile number
      document.getElementById('customerPhoneNumber').value = null

      // create visit
      let currentDate = new Date()
      let timeFordate = currentDate.toLocaleTimeString().split(" ")[0].split(":")[0] + ":" + currentDate.toLocaleTimeString().split(" ")[0].split(":")[1]
      let formattedDate = `${timeFordate + ' ' + currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`
      let visitObject = {
        type: visitType,
        date: formattedDate,
        dealershipCode: userInfo.dealership,
        dealershipLocation: userInfo.dealershipLocation,
        purpose,
        employee,
        typeOfBuyer:typeofBuyer,
        source,
        subSource,
        subSubSource,
        referralCustomerNumber: customerReferralNumber,
        leadType,
        subLeadType: leadSubType,
        model,
        fuleType: typeOfFuel,
        variant,
        car,
        interiorColor,
        exteriorColor,
        specifications,
        assignUser: assignResposiblePerson,
        contactID: createdContactIDs,
        noOfVisitors: noOfVisitors
      }

      try {
        let response = await Axios.post(`${CONSTANTS.API_URL}/api/v1/visit`, visitObject);
        if (response.status === 200) {
          let notificationObj = {
            typeOfNotification : "push",
            message : "Visit created",
            group : "message",
            isSent : true,
            isRead : false,
            sendTo : userInfo.uuid
          };
          let taskCompletionMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj);
          toastr.success('New Visit Created');
          props.onClose(e);

          if (taskCompletionMessage.status === 200) {
            // props.triggerNotifications(true)
          }
          // let responseVisit = await axios.get(`${CONSTANTS.API_URL}/api/v1/visit?contactID=${contactUUID}&type=Commercial&sortBy=dateCreated`);
          if (visitType === "Commercial") {
            let payload = {
              dealershipID: response.data.dealershipCode,
              contactID: response.data.contactID,
              visitID: response.data.uuid,
              assignedUserID: assignResposiblePerson
            }
            let instantiate =  await axios.post(`${CONSTANTS.API_URL}/api/v1/interaction/instantiate`, payload);

            if (instantiate) {
              let notificationObj2 = {
                typeOfNotification : "push",
                message : "New Case created and assigned to SC",
                group : "case",
                isSent : true,
                isRead : false,
                sendTo : assignResposiblePerson,
                caseID: instantiate.data.uuid
              };
              let newCaseMessage =  await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj2);
              await toastr.info('New Case Created');
              let userData = {
                userId: instantiate.data.uniqueID,
                phoneNumber: instantiate.data['dynamicProperties_mobile'],
                countryCode: "+91",
                "traits": {
                  "title": instantiate.data['dynamicProperties_salutation'],
                  "name": instantiate.data['dynamicProperties_customerName']
                }
              };
              /*
                modified : Ashutosh G
                modified : 15/03/2024
                modification : aws link change with awsBucketLink variable
              */
              let links = {
                alcazar: `${awsBucketLink}/ALCAZAR_PRICE_LIST_LATEST.pdf`,
                allnewi20: `${awsBucketLink}/ALL_NEW_i20_PRICE_LIST_LATEST.pdf`,
                aura: `${awsBucketLink}/AURA_PRICE_LIST_LATEST.pdf`,
                grandi10nios: `${awsBucketLink}/GRAND_I10_NIOS_CRETA_PRICE_LIST_LATEST.pdf`,
                i20Nline: '',
                konaev: '',
                newcreta: `${awsBucketLink}/NEW_CRETA_PRICE_LIST_LATEST.pdf`,
                nextgenverna: `${awsBucketLink}/NEXT_GEN_VERNA_CRETA_PRICE_LIST_LATEST.pdf`,
                santro: `${awsBucketLink}/SANTRO_PRICE_LIST_LATEST.pdf`,
                tucson: `${awsBucketLink}/TUCSON_CRETA_PRICE_LIST_LATEST.pdf`,
                newtucson: `${awsBucketLink}/TUCSON_CRETA_PRICE_LIST_LATEST.pdf`,
                venue: `${awsBucketLink}/VENUE_PRICE_LIST_LATEST.pdf`,
                venuenline: `${awsBucketLink}/VENUE_PRICE_LIST_LATEST.pdf`,
                xcentprime: ''
              };
              let brochureLinks = {
                alcazar: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/alcazar.pdf',
                allnewi20: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/i20-Hatchback-2020.pdf',
                aura: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/aura.pdf',
                grandi10nios: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/grand-i10-nios.pdf',
                i20Nline: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/N-Line.pdf',
                konaev: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_KONA_SUV_brochure.pdf',
                newcreta: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/creta-suv-brochure.pdf',
                nextgenverna: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Verna-Brochure.pdf',
                santro: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/SANTRO_Hatchback_brochure.pdf',
                tucson: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Tucson_suv_brochure.pdf',
                newtucson: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Tucson_suv_brochure.pdf',
                venue: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_VENUE_SUV_brochure.pdf',
                venuenline: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_VENUE_SUV_brochure.pdf',
                xcentprime: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/build-a-car/download-e-broucher/Web-Brochure-Xcent-Prime-2020.pdf',
              };

              /*let eventData = {
                userId:  instantiate.data.uniqueID,
                event: "welcomeUser",
                traits: {
                  "title": instantiate.data['dynamicProperties_salutation'],
                  "name": instantiate.data['dynamicProperties_customerName'],
                  "dealership": "Kothari Hyundai",
                  "branch": "Shankar Sheth Road",
                  "docUrl": links[instantiate.data['dynamicProperties_selectedModelName']]
                }
              }*/
              console.log(instantiate.data['dynamicProperties_salutation'],"instantiate.data['dynamicProperties_salutation']instantiate.data['dynamicProperties_salutation']");
              /*
                modified : Ashutosh G
                modified : 15/03/2024
                modification : eventData and brochureEventData object value merged and called sendWhatsappMessage only one time for only one message (unwanted code removed because brochure include in welcome message)
              */
              let eventData = {
                event: "welcomeUser",
                title: instantiate.data['dynamicProperties_salutation'],
                name: instantiate.data['dynamicProperties_customerName'],
                dealership: "Kothari Hyundai",
                branch: "Shankar Sheth Road",
                docUrl: links[instantiate.data['dynamicProperties_selectedModelName']],
                fileName: "Pricelist.pdf",
                message: brochureLinks[instantiate.data['dynamicProperties_selectedModelName']],
              }
              console.log("brochureLinks[instantiate.data['dynamicProperties_selectedModelName']]",brochureLinks[instantiate.data['dynamicProperties_selectedModelName']]);
              await sendWhatsappMessage(userData, eventData, response.data.contactID);
              await priceList(instantiate.data['dynamicProperties_selectedModelName']);

              if (newCaseMessage.status === 200) {
                // props.triggerNotifications(true)
              }
              /*
                Modification: Commented this notification creation and created from backend interaction instantiate api
                By: Devang
                Date: 20/02/2023
              */
              /*let notificationObj3 = {
                typeOfNotification : "push",
                message : "Fill Enquiry Form Task created",
                group : "task",
                isSent : true,
                isRead : false,
                sendTo : assignResposiblePerson
              };
              let EnquiryVisitMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj3);
              if (EnquiryVisitMessage.status === 200) {
                props.triggerNotifications(true)
              }*/
              toastr.info('Fill Enquiry Form Task Created');
            }
          }

          setVisitType('')
          setPurpose('')
          setEmployee('')
          setTypeOfBuyer('')
          setSource('')
          setSubSource('')
          setSubSubSource('')
          setCustomerReferralNumber('')
          setLeadType('')
          setLeadSubType('')
          setModel('')
          setTypeOfFuel('')
          setVariant('')
          setCar('')
          setInteriorColor('')
          setExteriorColor('')
          setSpecifications('')
          setAssignedTo('')
          // setContactCreatedUuid('')
          // getVisitListForLoginDealer()
        }
        props.onClose(e);
      } catch (HTTPException) {
        setAssignedTo('')
      }
      return;
    }
    {/*
      modified : Arun Singh
      modified : 02/05/2024
      modification : T1811- BG_FN: Alternate Number - Mobile Number validation missing
    */}
    {
      /*
          Modification: if else added
          Developer: Manohar sule
          Date: 21/06/2024
      */
    }
    if (contactData.alternativeMobile) {
      const alternativeMobileInput = document.getElementById("alternativeMobile");
      const isValid = /^[6-9]\d{9}$/.test(alternativeMobileInput.value);
      if (!isValid) {
        alternativeMobileInput.style.borderBottom = "2px solid red"
        alternativeMobile.focus()
        alternativeMobile.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
        return;
      } else {
        alternativeMobileInput.style.borderBottom = "1px solid #9e9e9e"
      }
    } else {
      const alternativeMobileInput = document.getElementById("alternativeMobile");
      alternativeMobileInput.style.borderBottom = "1px solid #9e9e9e"
    }

    if (n === 1) {
      console.log("nnnnnnnnnnnnnnnnnnnnnnnnn", currentTab, visitType, isUserFound);
      setExistingCaseSelection(true);
      (currentTab === 2 && !visitType) ? setIsNextDisable(true) :  setIsNextDisable(false)
      if (currentTab === 2) {
        if (isUserFound) {
          setNoOfVisitors(0);
        }
        /*
          Bug: 79	KH_BG_149	Receptionist Visit Customer Details 	When clicked on Next button for Customer Type - Corporate, next view is not displayed, restriction icon is displayed on Next button even if all the mandatory fields are filled
          Modification: Added appropriate conditions for individual and other type of customers
          By: Devang
          Date: 05/07/2023
        */
        if (contactData && ((customerType === 'Individual' && (!contactData.salutation || contactData.salutation.trim() === "" || !contactData.firstName || contactData.firstName.trim() === "" || !contactData.lastName || contactData.lastName.trim() === "")) || (customerType !== 'Individual' && (!contactData.firstName || contactData.firstName.trim() === "")))) {
          isFormValid = false;
          if (!contactData.salutation || contactData.salutation.trim() === "") {
            let salutation = document.getElementById("salutation");
            if (salutation) {
              salutation.style.borderBottom = "2px solid red";
              if (!contactData.lastName) {
                salutation.focus()
                salutation.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
              }
            }
          }
          if (!contactData.firstName || contactData.firstName.trim() === "") {
            let firstname = document.getElementById("first_name");
            if (firstname) {
              firstname.style.borderBottom = "2px solid red";
              if (!contactData.lastName) {
                firstname.focus()
                firstname.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
              }
            }
          }
          if (contactData && customerType === 'Individual' && (!contactData.lastName || contactData.lastName.trim() === "")) {
            let lastname = document.getElementById("last_name");
            if (lastname) {
              lastname.style.borderBottom = "2px solid red";
              if ( contactData.lastname) {
                lastname.focus()
                lastname.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
              }
            }
          }
          // if (!contactData.mobile || contactData.mobile.trim() === "") {
          //   let mobile = document.getElementById("phone_number_deatils");
          //   if (mobile) {
          //     mobile.style.borderBottom = "2px solid red";
          //     if (contactData.firstName && contactData.lastName) {
          //       mobile.focus()
          //       mobile.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
          //     }
          //   }
          // }
          // if (!contactData.pincode || contactData.pincode.trim() === "") {
          //   let pincode = document.getElementById("Pin Code_deatils");
          //   if (pincode) {
          //     pincode.style.borderBottom = "2px solid red";
          //     if (contactData.firstName && contactData.mobile && contactData.lastName) {
          //       pincode.focus()
          //       pincode.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
          //     }
          //   }
          // }
          setIsNextDisable(true)
        } else {

          /*
              Modification: After entering value remove error border
              Developer: Manohar sule
              Date: 21/06/2024
          */

          if (contactData.salutation) {
            let salutation = document.getElementById("salutation");
            if (salutation) {
              salutation.style.borderBottom = "1px solid #9e9e9e";
            }
          }
          if (contactData.firstName) {
            let firstname = document.getElementById("first_name");
            if (firstname) {
              firstname.style.borderBottom = "1px solid #9e9e9e";
            }
          }
          if (contactData.lastName) {
            let lastname = document.getElementById("last_name");
            if (lastname) {
              lastname.style.borderBottom = "1px solid #9e9e9e";
            }
          }
          if (contactData.alternativeMobile) {
            let alternativeMobile = document.getElementById("alternativeMobile");
            if (alternativeMobile) {
              alternativeMobile.style.borderBottom = "1px solid #9e9e9e";
            }
          }
          setIsNextDisable(false)
        }

      }
      if (currentTab === 3) {
        if (visitType === "Commercial" && isUserFound) {
          let cases = await axios.get(`${CONSTANTS.API_URL}/api/v1/userCases?mobile=${mobNumber}`);
          if (cases.data.length) {
            setCases(cases.data);
          } else {
            setCases([]);
          }
          document.getElementById("nextBtn").style.display = "none";
          document.getElementById("submitBtn").style.display = "block";
        } else if (isUserFound && visitType === "Non-Commercial" ) {
          document.getElementById("nextBtn").style.display = "none";
          document.getElementById("submitBtn").style.display = "block";
        }
        if (isUserFound) {
          setNoOfVisitors(0);
        }
        if (!contactData.pincode || contactData.pincode.trim() === "") {
          isFormValid = false;
          // if (!contactData.firstName || contactData.firstName.trim() === "") {
          //   let firstname = document.getElementById("first_name");
          //   if (firstname) {
          //     firstname.style.borderBottom = "2px solid red";
          //     if (!contactData.lastName || !contactData.mobile | !contactData.pincode) {
          //       firstname.focus()
          //       firstname.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
          //     }
          //   }
          // }
          // if (!contactData.lastName || contactData.lastName.trim() === "") {
          //   let lastname = document.getElementById("last_name");
          //   if (lastname) {
          //     lastname.style.borderBottom = "2px solid red";
          //     if ( contactData.firstName) {
          //       lastname.focus()
          //       lastname.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
          //     }
          //   }
          // }
          // if (!contactData.mobile || contactData.mobile.trim() === "") {
          //   let mobile = document.getElementById("phone_number_deatils");
          //   if (mobile) {
          //     mobile.style.borderBottom = "2px solid red";
          //     if (contactData.firstName && contactData.lastName) {
          //       mobile.focus()
          //       mobile.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
          //     }
          //   }
          // }
          if (!contactData.pincode || contactData.pincode.trim() === "") {
            let pincode = document.getElementById("Pin Code_deatils");
            if (pincode) {
              pincode.style.borderBottom = "2px solid red";
              if (contactData && contactData.firstName && contactData.mobile && contactData.lastName) {
                pincode.focus()
                pincode.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
              }
            }
          }
          setIsNextDisable(true)
        } else {
          setIsNextDisable(false)
          if (contactData.pincode) {
            let pincode = document.getElementById("Pin Code_deatils");
            if (pincode) {
              pincode.style.borderBottom = "1px solid #9e9e9e";
            }
          }
        }

      }

      if (currentTab === 4) {
        if (!typeofBuyer || typeofBuyer.trim() === "" || !source || source.trim() === "" || (source && (!subSource || subSource.trim() === "")) || !noOfVisitors) {
          isFormValid = false;
          if (!typeofBuyer  || typeofBuyer.trim() === "") {
            let buyer = document.getElementById("typeofBuyer");
            if (buyer || typeofBuyer.trim() === "") {
              buyer.style.borderBottom = "2px solid red";
              buyer.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
              buyer.focus()
            }
          }
          if (!source || source.trim() === "") {
            let sourceElement = document.getElementById("source");
            if (sourceElement) {
              sourceElement.style.borderBottom = "2px solid red";
              sourceElement.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
              sourceElement.focus()
            }
          }
          if (source && (!subSource || subSource.trim() === "")) {
            let subSourceEle = document.getElementById("subSource");
            if (subSourceEle) {
              subSourceEle.style.borderBottom = "2px solid red";
              subSourceEle.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
              subSourceEle.focus()
            }
          }
          if (!noOfVisitors) {
            let visitors = document.getElementById("noOfVisitors");
            if (visitors) {
              visitors.style.borderBottom = "2px solid red";
              visitors.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
              visitors.focus()
            }
          }

          setIsNextDisable(true)
        }
      }

      if (currentTab === 5) {
          if (!leadType || leadType.trim() === "" ||  ( leadType &&  leadType === "Vehicle" && leadSubType && (leadSubType === "New Vehicle")  && (!model || model.trim() === "")) ) {
            isFormValid = false;

            if (!leadType || leadType.trim() === "") {
              let leadTypeEle = document.getElementById("orderSource");
              if (leadTypeEle) {
                leadTypeEle.style.borderBottom = "2px solid red";
                leadTypeEle.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
                leadTypeEle.focus()
              }
            }
            if ( (leadType &&  leadType === "Vehicle" && leadSubType && (leadSubType === "New Vehicle")  && (!model || model.trim() === ""))) {
              let modelEle =  document.getElementById("orderSourceModel");
              if (modelEle) {
                modelEle.style.borderBottom = "2px solid red";
                modelEle.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
                modelEle.focus()
              }
            }
            setIsNextDisable(true)
          }
          //Modified By: Vihang Kale
          // Date: 09/06/2022
          // Modification: Car variant and model api called
          // let catalogoueCarVariantPetrolData;
          // if (variant) {
          //   catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue?uuids=${variant}`);
          // } else {
          //   catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue?uuids=${model}`);
          // }
          let modelName, variantName;
          
          if (variant) {
            let index = variantList.findIndex((d) => d.uuid === variant);
            if (index > -1) {
              modelName = variantList[index]['modelName'];
              variantName = variantList[index]['variantName'];
            }
          } else {
            let index = catalogoueItemList.findIndex((d) => d.uuid === model);
            if (index > -1) {
              modelName = catalogoueItemList[index]['model'];
            }
          }
          if (leadType && leadSubType === "New Vehicle") await selectedCarModel(modelName, variantName ? variantName: "", contactData)
        }
    }
    isFormValid ? x[currentTab].style.display = "none" : null;
    //Modified By: Vihang Kalee
    // Date: 04/04/2022
    // Modification: double pages shown in wizard tabs issue
    //temporary fix for double page shown on wizard
    // MOBILE VALIDATION NOT WORKING

    if (currentTab === 0) {
      if (mobNumber.length < 10) {
        // setMobNumber("0")
        document.getElementById('customerPhoneNumber').style['border'] = "2px solid red"
        setTimeout(() => {
          document.getElementById('customerPhoneNumber').style['border'] = "none"
          document.getElementById('customerPhoneNumber').style['border-left'] = "3px solid #408b8b"
        }, 1500)
        setMobNumber("0");
        return;
      }
      await setOTP('')
      await setDefaultForm(false);
      await setUserFound(false);
      await setOTPValid(false);
      await setContactData({})
      await setPreviousVisitDetails({})
      await searchCustomer();
    }


    // Increase or decrease the current tab by 1:
    isFormValid  ? currentTab = currentTab + n : null;
    // if you have reached the end of the form...
    if (currentTab >= x.length) {
      // ... the form gets submitted:
      // document.getElementById("regForm").submit();
      return false;
    }

    // Otherwise, display the correct tab:
    if (!isUserFound) {
      await showTab(currentTab);
      /*
        modification: Truecaller integration commented for visit creation 
      */
      // await Truecaller(e);
    } else {
      await showTab(currentTab, isUserFound);
      // await Truecaller(e);
    }
    console.log('specificationsspecifications0',specifications);
  }
  async function submitForm(e) {
    e.preventDefault();
    setIsNextDisable(true)
    let x = document.getElementsByClassName("wizard-tab");
    x[currentTab].style.display = "none";
    // Otherwise, display the correct tab:
    showTab(0);
    try {

      //ModifiedBy: Vihang Kalee
  // Date: 04/04/2022
  // Modification: no of visitors removed as it was not neede here
      let contactUUID = contactCreatedUuid
      delete contactData.uuid
      delete contactData.createdAt
      delete contactData._id
      delete contactData.__v
      delete contactData.updatedAt
      delete contactData.updatedBy
      delete contactData.createdBy
      delete contactData.deletedAt
      delete contactData.caseID
      delete contactData.noOfVisitors
      let response = await axios.put(`${CONSTANTS.API_URL}/api/v1/contact/${contactUUID}`, contactData);
      if (response.status === 200) {
        var createdContactIDs = response.data.uuid
        await setContactData({})
        await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: 'Update contact', email: userInfo.email });
      }
    } catch (HTTPException) {
      await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: 'error contact', typeOfVisit: 'error', errorCode: HTTPException.response.data.statusCode, errorMessage: HTTPException.response.data.message, email: userInfo.email });
    }

    //clearc enter mobile number
    document.getElementById('customerPhoneNumber').value = null

    // create visit
    let currentDate = new Date()
    let timeFordate = currentDate.toLocaleTimeString().split(" ")[0].split(":")[0] + ":" + currentDate.toLocaleTimeString().split(" ")[0].split(":")[1]
    let formattedDate = `${timeFordate + ' ' + currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`
    console.log(preownedModel,"preownedModelpreownedModelpreownedModel");
    
    let visitObject = {
      type: visitType,
      date: formattedDate,
      dealershipCode: userInfo.dealership,
      dealershipLocation: userInfo.dealershipLocation,
      purpose,
      employee,
      typeOfBuyer:typeofBuyer,
      source,
      subSource,
      subSubSource,
      referralCustomerNumber: customerReferralNumber,
      leadType,
      subLeadType: leadSubType,
      model,
      fuleType: typeOfFuel,
      variant,
      car,
      interiorColor,
      exteriorColor,
      specifications,
      assignUser: assignResposiblePerson,
      contactID: createdContactIDs,
      noOfVisitors: noOfVisitors,
      preownedModel: preownedModel
    }
    console.log(visitObject,"visitObjectvisitObjectvisitObject");
    

    try {
      let response = await Axios.post(`${CONSTANTS.API_URL}/api/v1/visit`, visitObject);
      if (response.status === 200) {
        let notificationObj = {
          typeOfNotification : "push",
          message : "Visit created",
          group : "message",
          isSent : true,
          isRead : false,
          sendTo : userInfo.uuid
        };
        let taskCompletionMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj);
        toastr.success('New Visit Created');
        console.log(contactData,"visitType",isUserFound, visitType === "Commercial" && !isUserFound);

        // if (taskCompletionMessage.status === 200) {
        //   props.triggerNotifications(true)
        // }
        // let responseVisit = await axios.get(`${CONSTANTS.API_URL}/api/v1/visit?contactID=${contactUUID}&type=Commercial&sortBy=dateCreated`);
        if (visitType === "Commercial" && !isUserFound) {
          let payload = {
            contactID: createdContactIDs,
            visitID: response.data.uuid,
            assignedToID: assignResposiblePerson,
            catalogueID: model,
            variantID: variant ? variant : '',
            source: response.data.source ? response.data.source: "",
            subSource: response.data.subSource ? response.data.subSource: "",
            type: response.data.leadType ? response.data.leadType: "",
            firstName: contactData.firstName ? contactData.firstName: "",
            lastName: contactData.lastName ? contactData.lastName: "",
            mobile: contactData.mobile ? contactData.mobile: "",
            gender: contactData.gender ? contactData.gender: "",
            email: contactData.email ? contactData.email: "",
            address: contactData.address ? contactData.address: "",
            city: contactData.city ? contactData.city: "",
            state: contactData.state ? contactData.state: "",
            pincode: contactData.pincode ? contactData.pincode: "",
            salutation: contactData.salutation ? contactData.salutation: "",
            typeOfBuyer: typeofBuyer ? typeofBuyer: "",
            typeOfCustomer: customerType ? customerType: ""
          };
          let CreatedCase =  await axios.post(`${CONSTANTS.API_URL}/api/v1/case`, payload);
          if (CreatedCase && CreatedCase.uuid) {
            let notificationObj2 = {
              typeOfNotification : "push",
              message : "New Case created and assigned to SC",
              group : "case",
              isSent : true,
              isRead : false,
              sendTo : assignResposiblePerson,
              caseID: CreatedCase.data.uuid
            };
            let newCaseMessage =  await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj2);
            await toastr.info('New Case Created');
            let userData = {
              userId: assignResposiblePerson,
              phoneNumber: CreatedCase.data.mobile,
              countryCode: "+91",
              "traits": {
                "title": CreatedCase.data.salutation ? CreatedCase.data.salutation: '',
                "name": CreatedCase.data.firstName
              }
            };
            /*
              modified : Ashutosh G
              modified : 15/03/2024
              modification : aws link change with awsBucketLink variable
            */
            let links = {
              alcazar: `${awsBucketLink}/ALCAZAR_PRICE_LIST_LATEST.pdf`,
              allnewi20: `${awsBucketLink}/ALL_NEW_i20_PRICE_LIST_LATEST.pdf`,
              aura: `${awsBucketLink}/AURA_PRICE_LIST_LATEST.pdf`,
              grandi10nios: `${awsBucketLink}/GRAND_I10_NIOS_CRETA_PRICE_LIST_LATEST.pdf`,
              i20Nline: '',
              konaev: '',
              newcreta: `${awsBucketLink}/NEW_CRETA_PRICE_LIST_LATEST.pdf`,
              nextgenverna: `${awsBucketLink}/NEXT_GEN_VERNA_CRETA_PRICE_LIST_LATEST.pdf`,
              santro: `${awsBucketLink}/SANTRO_PRICE_LIST_LATEST.pdf`,
              tucson: `${awsBucketLink}/TUCSON_CRETA_PRICE_LIST_LATEST.pdf`,
              newtucson: `${awsBucketLink}/TUCSON_CRETA_PRICE_LIST_LATEST.pdf`,
              venue: `${awsBucketLink}/VENUE_PRICE_LIST_LATEST.pdf`,
              venuenline: `${awsBucketLink}/VENUE_PRICE_LIST_LATEST.pdf`,
              xcentprime: ''
            };
            let brochureLinks = {
              alcazar: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/alcazar.pdf',
              allnewi20: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/i20-Hatchback-2020.pdf',
              aura: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/aura.pdf',
              grandi10nios: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/grand-i10-nios.pdf',
              i20Nline: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/N-Line.pdf',
              konaev: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_KONA_SUV_brochure.pdf',
              newcreta: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/creta-suv-brochure.pdf',
              nextgenverna: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Verna-Brochure.pdf',
              allnewverna: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Verna-Brochure.pdf',
              santro: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/SANTRO_Hatchback_brochure.pdf',
              tucson: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Tucson_suv_brochure.pdf',
              newtucson: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Tucson_suv_brochure.pdf',
              venue: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_VENUE_SUV_brochure.pdf',
              venuenline: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_VENUE_SUV_brochure.pdf',
              xcentprime: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/build-a-car/download-e-broucher/Web-Brochure-Xcent-Prime-2020.pdf',
            };
            /*let eventData = {
              userId:  instantiate.data.uniqueID,
              event: "welcomeUser",
              traits: {
                "title": instantiate.data['dynamicProperties_salutation'],
                "name": instantiate.data['dynamicProperties_customerName'],
                "dealership": "Kothari Hyundai",
                "branch": "Shankar Sheth Road",
                "docUrl": links[instantiate.data['dynamicProperties_selectedModelName']]
              }
            }*/
            /*
              modified : Ashutosh G
              modified : 15/03/2024
              modification : eventData and brochureEventData object value merged and called sendWhatsappMessage only one time for only message (unwanted code removed because brochure include in welcome message)
            */
            let eventData = {
              event: "welcomeUser",
              title: CreatedCase.data.salutation ? CreatedCase.data.salutation: '',
              name: CreatedCase.data.firstName,
              dealership: "Kothari Hyundai",
              branch: "Shankar Sheth Road",
              docUrl: links[CreatedCase.data.selectedModelName],
              fileName: "Pricelist.pdf",
              message: brochureLinks[CreatedCase.data.selectedModelName],
            }
            await sendWhatsappMessage(userData, eventData, CreatedCase.data.contactID);
            await priceList(CreatedCase.data.selectedModelName);

            if (newCaseMessage.status === 200) {
              props.triggerNotifications(true)
            }
          }
          let payloadData = {
            dealershipID: response.data.dealershipCode,
            contactID: response.data.contactID,
            visitID: response.data.uuid,
            caseID: CreatedCase.data.uuid,
            assignedUserID: assignResposiblePerson
          }
          let instantiate =  await axios.post(`${CONSTANTS.API_URL}/api/v1/interaction/instantiate`, payloadData);

          if (instantiate) {
            let notificationObj2 = {
              typeOfNotification : "push",
              message : "New Case created and assigned to SC",
              group : "case",
              isSent : true,
              isRead : false,
              sendTo : assignResposiblePerson,
              caseID: instantiate.data.uuid
            };
            let newCaseMessage =  await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj2);
            await toastr.info('New Case Created');
            let userData = {
              userId: instantiate.data.uniqueID,
              phoneNumber: instantiate.data['dynamicProperties_mobile'],
              countryCode: "+91",
              "traits": {
                "title": instantiate.data['dynamicProperties_salutation'],
                "name": instantiate.data['dynamicProperties_customerName']
              }
            };
            /*
              modified : Ashutosh G
              modified : 15/03/2024
              modification : aws link change with awsBucketLink variable
            */
            let links = {
              alcazar: `${awsBucketLink}/ALCAZAR_PRICE_LIST_LATEST.pdf`,
              allnewi20: `${awsBucketLink}/ALL_NEW_i20_PRICE_LIST_LATEST.pdf`,
              aura: `${awsBucketLink}/AURA_PRICE_LIST_LATEST.pdf`,
              grandi10nios: `${awsBucketLink}/GRAND_I10_NIOS_CRETA_PRICE_LIST_LATEST.pdf`,
              i20Nline: '',
              konaev: '',
              newcreta: `${awsBucketLink}/NEW_CRETA_PRICE_LIST_LATEST.pdf`,
              nextgenverna: `${awsBucketLink}/NEXT_GEN_VERNA_CRETA_PRICE_LIST_LATEST.pdf`,
              santro: `${awsBucketLink}/SANTRO_PRICE_LIST_LATEST.pdf`,
              tucson: `${awsBucketLink}/TUCSON_CRETA_PRICE_LIST_LATEST.pdf`,
              newtucson: `${awsBucketLink}/TUCSON_CRETA_PRICE_LIST_LATEST.pdf`,
              venue: `${awsBucketLink}/VENUE_PRICE_LIST_LATEST.pdf`,
              venuenline: `${awsBucketLink}/VENUE_PRICE_LIST_LATEST.pdf`,
              xcentprime: ''
            };
            let brochureLinks = {
              alcazar: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/alcazar.pdf',
              allnewi20: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/i20-Hatchback-2020.pdf',
              aura: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/aura.pdf',
              grandi10nios: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/grand-i10-nios.pdf',
              i20Nline: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/N-Line.pdf',
              konaev: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_KONA_SUV_brochure.pdf',
              newcreta: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/creta-suv-brochure.pdf',
              nextgenverna: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Verna-Brochure.pdf',
              santro: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/SANTRO_Hatchback_brochure.pdf',
              tucson: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Tucson_suv_brochure.pdf',
              newtucson: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Tucson_suv_brochure.pdf',
              venue: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_VENUE_SUV_brochure.pdf',
              venuenline: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_VENUE_SUV_brochure.pdf',
              xcentprime: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/build-a-car/download-e-broucher/Web-Brochure-Xcent-Prime-2020.pdf',
            };
            /*let eventData = {
              userId:  instantiate.data.uniqueID,
              event: "welcomeUser",
              traits: {
                "title": instantiate.data['dynamicProperties_salutation'],
                "name": instantiate.data['dynamicProperties_customerName'],
                "dealership": "Kothari Hyundai",
                "branch": "Shankar Sheth Road",
                "docUrl": links[instantiate.data['dynamicProperties_selectedModelName']]
              }
            }*/
            /*
              modified : Ashutosh G
              modified : 15/03/2024
              modification : eventData and brochureEventData object value merged and called sendWhatsappMessage only one time for only message (unwanted code removed because brochure include in welcome message)
            */
            let eventData = {
              event: "welcomeUser",
              title: instantiate.data['dynamicProperties_salutation'],
              name: instantiate.data['dynamicProperties_customerName'],
              dealership: "Kothari Hyundai",
              branch: "Shankar Sheth Road",
              docUrl: links[instantiate.data['dynamicProperties_selectedModelName']],
              fileName: "Pricelist.pdf",
              message: brochureLinks[instantiate.data['dynamicProperties_selectedModelName']],
            }
            await sendWhatsappMessage(userData, eventData, response.data.contactID);
            await priceList(instantiate.data['dynamicProperties_selectedModelName']);

            if (newCaseMessage.status === 200) {
              /*
                Bug: 143 KH_BG_213 Receptionist Visit Lead Details After creating a visit, the respective window is not getting closed automatically
                Modification: Added condition to execute condition only if exists
                By: Devang
                Date: 07/07/2023
              */
              props.triggerNotifications && props.triggerNotifications(true)
            }
            let notificationObj3 = {
              typeOfNotification : "push",
              message : "Fill Enquiry Form Task created",
              group : "task",
              isSent : true,
              isRead : false,
              sendTo : assignResposiblePerson
            };
            let EnquiryVisitMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj3);
            if (EnquiryVisitMessage.status === 200) {
              /*
                Bug: 143 KH_BG_213 Receptionist Visit Lead Details After creating a visit, the respective window is not getting closed automatically
                Modification: Added condition to execute condition only if exists
                By: Devang
                Date: 07/07/2023
              */
              props.triggerNotifications && props.triggerNotifications(true)
            }
            toastr.info('Fill Enquiry Form Task Created');
          }
        }

        setVisitType('')
        setPurpose('')
        setEmployee('')
        setTypeOfBuyer('')
        setSource('')
        setSubSource('')
        setSubSubSource('')
        setCustomerReferralNumber('')
        setLeadType('')
        setLeadSubType('')
        setModel('')
        setPreownedModel('')
        setTypeOfFuel('')
        setVariant('')
        setCar('')
        setInteriorColor('')
        setExteriorColor('')
        setSpecifications('')
        setAssignedTo('')
        // setContactCreatedUuid('')
        // getVisitListForLoginDealer()
      }
      props.onClose(e);
    } catch (HTTPException) {
      console.log(HTTPException, 'HTTPExceptionHTTPExceptionHTTPException');
      setAssignedTo('')
    }
    setTimeout(() => {
      setIsNextDisable(false)
    }, 500)

  }

  async function sendWhatsappMessage(userData, eventData, contactID) {
    /*
    // User Creation or Updation
    let res = await axios.post(`${CONSTANTS.API_URL}/api/v1/whatsappUser`, userData);
    if (res) {
      // Event Creation
      let response = await axios.post(`${CONSTANTS.API_URL}/api/v1/whatsappEvent`, eventData);
    }
    // Fetch all records
    // let res = await axios.get(`${CONSTANTS.API_URL}/api/v1/whatsappUsers`);
    */
    /*
      Modification: Added try catch to prevent function to break
      By: Devang
      Date: 07/07/2023
    */
    try {
      if (eventData.event === "welcomeUser") {
        console.log(eventData.title,"veventData.titleeventData.title");
        /*
          modified : Ashutosh G
          modified : 15/03/2024
          modification : sendWhatsappMessageWithMIM api called to sent welcome message with brochure to case client (only one 1 message and seperate message code commented) (unwanted code removed because brochure include in welcome message)
        */
        await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
          "templateName": "welocome_with_brochure",
          "parameters": [`${eventData.title} ${eventData.name}`, `${eventData.dealership} - ${eventData.branch}`, eventData.message || ""],
          "phoneNumber": userData.phoneNumber
        });
        let communicationLogPayload = {
          typeOfMessage: "whatsapp",
          sentOn: new Date(),
          sentStatus: "Sent",
          sentTo: userData.phoneNumber,
          messageTitle: "Welcome to Kothari Hyundai",
          messageText: `Dear ${eventData.title} ${eventData.name}, welcome to ${eventData.dealership} - ${eventData.branch}. Please find attached the price list and brochure for your reference.`,
          contactID
        };
        let responseLog = await axios.post(`${CONSTANTS.API_URL}/api/v1/communicationLog`, communicationLogPayload);
        // if (res1 && eventData.docUrl) {
          //   let res2 = await axios.post(`${CONSTANTS.API_URL}/api/v1/whatsappMedia`, {
        //     number: userData.phoneNumber,
        //     mediaURL: eventData.docUrl,
        //     fileName: eventData.fileName
        //   });
        // }
      }
    } catch (e) {
      console.error(e.message);
    }

  }
  async function removeImg(e) {
  let removeIndex
  let remainingImg = uploadImgArray.filter(async (img, index) => {
    if (img[0].name === e.target.id) {
      removeIndex = index
    }
  })
  if (removeIndex || removeIndex === 0) {
    uploadImgArray.splice(removeIndex, 1)
    await setUploadImgArry(uploadImgArray)
    document.getElementById(`uploadImg${e.target.id}`).remove()
  } else {
    return
  }

}

function counter(id, start, end, duration) {
  let obj = document.getElementById(id),
   current = start,
   range = end - start,
   increment = end > start ? 1 : -1,
   step = Math.abs(Math.floor(duration / range)),
   timer = setInterval(() => {
    current += increment;
    obj.textContent = current;
    if (current == end) {
     clearInterval(timer);
    }
   }, step);
 }

async function preview_image(event, type) {
  if (type === 'packagePhoto') {
    for (let i = 0; i < event.target.files.length; i++) {
      let reader = new FileReader();
      let outer_perview_div = document.getElementById('uploadPackagePhotoPreview')
      let inside_perview_div = document.createElement('div');
      let crossTip_span = document.createElement('span');
      let output = document.createElement('img');
      inside_perview_div.setAttribute('class', 'courierImg')
      inside_perview_div.setAttribute('id', `uploadImg${event.target.files[i].name}`)
      crossTip_span.setAttribute('class', 'crossTip')
      crossTip_span.innerHTML = '×'
      crossTip_span.setAttribute('id', `${event.target.files[i].name}`)
      crossTip_span.addEventListener('click', async (e) => removeImg(e))
      output.setAttribute('class', 'w-80 h-80  m-all border-black  min-h-80 min-w-100')
      inside_perview_div.append(output)
      inside_perview_div.append(crossTip_span)
      outer_perview_div.append(inside_perview_div)
      reader.onload = function () {
        output.src = reader.result;
      }
      reader.readAsDataURL(event.target.files[i]);
    }
  } else if (type === 'handOverPhoto') {
    for (let i = 0; i < event.target.files.length; i++) {
      let reader = new FileReader();
      let outer_perview_div_h = document.getElementById('uploadHandoverPhotoPreview')
      let inside_perview_div = document.createElement('div');
      let crossTip_span = document.createElement('span');
      let output = document.createElement('img');
      inside_perview_div.setAttribute('class', 'courierImg')
      inside_perview_div.setAttribute('id', `uploadImg${event.target.files[i].name}`)
      crossTip_span.setAttribute('class', 'crossTip')
      crossTip_span.innerHTML = '×'
      crossTip_span.setAttribute('id', `${event.target.files[i].name}`)
      crossTip_span.addEventListener('click', async (e) => removeImg(e))
      output.setAttribute('class', 'w-80 h-80  m-all border-black  min-h-80 min-w-100')
      inside_perview_div.append(output)
      inside_perview_div.append(crossTip_span)
      outer_perview_div_h.append(inside_perview_div)
      reader.onload = function () {
        output.src = reader.result;
      }
      reader.readAsDataURL(event.target.files[i]);
    }
  }
}

// async function updateCouier() {
//   let modal = document.getElementById("myModal");
//   let fileArr = []
//   let fileDetailArry = []
//
//   if (uploadImgArray.length !== 0) {
//     for (let i = 0; i < uploadImgArray.length; i++) {
//       let files = uploadImgArray[i][0]
//       if (!files) return;
//       const fileName = files.name;
//       const extension = fileName.split('.').pop();
//       if (imageTypeExtension.includes(extension.toLowerCase())) {
//         const fileObj = {
//           name: files.name,
//           size: files.size,
//           type: files.type,
//           value: files.name,
//         };
//         fileArr.push(fileObj)
//         fileDetailArry.push(files)
//       } else {
//         alert('Looks like the file you tried to upload did not match the system. Kindly upload only a .png, .jpg, .jpeg file');
//       }
//     }
//   }
//   Promise.all(fileArr.map(async (file, index) => {
//     let selectedCourier = courierData.uuid
//     // let detailsFiles = file.fileDetails
//     delete file.fileDetails
//     let payload = {
//       file: file,
//       courierID: selectedCourier
//     }
//
//     if (!isHandoverDocket) {
//       let fileDetails
//       await Axios.post(`${CONSTANTS.API_URL}/api/v1/file/getSignedUrl`, payload).then(async res => {
//         if (res && res.data) {
//           fileDetails = res.data;
//           let uploadPackagePhotoIDs = courierData.uploadPackagePhotoIDs ? courierData.uploadPackagePhotoIDs : []
//           await uploadPackagePhotoIDs.push(fileDetails.uuid);
//           courierData.uploadPackagePhotoIDs = await uploadPackagePhotoIDs
//
//           try {
//             //  Save File on S3
//             const opts = {
//               headers: {
//                 name: 'Content-Type',
//                 value: 'multipart/form-data',
//               }
//             };
//             const fileUpload = await Axios.put(fileDetails.signedURL, fileDetailArry[index], opts);
//           } catch (e) {
//             console.error(e);
//           }
//         }
//       });
//
//     }
//     if (isHandoverDocket) {
//       let fileDetails
//       await Axios.post(`${CONSTANTS.API_URL}/api/v1/file/getSignedUrl`, payload).then(async res => {
//         if (res && res.data) {
//           fileDetails = res.data;
//
//           let uploadHandoverPhotoIDs = courierData.uploadHandoverPhotoIDs ? courierData.uploadHandoverPhotoIDs : []
//           await uploadHandoverPhotoIDs.push(fileDetails.uuid);
//           courierData.uploadHandoverPhotoIDs = await uploadHandoverPhotoIDs
//
//           try {
//             //  Save File on S3
//             const opts = {
//               headers: {
//                 name: 'Content-Type',
//                 value: 'multipart/form-data'
//               }
//             };
//
//             const fileUpload = await Axios.put(fileDetails.signedURL, fileDetailArry[index], opts);
//           } catch (e) {
//             console.error(e);
//           }
//         }
//       });
//     }
//   })).then(async () => {
//     let selectedCourier = courierData.uuid
//     delete courierData.caseID
//     delete courierData.departmentDisplayName
//     delete courierData.handOverToUserName
//     delete courierData.receivedFormatedDate
//     delete courierData.uuid;
//     delete courierData.updatedAt;
//     delete courierData.updatedBy;
//     delete courierData._id;
//     delete courierData.createdBy;
//     delete courierData.createdAt;
//     delete courierData.deletedAt;
//     delete courierData.__v;
//     delete courierData.version;
//     delete courierData.uploadPackagePhotoSrc;
//     delete courierData.uploadHandoverPhotoSrc;
//
//     let responseCreateCourier = await axios.put(`${CONSTANTS.API_URL}/api/v1/updateCourier/${selectedCourier}`, courierData);
//     if (responseCreateCourier.status === 200) {
//       let courierResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/courier`);
//       const tableDataList = await getRowsListForCurier(courierResponse.data);
//       await setCourierDataSet(tableDataList);
//       let importantCourierData = await getRowsListForCurier(tableDataList.rows.filter((courier) => courier.isImportant === true))
//       await setImportantCourierDataSet(importantCourierData)
//       modal.style.display = "none";
//       setIsHandoverDocket(false);
//       setIsEditDocket(false);
//       setAddDocket(!isAddDocket);
//       setCourierImgDelete(false)
//       setUploadImgArry([])
//       // setVisitPopupVisibility(false);
//       await setCourierData({
//         departmentID: '',
//         receivedDate: null,
//         receivedFrom: '',
//         courierDescription: '',
//         typeOfCourier: '',
//         whomTo: '',
//         isImportant: false,
//         departmentID: '',
//         handOverTo: '',
//         timeOfHandOver: '',
//         remarks: '',
//         uploadHandoverPhotoIDs: [],
//         uploadPackagePhotoIDs: []
//       })
//       // ModifiedBy: Vihang Kalee
//       // Date: 24/12/2021
//       // Modification: added snackbar for successfull courier task updation
//       setSnackbarBgcolor('#00c853');
//       setSnackbarPositon('center');
//       setSnackBarMsg("Courier Task Updated Sucessfully");
//       setSnackbarTaskStatus(true);
//       setTimeout(() => {
//         setSnackbarTaskStatus(false);
//       }, 2000);
//     }
//   }).catch((err) => {
//     // ModifiedBy: Vihang Kalee
//     // Date: 24/12/2021
//     // Modification: added snackbar for failure of courier task updation
//     setSnackbarBgcolor('#d50000');
//     setSnackbarPositon('center');
//     setSnackBarMsg("Failed to Update the Courier Task! Please try again!");
//     setSnackbarTaskStatus(true);
//     setTimeout(() => {
//       setSnackbarTaskStatus(false);
//     }, 2000);
//   })
// }

// async function saveCourier(e) {
//
//   if (!courierData.receivedFrom && !courierData.typeOfCourier) {
//     document.getElementById('receivedFromError').style['display'] = 'block'
//     document.getElementById('typeOfCourierError').style['display'] = 'block'
//     setTimeout(()=>{
//       document.getElementById('receivedFromError').style['display'] = 'none'
//       document.getElementById('typeOfCourierError').style['display'] = 'none'
//     },2000)
//   }else if (!courierData.receivedFrom) {
//     document.getElementById('receivedFromError').style['display'] = 'block'
//     setTimeout(()=>{
//       document.getElementById('receivedFromError').style['display'] = 'none'
//     },2000)
//   }else if (!courierData.typeOfCourier) {
//     document.getElementById('typeOfCourierError').style['display'] = 'block'
//     setTimeout(()=>{
//       document.getElementById('typeOfCourierError').style['display'] = 'none'
//     },2000)
//   }else{
//     setAddDocket(!isAddDocket);
//     let modal = document.getElementById("myModal");
//     let courierModal = document.getElementById('courierModal')
//      let responseCreateCourier = await axios.post(`${CONSTANTS.API_URL}/api/v1/courier`, courierData);
//   let fileArr = []
//   let fileDetailArry = []
//
//   for (let i = 0; i < uploadImgArray.length; i++) {
//     let files = uploadImgArray[i][0]
//     if (!files) return;
//     const fileName = files.name;
//     const extension = fileName.split('.').pop();
//     if (imageTypeExtension.includes(extension.toLowerCase())) {
//       const fileObj = {
//         name: files.name,
//         size: files.size,
//         type: files.type,
//         value: files.name,
//       };
//       fileArr.push(fileObj)
//       fileDetailArry.push(files)
//     } else {
//       alert('Looks like the file you tried to upload did not match the system. Kindly upload only a .png, .jpg, .jpeg file');
//     }
//   }
//   Promise.all(fileArr.map(async (file, index) => {
//     let selectedCourier = courierData.uuid
//     delete file.fileDetails
//     let payload = {
//       file: file,
//       courierID: responseCreateCourier.data.uuid
//     }
//
//     let fileDetails
//     await Axios.post(`${CONSTANTS.API_URL}/api/v1/file/getSignedUrl`, payload).then(async res => {
//       if (res && res.data) {
//         fileDetails = res.data;
//         let uploadPackagePhotoIDs = courierData.uploadPackagePhotoIDs ? courierData.uploadPackagePhotoIDs : []
//         await uploadPackagePhotoIDs.push(fileDetails.uuid);
//         courierData.uploadPackagePhotoIDs = await uploadPackagePhotoIDs
//
//         try {
//           //  Save File on S3
//           const opts = {
//             headers: {
//               name: 'Content-Type',
//               value: 'multipart/form-data',
//             }
//           };
//           const fileUpload = await Axios.put(fileDetails.signedURL, fileDetailArry[index], opts);
//         } catch (e) {
//           console.error(e);
//         }
//       }
//     });
//   })).then(async () => {
//     delete courierData.caseID
//     delete courierData.departmentDisplayName
//     delete courierData.handOverToUserName
//     delete courierData.receivedFormatedDate
//     delete courierData.uuid;
//     delete courierData.updatedAt;
//     delete courierData.updatedBy;
//     delete courierData._id;
//     delete courierData.createdBy;
//     delete courierData.createdAt;
//     delete courierData.deletedAt;
//     delete courierData.__v;
//     delete courierData.version;
//     delete courierData.uploadPackagePhotoSrc;
//     delete courierData.uploadHandoverPhotoSrc;
//
//     let responseUpdateCourier = await axios.put(`${CONSTANTS.API_URL}/api/v1/updateCourier/${responseCreateCourier.data.uuid}`, courierData);
//     if (responseUpdateCourier.status === 200) {
//       let courierResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/courier`);
//       const tableDataList = await getRowsListForCurier(courierResponse.data);
//       await setCourierDataSet(tableDataList);
//       let importantCourierData = await getRowsListForCurier(tableDataList.rows.filter((courier) => courier.isImportant === true))
//       await setImportantCourierDataSet(importantCourierData)
//       setCourierImgDelete(false)
//       // courierModal.style.display = 'none'
//     }
//   }).catch((err) => {
//     // ModifiedBy: Vihang Kale
//     // Date: 24/12/2021
//     // Modification: added snackbar for failure of courier task creation
//     setSnackbarBgcolor('#d50000');
//     setSnackBarMsg("Failed To Create Courier Task! Please try again!");
//     setSnackbarTaskStatus(true);
//     setSnackbarPositon('center');
//     setTimeout(() => {
//       setDisableTaskSubmitButton(false)
//       setSnackbarTaskStatus(false);
//     }, 2000);
//   })
//
//   if (responseCreateCourier.status === 200) {
//     modal.style.display = "none";
//     setAddDocket(!isAddDocket);
//     setVisitPopupVisibility(false);
//     await setCourierData({
//       departmentID: '',
//       receivedDate: null,
//       receivedFrom: '',
//       courierDescription: '',
//       typeOfCourier: '',
//       whomTo: '',
//       isImportant: false,
//       departmentID: '',
//       handOverTo: '',
//       timeOfHandOver: '',
//       remarks: '',
//       uploadPackagePhotoIDs: [],
//       uploadHandoverPhotoIDs: [],
//     })
//
//     let courierResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/courier`);
//     const tableDataList = await getRowsListForCurier(courierResponse.data);
//     await setCourierDataSet(tableDataList);
//     let importantCourierData = await getRowsListForCurier(tableDataList.rows.filter((courier) => courier.isImportant === true))
//     await setImportantCourierDataSet(importantCourierData)
//     // ModifiedBy: Vihang Kale
//     // Date: 24/12/2021
//     // Modification: added snackbar for successfull courier task creation
//     setSnackbarBgcolor('#00c853');
//     setSnackbarPositon('center');
//     setSnackBarMsg("Courier Task Created Sucessfully");
//     setSnackbarTaskStatus(true);
//     setTimeout(() => {
//       setSnackbarTaskStatus(false);
//     }, 2000);
//   }
//
//   }
// }
  // function setSelectedModalMode(mode, e) {
  //   setSelectedMode(mode);
  //   // let modal = document.getElementById("Lead #10");
  //   if (mode === "Minimize") {
  //     // modal.classList.remove("is-full-height");
  //     // modal.classList.remove("maximized");
  //     // modal.classList.add("minimized");
  //     setMainModalSize('minimized');
  //   }
  //   if (mode === "Full") {
  //
  //     // modal.classList.remove("minimized");
  //     // modal.classList.remove("maximized");
  //     // modal.classList.add("is-full-height");
  //     setMainModalSize('is-full-height');
  //
  //   }
  //   if (mode === "Maximize") {
  //
  //     // modal.classList.remove("minimized");
  //     // modal.classList.remove("is-full-height");
  //     setMainModalSize('maximized');
  //     // modal.classList.add("maximized");
  //   }
  // }
  async function toggleFeedbackModal(type, data) {
    if (data) {
      await setSelectedVisitDetails(data)
      await setSelectedVisitUuid(data.uuid)
    }
    if (type === 'Feedback') {
      setFeedbackPopupVisibility(!isFeedbackPopupOpen);
      let modal = document.getElementById("myFeedbackModal");
      if (!isFeedbackPopupOpen) {
        modal.style.display = "block";
        setTimeout(async () => {
          let properties = [
            { "rating": "0", "maxRating": "5", "minRating": "0.5", "readOnly": "no", "starImage": `/assets/images/Star_selected.svg`, "backgroundStarImage": `/assets/images/Star_unselected.svg`, "starSize": "30", "step": "0.5" }
          ];
          let className = "ratingFeedback";
          await rateSystem(className, properties, (rating, ratingTargetElement) => { ratingTargetElement.parentElement.parentElement.getElementsByClassName("ratingHolder")[0].innerHTML = rating; });
          let classNameService = "ratingFeedbackService";
          await rateSystem(classNameService, properties, (rating, ratingTargetElement) => { ratingTargetElement.parentElement.parentElement.getElementsByClassName("ratingHolder")[0].innerHTML = rating; });
          let classNameSecurity = "ratingFeedbackSecurity";
          await rateSystem(classNameSecurity, properties, (rating, ratingTargetElement) => { ratingTargetElement.parentElement.parentElement.getElementsByClassName("ratingHolder")[0].innerHTML = rating; });
        }, 500);
      } else {
        modal.style.display = "none";
      }
    } else if (type === 'Assign SC') {
      if (assignResposiblePerson) {
        let visitobj = {
          assignUser: assignResposiblePerson
        }
        let responseUpdateVisit = await Axios.put(`${CONSTANTS.API_URL}/api/v1/updateVisit/${selectedVisitUuid}`, visitobj);
        // setActiveFilterForCommerical('UNASSIGNED');
        if (responseUpdateVisit.status === 200) {
          // await getVisitListForLoginDealer()
          setSnackbarBgcolor('#00c853');
          setSnackbarPositon('center');
          setSnackBarMsg("Successfully assigned SC");
          setSnackbarTaskStatus(true);
          setTimeout(() => {
            setSnackbarTaskStatus(false);
            // route('/homeReception');
          }, 2000);
        }
      }

      await setAssignedTo('')
      setAssignModalOpen(!isAssignModalOpen);
      let modal = document.getElementById("myAssignModal");
      if (!isAssignModalOpen) {
        modal.style.display = "block";
      } else {
        modal.style.display = "none";
      }
    } else if (type === 'Assign SC Closed') {
      await setAssignedTo('')
      await setAssignResposiblePerson('')
      setAssignModalOpen(!isAssignModalOpen);
      let modal = document.getElementById("myAssignModal");
      if (!isAssignModalOpen) {
        modal.style.display = "block";
      } else {
        modal.style.display = "none";
      }
    } else if (type === 'Details') {
      setNonCommercialCustomerProfileVisibility(!isNonCommercialCustomerProfileOpen);
    } else {
      setCustomerProfileVisibility(!isCustomerProfileOpen);
    }
  }
  function selectCustomerType(e) {
    setCustomerType(e.target.value);
  }
  // async function setCommercialData(filter) {
  //    setActiveFilterForCommerical(filter);
  //   if (filter === "UNASSIGNED") {
  //     await setCommercialVisitDataSet(unassigedCommercialVisitDataTableData);
  //   } else if (filter === "OPEN") {
  //     await setCommercialVisitDataSet(openCommercialVisitDataTableData)
  //   } else if (filter === "CLOSED") {
  //     await setCommercialVisitDataSet(closedCommercialVisitDataTableData)
  //   }
  // }
  // async function setNonCommercialData(filter) {
  //    setActiveFilterForNonCommerical(filter);
  //   if (filter === "OPEN") {
  //     await setNonCommercialVisitDataSet(openNonCommercialVisitDataTableData)
  //   } else if (filter === "CLOSED") {
  //     await setNonCommercialVisitDataSet(closedNonCommercialVisitDataTableData)
  //   }
  // }
  // async function setTaskData(filter) {
  //   setActiveFilter(filter);
  //   if (activePageTabItem === 'TASKS TO DO') {
  //     if (filter === "DAILY TASKS") {
  //       await setTasksData(taskToDoDaily)
  //     } else if (filter === "FOLLOW UP") {
  //       await setTasksData(taskToDoFollow)
  //     } else if (filter === "COURIER") {
  //       await setTasksData(taskToDoCourier)
  //     }
  //     else if (filter === "ESCALATED TASKS") {
  //       await setTasksData(taskToDoEscalatedTasks)
  //     }
  //     else if (filter === "CALLS") {
  //       await setTasksData(taskToDoCalls)
  //     }
  //   } else if (activePageTabItem === "TASKS TO TRACK") {
  //     if (filter === "DAILY TASKS") {
  //       await setTasksData(taskToTrackDaily)
  //     } else if (filter === "FOLLOW UP") {
  //       await setTasksData(taskToTrackFollow)
  //     } else if (filter === "COURIER") {
  //       await setTasksData(taskToTrackCourier)
  //     }
  //     else if (filter === "ESCALATED TASKS") {
  //       await setTasksData(taskToTrackEscalatedTasks)
  //     }
  //     else if (filter === "CALLS") {
  //       await setTasksData(taskToTrackCalls)
  //     }
  //   } else if (activePageTabItem === 'COMPLETED TASKS') {
  //     if (filter === "DAILY TASKS") {
  //       await setTasksData(completedTaskDaily)
  //     } else if (filter === "FOLLOW UP") {
  //       await setTasksData(completedTaskFollow)
  //     } else if (filter === "COURIER") {
  //       await setTasksData(completedTaskCourier)
  //     }
  //   }
  // }
  // async function uploadPackageImage(e, type) {
  //   uploadImgArray.push(e.target.files);
  //   await setUploadImgArry(uploadImgArray)
  //   await preview_image(e, type)
  // }
  // function DownloadChecklist() {
  //
  //   let pdfName = "Hyundai_Checklist" + ".pdf"
  //   let docDefinition = {
  //     pageSize: 'A3',
  //     pageOrientation: PDFSTYLE.pageSetup.pageOrientationPortrait,
  //     pageMargins: PDFSTYLE.pageSetup.pageMargins,
  //
  //     footer(currentPage, pageCount, page) {
  //       if (page > 1)
  //         return {
  //           style: "pageFooter",
  //           columns: [
  //             {
  //               text: [{ text: "Created by KDMS\n", width: 50 }]
  //             },
  //
  //             { text: currentPage.toString() + " of " + pageCount, alignment: "right" }
  //           ]
  //         }
  //     },
  //     content: [
  //
  //
  //       {
  //         columns: [
  //           { image: hyundaiX, width: 150 },
  //           {
  //             table: {
  //               widths: ["*"],
  //               heights: [30],
  //               body: [
  //                 [{ text: "KOTHARI HYUNDAI", bold: true, fontSize: 22, alignment: "center" }]
  //               ]
  //             },
  //             margin: [10, 0, 10, 0]
  //           },
  //           { image: hyundaiLogo, width: 150 }
  //         ]
  //
  //       },
  //       {
  //         columns: [
  //           {},
  //           { text: "SHOWROOM READINESS CHECKLIST", bold: true, fontSize: 14, width: "auto", alignment: "center", margin: [5, 5, 5, 5] },
  //           { text: "DATE:09/09/21", bold: true, alignment: "right", margin: [25, 10, 5, 0] }
  //         ],
  //
  //       },
  //       {
  //
  //         fontSize: 9,
  //         table: {
  //           widths: ["auto", "auto", "auto", "*", "*", "*", "*", "*", "*", "*", "*", "*"],
  //           body: [
  //             [{ text: "S.NO.", margin: [0, 5, 0, 0] }, { text: "Parameters", colSpan: 2, alignment: "center", margin: [0, 5, 0, 0] }, {}, { text: "Availability", colSpan: 3, alignment: "center", margin: [0, 5, 0, 0] }, {}, {}, { text: "Quality/Condition/Cleanliness", colSpan: 3, alignment: "center" }, {}, {}, { text: "Remarks", colSpan: 3, alignment: "center", margin: [0, 5, 0, 0] }, {}, {}],
  //             [{ text: "1", alignment: "center" }, { text: "Showroom Exterior", alignment: "center", rowSpan: 8, margin: [0, 55, 0, 0, 0] }, { text: "Customer Car Parking Area" }, { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "2", alignment: "center" }, {}, "Valet Parking Service ", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "3", alignment: "center" }, {}, "Security Guard", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "4", alignment: "center" }, {}, " Entrance Arch Gate ", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "5", alignment: "center" }, {}, "Showroom Glass Facade", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "6", alignment: "center" }, {}, "Showroom Surroundings", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "7", alignment: "center" }, {}, "Main Pylon", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "8", alignment: "center" }, {}, "Doormats", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "9", alignment: "center" }, { text: "Showroom Interior", alignment: "center", rowSpan: 15, margin: [0, 100, 0, 0] }, "Reception Desk", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "10", alignment: "center" }, {}, "Color Chips of Cars", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "11", alignment: "center", margin: [0, 5, 0, 0] }, {}, "Customer Lounge (LCD TV, Sofas, Center Table, Current News Papers & Magazines)", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "12", alignment: "center" }, {}, "Discussion Tables and Chairs", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "13", alignment: "center" }, {}, "Showroom Floor", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "14", alignment: "center" }, {}, "Showroom Walls & Ceiling", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "15", alignment: "center" }, {}, "Showroom Light", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "16", alignment: "center" }, {}, "Showroom Temperature", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "17", alignment: "center" }, {}, "Functioning of A/C", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "18", alignment: "center" }, {}, "Soft Music inside the Showroom", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "19", alignment: "center" }, {}, "Restroom - Male", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "20", alignment: "center" }, {}, " Restroom - Female", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "21", alignment: "center" }, {}, "Pantry", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "22", alignment: "center" }, {}, "Uniform & Grooming of Pantry Boy", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "23", alignment: "center" }, {}, "Quality of Glasses, Gups, Tray", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "24", alignment: "center" }, { text: "Boards & Posters", alignment: "center", rowSpan: 8, margin: [0, 55, 0, 0] }, "Satisfaction Rating Standee", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "25", alignment: "center" }, {}, "Satisfaction Rating Poster", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "26", alignment: "center" }, {}, "Delivery Schedule Board Center Table, Current News Papers & Magazines", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "27", alignment: "center" }, {}, "Car Waiting Board", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "28", alignment: "center" }, {}, "RC Board", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "29", alignment: "center" }, {}, "Customer Delight Poster", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "30", alignment: "center" }, {}, "Swachh Can Standee in Delivery Ceremony Area", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "31", alignment: "center", margin: [0, 5, 0, 0] }, {}, "Notice Board Updated with latest communication from RMM (Regional Marketing Manager)", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "32", alignment: "center" }, { text: "Stationery", alignment: "center", rowSpan: 3, margin: [0, 15, 0, 0] }, "Letter Heads as per norms", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "33", alignment: "center" }, {}, "Visiting Cards as per norms", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "34", alignment: "center" }, {}, "Envelops as per norms", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "35", alignment: "center" }, { text: "Digital", alignment: "center", rowSpan: 5, margin: [0, 32, 0, 0] }, "Dealer Location,Contact Information on Dealer Website", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "36", alignment: "center" }, {}, "Kiosk updated with latest Scheme & Models", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "37", alignment: "center" }, {}, "Tabs/ Mobiles updated with latest Scheme & Models", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "38", alignment: "center" }, {}, "Dealer WiFi for Customers", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "39", alignment: "center" }, {}, "Dealer WiFi Sign Board", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //           ]
  //         }
  //       },
  //
  //       {
  //         columns: [
  //           { image: hyundaiX, width: 150 },
  //           {
  //             table: {
  //               widths: ["*"],
  //               heights: [30],
  //               body: [
  //                 [{ text: "KOTHARI HYUNDAI", bold: true, fontSize: 22, alignment: "center" }]
  //               ]
  //             },
  //             margin: [10, 0, 10, 0]
  //           },
  //           { image: hyundaiLogo, width: 150 }
  //         ],
  //         pageBreak: "before"
  //       },
  //       {
  //         columns: [
  //           {},
  //           { text: "SHOWROOM READINESS CHECKLIST", bold: true, fontSize: 14, width: "auto", alignment: "center", margin: [5, 5, 5, 5] },
  //           { text: "DATE:09/09/21", bold: true, alignment: "right", margin: [25, 10, 5, 0] }
  //         ],
  //
  //       },
  //       {
  //
  //         fontSize: 9,
  //         table: {
  //           widths: ["auto", "auto", "auto", "*", "*", "*", "*", "*", "*", "*", "*", "*"],
  //           body: [
  //             [{ text: "S.NO." }, { text: "Parameters", colSpan: 2, alignment: "center" }, {}, { text: "Availability", colSpan: 3, alignment: "center" }, {}, {}, { text: "Quality/Condition/Cleanliness", colSpan: 3, alignment: "center" }, {}, {}, { text: "Remarks", colSpan: 3, alignment: "center" }, {}, {}],
  //             [{ text: "40", alignment: "center" }, { text: "Sales Quality Monitoring Tools", alignment: "center", rowSpan: 10, margin: [0, 70, 0, 0, 0] }, { text: "Dedicated Uninturrupted Phone Line" }, { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "41", alignment: "center" }, {}, "Enquiry Register ", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "42", alignment: "center" }, {}, "Enquiry Forms", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "43", alignment: "center" }, {}, " Test Drive Maintenance Checklist ", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "44", alignment: "center" }, {}, "Test Drive Feedback Forms", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "45", alignment: "center" }, {}, "Delivery Checklists", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "46", alignment: "center" }, {}, "Happiness Checklist", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "47", alignment: "center" }, {}, "Sales Consultants/TL-Booklet/Folder", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "48", alignment: "center" }, {}, "Customer Dockets", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "49", alignment: "center" }, {}, "Customer Care Number updated on Customer Docket", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "50", alignment: "center" }, { text: "Delivery Process", alignment: "center", rowSpan: 10, margin: [0, 70, 0, 0, 0] }, "New Car Delivery Ceremony Area", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "51", alignment: "center" }, {}, "Bouqet", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "52", alignment: "center" }, {}, "Sweet Box/ Chocolate Box/ Cake", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "53", alignment: "center" }, {}, "5 Litre of Fuel", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "54", alignment: "center" }, {}, "Dummy Key", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "55", alignment: "center" }, {}, "Backdrop/ Standee as per norms", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "56", alignment: "center" }, {}, "Congratulations Song during Ceremony", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "57", alignment: "center" }, {}, "Satin Cover on Delivery Car", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "58", alignment: "center" }, {}, "Instant Photograph", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "59", alignment: "center" }, {}, "Senior Management Present during Car Deliveries", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "60", alignment: "center" }, { text: "Others", alignment: "center", rowSpan: 3, margin: [0, 15, 0, 0] }, "Menu Card for Refreshments", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "61", alignment: "center" }, {}, "Smiley Badges wih oil Consultants", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "62", alignment: "center" }, {}, "Mineral Water Bottles for Customers", { text: "", colSpan: 3 }, "", "", { text: "", colSpan: 3 }, {}, {}, { text: "", colSpan: 3 }, {}, {}],
  //             [{ text: "S.NO.", rowSpan: 2, margin: [0, 8, 0, 0] }, { text: "Parameters", colSpan: 2, alignment: "center" }, {}, { text: "Vehicle 1", alignment: "center" }, { text: "Vehicle 2" }, { text: "Vehicle 3" }, { text: "Vehicle 4" }, { text: "Vehicle 5" }, { text: "Vehicle 6" }, { text: "Vehicle 7" }, { text: "Vehicle 8" }, { text: "Vehicle 9" }],
  //             [{}, { text: "MODEL NAME", colSpan: 2, alignment: "center" }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
  //             [{ text: "63", alignment: "center" }, { text: "Display Cars", alignment: "center", rowSpan: 11, margin: [0, 80, 0, 0] }, "Exterior Clean & Polished", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "64", alignment: "center" }, {}, "Interior Clean & Polished", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "65", alignment: "center" }, {}, "Spec Board Placed with every Car", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "66", alignment: "center" }, {}, "Clean Paper Mats with Hyundai logo", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "67", alignment: "center" }, {}, "Boot Clean With Mats", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "68", alignment: "center" }, {}, "Seat Covers", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "69", alignment: "center" }, {}, "Wheel Arch Clean", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "70", alignment: "center" }, {}, "Windows in ‘up’ Position", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "71", alignment: "center" }, {}, "Name Plate", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "72", alignment: "center" }, {}, "Call out Stickers", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "73", alignment: "center" }, {}, "Swachh Can", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "74", alignment: "center" }, { text: "Test Drive Cars", alignment: "center", rowSpan: 7, margin: [0, 50, 0] }, "Demo Car Sticker", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "75", alignment: "center" }, {}, "Test Drive Route Map", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "76", alignment: "center" }, {}, "Exterior Clean & Polished", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "77", alignment: "center" }, {}, "Interior Clean & Polished", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "78", alignment: "center" }, {}, "Clean Paper Mats with Hyundai logo", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "79", alignment: "center" }, {}, "Boot Clean with Mats", "", "", "", {}, {}, {}, {}, {}, {}],
  //             [{ text: "80", alignment: "center" }, {}, " Seat Covers", "", "", "", {}, {}, {}, {}, {}, {}]
  //           ]
  //         }
  //       },
  //
  //     ],
  //     styles: PDFSTYLE.styles,
  //     defaultStyle: {
  //       fontSize: 10
  //     }
  //   }
  //   pdfMake.createPdf(docDefinition).open()
  //   // pdfMake.createPdf(docDefinition).download(pdfName);
  // }
  async function getUsersList() {
    let response = await axios.get(`${CONSTANTS.API_URL}/api/v1/users?dealershipIDs=${userInfo.dealership}`);
    let responseAllUser = await axios.get(`${CONSTANTS.API_URL}/api/v1/users`);
    await setAllUserList(responseAllUser.data)
    await setUsersList(response.data)
  }
  async function getSelectedTypeUserList(value) {
    /*
      Bug: 76	KH_BG_146	Branch - Kondhwa - Roles which can create new cases	Add New Case , Visit								Assigned To - Sales Manager - Dropdown list	The name of the "Sales Manager" - "Ravindra Dhumal" is displayed twice in the dropdown list
      Modification: Sent userID as uniqueKey to filter the final list with uniqueValue of that unique key only
      By: Devang
      Date: 04/07/2023
    */
    let response = await axios.get(`${CONSTANTS.API_URL}/api/v1/userorganizations?dealershipIDs=${userInfo.dealership}&designation=${value}&branchIDs=${userInfo.userBranchID}&uniqueBy=userID`);
    // let userList = response.data.filter((user) => user.roleName === value)
    await setAssignUserList(response.data)
  }
  async function fillAssigneduser(value) {
    await setAssignResposiblePerson(value)
    if (value) {
      setIsSubmitDisable(false)
    } else {
      setIsSubmitDisable(true)
    }
  }
  // async function closedVisit() {
  //   let obj = {
  //     outTime: visitOutTime,
  //     status: "Closed",
  //     comment: commentForClosedVisit
  //   }
  //   let responseUpdate = await axios.put(`${CONSTANTS.API_URL}/api/v1/updateVisit/${selectedVisitDetails.uuid}`, obj);
  //   if (responseUpdate.status === 200) {
  //     setVisitOutTime('')
  //     setCommentForClosedVisit('')
  //   }
  //    setIsEditable(!isEdit);
  //   // await setRefreshNonCommercialList(!refreshNonCommercialList);
  // }

  async function getVariantForSelectedModel(fuelType) {
    // let variantReponse = await axios.get((`${CONSTANTS.API_URL}/api/v1/catalogue/variants?selectedCatalogueItemID=${id}`))
    // await setVariantList(variantReponse.data)
    await axios.get((`${CONSTANTS.API_URL}/api/v1/catalogue/variants?selectedCatalogueItemID=${model}&fuelType=${fuelType}`)).then((response) => {
      let variantReponse = response.data;
      const result = [];
      const map = new Map();
      // for (const item of variantReponse) {
      variantReponse.map(item => {
        let veriantColorArray = [];
        veriantColorArray.push()
        if (!map.has(item.variant)) {
          item['colors'] = [];
          let color = (item.oemColor === '$color' || !item.oemColor) ? item.color.split(' ').join(' ') : item.oemColor.split(' ').join('-')
          item.colors.push(color);
          map.set(item.variant, true);    // set any value to Map
          result.push(item);
        } else {
          let idx = result.findIndex(d => d.variant === item.variant);
          let color = (item.oemColor === '$color' || !item.oemColor) ? item.color.split(' ').join(' ') : item.oemColor.split(' ').join('-')
          result[idx]['colors'].push(color);
        }
      })
      setVariantList(result)
    })
  }

  // async function getFuelTypesForSelectedModel(id) {
  //   await axios.get((`${CONSTANTS.API_URL}/api/v1/catalogue/fuelTypes?selectedCatalogueItemID=${id}`)).then(async (response) => {
  //     let fuelTypesResponse = response.data;
  //     const result = [];
  //     const map = new Map();
  //     // for (const item of variantReponse) {
  //     await Promise.all(fuelTypesResponse.map(item => {
  //       if (!map.has(item.fuelType)) {
  //         map.set(item.fuelType, true);    // set any value to Map
  //         result.push(item);
  //       }
  //     }))
  //     await setFuelTypes(result);
  //     await setVariantList([]);
  //     await setVariant('')
  //   });
  // }

  // async function getVariantDetails(id) {
  //   // let variantReponse = await axios.get((`${CONSTANTS.API_URL}/api/v1/catalogue/variant?selectedVariantID=${id}`))
  //   let index = variantList.findIndex(variant => variant.uuid === id);
  //   if (index > -1) {
  //     await setSelectedVariant(variantList[index]);
  //   }
  // }

     async function getVariantDetails(id) {
    console.log(id, 'modelId');
  
    try {
      const response = await axios.get(
        `${CONSTANTS.API_URL}/api/v1/variants`,
        {
          params: {
            modelId: id,
            noLimit: 'noLimit',
            status: 'Active'
          }
        }
      );
  
      const variantResponse = response.data || [];
      console.log(variantResponse, 'variantResponse');
  
      const result = [];
      const map = new Map();
  
      variantResponse.forEach(item => {
        const colors = item.colorCodes || [];
  
        if (!map.has(item.variantName)) {
          map.set(item.variantName, true);
  
          result.push({
            ...item,
            colors: [...colors]
          });
        } else {
          const idx = result.findIndex(
            d => d.variantName === item.variantName
          );
  
          if (idx !== -1) {
            result[idx].colors.push(...colors);
          }
        }
      });
  
      console.log(result, '-------------------result');
      setVariantList(result);
  
    } catch (error) {
      console.error('Error fetching variants:', error);
    }
  }

     async function getVariantDetailsByFuelType(fuelType) {
    console.log(model, 'modelId');
  
    try {
      const response = await axios.get(
        `${CONSTANTS.API_URL}/api/v1/variants`,
        {
          params: {
            modelId: model,
            fuelType: fuelType,
            noLimit: 'noLimit',
            status: 'Active'
          }
        }
      );
  
      const variantResponse = response.data || [];
      console.log(variantResponse, 'variantResponse');
  
      const result = [];
      const map = new Map();
  
      variantResponse.forEach(item => {
        const colors = item.colorCodes || [];
  
        if (!map.has(item.variantName)) {
          map.set(item.variantName, true);
  
          result.push({
            ...item,
            colors: [...colors]
          });
        } else {
          const idx = result.findIndex(
            d => d.variantName === item.variantName
          );
  
          if (idx !== -1) {
            result[idx].colors.push(...colors);
          }
        }
      });
  
      console.log(result, '-------------------result');
      setVariantList(result);
  
    } catch (error) {
      console.error('Error fetching variants:', error);
    }
  }

  async function getSelectedVariantDetails(variant) {
    console.log('selectedVariant', variant);
    //get the details of selected variant from variantList and set it to selectedVariant state
    let index = variantList.findIndex(item => item.uuid === variant);
    if (index > -1) {
      await setSelectedVariant(variantList[index]);
      setModelVariantName(variantList[index].variantName);

    }

  }
  // function toggleInboxFilter(inboxFilter,inboxTask) {
  //   setInboxChatFilter(inboxFilter);
  //   setInboxTasks(inboxTask);
  // }
  /*
    Bug: 80	KH_BG_150	Receptionist	Visit Create Showroom Visit - No. of Visitors	If deleted the default value for No. of Visitors, "0" is displayed and if entered new value, "0" is not getting deleted
    Modification: Added onblur function and handled the input if 0 in that function
    By: Devang
    Date: 05/07/2023
  */
  function changeNoOfVisitors(e) {
    if (!isNaN(e.target.value))
      setNoOfVisitors(e.target.value);
    /*let value = e.target.value;
    if (value > 0) {
      setNoOfVisitors(value);
    } else {
      setNoOfVisitors(1);
      e.target.value = 0;
    }*/
  }
  function handleNoOfVisitorsOnBlur(e) {
    if (!Number(e.target.value))
      setNoOfVisitors(1);
    else
      setNoOfVisitors(parseInt(e.target.value));
  }

  function changeNoOfAdditionalVehicles(e) {
    let value = e.target.value;
    if (value > 0) {
      setNoOfAdditionalVehicles(value);
    } else {
      setNoOfAdditionalVehicles(1);
      e.target.value = 0;
    }
  }

  async function getAreaByPincode(pincode) {
    let areaList = pincodeDirectory.lookup(pincode);
    await setAreaList(areaList);
  }

  /*
      BN:1008
      Modification: Added the function from utils to add extra city Names
      Date: 29/09/26
      By: Priya
      */
  async function getCityList(stateName) {
    let stateObj = stateList.find(state => state.name === stateName);
    let countryCode = stateObj.countryCode ? stateObj.countryCode : '';
    let stateCode = stateObj.isoCode ? stateObj.isoCode : '';
    // let cityList = City.getCitiesOfState(countryCode, stateCode);
     let cityList = getCitiesOfStateWithExtras(countryCode, stateCode);
    setCityList(cityList);
  }

  //Modified By: Vihang Kale
  // Date: 09/06/2022
  // Modification: selected car model function to map the car variant data
  // async function selectedCarModel(model,variant, contactData) {
  //   setDisablePDFButton(true);
  //   setModelVariantName('');
  //   // setCatalogueCarVariant([]);
  //   setCarVariantTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   setExShowroomTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   setTcsExShowroomTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   setInsuranceTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   setRtoCompanyTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   setRtoIndividualTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   setFourFifthExtendedWarrantyTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   setRmkTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   setBasicAccessoriesKitTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   setRsaTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   setAdditionalPremiumForEngineProtectionTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   setAdditionalPremiumforReturnToInvoiceTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   setTotalIndividualTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   setTotalCompanyTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   setSheildOfTrustTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   setPriceListForPmc([{text:'PRICE LIST FOR ' + ((contactData && contactData.firstName) ? contactData.firstName : '') + " " + ((contactData && contactData.lastName) ? contactData.lastName : ''), fontSize:12,bold:false,alignment:"center"}]);
  //   setAllNewi20TableHeader([{text:'All New i20',alignment:"center",fontSize:15,bold:false}]);
  //   setSolidColourTableHeader([{text:'COLOUR : SOLID COLOUR = ', fontSize:12,bold:false}]);
  //   setNoCashPaymentTableHeader([{text:'Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED', fontSize:12,bold:false}]);
  //   setTermsAndConitionsTableHeader([{text:'Terms & Conditions Details Overleaf', fontSize:12,bold:false}]);
  //   setTermsAndConitionsTableData([{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', fontSize:12,bold:false}]);
  //   setTermsAndConitionsDetailsTableData([{
  //     colSpan:0,
  //     bold:false,
  //     ol: [
  //       'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
  //       "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
  //       "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
  //       "Model specifiction, features & Colours are subject to change without prior notice.",
  //       "Delivery - Subject to realisation of  DD / Cheque.",
  //       "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
  //       "Subject to jurisdiction of Pune Court only",
  //       "Two schemes cannot be clubbed together.",
  //       "Basic Accessories Kit Not Included Labour Charges",
  //       "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
  //       "Force majeure clause would be applicable to all deliveries.",
  //       "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
  //       "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
  //       "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
  //       "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
  //       "Income tax Pan no and address proof in original are necessary at the time of Booking.",
  //       "Purchase of Insurance Policy and Accessories from Dealer are optional.",
  //       "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
  //       "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
  //       "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
  //     ]

  //   }]);
  //   setShowroomITableData([{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   setShowroomIITableData([{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   setShowroomIIITableData([{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', fontSize:12,bold:false}]);
  //   setShowroomIVTableData([{text:'Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525', fontSize:12,bold:false}]);
  //   setShowroomVTableData([{text:'"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205', fontSize:12,bold:false}]);
  //   setShowroomVITableData([{text:'"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   setWork1TableData([{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', fontSize:12,bold:false}]);
  //   setWork2TableData([{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', fontSize:12,bold:false}]);
  //   setWork3TableData([{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}]);
  //   setWork4TableData([{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', fontSize:12,bold:false}]);
  //   setDepotTableData([{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', fontSize:12,bold:false}]);
  //   setCarVariantDieselTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   setExShowroomDieselTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   setTcsExShowroomDieselTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   setInsuranceDieselTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   setRtoCompanyDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   setRtoIndividualDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   setFourFifthExtendedWarrantyDieselTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   setRmkDieselTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   setBasicAccessoriesKitDieselTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   setRsaDieselTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   setAdditionalPremiumForEngineProtectionDieselTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   setAdditionalPremiumforReturnToInvoiceDieselTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   setTotalIndividualDieselTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   setTotalCompanyDieselTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   setSheildOfTrustDieselTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   setModelDieselTableHeader([{text:'',alignment:"center",fontSize:12,bold:false}]);
  //   setCarVariantCNGTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   setExShowroomCNGTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   setTcsExShowroomCNGTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   setInsuranceCNGTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   setRtoCompanyCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   setRtoIndividualCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   setFourFifthExtendedWarrantyCNGTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   setRmkCNGTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   setBasicAccessoriesKitCNGTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   setRsaCNGTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   setAdditionalPremiumForEngineProtectionCNGTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   setAdditionalPremiumforReturnToInvoiceCNGTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   setTotalIndividualCNGTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   setTotalCompanyCNGTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   setSheildOfTrustCNGTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   let catalogoueCarVariantPetrolData;
  //   let catalogoueCarVariantDieselData;
  //   let catalogoueCarVariantCNGData;
  //   if (model === "konaev") {
  //     catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue/carVariant?model=${model}&&fuelType=electric`);
  //     await setCatalogueCarVariant(catalogoueCarVariantPetrolData.data);
  //   } else {
  //     catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue/carVariant?model=${model}&&fuelType=petrol`);
  //     await setCatalogueCarVariant(catalogoueCarVariantPetrolData.data);
  //     catalogoueCarVariantDieselData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue/carVariant?model=${model}&&fuelType=diesel`);
  //     await setCatalogueCarVariantDiesel(catalogoueCarVariantDieselData.data);
  //     catalogoueCarVariantCNGData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue/carVariant?model=${model}&&fuelType=cng`);
  //     await setCatalogueCarVariantCNG(catalogoueCarVariantCNGData.data);
  //   }
  //   if (model === "alcazar") {
  //     await setPDFCarImages(alcazar);
  //   } else if (model === "santro") {
  //     await setPDFCarImages(santro);
  //   } else if (model === "aura") {
  //     await setPDFCarImages(aura);
  //   } else if (model === "venue") {
  //     await setPDFCarImages(venue);
  //   } else if (model === "newcreta") {
  //     await setPDFCarImages(creta);
  //   } else if (model === "nextgenverna") {
  //     await setPDFCarImages(nextGenVerna);
  //   } else if (model === "allnewi20") {
  //     await setPDFCarImages(allNewi20);
  //   } else if (model === "elantra") {
  //     await setPDFCarImages(elantra);
  //   } else if (model === "grandi10nios") {
  //     await setPDFCarImages(grandi10Nios);
  //   } else if (model === "i20nline") {
  //     await setPDFCarImages(i20Nline);
  //   } else if (model === "konaev") {
  //     await setPDFCarImages(hyundaikona);
  //   } else if (model === "tucson") {
  //     await setPDFCarImages(tucson);
  //   } else if (model === "xcentprime") {
  //     await setPDFCarImages(HyundaiXcent);
  //   }

  //   //Modified By: Vihang Kale
  //   // Date: 09/06/2022
  //   // Modification: Matched car variant will have background color for highlighting the variant
  //   let solidColors = [];
  //   await catalogoueCarVariantPetrolData.data.map((car)=> solidColors.push(car.color));
  //   let uniqueColors = await Array.from(new Set(solidColors))
  //   if (catalogoueCarVariantPetrolData && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.length > 0) {
  //     let pdfWidth = ['auto'];
  //     catalogoueCarVariantPetrolData.data.map(i => {
  //       pdfWidth.push('*');
  //     });
  //     await setPdfWidthForCarVariant(pdfWidth);
  //     allnewi20tableHeader[0].text = modelMapping[model.toLowerCase()] + (model === "KonaEV" ? " Electric" : " Petrol") ;
  //     await setAllNewi20TableHeader(allnewi20tableHeader);
  //     // modified by Vihang
  //     // modified at 5 May 2022
  //     // modification: solidcolor data integration for pricelist pdf

  //     // modified by Vihang
  //     // modified at 16 May 2022
  //     // modification: solidcolor changes for pricelist pdf
  //     let solidColorOnce = true;
  //     await catalogoueCarVariantPetrolData.data.map(async(car)=> {
  //       if (car && car.color) {
  //         if (solidColorOnce ) {
  //           let solidColor;
  //           await uniqueColors.map((colors,index,colorArr)=> {
  //             solidColor = colors[0].toUpperCase() + colors.substring(1);
  //             solidColourTableHeader[0].text = solidColourTableHeader[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ");
  //             solidColorOnce = false;
  //           });
  //         }
  //       }
  //       let carVariant;
  //       if (car && car.variant) {
  //         carVariant = await car.variant[0].toUpperCase() + car.variant.substring(1);
  //       }
  //       // modified by Vihang
  //       // modified at 16/05/2022
  //       // modification : new amount format added for all the prices and solid color changes
  //       carVariantTableData.push(car.variant ? variant && car.variant === variant ? {text:carVariant,fillColor:"#FFFF5C"} : carVariant :  "");
  //       exShowroomTableData.push(String(car.exShowroom) ?  variant && car.variant === variant ? {text: getFormattedAmount(car.exShowroom),fillColor:"#FFFF5C"} :  getFormattedAmount(car.exShowroom) : "₹" + "0" );
  //       tcsExShowroomTableData.push(String(car.tcsOnExShowroom) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.tcsOnExShowroom),fillColor:"#FFFF5C"} :  getFormattedAmount(car.tcsOnExShowroom) : "₹" + "0" );
  //       insuranceTableData.push(String(car.insuranceCalculated) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.insuranceCalculated),fillColor:"#FFFF5C"} :  getFormattedAmount(car.insuranceCalculated) : "₹" + "0" );
  //       rtoCompanyTableData.push(String(car.rtoCompany) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.rtoCompany + car.registrationFee),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rtoCompany + car.registrationFee) : "₹" + "0" );
  //       rtoIndividualTableData.push(String(car.rtoIndividual) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.rtoIndividual+ car.registrationFee),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rtoIndividual+ car.registrationFee) : "₹" +  "0" );
  //       fourFifthExtendedWarrantyTableData.push(String(car.fourthAnd5thYearExtendedWarranty) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.fourthAnd5thYearExtendedWarranty),fillColor:"#FFFF5C"} :  getFormattedAmount(car.fourthAnd5thYearExtendedWarranty) : "₹" + "0");
  //       rmkTableData.push(String(car.rmk)  ? variant && car.variant === variant ? {text: getFormattedAmount(car.rmk),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rmk) :  "₹" +"0");
  //       basicAccessoriesKitTableData.push(String(car.basicAccessoriesKit) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.basicAccessoriesKit),fillColor:"#FFFF5C"} :  getFormattedAmount(car.basicAccessoriesKit) : "₹" + "0");
  //       rsaTableData.push(String(car.rsa) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.rsa),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rsa) : "₹" + "0");
  //       additionalPremiumForEngineProtectionTableData.push(String(car.additionalPremiumForEngineProtection) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.additionalPremiumForEngineProtection),fillColor:"#FFFF5C"} :  getFormattedAmount(car.additionalPremiumForEngineProtection) :  "₹" + "0");
  //       additionalPremiumforReturnToInvoiceTableData.push(String(car.additionalPremiumForRTI) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.additionalPremiumForRTI),fillColor:"#FFFF5C"} :  getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
  //       totalIndividualTableData.push(String(car.totalIndividual) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.totalIndividual),fillColor:"#FFFF5C"} :  getFormattedAmount(car.totalIndividual) : "₹" + "0");
  //       totalCompanyTableData.push(String(car.totalCompany) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.totalCompany),fillColor:"#FFFF5C"} :  getFormattedAmount(car.totalCompany) : "₹" + "0");
  //       sheildOfTrustTableData.push(String(car.sheildOfTrust) ?  variant && car.variant === variant ? {text:getFormattedAmount(car.sheildOfTrust),fillColor:"#FFFF5C"} :  getFormattedAmount(car.sheildOfTrust) : "₹" + "0");
  //       await setSolidColourTableHeader(solidColourTableHeader);
  //       await setCarVariantTableData(carVariantTableData);
  //       await setExShowroomTableData(exShowroomTableData);
  //       await setTcsExShowroomTableData(tcsExShowroomTableData);
  //       await setInsuranceTableData(insuranceTableData);
  //       await setRtoCompanyTableData(rtoCompanyTableData);
  //       await setRtoIndividualTableData(rtoIndividualTableData);
  //       await setFourFifthExtendedWarrantyTableData(fourFifthExtendedWarrantyTableData);
  //       await setRmkTableData(rmkTableData);
  //       await setBasicAccessoriesKitTableData(basicAccessoriesKitTableData);
  //       await setRsaTableData(rsaTableData);
  //       await setAdditionalPremiumForEngineProtectionTableData(additionalPremiumForEngineProtectionTableData);
  //       await setAdditionalPremiumforReturnToInvoiceTableData(additionalPremiumforReturnToInvoiceTableData);
  //       await setTotalIndividualTableData(totalIndividualTableData);
  //       await setTotalCompanyTableData(totalCompanyTableData);
  //       await setSheildOfTrustTableData(sheildOfTrustTableData);
  //     }
  //     );
  //   }

  //   if (catalogoueCarVariantDieselData && catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.length > 0) {
  //     let pdfWidth = ['auto'];
  //     catalogoueCarVariantDieselData.data.map(i => {
  //       pdfWidth.push('*');
  //     });
  //     await setPdfWidthForCarVariantDiesel(pdfWidth);
  //     modelDieseltableHeader[0].text = modelMapping[model.toLowerCase()] + " Diesel";
  //     await setModelDieselTableHeader(modelDieseltableHeader);
  //     // modified by Vihang
  //     // modified at 5 May 2022
  //     // modification: solidcolor data integration for pricelist pdf
  //     // modified by Vihang
  //     // modified at 16 May 2022
  //     // modification: solidcolor changes for pricelist pdf
  //     let solidColors = [];
  //     await catalogoueCarVariantDieselData.data.map((car)=> solidColors.push(car.color));
  //     let uniqueColors = await Array.from(new Set(solidColors))
  //     let solidColorOnce = true;
  //     await catalogoueCarVariantDieselData.data.map(async(car)=> {
  //       if (car && car.color) {
  //         if (solidColorOnce ) {
  //           let solidColor;
  //           await uniqueColors.map((colors,index,colorArr)=> {
  //             solidColor = colors[0].toUpperCase() + colors.substring(1);
  //             solidColourDieselTableData[0].text = solidColourDieselTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ");
  //             solidColorOnce = false;
  //           });
  //         }
  //       }
  //       let carVariant;
  //       if (car && car.variant) {
  //         carVariant = await car.variant[0].toUpperCase() + car.variant.substring(1);
  //       }
  //       // modified by Vihang
  //       // modified at 16/05/2022
  //       // modification : new amount format added for all the prices and solid color changes
  //       carVariantDieselTableData.push(car.variant ?  variant && car.variant === variant ? {text:carVariant,fillColor:"#FFFF5C"} : carVariant : "0");
  //       exShowroomDieselTableData.push(String(car.exShowroom) ? variant && car.variant === variant ? {text:getFormattedAmount(car.exShowroom),fillColor:"#FFFF5C"} :  getFormattedAmount(car.exShowroom) :  "₹" + "0");
  //       tcsExShowroomDieselTableData.push(String(car.tcsOnExShowroom) ? variant && car.variant === variant ? {text: getFormattedAmount(car.tcsOnExShowroom),fillColor:"#FFFF5C"} :  getFormattedAmount(car.tcsOnExShowroom) :  "₹" + "0");
  //       insuranceDieselTableData.push(String(car.insuranceCalculated) ? variant && car.variant === variant ? {text:getFormattedAmount(car.insuranceCalculated),fillColor:"#FFFF5C"} :  getFormattedAmount(car.insuranceCalculated) :  "₹" + "0");
  //       rtoCompanyDieselTableData.push(String(car.rtoCompany) ? variant && car.variant === variant ? {text: getFormattedAmount(car.rtoCompany + car.registrationFee),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rtoCompany + car.registrationFee) :  "₹" + "0");
  //       rtoIndividualDieselTableData.push(String(car.rtoIndividual) ? variant && car.variant === variant ? {text:getFormattedAmount(car.rtoIndividual+ car.registrationFee),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rtoIndividual+ car.registrationFee) :  "₹" + "0");
  //       fourFifthExtendedWarrantyDieselTableData.push(String(car.fourthAnd5thYearExtendedWarranty) ? variant && car.variant === variant ? {text: getFormattedAmount(car.fourthAnd5thYearExtendedWarranty),fillColor:"#FFFF5C"} :  getFormattedAmount(car.fourthAnd5thYearExtendedWarranty) :  "₹" + "0");
  //       rmkDieselTableData.push(String(car.rmk) ? variant && car.variant === variant ? {text: getFormattedAmount(car.rmk),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rmk) :  "₹" + "0");
  //       basicAccessoriesKitDieselTableData.push(String(car.basicAccessoriesKit) ? variant && car.variant === variant ? {text:getFormattedAmount(car.basicAccessoriesKit),fillColor:"#FFFF5C"} :  getFormattedAmount(car.basicAccessoriesKit) :  "₹" + "0");
  //       rsaDieselTableData.push(String(car.rsa) ? variant && car.variant === variant ? {text:getFormattedAmount(car.rsa),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rsa) :  "₹" + "0");
  //       additionalPremiumForEngineProtectionDieselTableData.push(String(car.additionalPremiumForEngineProtection) ? variant && car.variant === variant ? {text:getFormattedAmount(car.additionalPremiumForEngineProtection),fillColor:"#FFFF5C"} :  getFormattedAmount(car.additionalPremiumForEngineProtection) :  "₹" + "0");
  //       additionalPremiumforReturnToInvoiceDieselTableData.push(String(car.additionalPremiumForRTI) ? variant && car.variant === variant ? {text:getFormattedAmount(car.additionalPremiumForRTI),fillColor:"#FFFF5C"} :  getFormattedAmount(car.additionalPremiumForRTI) :  "₹" + "0");
  //       totalIndividualDieselTableData.push(String(car.totalIndividual) ? variant && car.variant === variant ? {text:getFormattedAmount(car.totalIndividual),fillColor:"#FFFF5C"} :  getFormattedAmount(car.totalIndividual) :  "₹" + "0");
  //       totalCompanyDieselTableData.push(String(car.totalCompany) ? variant && car.variant === variant ? {text:getFormattedAmount(car.totalCompany),fillColor:"#FFFF5C"} :  getFormattedAmount(car.totalCompany) :  "₹" + "0");
  //       sheildOfTrustDieselTableData.push(String(car.sheildOfTrust) ? variant && car.variant === variant ? {text:getFormattedAmount(car.sheildOfTrust),fillColor:"#FFFF5C"} :  getFormattedAmount(car.sheildOfTrust) :  "₹" + "0");
  //       await setSolidColourDieselTableData(solidColourDieselTableData);
  //       await setCarVariantDieselTableData(carVariantDieselTableData);
  //       await setExShowroomDieselTableData(exShowroomDieselTableData);
  //       await setTcsExShowroomDieselTableData(tcsExShowroomDieselTableData);
  //       await setInsuranceDieselTableData(insuranceDieselTableData);
  //       await setRtoCompanyDieselTableData(rtoCompanyDieselTableData);
  //       await setRtoIndividualDieselTableData(rtoIndividualDieselTableData);
  //       await setFourFifthExtendedWarrantyDieselTableData(fourFifthExtendedWarrantyDieselTableData);
  //       await setRmkDieselTableData(rmkDieselTableData);
  //       await setBasicAccessoriesKitDieselTableData(basicAccessoriesKitDieselTableData);
  //       await setRsaDieselTableData(rsaDieselTableData);
  //       await setAdditionalPremiumForEngineProtectionDieselTableData(additionalPremiumForEngineProtectionDieselTableData);
  //       await setAdditionalPremiumforReturnToInvoiceDieselTableData(additionalPremiumforReturnToInvoiceDieselTableData);
  //       await setTotalIndividualDieselTableData(totalIndividualDieselTableData);
  //       await setTotalCompanyDieselTableData(totalCompanyDieselTableData);
  //       await setSheildOfTrustDieselTableData(sheildOfTrustDieselTableData);
  //     });
  //   }

  //   if (catalogoueCarVariantCNGData && catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.length > 0) {
  //     let pdfWidth = await Array(catalogoueCarVariantCNGData.data.length + 1).fill("*");
  //     await setPdfWidthForCarVariantCNG(pdfWidth);
  //     modelCNGtableHeader[0].text = modelMapping[model.toLowerCase()] + " CNG";
  //     await setModelCNGTableHeader(modelCNGtableHeader);
  //     // modified by Vihang
  //     // modified at 5 May 2022
  //     // modification: solidcolor data integration for pricelist pdf
  //     // modified by Vihang
  //     // modified at 16 May 2022
  //     // modification: solidcolor changes for pricelist pdf
  //     await catalogoueCarVariantCNGData.data.map((car)=> solidColors.push(car.color));
  //     let uniqueColors = await Array.from(new Set(solidColors))
  //     let solidColorOnce = true;
  //     await catalogoueCarVariantCNGData.data.map(async(car)=> {
  //       if (car && car.color) {
  //         let solidColors = await catalogoueCarVariantCNGData.data.filter((value, index, self) => index === self.findIndex((t) => t.color === car.color));
  //         if (solidColorOnce) {
  //           let solidColor;
  //           await uniqueColors.map((colors,index,colorArr)=> {
  //             solidColor = colors[0].toUpperCase() + colors.substring(1);
  //             solidColourCNGTableData[0].text = solidColourCNGTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ") ;
  //             solidColorOnce = false;
  //           });
  //         }
  //       }
  //       let carVariant;
  //       if (car && car.variant) {
  //         carVariant = await car.variant[0].toUpperCase() + car.variant.substring(1);
  //       }
  //       // modified by Vihang
  //       // modified at 16/05/2022
  //       // modification : removed rupees symbol from car variant data in CNG and new amount format added for all the prices
  //       carVariantCNGTableData.push(String(car.variant) ? variant && car.variant === variant ? {text:carVariant,fillColor:"#FFFF5C"} :  carVariant : "0");
  //       exShowroomCNGTableData.push(String(car.exShowroom) ? variant && car.variant === variant ? {text:getFormattedAmount(car.exShowroom),fillColor:"#FFFF5C"} :  getFormattedAmount(car.exShowroom) : "₹" + "0");
  //       tcsExShowroomCNGTableData.push(String(car.tcsOnExShowroom) ? variant && car.variant === variant ? {text:getFormattedAmount(car.tcsOnExShowroom),fillColor:"#FFFF5C"} :  getFormattedAmount(car.tcsOnExShowroom) : "₹" + "0");
  //       insuranceCNGTableData.push(String(car.insuranceCalculated) ? variant && car.variant === variant ? {text: getFormattedAmount(car.insuranceCalculated),fillColor:"#FFFF5C"} :  getFormattedAmount(car.insuranceCalculated) : "₹" + "0");
  //       rtoCompanyCNGTableData.push(String(car.rtoCompany) ? variant && car.variant === variant ? {text:getFormattedAmount(car.rtoCompany + car.registrationFee),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rtoCompany + car.registrationFee) : "₹" + "0");
  //       rtoIndividualCNGTableData.push(String(car.rtoIndividual) ? variant && car.variant === variant ? {text:getFormattedAmount(car.rtoIndividual+ car.registrationFee),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rtoIndividual+ car.registrationFee) : "₹" + "0");
  //       fourFifthExtendedWarrantyCNGTableData.push(String(car.fourthAnd5thYearExtendedWarranty) ? variant && car.variant === variant ? {text:getFormattedAmount(car.fourthAnd5thYearExtendedWarranty),fillColor:"#FFFF5C"} :  getFormattedAmount(car.fourthAnd5thYearExtendedWarranty) : "₹" + "0");
  //       rmkCNGTableData.push(String(car.rmk) ? variant && car.variant === variant ? {text:getFormattedAmount(car.rmk),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rmk) : "₹" + "0");
  //       basicAccessoriesKitCNGTableData.push(String(car.basicAccessoriesKit) ? variant && car.variant === variant ? {text:getFormattedAmount(car.basicAccessoriesKit),fillColor:"#FFFF5C"} :  getFormattedAmount(car.basicAccessoriesKit) : "₹" + "0");
  //       rsaCNGTableData.push(String(car.rsa) ? variant && car.variant === variant ? {text:getFormattedAmount(car.rsa),fillColor:"#FFFF5C"} :  getFormattedAmount(car.rsa) : "₹" + "0");
  //       additionalPremiumForEngineProtectionCNGTableData.push(String(car.additionalPremiumForEngineProtection) ? variant && car.variant === variant ? {text: getFormattedAmount(car.additionalPremiumForEngineProtection),fillColor:"#FFFF5C"} :  getFormattedAmount(car.additionalPremiumForEngineProtection) : "₹" + "0");
  //       additionalPremiumforReturnToInvoiceCNGTableData.push(String(car.additionalPremiumForRTI) ? variant && car.variant === variant ? {text:getFormattedAmount(car.additionalPremiumForRTI),fillColor:"#FFFF5C"} :  getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
  //       totalIndividualCNGTableData.push(String(car.totalIndividual) ? variant && car.variant === variant ? {text:getFormattedAmount(car.totalIndividual),fillColor:"#FFFF5C"} :  getFormattedAmount(car.totalIndividual) : "₹" + "0");
  //       totalCompanyCNGTableData.push(String(car.totalCompany) ? variant && car.variant === variant ? {text:getFormattedAmount(car.totalCompany),fillColor:"#FFFF5C"} :  getFormattedAmount(car.totalCompany) : "₹" + "0");
  //       sheildOfTrustCNGTableData.push(String(car.sheildOfTrust) ? variant && car.variant === variant ? {text: getFormattedAmount(car.sheildOfTrust),fillColor:"#FFFF5C"} :  getFormattedAmount(car.sheildOfTrust) : "₹" + "0");
  //       await setSolidColourCNGTableData(solidColourDieselTableData);
  //       await setCarVariantCNGTableData(carVariantCNGTableData);
  //       await setExShowroomCNGTableData(exShowroomCNGTableData);
  //       await setTcsExShowroomCNGTableData(tcsExShowroomCNGTableData);
  //       await setInsuranceCNGTableData(insuranceCNGTableData);
  //       await setRtoCompanyCNGTableData(rtoCompanyCNGTableData);
  //       await setRtoIndividualCNGTableData(rtoIndividualCNGTableData);
  //       await setFourFifthExtendedWarrantyCNGTableData(fourFifthExtendedWarrantyCNGTableData);
  //       await setRmkCNGTableData(rmkCNGTableData);
  //       await setBasicAccessoriesKitCNGTableData(basicAccessoriesKitCNGTableData);
  //       await setRsaCNGTableData(rsaCNGTableData);
  //       await setAdditionalPremiumForEngineProtectionCNGTableData(additionalPremiumForEngineProtectionCNGTableData);
  //       await setAdditionalPremiumforReturnToInvoiceCNGTableData(additionalPremiumforReturnToInvoiceCNGTableData);
  //       await setTotalIndividualCNGTableData(totalIndividualCNGTableData);
  //       await setTotalCompanyCNGTableData(totalCompanyCNGTableData);
  //       await setSheildOfTrustCNGTableData(sheildOfTrustCNGTableData);
  //       await setCNGCarVariant(true);
  //     });
  //   }
  //   await setDisablePDFButton(false);
  // }


  // async function selectedCarModel(model, variant, contactData) {
  //     setDisablePDFButton(true);
  //     setModelVariantName('');
  //     // setCatalogueCarVariant([]);
  //     setCarVariantTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //     setExShowroomTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //     setTcsExShowroomTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //     setInsuranceTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //     setRtoBHPassingTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}]);
  //     setRtoIndividualTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //     setFourFifthExtendedWarrantyTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //     setRmkTableData([{text:'RMK', fontSize:12,bold:false}]);
  //     setBasicAccessoriesKitTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //     setRsaTableData([{text:'RSA', fontSize:12,bold:false}]);
  //     setAdditionalPremiumForEngineProtectionTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //     setAdditionalPremiumforReturnToInvoiceTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //     setTotalIndividualTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //     setTotalCompanyTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //     setSheildOfTrustTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //     setPriceListForPmc([{text:'PRICE LIST FOR KDMS', fontSize:12,bold:false,alignment:"center"}]);
  //     setAllNewi20TableHeader([{text:'All New i20',alignment:"center",fontSize:15,bold:false}]);
  //     setSolidColourTableHeader([{text:'COLOUR : SOLID COLOUR = ', fontSize:12,bold:false}]);
  //     setNoCashPaymentTableHeader([{text:'Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED', fontSize:12,bold:false}]);
  //     setTermsAndConitionsTableHeader([{text:'Terms & Conditions Details Overleaf', fontSize:12,bold:false}]);
  //     setTermsAndConitionsTableData([{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', fontSize:12,bold:false}]);
  //     setTermsAndConitionsDetailsTableData([{
  //       colSpan:0,
  //       bold:false,
  //       ol: []
  
  //     }]);
  //     setShowroomITableData([{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //     setShowroomIITableData([{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //     setShowroomIIITableData([{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', fontSize:12,bold:false}]);
  //     setShowroomIVTableData([{text:'Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525', fontSize:12,bold:false}]);
  //     setShowroomVTableData([{text:'"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205', fontSize:12,bold:false}]);
  //     setShowroomVITableData([{text:'"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //     setWork1TableData([{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', fontSize:12,bold:false}]);
  //     setWork2TableData([{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', fontSize:12,bold:false}]);
  //     setWork3TableData([{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}]);
  //     setWork4TableData([{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', fontSize:12,bold:false}]);
  //     setDepotTableData([{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', fontSize:12,bold:false}]);
  //     setCarVariantDieselTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //     setExShowroomDieselTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //     setTcsExShowroomDieselTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //     setInsuranceDieselTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //     setRtoCompanyDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //     setRtoIndividualDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //     setRtoBHPassingDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', fontSize:12,bold:false}]);
  //     setFourFifthExtendedWarrantyDieselTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //     setRmkDieselTableData([{text:'RMK', fontSize:12,bold:false}]);
  //     setBasicAccessoriesKitDieselTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //     setRsaDieselTableData([{text:'RSA', fontSize:12,bold:false}]);
  //     setAdditionalPremiumForEngineProtectionDieselTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //     setAdditionalPremiumforReturnToInvoiceDieselTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //     setTotalIndividualDieselTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //     setTotalCompanyDieselTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //     setSheildOfTrustDieselTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //     setModelDieselTableHeader([{text:'',alignment:"center",fontSize:12,bold:false}]);
  //     setCarVariantCNGTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //     setExShowroomCNGTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //     setTcsExShowroomCNGTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //     setInsuranceCNGTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //     setRtoCompanyCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //     setRtoIndividualCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //     setRtoBHPassingCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', fontSize:12,bold:false}]);
  //     setFourFifthExtendedWarrantyCNGTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //     setRmkCNGTableData([{text:'RMK', fontSize:12,bold:false}]);
  //     setBasicAccessoriesKitCNGTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //     setRsaCNGTableData([{text:'RSA', fontSize:12,bold:false}]);
  //     setAdditionalPremiumForEngineProtectionCNGTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //     setAdditionalPremiumforReturnToInvoiceCNGTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //     setTotalIndividualCNGTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //     setTotalCompanyCNGTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //     setSheildOfTrustCNGTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //     let catalogoueCarVariantPetrolData;
  //     let catalogoueCarVariantDieselData;
  //     let catalogoueCarVariantCNGData;
  //     let termsAndConditionsData;
  //     let termsAndConditionsDataCNG;
  //     let termsAndConditionsDataDiesel;
  
  //     if(model === "konaev") {
  //       catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue/carVariant?model=${model}&&fuelType=EV`);
  //       await setCatalogueCarVariant(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems);
  //     } else {
  //       catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=Petrol&status=Active&noLimit=noLimit`);
  //       console.log(catalogoueCarVariantPetrolData, 'catalogoueCarVariantPetrolData---------------------------');
        
  //       termsAndConditionsData = catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.termsAndConditions ? catalogoueCarVariantPetrolData.data.termsAndConditions : [];
  //       setTermsAndConditionsData(termsAndConditionsData);
  //       setEffectivePriceListDate(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.effectivePriceListDate ? catalogoueCarVariantPetrolData.data.effectivePriceListDate : ''); 
  //       await setCatalogueCarVariant(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems);
  //       catalogoueCarVariantDieselData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=Diesel&status=Active&noLimit=noLimit`);
  //       await setCatalogueCarVariantDiesel(catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.priceListItems);
  //       termsAndConditionsDataDiesel = catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.termsAndConditions ? catalogoueCarVariantDieselData.data.termsAndConditions : termsAndConditionsDataDiesel;
  //       setTermsAndConditionsDataDiesel(termsAndConditionsDataDiesel);
  //       catalogoueCarVariantCNGData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=CNG&status=Active&noLimit=noLimit`);
  //       await setCatalogueCarVariantCNG(catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.priceListItems);
  //       termsAndConditionsDataCNG = catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.termsAndConditions ? catalogoueCarVariantCNGData.data.termsAndConditions : termsAndConditionsDataCNG;
  //       setTermsAndConditionsDataCNG(termsAndConditionsDataCNG);
  //     }
  //     let selectedModelName = model.toLowerCase();
  //     if (selectedModelName === "alcazar") {
  //       await setPDFCarImages(alcazar);
  //     } else if (selectedModelName === "santro") {
  //       await setPDFCarImages(santro);
  //     } else if (selectedModelName === "aura") {
  //       await setPDFCarImages(aura);
  //     } else if (selectedModelName === "venue") {
  //       await setPDFCarImages(venue);
  //     } else if (selectedModelName === "newcreta") {
  //       await setPDFCarImages(creta);
  //     } else if (selectedModelName === "nextgenverna") {
  //       await setPDFCarImages(nextGenVerna);
  //     } else if (selectedModelName === "allnewi20") {
  //       await setPDFCarImages(allNewi20);
  //     } else if (selectedModelName === "elantra") {
  //       await setPDFCarImages(elantra);
  //     } else if (selectedModelName === "grandi10nios") {
  //       await setPDFCarImages(grandi10Nios);
  //     } else if (selectedModelName === "i20nline") {
  //       await setPDFCarImages(i20Nline);
  //     } else if (selectedModelName === "konaev") {
  //       await setPDFCarImages(hyundaikona);
  //     } else if (selectedModelName === "tucson") {
  //       await setPDFCarImages(tucson);
  //     } else if (selectedModelName === "xcentprime") {
  //       await setPDFCarImages(HyundaiXcent);
  //     } else if (selectedModelName === "venuenline") {
  //       await setPDFCarImages(venue);
  //     } else if (selectedModelName === "newtucson") {
  //       await setPDFCarImages(tucson);
  //     }
  //     let solidColors = [];
  //     await catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map((car)=> solidColors.push(car.color));
  //     let uniqueColors = await Array.from(new Set(solidColors))
  //     if (catalogoueCarVariantPetrolData && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.length > 0) {
  //       let pdfWidth = ['auto'];
  //       catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map(i => {
  //         pdfWidth.push('*');
  //       });
  //       await setPdfWidthForCarVariant(pdfWidth);
  //       allnewi20tableHeader[0].text = (model === "konaev" ? " Electric" : " Petrol") ;
  //       await setAllNewi20TableHeader(allnewi20tableHeader);
  //       // modified by Vihang
  //       // modified at 5 May 2022
  //       // modification: solidcolor data integration for pricelist pdf
  
  //       // modified by Vihang
  //       // modified at 16 May 2022
  //       // modification: solidcolor changes for pricelist pdf
  //       let solidColorOnce = true;
  //       await catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map(async(car)=> {
  //         if (car && car.color) {
  //           if (solidColorOnce ) {
  //             let solidColor;
  //             await uniqueColors.map((colors,index,colorArr)=> {
  //               solidColor = colors[0].toUpperCase();
  //               solidColourTableHeader[0].text = solidColourTableHeader[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ");
  //               solidColorOnce = false;
  //             });
  //           }
  //         }
  //         let carVariant;
  //         if (car && car.variantName) {
  //           carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
  //         }
  //         // modified by Vihang
  //         // modified at 16/05/2022
  //         // modification : new amount format added for all the prices and solid color changes
  //         carVariantTableData.push({text:car.variantName ? carVariant : "0",bold:false});
  //         exShowroomTableData.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
  //         tcsExShowroomTableData.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0" );
  //         insuranceTableData.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0" );
  //         rtoCompanyTableData.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0" );
  //         rtoIndividualTableData.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0" );
  //         rtoBHPassingTableData.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0" );
  //         fourFifthExtendedWarrantyTableData.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
  //         rmkTableData.push(car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0");
  //         basicAccessoriesKitTableData.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
  //         rsaTableData.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
  //         additionalPremiumForEngineProtectionTableData.push(car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0");
  //         additionalPremiumforReturnToInvoiceTableData.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
  //         totalIndividualTableData.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
  //         totalCompanyTableData.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
  //         sheildOfTrustTableData.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
  //         effectiveDateFrom.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");
  //         await setSolidColourTableHeader(solidColourTableHeader);
  //         await setCarVariantTableData(carVariantTableData);
  //         await setExShowroomTableData(exShowroomTableData);
  //         await setTcsExShowroomTableData(tcsExShowroomTableData);
  //         await setInsuranceTableData(insuranceTableData);
  //         await setRtoCompanyTableData(rtoCompanyTableData);
  //         await setRtoIndividualTableData(rtoIndividualTableData);
  //         await setRtoBHPassingTableData(rtoBHPassingTableData);
  //         await setFourFifthExtendedWarrantyTableData(fourFifthExtendedWarrantyTableData);
  //         await setRmkTableData(rmkTableData);
  //         await setBasicAccessoriesKitTableData(basicAccessoriesKitTableData);
  //         await setRsaTableData(rsaTableData);
  //         await setAdditionalPremiumForEngineProtectionTableData(additionalPremiumForEngineProtectionTableData);
  //         await setAdditionalPremiumforReturnToInvoiceTableData(additionalPremiumforReturnToInvoiceTableData);
  //         await setTotalIndividualTableData(totalIndividualTableData);
  //         await setTotalCompanyTableData(totalCompanyTableData);
  //         await setSheildOfTrustTableData(sheildOfTrustTableData);
  //         await setEffectiveDateFrom(effectiveDateFrom);
  //       }
  //       );
  //     }
  
  //     if (catalogoueCarVariantDieselData && catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.priceListItems && catalogoueCarVariantDieselData.data.priceListItems.length > 0) {
  //       let pdfWidth = ['auto'];
  //       catalogoueCarVariantDieselData.data.priceListItems.map(i => {
  //         pdfWidth.push('*');
  //       });
  //       await setPdfWidthForCarVariantDiesel(pdfWidth);
  //       modelDieseltableHeader[0].text = modelMapping[model] + " Diesel";
  //       await setModelDieselTableHeader(modelDieseltableHeader);
  //       // modified by Vihang
  //       // modified at 5 May 2022
  //       // modification: solidcolor data integration for pricelist pdf
  //       // modified by Vihang
  //       // modified at 16 May 2022
  //       // modification: solidcolor changes for pricelist pdf
  //       let solidColors = [];
  //       await catalogoueCarVariantDieselData.data.priceListItems.map((car)=> solidColors.push(car.color));
  //       let uniqueColors = await Array.from(new Set(solidColors))
  //       let solidColorOnce = true;
  //       await catalogoueCarVariantDieselData.data.priceListItems.map(async(car)=> {
  //         if (car && car.color) {
  //           if (solidColorOnce ) {
  //             let solidColor;
  //             await uniqueColors.map((colors,index,colorArr)=> {
  //               solidColor = colors[0].toUpperCase();
  //               solidColourDieselTableData[0].text = solidColourDieselTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ");
  //               solidColorOnce = false;
  //             });
  //           }
  //         }
  //         let carVariant;
  //         if (car && car.variantName) {
  //           carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
  //         }
  //         // modified by Vihang
  //         // modified at 16/05/2022
  //         // modification : new amount format added for all the prices and solid color changes
  //         carVariantDieselTableData.push({text:car.variantName ? carVariant : "0",bold:false});
  //         exShowroomDieselTableData.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
  //         tcsExShowroomDieselTableData.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0" );
  //         insuranceDieselTableData.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0" );
  //         rtoCompanyDieselTableData.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0" );
  //         rtoIndividualDieselTableData.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0" );
  //         rtoBHPassingDieselTableData.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0" );
  //         fourFifthExtendedWarrantyDieselTableData.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
  //         rmkDieselTableData.push(car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0");
  //         basicAccessoriesKitDieselTableData.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
  //         rsaDieselTableData.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
  //         additionalPremiumForEngineProtectionDieselTableData.push(car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0");
  //         additionalPremiumforReturnToInvoiceDieselTableData.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
  //         totalIndividualDieselTableData.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
  //         totalCompanyDieselTableData.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
  //         sheildOfTrustDieselTableData.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
  //         effectiveDateDieselFrom.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");
  //         await setSolidColourDieselTableData(solidColourDieselTableData);
  //         await setCarVariantDieselTableData(carVariantDieselTableData);
  //         await setExShowroomDieselTableData(exShowroomDieselTableData);
  //         await setTcsExShowroomDieselTableData(tcsExShowroomDieselTableData);
  //         await setInsuranceDieselTableData(insuranceDieselTableData);
  //         await setRtoCompanyDieselTableData(rtoCompanyDieselTableData);
  //         await setRtoBHPassingDieselTableData(rtoBHPassingDieselTableData);
  //         await setRtoIndividualDieselTableData(rtoIndividualDieselTableData);
  //         await setFourFifthExtendedWarrantyDieselTableData(fourFifthExtendedWarrantyDieselTableData);
  //         await setRmkDieselTableData(rmkDieselTableData);
  //         await setBasicAccessoriesKitDieselTableData(basicAccessoriesKitDieselTableData);
  //         await setRsaDieselTableData(rsaDieselTableData);
  //         await setAdditionalPremiumForEngineProtectionDieselTableData(additionalPremiumForEngineProtectionDieselTableData);
  //         await setAdditionalPremiumforReturnToInvoiceDieselTableData(additionalPremiumforReturnToInvoiceDieselTableData);
  //         await setTotalIndividualDieselTableData(totalIndividualDieselTableData);
  //         await setTotalCompanyDieselTableData(totalCompanyDieselTableData);
  //         await setSheildOfTrustDieselTableData(sheildOfTrustDieselTableData);
  //         await setEffectiveDateDieselFrom(effectiveDateDieselFrom);
  //       });
  //     }
  
  //     if (catalogoueCarVariantCNGData && catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.priceListItems && catalogoueCarVariantCNGData.data.priceListItems.length > 0) {
  //       console.log(catalogoueCarVariantCNGData,'------------catalogoueCarVariantCNGData----------');
        
  //       let pdfWidth = await Array(catalogoueCarVariantCNGData.data.priceListItems.length + 1).fill("*");
  //       await setPdfWidthForCarVariantCNG(pdfWidth);
  //       modelCNGtableHeader[0].text = model + " CNG";
  //       await setModelCNGTableHeader(modelCNGtableHeader);
  //       // modified by Vihang
  //       // modified at 5 May 2022
  //       // modification: solidcolor data integration for pricelist pdf
  //       // modified by Vihang
  //       // modified at 16 May 2022
  //       // modification: solidcolor changes for pricelist pdf
  //       await catalogoueCarVariantCNGData.data.priceListItems.map((car)=> solidColors.push(car.color));
  //       let uniqueColors = await Array.from(new Set(solidColors))
  //       let solidColorOnce = true;
  //       await catalogoueCarVariantCNGData.data.priceListItems.map(async(car)=> {
  //         if (car && car.color) {
  //           let solidColors = await catalogoueCarVariantCNGData.data.priceListItems.filter((value, index, self) => index === self.findIndex((t) => t.color === car.color));
  //           if (solidColorOnce) {
  //             let solidColor;
  //             await uniqueColors.map((colors,index,colorArr)=> {
  //               solidColor = colors[0].toUpperCase();
  //               solidColourCNGTableData[0].text = solidColourCNGTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ") ;
  //               solidColorOnce = false;
  //             });
  //           }
  //         }
  //         let carVariant;
  //         if (car && car.variantName) {
  //           carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
  //         }
  //         console.log(car,"carcar");
  //         // modified by Vihang
  //         // modified at 16/05/2022
  //         // modification : removed rupees symbol from car variant data in CNG and new amount format added for all the prices
  //         carVariantCNGTableData.push({text:car.variantName ? carVariant : "0",bold:false});
          
  //         exShowroomCNGTableData.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
  //         tcsExShowroomCNGTableData.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0" );
  //         insuranceCNGTableData.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0" );
  //         rtoCompanyCNGTableData.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0" );
  //         rtoIndividualCNGTableData.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0" );
  //         rtoBHPassingCNGTableData.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0" );
  //         fourFifthExtendedWarrantyCNGTableData.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
  //         rmkCNGTableData.push(car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0");
  //         basicAccessoriesKitCNGTableData.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
  //         rsaCNGTableData.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
  //         additionalPremiumForEngineProtectionCNGTableData.push(car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0");
  //         additionalPremiumforReturnToInvoiceCNGTableData.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
  //         totalIndividualCNGTableData.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
  //         totalCompanyCNGTableData.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
  //         sheildOfTrustCNGTableData.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
  //         effectiveDateCNGFrom.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");
  //         await setSolidColourCNGTableData(solidColourCNGTableData);
  //         await setCarVariantCNGTableData(carVariantCNGTableData);
  //         await setExShowroomCNGTableData(exShowroomCNGTableData);
  //         await setTcsExShowroomCNGTableData(tcsExShowroomCNGTableData);
  //         await setInsuranceCNGTableData(insuranceCNGTableData);
  //         await setRtoCompanyCNGTableData(rtoCompanyCNGTableData);
  //         await setRtoIndividualCNGTableData(rtoIndividualCNGTableData);
  //         await setRtoBHPassingCNGTableData(rtoBHPassingCNGTableData);
  //         await setFourFifthExtendedWarrantyCNGTableData(fourFifthExtendedWarrantyCNGTableData);
  //         await setRmkCNGTableData(rmkCNGTableData);
  //         await setBasicAccessoriesKitCNGTableData(basicAccessoriesKitCNGTableData);
  //         await setRsaCNGTableData(rsaCNGTableData);
  //         await setAdditionalPremiumForEngineProtectionCNGTableData(additionalPremiumForEngineProtectionCNGTableData);
  //         await setAdditionalPremiumforReturnToInvoiceCNGTableData(additionalPremiumforReturnToInvoiceCNGTableData);
  //         await setTotalIndividualCNGTableData(totalIndividualCNGTableData);
  //         await setTotalCompanyCNGTableData(totalCompanyCNGTableData);
  //         await setSheildOfTrustCNGTableData(sheildOfTrustCNGTableData);
  //         await setCNGCarVariant(true);
  //         await setEffectiveDateCNGFrom(effectiveDateCNGFrom);
  //       });
  //     }
  //     await setDisablePDFButton(false);
  //   }

    async function selectedCarModel(model) {
      // setModelForPriceList(model);
      setDisablePDFButton(true);
      setModelVariantName('');
      setCatalogueCarVariant([]);
      setCatalogueCarVariantDiesel([]);
      setCatalogueCarVariantCNG([]);
      
      setCarVariantTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
      setExShowroomTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
      setTcsExShowroomTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
      setInsuranceTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
      setRtoBHPassingTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}]);
      setRtoIndividualTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  
      setFourFifthExtendedWarrantyTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
      setRmkTableData([{text:'RMK', fontSize:12,bold:false}]);
      setBasicAccessoriesKitTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
      setRsaTableData([{text:'RSA', fontSize:12,bold:false}]);
      setAdditionalPremiumForEngineProtectionTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
      setAdditionalPremiumforReturnToInvoiceTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
      setTotalIndividualTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
      setTotalCompanyTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
      setSheildOfTrustTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
      setPriceListForPmc([{text:'PRICE LIST FOR KDMS', fontSize:12,bold:false,alignment:"center"}]);
      setAllNewi20TableHeader([{text:'All New i20',alignment:"center",fontSize:15,bold:false}]);
      setSolidColourTableHeader([{text:'COLOUR : SOLID COLOUR = ', fontSize:12,bold:false}]);
      setNoCashPaymentTableHeader([{text:'Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED', fontSize:12,bold:false}]);
      setTermsAndConitionsTableHeader([{text:'Terms & Conditions Details Overleaf', fontSize:12,bold:false}]);
      setTermsAndConitionsTableData([{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', fontSize:12,bold:false}]);
      setTermsAndConitionsDetailsTableData([{
        colSpan:0,
        bold:false,
        ol: []
  
      }]);
      setShowroomITableData([{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
      setShowroomIITableData([{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
      setShowroomIIITableData([{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', fontSize:12,bold:false}]);
      setShowroomIVTableData([{text:'Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525', fontSize:12,bold:false}]);
      setShowroomVTableData([{text:'"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205', fontSize:12,bold:false}]);
      setShowroomVITableData([{text:'"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
      setWork1TableData([{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', fontSize:12,bold:false}]);
      setWork2TableData([{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', fontSize:12,bold:false}]);
      setWork3TableData([{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}]);
      setWork4TableData([{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', fontSize:12,bold:false}]);
      setDepotTableData([{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', fontSize:12,bold:false}]);
      setCarVariantDieselTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
      setExShowroomDieselTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
      setTcsExShowroomDieselTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
      setInsuranceDieselTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
      setRtoCompanyDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
      setRtoIndividualDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
      setRtoBHPassingDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', fontSize:12,bold:false}]);
      setFourFifthExtendedWarrantyDieselTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
      setRmkDieselTableData([{text:'RMK', fontSize:12,bold:false}]);
      setBasicAccessoriesKitDieselTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
      setRsaDieselTableData([{text:'RSA', fontSize:12,bold:false}]);
      setAdditionalPremiumForEngineProtectionDieselTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
      setAdditionalPremiumforReturnToInvoiceDieselTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
      setTotalIndividualDieselTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
      setTotalCompanyDieselTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
      setSheildOfTrustDieselTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
      setModelDieselTableHeader([{text:'',alignment:"center",fontSize:12,bold:false}]);
      setCarVariantCNGTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
      setExShowroomCNGTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
      setTcsExShowroomCNGTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
      setInsuranceCNGTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
      setRtoCompanyCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
      setRtoIndividualCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
      setRtoBHPassingCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', fontSize:12,bold:false}]);
      setFourFifthExtendedWarrantyCNGTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
      setRmkCNGTableData([{text:'RMK', fontSize:12,bold:false}]);
      setBasicAccessoriesKitCNGTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
      setRsaCNGTableData([{text:'RSA', fontSize:12,bold:false}]);
      setAdditionalPremiumForEngineProtectionCNGTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
      setAdditionalPremiumforReturnToInvoiceCNGTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
      setTotalIndividualCNGTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
      setTotalCompanyCNGTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
      setSheildOfTrustCNGTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  
      let catalogoueCarVariantPetrolData;
      let catalogoueCarVariantDieselData;
      let catalogoueCarVariantCNGData;
      let catalogoueCarVariantEVData;
      let termsAndConditionsData;
      let termsAndConditionsDataCNG;
      let termsAndConditionsDataDiesel;
      let termsAndConditionsDataEV;
  
      // if(model === "konaev") {
      //   catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue/carVariant?model=${model}&&fuelType=EV`);
      //   await setCatalogueCarVariant(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems);
      // } else {
  
        //For Petrol Variants
        catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=Petrol&status=Active&noLimit=noLimit`);
        termsAndConditionsData = catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.termsAndConditions ? catalogoueCarVariantPetrolData.data.termsAndConditions : [];
        setTermsAndConditionsData(termsAndConditionsData);
        setEffectivePriceListDate(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.effectivePriceListDate ? catalogoueCarVariantPetrolData.data.effectivePriceListDate : ''); 
        await setCatalogueCarVariant(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems);
  
        // For Diesel Variants
        catalogoueCarVariantDieselData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=Diesel&status=Active&noLimit=noLimit`);
        await setCatalogueCarVariantDiesel(catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.priceListItems);
        termsAndConditionsDataDiesel = catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.termsAndConditions ? catalogoueCarVariantDieselData.data.termsAndConditions : termsAndConditionsDataDiesel;
        setTermsAndConditionsDataDiesel(termsAndConditionsDataDiesel);
  
        // For CNG Variants
        catalogoueCarVariantCNGData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=CNG&status=Active&noLimit=noLimit`);
        await setCatalogueCarVariantCNG(catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.priceListItems);
        termsAndConditionsDataCNG = catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.termsAndConditions ? catalogoueCarVariantCNGData.data.termsAndConditions : termsAndConditionsDataCNG;
        setTermsAndConditionsDataCNG(termsAndConditionsDataCNG);
  
        // For EV Variants
        catalogoueCarVariantEVData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=EV&status=Active&noLimit=noLimit`);
        await setCatalogueCarVariantEV(catalogoueCarVariantEVData.data && catalogoueCarVariantEVData.data.priceListItems);
        termsAndConditionsDataEV = catalogoueCarVariantEVData.data && catalogoueCarVariantEVData.data.termsAndConditions ? catalogoueCarVariantEVData.data.termsAndConditions : termsAndConditionsDataEV;
        setTermsAndConditionsDataEV(termsAndConditionsDataEV);
      // }
  
      let mapModel = model.toLowerCase();
      await setPDFCarImages(carLogo);
      
      if (mapModel === "alcazar") {
        await setPDFCarImages(alcazar);
      } else if (mapModel === "santro") {
        await setPDFCarImages(santro);
      } else if (mapModel === "aura") {
        await setPDFCarImages(aura);
      } else if (mapModel === "venue") {
        await setPDFCarImages(venue);
      } else if (mapModel === "newcreta") {
        await setPDFCarImages(creta);
      } else if (mapModel === "nextgenverna") {
        await setPDFCarImages(nextGenVerna);
      } else if (mapModel === "allnewi20") {
        await setPDFCarImages(allNewi20);
      } else if (mapModel === "elantra") {
        await setPDFCarImages(elantra);
      } else if (mapModel === "grandi10nios") {
        await setPDFCarImages(grandi10Nios);
      } else if (mapModel === "i20nline") {
        await setPDFCarImages(i20Nline);
      } else if (mapModel === "konaev") {
        await setPDFCarImages(hyundaikona);
      } else if (mapModel === "hyundai tucson") {
        await setPDFCarImages(tucson);
      } else if (mapModel === "xcentprime") {
        await setPDFCarImages(HyundaiXcent);
      } else if (mapModel === "venuenline") {
        await setPDFCarImages(venue);
      } else if (mapModel === "newtucson") {
        await setPDFCarImages(tucson);
      }
      let solidColors = [];
      
      if (catalogoueCarVariantPetrolData && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.length > 0) {
        
        await catalogoueCarVariantPetrolData && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map((car)=> solidColors.push(car.color));
        let uniqueColors = await Array.from(new Set(solidColors))
          let pdfWidth = ['auto'];
          catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map(i => {
            pdfWidth.push('*');
          });
          await setPdfWidthForCarVariant(pdfWidth);
          // await setAllNewi20TableHeader(allnewi20tableHeader);
          let FT = model.toLowerCase() === "konaev" ? "EV" : "Petrol";
          
        
        await setAllNewi20TableHeader([{text: model + " " + FT ,alignment:"center",fontSize:18,bold:false}]);
  
        let solidColorOnce = true;
  
        let carVariantTableDataArray = [{text:"PARTICULARS", fontSize:12,bold:false}];
        let exShowroomTableDataArray = [{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}];
        let tcsExShowroomTableDataArray = [{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}];
        let insuranceTableDataArray = [{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}];
        let rtoCompanyTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}];
        let rtoIndividualTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}];
        let rtoBHPassingTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}];
        let fourFifthExtendedWarrantyTableDataArray = [{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}];
        let rmkTableDataArray = [{text:'RMK', fontSize:12,bold:false}];
        let basicAccessoriesKitTableDataArray = [{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}];
        let rsaTableDataArray = [{text:'RSA', fontSize:12,bold:false}];
        let additionalPremiumForEngineProtectionTableDataArray = [{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}];
        let additionalPremiumforReturnToInvoiceTableDataArray = [{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}];
        let totalIndividualTableDataArray = [{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}];
        let totalCompanyTableDataArray = [{text:'TOTAL COMPANY', fontSize:12,bold:false}];
        let sheildOfTrustTableDataArray = [{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}];
        let effectiveDateFromArray = [{text:'Effective Date', fontSize:12,bold:false}];
  
        await catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map(async(car)=> {
      
          let carVariant;
          if (car && car.variantName) {
            carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
          }
          // modified by Vihang
          // modified at 16/05/2022
          // modification : new amount format added for all the prices and solid color changes
          // carVariantTableData.push({text:car.variantName ? carVariant : "0",bold:false});
          // exShowroomTableData.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
          console.log(exShowroomTableData,'----------------exShowroomTableData');
  
          carVariantTableDataArray.push({text:car.variantName ? carVariant : "0",bold:false});
          exShowroomTableDataArray.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
          tcsExShowroomTableDataArray.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0" );
          insuranceTableDataArray.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0" );
          rtoCompanyTableDataArray.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0" );
          rtoIndividualTableDataArray.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0" );
          rtoBHPassingTableDataArray.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0" );
          fourFifthExtendedWarrantyTableDataArray.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
          rmkTableDataArray.push(car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0");
          basicAccessoriesKitTableDataArray.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
          rsaTableDataArray.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
          additionalPremiumForEngineProtectionTableDataArray.push(car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0");
          additionalPremiumforReturnToInvoiceTableDataArray.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
          totalIndividualTableDataArray.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
          totalCompanyTableDataArray.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
          sheildOfTrustTableDataArray.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
          effectiveDateFromArray.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");
  
          setCarVariantTableData(carVariantTableDataArray);
          setExShowroomTableData(exShowroomTableDataArray);
          setTcsExShowroomTableData(tcsExShowroomTableDataArray);
          setInsuranceTableData(insuranceTableDataArray);
          setRtoBHPassingTableData(rtoBHPassingTableDataArray);
          setRtoIndividualTableData(rtoIndividualTableDataArray);
          setRtoCompanyTableData(rtoCompanyTableDataArray);
          setFourFifthExtendedWarrantyTableData(fourFifthExtendedWarrantyTableDataArray);
          setRmkTableData(rmkTableDataArray);
          setBasicAccessoriesKitTableData(basicAccessoriesKitTableDataArray);
          setRsaTableData(rsaTableDataArray);
          setAdditionalPremiumForEngineProtectionTableData(additionalPremiumForEngineProtectionTableDataArray);
          setAdditionalPremiumforReturnToInvoiceTableData(additionalPremiumforReturnToInvoiceTableDataArray);
          setTotalIndividualTableData(totalIndividualTableDataArray);
          setTotalCompanyTableData(totalCompanyTableDataArray);
          setSheildOfTrustTableData(sheildOfTrustTableDataArray);
          setEffectiveDateFrom(effectiveDateFromArray);
  
          // setCarVariantTableData([{text:"PARTICULARS", fontSize:12,bold:false}, {text:car.variantName ? carVariant : "0",bold:false}]);
          // setExShowroomTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}, car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" ]);
          // setTcsExShowroomTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}, car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0"]);
          // setInsuranceTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}, car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0"]);
          // setRtoBHPassingTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}, car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0"]);
          // setRtoIndividualTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}, car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0"]);
          // setRtoCompanyTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}, car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" +  "0"]);
          // setFourFifthExtendedWarrantyTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}, car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0"]);
          // setRmkTableData([{text:'RMK', fontSize:12,bold:false}, car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0"]);
          // setBasicAccessoriesKitTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}, car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0"]);
          // setRsaTableData([{text:'RSA', fontSize:12,bold:false}, car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0"]);
          // setAdditionalPremiumForEngineProtectionTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}, car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0"]);
          // setAdditionalPremiumforReturnToInvoiceTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}, car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0"]);
          // setTotalIndividualTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}, car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0"]);
          // setTotalCompanyTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}, car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0"]);
          // setSheildOfTrustTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}, car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0"]);
          // setEffectiveDateFrom([{text:'Effective Date', fontSize:12,bold:false}, car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA"]);
  
        }
        );
      }
  
      if (catalogoueCarVariantDieselData && catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.priceListItems && catalogoueCarVariantDieselData.data.priceListItems.length > 0) {
        let pdfWidth = ['auto'];
        catalogoueCarVariantDieselData.data.priceListItems.map(i => {
          pdfWidth.push('*');
        });
        await setPdfWidthForCarVariantDiesel(pdfWidth);
        modelDieseltableHeader[0].text = model + " Diesel";
        await setModelDieselTableHeader(modelDieseltableHeader);
        // modified by Vihang
        // modified at 5 May 2022
        // modification: solidcolor data integration for pricelist pdf
        // modified by Vihang
        // modified at 16 May 2022
        // modification: solidcolor changes for pricelist pdf
        let solidColors = [];
        await catalogoueCarVariantDieselData.data.priceListItems.map((car)=> solidColors.push(car.color));
        let uniqueColors = await Array.from(new Set(solidColors))
        let solidColorOnce = true;
        let carVariantDieselTableDataArray = [{text:"PARTICULARS", fontSize:12,bold:false}];
        let exShowroomDieselTableDataArray = [{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}];
        let tcsExShowroomDieselTableDataArray = [{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}];
        let insuranceDieselTableDataArray = [{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}];
        let rtoCompanyDieselTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}];
        let rtoIndividualDieselTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}];
        let rtoBHPassingDieselTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}];
        let fourFifthExtendedWarrantyDieselTableDataArray = [{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}];
        let rmkDieselTableDataArray = [{text:'RMK', fontSize:12,bold:false}];
        let basicAccessoriesKitDieselTableDataArray = [{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}];
        let rsaDieselTableDataArray = [{text:'RSA', fontSize:12,bold:false}];
        let additionalPremiumForEngineProtectionDieselTableDataArray = [{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}];
        let additionalPremiumforReturnToInvoiceDieselTableDataArray = [{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}];
        let totalIndividualDieselTableDataArray = [{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}];
        let totalCompanyDieselTableDataArray = [{text:'TOTAL COMPANY', fontSize:12,bold:false}];
        let sheildOfTrustDieselTableDataArray = [{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}];
        let effectiveDateDieselFromArray = [{text:'Effective Date', fontSize:12,bold:false}];
        await catalogoueCarVariantDieselData.data.priceListItems.map(async(car)=> {
          if (car && car.color) {
            if (solidColorOnce ) {
              let solidColor;
              await uniqueColors.map((colors,index,colorArr)=> {
                solidColor = colors[0].toUpperCase();
                solidColourDieselTableData[0].text = solidColourDieselTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ");
                solidColorOnce = false;
              });
            }
          }
          let carVariant;
          if (car && car.variantName) {
            carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
          }
          // modified by Vihang
          // modified at 16/05/2022
          // modification : new amount format added for all the prices and solid color changes
          carVariantDieselTableDataArray.push({text:car.variantName ? carVariant : "0",bold:false});
          exShowroomDieselTableDataArray.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
          tcsExShowroomDieselTableDataArray.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0" );
          insuranceDieselTableDataArray.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0" );
          rtoCompanyDieselTableDataArray.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0" );
          rtoIndividualDieselTableDataArray.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0" );
          rtoBHPassingDieselTableDataArray.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0" );
          fourFifthExtendedWarrantyDieselTableDataArray.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
          rmkDieselTableDataArray.push(car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0");
          basicAccessoriesKitDieselTableDataArray.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
          rsaDieselTableDataArray.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
          additionalPremiumForEngineProtectionDieselTableDataArray.push(car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0");
          additionalPremiumforReturnToInvoiceDieselTableDataArray.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
          totalIndividualDieselTableDataArray.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
          totalCompanyDieselTableDataArray.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
          sheildOfTrustDieselTableDataArray.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
          effectiveDateDieselFromArray.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");
  
          // await setSolidColourDieselTableData(solidColourDieselTableDataArray);
          await setCarVariantDieselTableData(carVariantDieselTableDataArray);
          await setExShowroomDieselTableData(exShowroomDieselTableDataArray);
          await setTcsExShowroomDieselTableData(tcsExShowroomDieselTableDataArray);
          await setInsuranceDieselTableData(insuranceDieselTableDataArray);
          await setRtoCompanyDieselTableData(rtoCompanyDieselTableDataArray);
          await setRtoBHPassingDieselTableData(rtoBHPassingDieselTableDataArray);
          await setRtoIndividualDieselTableData(rtoIndividualDieselTableDataArray);
          await setFourFifthExtendedWarrantyDieselTableData(fourFifthExtendedWarrantyDieselTableDataArray);
          await setRmkDieselTableData(rmkDieselTableDataArray);
          await setBasicAccessoriesKitDieselTableData(basicAccessoriesKitDieselTableDataArray);
          await setRsaDieselTableData(rsaDieselTableDataArray);
          await setAdditionalPremiumForEngineProtectionDieselTableData(additionalPremiumForEngineProtectionDieselTableDataArray);
          await setAdditionalPremiumforReturnToInvoiceDieselTableData(additionalPremiumforReturnToInvoiceDieselTableDataArray);
          await setTotalIndividualDieselTableData(totalIndividualDieselTableDataArray);
          await setTotalCompanyDieselTableData(totalCompanyDieselTableDataArray);
          await setSheildOfTrustDieselTableData(sheildOfTrustDieselTableDataArray);
          await setEffectiveDateDieselFrom(effectiveDateDieselFromArray);
  
  
          // setCarVariantDieselTableData([{text:"PARTICULARS", fontSize:12,bold:false}, {text:car.variantName ? carVariant : "0",bold:false}]);
          // setExShowroomDieselTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}, car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" ]);
          // setTcsExShowroomDieselTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}, car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0"]);
          // setInsuranceDieselTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}, car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0"]);
          // setRtoBHPassingDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}, car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0"]);
          // setRtoIndividualDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}, car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0"]);
          // setRtoCompanyDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}, car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" +  "0"]);
          // setFourFifthExtendedWarrantyDieselTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}, car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0"]);
          // setRmkDieselTableData([{text:'RMK', fontSize:12,bold:false}, car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0"]);
          // setBasicAccessoriesKitDieselTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}, car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0"]);
          // setRsaDieselTableData([{text:'RSA', fontSize:12,bold:false}, car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0"]);
          // setAdditionalPremiumForEngineProtectionDieselTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}, car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0"]);
          // setAdditionalPremiumforReturnToInvoiceDieselTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}, car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0"]);
          // setTotalIndividualDieselTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}, car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0"]);
          // setTotalCompanyDieselTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}, car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0"]);
          // setSheildOfTrustDieselTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}, car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0"]);
          // setEffectiveDateDieselFrom([{text:'Effective Date', fontSize:12,bold:false}, car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA"]);
  
        });
      }
  
      if (catalogoueCarVariantCNGData && catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.priceListItems && catalogoueCarVariantCNGData.data.priceListItems.length > 0) {
        console.log(catalogoueCarVariantCNGData,'------------catalogoueCarVariantCNGData----------');
        
        let pdfWidth = await Array(catalogoueCarVariantCNGData.data.priceListItems.length + 1).fill("*");
        await setPdfWidthForCarVariantCNG(pdfWidth);
        modelCNGtableHeader[0].text = model + " CNG";
        await setModelCNGTableHeader(modelCNGtableHeader);
        // modified by Vihang
        // modified at 5 May 2022
        // modification: solidcolor data integration for pricelist pdf
        // modified by Vihang
        // modified at 16 May 2022
        // modification: solidcolor changes for pricelist pdf
        await catalogoueCarVariantCNGData.data.priceListItems.map((car)=> solidColors.push(car.color));
        let uniqueColors = await Array.from(new Set(solidColors))
        let solidColorOnce = true;
  
        let carVariantCNGTableDataArray = [{text:"PARTICULARS", fontSize:12,bold:false}];
        let exShowroomCNGTableDataArray = [{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}];
        let tcsExShowroomCNGTableDataArray = [{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}];
        let insuranceCNGTableDataArray = [{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}];
        let rtoCompanyCNGTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}];
        let rtoIndividualCNGTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}];
        let rtoBHPassingCNGTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}];
        let fourFifthExtendedWarrantyCNGTableDataArray = [{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}];
        let rmkCNGTableDataArray = [{text:'RMK', fontSize:12,bold:false}];
        let basicAccessoriesKitCNGTableDataArray = [{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}];
        let rsaCNGTableDataArray = [{text:'RSA', fontSize:12,bold:false}];
        let additionalPremiumForEngineProtectionCNGTableDataArray = [{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}];
        let additionalPremiumforReturnToInvoiceCNGTableDataArray = [{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}];
        let totalIndividualCNGTableDataArray = [{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}];
        let totalCompanyCNGTableDataArray = [{text:'TOTAL COMPANY', fontSize:12,bold:false}];
        let sheildOfTrustCNGTableDataArray = [{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}];
        let effectiveDateCNGFromArray = [{text:'Effective Date', fontSize:12,bold:false}];
  
        await catalogoueCarVariantCNGData.data.priceListItems.map(async(car)=> {
          if (car && car.color) {
            let solidColors = await catalogoueCarVariantCNGData.data.priceListItems.filter((value, index, self) => index === self.findIndex((t) => t.color === car.color));
            if (solidColorOnce) {
              let solidColor;
              await uniqueColors.map((colors,index,colorArr)=> {
                solidColor = colors[0].toUpperCase();
                solidColourCNGTableData[0].text = solidColourCNGTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ") ;
                solidColorOnce = false;
              });
            }
          }
          let carVariant;
          if (car && car.variantName) {
            carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
          }
          console.log(car,"carcar");
          // modified by Vihang
          // modified at 16/05/2022
          // modification : removed rupees symbol from car variant data in CNG and new amount format added for all the prices
          
          carVariantCNGTableDataArray.push({text:car.variantName ? carVariant : "0",bold:false});
          exShowroomCNGTableDataArray.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
          tcsExShowroomCNGTableDataArray.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0" );
          insuranceCNGTableDataArray.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0" );
          rtoCompanyCNGTableDataArray.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0" );
          rtoIndividualCNGTableDataArray.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0" );
          rtoBHPassingCNGTableDataArray.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0" );
          fourFifthExtendedWarrantyCNGTableDataArray.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
          rmkCNGTableDataArray.push(car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0");
          basicAccessoriesKitCNGTableDataArray.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
          rsaCNGTableDataArray.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
          additionalPremiumForEngineProtectionCNGTableDataArray.push(car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0");
          additionalPremiumforReturnToInvoiceCNGTableDataArray.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
          totalIndividualCNGTableDataArray.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
          totalCompanyCNGTableDataArray.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
          sheildOfTrustCNGTableDataArray.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
          effectiveDateCNGFromArray.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");
  
          // await setSolidColourCNGTableData(solidColourCNGTableData);
          await setCarVariantCNGTableData(carVariantCNGTableDataArray);
          await setExShowroomCNGTableData(exShowroomCNGTableDataArray);
          await setTcsExShowroomCNGTableData(tcsExShowroomCNGTableDataArray);
          await setInsuranceCNGTableData(insuranceCNGTableDataArray);
          await setRtoCompanyCNGTableData(rtoCompanyCNGTableDataArray);
          await setRtoIndividualCNGTableData(rtoIndividualCNGTableDataArray);
          await setRtoBHPassingCNGTableData(rtoBHPassingCNGTableDataArray);
          await setFourFifthExtendedWarrantyCNGTableData(fourFifthExtendedWarrantyCNGTableDataArray);
          await setRmkCNGTableData(rmkCNGTableDataArray);
          await setBasicAccessoriesKitCNGTableData(basicAccessoriesKitCNGTableDataArray);
          await setRsaCNGTableData(rsaCNGTableDataArray);
          await setAdditionalPremiumForEngineProtectionCNGTableData(additionalPremiumForEngineProtectionCNGTableDataArray);
          await setAdditionalPremiumforReturnToInvoiceCNGTableData(additionalPremiumforReturnToInvoiceCNGTableDataArray);
          await setTotalIndividualCNGTableData(totalIndividualCNGTableDataArray);
          await setTotalCompanyCNGTableData(totalCompanyCNGTableDataArray);
          await setSheildOfTrustCNGTableData(sheildOfTrustCNGTableDataArray);
          await setCNGCarVariant(true);
          await setEffectiveDateCNGFrom(effectiveDateCNGFromArray);
  
          // setCarVariantCNGTableData([{text:"PARTICULARS", fontSize:12,bold:false}, {text:car.variantName ? carVariant : "0",bold:false}]);
          // setExShowroomCNGTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}, car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" ]);
          // setTcsExShowroomCNGTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}, car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0"]);
          // setInsuranceCNGTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}, car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0"]);
          // setRtoBHPassingCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}, car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0"]);
          // setRtoIndividualCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}, car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0"]);
          // setRtoCompanyCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}, car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" +  "0"]);
          // setFourFifthExtendedWarrantyCNGTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}, car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0"]);
          // setRmkCNGTableData([{text:'RMK', fontSize:12,bold:false}, car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0"]);
          // setBasicAccessoriesKitCNGTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}, car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0"]);
          // setRsaCNGTableData([{text:'RSA', fontSize:12,bold:false}, car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0"]);
          // setAdditionalPremiumForEngineProtectionCNGTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}, car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0"]);
          // setAdditionalPremiumforReturnToInvoiceCNGTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}, car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0"]);
          // setTotalIndividualCNGTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}, car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0"]);
          // setTotalCompanyCNGTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}, car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0"]);
          // setSheildOfTrustCNGTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}, car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0"]);
          // setEffectiveDateCNGFrom([{text:'Effective Date', fontSize:12,bold:false}, car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA"]);
  
        });
      }
  
      if (catalogoueCarVariantEVData && catalogoueCarVariantEVData.data && catalogoueCarVariantEVData.data.priceListItems && catalogoueCarVariantEVData.data.priceListItems.length > 0) {
        console.log(catalogoueCarVariantEVData,'------------catalogoueCarVariantEVData----------');
        
        let pdfWidth = await Array(catalogoueCarVariantEVData.data.priceListItems.length + 1).fill("*");
        await setPdfWidthForCarVariantEV(pdfWidth);
        modelEVtableHeader[0].text = model + " EV";
        await setModelEVTableHeader(modelEVtableHeader);
        // modified by Vihang
        // modified at 5 May 2022
        // modification: solidcolor data integration for pricelist pdf
        // modified by Vihang
        // modified at 16 May 2022
        // modification: solidcolor changes for pricelist pdf
        await catalogoueCarVariantEVData.data.priceListItems.map((car)=> solidColors.push(car.color));
        let uniqueColors = await Array.from(new Set(solidColors))
        let solidColorOnce = true;
  
        let carVariantEVTableDataArray = [{text:"PARTICULARS", fontSize:12,bold:false}];
        let exShowroomEVTableDataArray = [{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}];
        let tcsExShowroomEVTableDataArray = [{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}];
        let insuranceEVTableDataArray = [{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}];
        let rtoCompanyEVTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}];
        let rtoIndividualEVTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}];
        let rtoBHPassingEVTableDataArray = [{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}];
        let fourFifthExtendedWarrantyEVTableDataArray = [{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}];
        let rmkEVTableDataArray = [{text:'RMK', fontSize:12,bold:false}];
        let basicAccessoriesKitEVTableDataArray = [{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}];
        let rsaEVTableDataArray = [{text:'RSA', fontSize:12,bold:false}];
        let additionalPremiumForEngineProtectionEVTableDataArray = [{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}];
        let additionalPremiumforReturnToInvoiceEVTableDataArray = [{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}];
        let totalIndividualEVTableDataArray = [{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}];
        let totalCompanyEVTableDataArray = [{text:'TOTAL COMPANY', fontSize:12,bold:false}];
        let sheildOfTrustEVTableDataArray = [{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}];
        let effectiveDateEVFromArray = [{text:'Effective Date', fontSize:12,bold:false}];
  
  
        await catalogoueCarVariantEVData.data.priceListItems.map(async(car)=> {
          if (car && car.color) {
            let solidColors = await catalogoueCarVariantEVData.data.priceListItems.filter((value, index, self) => index === self.findIndex((t) => t.color === car.color));
            if (solidColorOnce) {
              let solidColor;
              await uniqueColors.map((colors,index,colorArr)=> {
                solidColor = colors[0].toUpperCase();
                solidColourEVTableData[0].text = solidColourEVTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ") ;
                solidColorOnce = false;
              });
            }
          }
          let carVariant;
          if (car && car.variantName) {
            carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
          }
          console.log(car,"carcar");
          
          carVariantEVTableDataArray.push({text:car.variantName ? carVariant : "0",bold:false});
          exShowroomEVTableDataArray.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
          tcsExShowroomEVTableDataArray.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0" );
          insuranceEVTableDataArray.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0" );
          rtoCompanyEVTableDataArray.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0" );
          rtoIndividualEVTableDataArray.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0" );
          rtoBHPassingEVTableDataArray.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0" );
          fourFifthExtendedWarrantyEVTableDataArray.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
          rmkEVTableDataArray.push(car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0");
          basicAccessoriesKitEVTableDataArray.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
          rsaEVTableDataArray.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
          additionalPremiumForEngineProtectionEVTableDataArray.push(car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0");
          additionalPremiumforReturnToInvoiceEVTableDataArray.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
          totalIndividualEVTableDataArray.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
          totalCompanyEVTableDataArray.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
          sheildOfTrustEVTableDataArray.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
          effectiveDateEVFromArray.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");
  
          // await setSolidColourEVTableData(solidColourEVTableData);
          await setCarVariantEVTableData(carVariantEVTableDataArray);
          await setExShowroomEVTableData(exShowroomEVTableDataArray);
          await setTcsExShowroomEVTableData(tcsExShowroomEVTableDataArray);
          await setInsuranceEVTableData(insuranceEVTableDataArray);
          await setRtoCompanyEVTableData(rtoCompanyEVTableDataArray);
          await setRtoIndividualEVTableData(rtoIndividualEVTableDataArray);
          await setRtoBHPassingEVTableData(rtoBHPassingEVTableDataArray);
          await setFourFifthExtendedWarrantyEVTableData(fourFifthExtendedWarrantyEVTableDataArray);
          await setRmkEVTableData(rmkEVTableDataArray);
          await setBasicAccessoriesKitEVTableData(basicAccessoriesKitEVTableDataArray);
          await setRsaEVTableData(rsaEVTableDataArray);
          await setAdditionalPremiumForEngineProtectionEVTableData(additionalPremiumForEngineProtectionEVTableDataArray);
          await setAdditionalPremiumforReturnToInvoiceEVTableData(additionalPremiumforReturnToInvoiceEVTableDataArray);
          await setTotalIndividualEVTableData(totalIndividualEVTableDataArray);
          await setTotalCompanyEVTableData(totalCompanyEVTableDataArray);
          await setSheildOfTrustEVTableData(sheildOfTrustEVTableDataArray);
          // await setEVCarVariant(true);
          await setEffectiveDateEVFrom(effectiveDateEVFromArray);
        });
      }
  
      
      await setDisablePDFButton(false);
    }

  //Modified By: Vihang Kale
  // Date: 09/06/2022
  // Modification: Pricelist function to download pricelist pdf and pricelist pdf sent to visitors mobile number
  // async function priceList(model) {
  //   let pdfName = "Price_List" + ".pdf";
  //   let docDefinition = {
  //     pageSize: 'A1',
  //     pageOrientation: PDFSTYLE.pageSetup.pageOrientationPortrait,
  //     pageMargins: PDFSTYLE.pageSetup.pageMargins,

  //     // background: function (page) {
  //     //     if (page > 1)
  //     //     return {

  //     //             columns: [
  //     //               { image:hyundai, width: 600, height:1000},
  //     //             ]
  //     //     };
  //     // },
  //     // footer(currentPage, pageCount,page) {
  //     //   if (page > 1)
  //     //     return {
  //     //         style: "pageFooter",
  //     //         columns: [
  //     //             {
  //     //                 text: [{ text: "Created by KDMS\n", width: 50 }]
  //     //             },

  //     //             { text: currentPage.toString() + " of " + pageCount, alignment: "right" }
  //     //         ]
  //     //     }
  //     // },
  //     content: [
  //       {
  //         alignment: 'justify',
  //         columns: [
  //           {
  //             // image:hyundaiLogo,
  //             // width:200,
  //             // height:80
  //             text:""
  //           },
  //           {
  //             text: 'KOTHARI CARS PVT LTD\nPRICE LIST W.E.F. 01 JAN 2023\n' + modelVariantName,
  //             alignment:"center",
  //             bold:false,
  //             fontSize:18
  //           },
  //           {
  //             // image:PDFCarImages,
  //             // width:150,
  //             // height:80
  //             text:""
  //           }
  //         ]
  //       },
  //       {
  //         alignment: 'justify',
  //         columns: [
  //           {
  //               text: 'Dear ' + ((contactData && contactData.firstName) ? contactData.firstName : '') + " " + ((contactData && contactData.lastName) ? contactData.lastName : '') + ', here is the price list for model of your interest.' + (variant ? " Variant of your interest is highlighted in yellow.": ""),
  //               width:"*"
  //           },
  //           {
  //             text: "",
  //             width:"*"
  //           },
  //         ]
  //       },
  //       {
  //         fontSize:16,
  //         table: {
  //           widths: ['*'],
  //           body: [
  //             [{
  //               text: "", alignment: 'center'
  //             }],
  //             [{
  //               text: allnewi20tableHeader, alignment: 'center'
  //             }]
  //           ]
  //         }
  //       },
  //       (carVariantTableData && carVariantTableData.length > 0) && (
  //         {
  //           fontSize:12,
  //           table: {
  //             widths:pdfWidthForCarVariant,
  //             body: [
  //               carVariantTableData,
  //               exShowroomTableData,
  //               tcsExShowroomTableData,
  //               insuranceTableData,
  //               rtoCompanyTableData,
  //               rtoIndividualTableData,
  //               fourFifthExtendedWarrantyTableData,
  //               rmkTableData,
  //               basicAccessoriesKitTableData,
  //               rsaTableData,
  //               additionalPremiumForEngineProtectionTableData,
  //               additionalPremiumforReturnToInvoiceTableData,
  //               totalIndividualTableData,
  //               totalCompanyTableData,
  //               sheildOfTrustTableData
  //             ]
  //           }
  //         }
  //       ),
  //       {
  //         fontSize:12,
  //         pageBreak: catalogueCarVariantDiesel && catalogueCarVariantDiesel.length > 0 ? "after" : "",
  //         table: {
  //           widths:["*"],
  //           body: [
  //             solidColourTableHeader,
  //             noCashPaymentTableHeader,
  //             termsAndConitionsTableHeader,
  //             termsAndConditionsTableData,
  //             termsAndConditionsDetailsTableData ,
  //             ShowroomITableData,
  //             ShowroomIITableData,
  //             ShowroomIIITableData,
  //             ShowroomIVTableData,
  //             ShowroomVTableData,
  //             ShowroomVITableData,
  //             work1TableData,
  //             work2TableData,
  //             work3TableData,
  //             work4TableData,
  //             depotTableData
  //           ]
  //         }
  //       },
  //       (catalogueCarVariantDiesel && catalogueCarVariantDiesel.length > 0) ? ({
  //         fontSize:16,
  //         table: {
  //           widths: ['*'],
  //           body: [
  //             [{
  //               text: 'PRICE LIST FOR ' + ((contactData && contactData.firstName) ? contactData.firstName : '') + " " + ((contactData && contactData.lastName) ? contactData.lastName : ''), alignment: 'center'
  //             }],
  //             [{
  //               text: modelDieseltableHeader, alignment: 'center'
  //             }]
  //           ]
  //         }
  //       }) : {},
  //       (catalogueCarVariantDiesel && catalogueCarVariantDiesel.length > 0) ? (
  //         {
  //           fontSize:12,
  //           table: {
  //             widths:pdfWidthForCarVariantDiesel,
  //             body: [
  //               carVariantDieselTableData,
  //               exShowroomDieselTableData,
  //               tcsExShowroomDieselTableData,
  //               insuranceDieselTableData,
  //               rtoCompanyDieselTableData,
  //               rtoIndividualDieselTableData,
  //               fourFifthExtendedWarrantyDieselTableData,
  //               rmkDieselTableData,
  //               basicAccessoriesKitDieselTableData,
  //               rsaDieselTableData,
  //               additionalPremiumForEngineProtectionDieselTableData,
  //               additionalPremiumforReturnToInvoiceDieselTableData,
  //               totalIndividualDieselTableData,
  //               totalCompanyDieselTableData,
  //               sheildOfTrustDieselTableData
  //             ]
  //           }
  //         }
  //       ) : {},
  //       (catalogueCarVariantDiesel && catalogueCarVariantDiesel.length > 0) ? ({
  //         fontSize:12,
  //         pageBreak: catalogueCarVariantCNG && catalogueCarVariantCNG.length > 0 ? "after" : "",
  //         table: {
  //           widths:["*"],
  //           body: [
  //             solidColourDieselTableData,
  //             ["Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED"],
  //             ["Terms & Conditions Details Overleaf"],
  //             ["TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi"],
  //             [{  ol: [
  //               'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
  //               "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
  //               "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
  //               "Model specifiction, features & Colours are subject to change without prior notice.",
  //               "Delivery - Subject to realisation of  DD / Cheque.",
  //               "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
  //               "Subject to jurisdiction of Pune Court only",
  //               "Two schemes cannot be clubbed together.",
  //               "Basic Accessories Kit Not Included Labour Charges",
  //               "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
  //               "Force majeure clause would be applicable to all deliveries.",
  //               "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
  //               "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
  //               "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
  //               "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
  //               "Income tax Pan no and address proof in original are necessary at the time of Booking.",
  //               "Purchase of Insurance Policy and Accessories from Dealer are optional.",
  //               "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
  //               "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
  //               "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
  //             ]} ],
  //             ["Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com."],
  //             ["Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com."],
  //             ["Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100"],
  //             ["Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525"],
  //             ["Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205"],
  //             ["Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com."],
  //             ["Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96"],
  //             ["Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237 "],
  //             ["Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506"],
  //             ["Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 "],
  //             ["Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  "]
  //           ]
  //         }
  //       }) : {},
  //       (catalogueCarVariantCNG && catalogueCarVariantCNG.length > 0) ? (
  //         {
  //           fontSize:16,
  //           table: {
  //             widths: ['*'],
  //             body: [
  //               [{
  //                 text: 'PRICE LIST FOR ' + ((contactData && contactData.firstName) ? contactData.firstName : '') + " " + ((contactData && contactData.lastName) ? contactData.lastName : ''), alignment: 'center'
  //               }],
  //               [{
  //                 text: modelCNGtableHeader, alignment: 'center'
  //               }]
  //             ]
  //           }
  //         }
  //       ) : {},
  //       (catalogueCarVariantCNG && catalogueCarVariantCNG.length > 0) ? (
  //         {
  //           fontSize:12,
  //           table: {
  //             widths:pdfWidthForCarVariantCNG,
  //             body: [
  //               // addEmptyValuesForRecord(priceListForPmc,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(modelCNGtableHeader,catalogueCarVariantCNG.length),
  //               carVariantCNGTableData,
  //               exShowroomCNGTableData,
  //               tcsExShowroomCNGTableData,
  //               insuranceCNGTableData,
  //               rtoCompanyCNGTableData,
  //               rtoIndividualCNGTableData,
  //               fourFifthExtendedWarrantyCNGTableData,
  //               rmkCNGTableData,
  //               basicAccessoriesKitCNGTableData,
  //               rsaCNGTableData,
  //               additionalPremiumForEngineProtectionCNGTableData,
  //               additionalPremiumforReturnToInvoiceCNGTableData,
  //               totalIndividualCNGTableData,
  //               totalCompanyCNGTableData,
  //               sheildOfTrustCNGTableData
  //               // addEmptyValuesForRecord(solidColourTableHeader,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(noCashPaymentTableHeader,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(termsAndConitionsTableHeader,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(termsAndConditionsTableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(termsAndConditionsDetailsTableData,catalogueCarVariantCNG.length) ,
  //               // addEmptyValuesForRecord(ShowroomITableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomIITableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomIIITableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomIVTableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomVTableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomVITableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(work1TableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(work2TableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(work3TableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(work4TableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(depotTableData,catalogueCarVariantCNG.length)
  //             ]
  //           }
  //         }
  //       ) : {},
  //       (catalogueCarVariantCNG && catalogueCarVariantCNG.length > 0) ? (
  //         {
  //           fontSize:12,
  //           table: {
  //             widths:["*"],
  //             body: [
  //               solidColourCNGTableData,
  //               ["Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED"],
  //               ["Terms & Conditions Details Overleaf"],
  //               ["TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi"],
  //               [{  ol: [
  //                 'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
  //                 "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
  //                 "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
  //                 "Model specifiction, features & Colours are subject to change without prior notice.",
  //                 "Delivery - Subject to realisation of  DD / Cheque.",
  //                 "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
  //                 "Subject to jurisdiction of Pune Court only",
  //                 "Two schemes cannot be clubbed together.",
  //                 "Basic Accessories Kit Not Included Labour Charges",
  //                 "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
  //                 "Force majeure clause would be applicable to all deliveries.",
  //                 "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
  //                 "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
  //                 "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
  //                 "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
  //                 "Income tax Pan no and address proof in original are necessary at the time of Booking.",
  //                 "Purchase of Insurance Policy and Accessories from Dealer are optional.",
  //                 "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
  //                 "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
  //                 "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
  //               ]} ],
  //               ["Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com."],
  //               ["Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com."],
  //               ["Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100"],
  //               ["Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525"],
  //               ["Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205"],
  //               ["Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com."],
  //               ["Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96"],
  //               ["Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237 "],
  //               ["Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506"],
  //               ["Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 "],
  //               ["Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  "]
  //             ]
  //           }
  //         }
  //       ) : {}

  //     ],
  //     styles: PDFSTYLE.styles,
  //     undertakingTable: {
  //       margin: [0, 0, 0, 10]
  //     },
  //     undertakingHeader: {
  //       fontSize: 18,
  //       bold:false,
  //       alignment:"center"
  //     }
  //   };
  //   // await pdfMake.createPdf(docDefinition).open();
  //   const pdfDocGenerator = pdfMake.createPdf(docDefinition);
  //   // const djjfkhjdfks = pdfMake.createPdf(docDefinition).open();

  //   pdfDocGenerator.getBuffer(async data => {
  //     let stringLength = await data.length - 'data:image/png;base64,'.length;
  //     let sizeInBytes = 4 * Math.ceil((stringLength / 3))*0.5624896334383812;
  //     let payload = {
  //       file: {
  //         name: pdfName,
  //         size: sizeInBytes,
  //         type: 'PDF',
  //         value: pdfName,
  //       },
  //       typeOfTask:"visit"
  //     }
  //     let fileDetails
  //     await axios.post(`${CONSTANTS.API_URL}/api/v1/file/getSignedUrl`, payload).then(async res => {
  //       if (res && res.data) {
  //         fileDetails = res.data;

  //         try {
  //           //  Save File on S3
  //           const opts = {
  //             headers: {
  //               name: 'Content-Type',
  //               value: 'application/pdf',
  //             }
  //           };
  //           const fileUpload = await axios.put(fileDetails.signedURL, data, opts);
  //           /*
  //             modified : Ashutosh G
  //             modified : 15/03/2024
  //             modification : aws link replaced with awsBucketLink
  //           */
  //           let mediaURL = `${awsBucketLink}/files/${fileDetails.uuid}/${pdfName}`
  //           let payload = {
  //             number: mobNumber,
  //             mediaURL,
  //             fileName: pdfName,
  //           }
  //           /*
  //             modified : Ashutosh G
  //             modified : 15/03/2024
  //             modification : sendWhatsappMessageWithMIM called to send price list to case client
  //           */
  //           await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
  //             "templateName": "visit_price_list",
  //             "parameters": [mediaURL],
  //             "phoneNumber": mobNumber
  //           });
  //           // if (sendPdfToWhatsapp.data === 200) {
  //           //   toastr.success('Price List sent sucessfully');
  //           // }
  //         } catch (e) {
  //           console.error(e);
  //         }
  //       }
  //     });
  //   });
  //   setCatalogueCarVariant([]);
  //   await setCarVariantTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   await setExShowroomTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   await setTcsExShowroomTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   await setInsuranceTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   await setRtoCompanyTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   await setRtoIndividualTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   await setFourFifthExtendedWarrantyTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   await setRmkTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   await setBasicAccessoriesKitTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   await setRsaTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumForEngineProtectionTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumforReturnToInvoiceTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   await setTotalIndividualTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   await setTotalCompanyTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   await setSheildOfTrustTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   await  setPriceListForPmc([{text:'PRICE LIST FOR ' + ((contactData && contactData.firstName) ? contactData.firstName : '') + " " + ((contactData && contactData.lastName) ? contactData.lastName : ''), fontSize:12,bold:false,alignment:"center"}]);
  //   await setAllNewi20TableHeader([{text:'All New i20',alignment:"center",fontSize:15,bold:false}]);
  //   await setSolidColourTableHeader([{text:'COLOUR : SOLID COLOUR = ', fontSize:12,bold:false}]);
  //   await setNoCashPaymentTableHeader([{text:'Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED', fontSize:12,bold:false}]);
  //   await setTermsAndConitionsTableHeader([{text:'Terms & Conditions Details Overleaf', fontSize:12,bold:false}]);
  //   await setTermsAndConitionsTableData([{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', fontSize:12,bold:false}]);
  //   await setTermsAndConitionsDetailsTableData([{
  //     colSpan:0,
  //     bold:false,
  //     ol: [
  //       'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
  //       "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
  //       "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
  //       "Model specifiction, features & Colours are subject to change without prior notice.",
  //       "Delivery - Subject to realisation of  DD / Cheque.",
  //       "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
  //       "Subject to jurisdiction of Pune Court only",
  //       "Two schemes cannot be clubbed together.",
  //       "Basic Accessories Kit Not Included Labour Charges",
  //       "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
  //       "Force majeure clause would be applicable to all deliveries.",
  //       "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
  //       "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
  //       "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
  //       "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
  //       "Income tax Pan no and address proof in original are necessary at the time of Booking.",
  //       "Purchase of Insurance Policy and Accessories from Dealer are optional.",
  //       "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
  //       "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
  //       "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
  //     ]

  //   }]);
  //   await setShowroomITableData([{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   await setShowroomIITableData([{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   await setShowroomIIITableData([{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', fontSize:12,bold:false}]);
  //   await setShowroomIVTableData([{text:'Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525', fontSize:12,bold:false}]);
  //   await setShowroomVTableData([{text:'"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205', fontSize:12,bold:false}]);
  //   await setShowroomVITableData([{text:'"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   await setWork1TableData([{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', fontSize:12,bold:false}]);
  //   await setWork2TableData([{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', fontSize:12,bold:false}]);
  //   await setWork3TableData([{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}]);
  //   await setWork4TableData([{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', fontSize:12,bold:false}]);
  //   await setDepotTableData([{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', fontSize:12,bold:false}]);
  //   await setCarVariantDieselTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   await setExShowroomDieselTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   await setTcsExShowroomDieselTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   await setInsuranceDieselTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   await setRtoCompanyDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   await setRtoIndividualDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   await setFourFifthExtendedWarrantyDieselTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   await setRmkDieselTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   await setBasicAccessoriesKitDieselTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   await setRsaDieselTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumForEngineProtectionDieselTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumforReturnToInvoiceDieselTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   await setTotalIndividualDieselTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   await setTotalCompanyDieselTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   await setSheildOfTrustDieselTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   await setModelDieselTableHeader([{text:'',alignment:"center",fontSize:12,bold:false}]);
  //   await setCarVariantCNGTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   await setExShowroomCNGTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   await setTcsExShowroomCNGTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   await setInsuranceCNGTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   await setRtoCompanyCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   await setRtoIndividualCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   await setFourFifthExtendedWarrantyCNGTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   await setRmkCNGTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   await setBasicAccessoriesKitCNGTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   await setRsaCNGTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumForEngineProtectionCNGTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumforReturnToInvoiceCNGTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   await setTotalIndividualCNGTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   await setTotalCompanyCNGTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   await setSheildOfTrustCNGTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   await setDisablePDFButton(true);
  // }

  function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  //   async function priceList() {
  
  //   /* ---------------------------------
  //      SAFE HELPERS
  //   ----------------------------------*/
  
  //   const safeRow = (row, colCount) => {
  //     if (!Array.isArray(row)) {
  //       return Array(colCount).fill('');
  //     }
  //     if (row.length < colCount) {
  //       return [...row, ...Array(colCount - row.length).fill('')];
  //     }
  //     if (row.length > colCount) {
  //       return row.slice(0, colCount);
  //     }
  //     return row;
  //   };
  
  //   const safeTable = (widths, rows) => {
  //     const colCount = widths.length;
  //     return {
  //       table: {
  //         widths,
  //         body: rows.map(r => safeRow(r, colCount))
  //       }
  //     };
  //   };
  
  //   const content = [];
  
  //   /* ---------------------------------
  //      HEADER
  //   ----------------------------------*/
  
  //   content.push({
  //     columns: [
  //       {
  //         image: await getBase64ImageFromURL(hyundaiLogo),
  //         width: 200,
  //         height: 80
  //       },
  //       {
  //         text:
  //           `KOTHARI CARS PVT LTD\n` +
  //           `PRICE LIST W.E.F. ${effectivePriceListDate}\n` +
  //           `${modelVariantName}`,
  //         alignment: "center",
  //         fontSize: 18
  //       },
  //       {
  //         image: await getBase64ImageFromURL(PDFCarImages),
  //         width: 150,
  //         height: 80
  //       }
  //     ]
  //   });
  
  //   /* ---------------------------------
  //      PETROL SECTION
  //   ----------------------------------*/
  
  //   if (carVariantTableData?.length) {
  //     content.push({
  //       fontSize: 16,
  //       // margin: [0, 0, 0, 25],
  //       table: {
  //         widths: ["*"],
          
  //         body: [
  //           [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
  //           [{ text: allnewi20tableHeader, alignment: "center" }]
  //         ]
  //       }
  //     });
  
  //     content.push({
  //       fontSize: 12,
  //       ...safeTable(pdfWidthForCarVariant, [
  //         effectiveDateFrom,
  //         carVariantTableData,
  //         exShowroomTableData,
  //         tcsExShowroomTableData,
  //         insuranceTableData,
  //         rtoCompanyTableData,
  //         rtoBHPassingTableData,
  //         rtoIndividualTableData,
  //         fourFifthExtendedWarrantyTableData,
  //         rmkTableData,
  //         basicAccessoriesKitTableData,
  //         rsaTableData,
  //         additionalPremiumForEngineProtectionTableData,
  //         additionalPremiumforReturnToInvoiceTableData,
  //         totalIndividualTableData,
  //         totalCompanyTableData,
  //         sheildOfTrustTableData,
          
  //       ])
  //     });
  
  //     /* ---------------------------------
  //       COMMON TERMS PAGE
  //     ----------------------------------*/
  
  //     content.push({
  //       fontSize: 12,
  //       table: {
  //         widths: ["*"],
  //         body: [
  //           // solidColourTableHeader,
  //           // noCashPaymentTableHeader,
  //           [{text:'Terms & Conditions Details Overleaf',bold:false}],
  //           [{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi',bold:false}],
  //           [{
  //           colSpan:0,
  //           bold:false,
  //           ol: termsAndConditionsData
  //         }],
  //           [{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.',bold:false}],
  //           [{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.',bold:false}],
  //           [{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100',bold:false}],
  //           [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
  //           [{text:"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205",bold:false}],
  //           [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
  //           [{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96',bold:false}],
  //           [{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ',bold:false}],
  //           [{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}],
  //           [{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ',bold:false}],
  //           [{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ',bold:false}]
  //         ].filter(Boolean)
  //       }
  //     });
  //   }
   
  
  //     /* ---------------------------------
  //      CNG SECTION
  //   ----------------------------------*/
  
  //   if (catalogueCarVariantCNG?.length) {
  //     console.log(rtoBHPassingCNGTableData,'-----------rtoBHPassingCNGTableData-----------');
  //     content.push({ text: '', margin: [0, 20] });
  //     // content.push({ pageBreak: "before", text: "" });
  
  //     content.push({
  //       fontSize: 16,
  //       table: {
  //         widths: ["*"],
  //         body: [
  //           [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
  //           [{ text: modelCNGtableHeader, alignment: "center" }]
  //         ]
  //       }
  //     });
  
  //     content.push({
  //       fontSize: 12,
  //       ...safeTable(pdfWidthForCarVariantCNG, [
  //         effectiveDateCNGFrom,
  //         carVariantCNGTableData,
  //         exShowroomCNGTableData,
  //         tcsExShowroomCNGTableData,
  //         insuranceCNGTableData,
  //         rtoCompanyCNGTableData,
  //         rtoIndividualCNGTableData,
  //         rtoBHPassingCNGTableData,
  //         fourFifthExtendedWarrantyCNGTableData,
  //         rmkCNGTableData,
  //         basicAccessoriesKitCNGTableData,
  //         rsaCNGTableData,
  //         additionalPremiumForEngineProtectionCNGTableData,
  //         additionalPremiumforReturnToInvoiceCNGTableData,
  //         totalIndividualCNGTableData,
  //         totalCompanyCNGTableData,
  //         sheildOfTrustCNGTableData,
          
  //       ])
  //     });
  
  //     /* ---------------------------------
  //       COMMON TERMS PAGE
  //     ----------------------------------*/
  
  //     content.push({
  //       fontSize: 12,
  //       table: {
  //         widths: ["*"],
  //         body: [
  //           // solidColourTableHeader,
  //           // noCashPaymentTableHeader,
  //           [{text:'Terms & Conditions Details Overleaf',bold:false}],
  //           [{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi',bold:false}],
  //           [{
  //           colSpan:0,
  //           bold:false,
  //           ol: termsAndConditionsDataCNG
  //         }],
  //           [{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.',bold:false}],
  //           [{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.',bold:false}],
  //           [{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100',bold:false}],
  //           [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
  //           [{text:"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205",bold:false}],
  //           [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
  //           [{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96',bold:false}],
  //           [{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ',bold:false}],
  //           [{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}],
  //           [{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ',bold:false}],
  //           [{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ',bold:false}]
  //         ].filter(Boolean)
  //       }
  //     });
  
  //   }
  
  //   /* ---------------------------------
  //      DIESEL SECTION
  //   ----------------------------------*/
  
  //   if (catalogueCarVariantDiesel?.length) {
  
  //     if (catalogueCarVariantCNG?.length || carVariantTableData?.length) {
  //       content.push({ pageBreak: "before", text: "" });
  //     }
      
  
  //     content.push({
  //       fontSize: 16,
  //       table: {
  //         widths: ["*"],
  //         body: [
  //           [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
  //           [{ text: modelDieseltableHeader, alignment: "center" }]
  //         ]
  //       }
  //     });
  
  //     content.push({
  //       fontSize: 12,
  //       ...safeTable(pdfWidthForCarVariantDiesel, [
  //         effectiveDateDieselFrom,
  //         carVariantDieselTableData,
  //         exShowroomDieselTableData,
  //         tcsExShowroomDieselTableData,
  //         insuranceDieselTableData,
  //         rtoCompanyDieselTableData,
  //         rtoIndividualDieselTableData,
  //         rtoBHPassingDieselTableData,
  //         fourFifthExtendedWarrantyDieselTableData,
  //         rmkDieselTableData,
  //         basicAccessoriesKitDieselTableData,
  //         rsaDieselTableData,
  //         additionalPremiumForEngineProtectionDieselTableData,
  //         additionalPremiumforReturnToInvoiceDieselTableData,
  //         totalIndividualDieselTableData,
  //         totalCompanyDieselTableData,
  //         sheildOfTrustDieselTableData,
  //         // effectiveDateDieselFrom
  //       ])
  //     });
  
  //         /* ---------------------------------
  //      COMMON TERMS PAGE
  //   ----------------------------------*/
  
  //   content.push({
  //     fontSize: 12,
  //     table: {
  //       widths: ["*"],
  //       body: [
  //         // solidColourTableHeader,
  //         // noCashPaymentTableHeader,
  //         [{text:'Terms & Conditions Details Overleaf',bold:false}],
  //         [{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi',bold:false}],
  //         [{
  //           colSpan:0,
  //           bold:false,
  //           ol: termsAndConditionsDataDiesel
  //         }],
  //         [{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.',bold:false}],
  //         [{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.',bold:false}],
  //         [{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100',bold:false}],
  //         [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
  //         [{text:"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205",bold:false}],
  //         [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
  //         [{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96',bold:false}],
  //         [{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ',bold:false}],
  //         [{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}],
  //         [{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ',bold:false}],
  //         [{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ',bold:false}]
  //       ].filter(Boolean)
  //     }
  //   });
  //   }
  
  
  //   /* ---------------------------------
  //      FINAL DOC
  //   ----------------------------------*/
  
  //   const docDefinition = {
  //     pageSize: "A1",
  //     pageOrientation: "portrait",
  //     pageMargins: PDFSTYLE.pageSetup.pageMargins,
  //     content: content.filter(Boolean),
  //     styles: PDFSTYLE.styles
  //   };
  
  //   /* ---------------------------------
  //      CREATE PDF (state reset AFTER)
  //   ----------------------------------*/
  
  //   pdfMake.createPdf(docDefinition).open();
  
  //   setTimeout(() => {
  //     setCatalogueCarVariant([]);
  //     setDisablePDFButton(true);
  //   }, 0);
  // }

    async function priceList() {
  console.log(exShowroomTableData,'++++++++++++++++++setExShowroomTableData');
  console.log(carVariantTableData,'+++++++++++++++++carVariantTableData');
  console.log(carVariantCNGTableData,'+++++++++++++++++carVariantCNGTableData');
  
  
  
    /* ---------------------------------
       SAFE HELPERS
    ----------------------------------*/
  
    const safeRow = (row, colCount) => {
      if (!Array.isArray(row)) {
        return Array(colCount).fill('');
      }
      if (row.length < colCount) {
        return [...row, ...Array(colCount - row.length).fill('')];
      }
      if (row.length > colCount) {
        return row.slice(0, colCount);
      }
      return row;
    };
  
    const safeTable = (widths, rows) => {
      const colCount = widths.length;
      return {
        table: {
          widths,
          body: rows.map(r => safeRow(r, colCount))
        }
      };
    };
  
    const content = [];
  
    /* ---------------------------------
       HEADER
    ----------------------------------*/
  
    content.push({
      columns: [
        {
          image: await getBase64ImageFromURL(hyundaiLogo),
          width: 200,
          height: 80
        },
        {
          text:
            `KOTHARI CARS PVT LTD\n` +
            `PRICE LIST W.E.F. ${effectivePriceListDate}\n` +
            `${modelVariantName}`,
          alignment: "center",
          fontSize: 18
        },
        {
          image: await getBase64ImageFromURL(PDFCarImages),
          width: 150,
          height: 80
        }
      ]
    });
  
    /* ---------------------------------
       PETROL SECTION
    ----------------------------------*/
  
    if (catalogueCarVariant?.length) {
      content.push({
        fontSize: 16,
        // margin: [0, 0, 0, 25],
        table: {
          widths: ["*"],
          
          body: [
            [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
            [{ text: allnewi20tableHeader, alignment: "center" }]
          ]
        }
      });
  
      content.push({
        fontSize: 12,
        ...safeTable(pdfWidthForCarVariant, [
          effectiveDateFrom,
          carVariantTableData,
          exShowroomTableData,
          tcsExShowroomTableData,
          insuranceTableData,
          rtoCompanyTableData,
          rtoBHPassingTableData,
          rtoIndividualTableData,
          fourFifthExtendedWarrantyTableData,
          rmkTableData,
          basicAccessoriesKitTableData,
          rsaTableData,
          sheildOfTrustTableData,
          additionalPremiumForEngineProtectionTableData,
          additionalPremiumforReturnToInvoiceTableData,
          totalIndividualTableData,
          totalCompanyTableData,
          
          
        ])
      });
  
      /* ---------------------------------
        COMMON TERMS PAGE
      ----------------------------------*/
  
      content.push({
        fontSize: 12,
        table: {
          widths: ["*"],
          body: [
            // solidColourTableHeader,
            // noCashPaymentTableHeader,
            [{text:'Terms & Conditions Details Overleaf',bold:false}],
            [{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi',bold:false}],
            [{
            colSpan:0,
            bold:false,
            ol: termsAndConditionsData
          }],
            [{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.',bold:false}],
            [{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.',bold:false}],
            [{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100',bold:false}],
            [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
            [{text:"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205",bold:false}],
            [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
            [{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96',bold:false}],
            [{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ',bold:false}],
            [{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}],
            [{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ',bold:false}],
            [{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ',bold:false}]
          ].filter(Boolean)
        }
      });
    }
   
      /* ---------------------------------
       CNG SECTION
    ----------------------------------*/
  
    if (catalogueCarVariantCNG?.length) {
      console.log(rtoBHPassingCNGTableData,'-----------rtoBHPassingCNGTableData-----------');
      content.push({ text: '', margin: [0, 20] });
      // content.push({ pageBreak: "before", text: "" });
  
      content.push({
        fontSize: 16,
        table: {
          widths: ["*"],
          body: [
            [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
            [{ text: modelCNGtableHeader, alignment: "center" }]
          ]
        }
      });
  
      content.push({
        fontSize: 12,
        ...safeTable(pdfWidthForCarVariantCNG, [
          effectiveDateCNGFrom,
          carVariantCNGTableData,
          exShowroomCNGTableData,
          tcsExShowroomCNGTableData,
          insuranceCNGTableData,
          rtoCompanyCNGTableData,
          rtoIndividualCNGTableData,
          rtoBHPassingCNGTableData,
          fourFifthExtendedWarrantyCNGTableData,
          rmkCNGTableData,
          basicAccessoriesKitCNGTableData,
          rsaCNGTableData,
          sheildOfTrustCNGTableData,
          additionalPremiumForEngineProtectionCNGTableData,
          additionalPremiumforReturnToInvoiceCNGTableData,
          totalIndividualCNGTableData,
          totalCompanyCNGTableData,
          
          
        ])
      });
  
      /* ---------------------------------
        COMMON TERMS PAGE
      ----------------------------------*/
  
      content.push({
        fontSize: 12,
        table: {
          widths: ["*"],
          body: [
            // solidColourTableHeader,
            // noCashPaymentTableHeader,
            [{text:'Terms & Conditions Details Overleaf',bold:false}],
            [{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi',bold:false}],
            [{
            colSpan:0,
            bold:false,
            ol: termsAndConditionsDataCNG
          }],
            [{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.',bold:false}],
            [{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.',bold:false}],
            [{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100',bold:false}],
            [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
            [{text:"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205",bold:false}],
            [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
            [{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96',bold:false}],
            [{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ',bold:false}],
            [{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}],
            [{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ',bold:false}],
            [{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ',bold:false}]
          ].filter(Boolean)
        }
      });
  
    }
  
    /* ---------------------------------
       DIESEL SECTION
    ----------------------------------*/
  
    if (catalogueCarVariantDiesel?.length) {
  
      if (catalogueCarVariantCNG?.length || carVariantTableData?.length) {
        content.push({ pageBreak: "before", text: "" });
      }
      
  
      content.push({
        fontSize: 16,
        table: {
          widths: ["*"],
          body: [
            [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
            [{ text: modelDieseltableHeader, alignment: "center" }]
          ]
        }
      });
  
      content.push({
        fontSize: 12,
        ...safeTable(pdfWidthForCarVariantDiesel, [
          effectiveDateDieselFrom,
          carVariantDieselTableData,
          exShowroomDieselTableData,
          tcsExShowroomDieselTableData,
          insuranceDieselTableData,
          rtoCompanyDieselTableData,
          rtoIndividualDieselTableData,
          rtoBHPassingDieselTableData,
          fourFifthExtendedWarrantyDieselTableData,
          rmkDieselTableData,
          basicAccessoriesKitDieselTableData,
          rsaDieselTableData,
          sheildOfTrustDieselTableData,
          additionalPremiumForEngineProtectionDieselTableData,
          additionalPremiumforReturnToInvoiceDieselTableData,
          totalIndividualDieselTableData,
          totalCompanyDieselTableData,
          
          // effectiveDateDieselFrom
        ])
      });
  
          /* ---------------------------------
       COMMON TERMS PAGE
    ----------------------------------*/
  
    content.push({
      fontSize: 12,
      table: {
        widths: ["*"],
        body: [
          // solidColourTableHeader,
          // noCashPaymentTableHeader,
          [{text:'Terms & Conditions Details Overleaf',bold:false}],
          [{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi',bold:false}],
          [{
            colSpan:0,
            bold:false,
            ol: termsAndConditionsDataDiesel
          }],
          [{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.',bold:false}],
          [{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.',bold:false}],
          [{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100',bold:false}],
          [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
          [{text:"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205",bold:false}],
          [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
          [{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96',bold:false}],
          [{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ',bold:false}],
          [{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}],
          [{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ',bold:false}],
          [{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ',bold:false}]
        ].filter(Boolean)
      }
    });
    }
  
    /* ---------------------------------
       EV SECTION
    ----------------------------------*/
  
    if (catalogueCarVariantEV?.length) {
      console.log(rtoBHPassingEVTableData,'-----------rtoBHPassingEVTableData-----------');
      content.push({ text: '', margin: [0, 20] });
      // content.push({ pageBreak: "before", text: "" });
  
      content.push({
        fontSize: 16,
        table: {
          widths: ["*"],
          body: [
            [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
            [{ text: modelEVtableHeader, alignment: "center" }]
          ]
        }
      });
  
      content.push({
        fontSize: 12,
        ...safeTable(pdfWidthForCarVariantEV, [
          effectiveDateEVFrom,
          carVariantEVTableData,
          exShowroomEVTableData,
          tcsExShowroomEVTableData,
          insuranceEVTableData,
          rtoCompanyEVTableData,
          rtoIndividualEVTableData,
          rtoBHPassingEVTableData,
          fourFifthExtendedWarrantyEVTableData,
          rmkEVTableData,
          basicAccessoriesKitEVTableData,
          rsaEVTableData,
          sheildOfTrustEVTableData,
          additionalPremiumForEngineProtectionEVTableData,
          additionalPremiumforReturnToInvoiceEVTableData,
          totalIndividualEVTableData,
          totalCompanyEVTableData,
          
          
        ])
      });
  
      /* ---------------------------------
        COMMON TERMS PAGE
      ----------------------------------*/
  
      content.push({
        fontSize: 12,
        table: {
          widths: ["*"],
          body: [
            // solidColourTableHeader,
            // noCashPaymentTableHeader,
            [{text:'Terms & Conditions Details Overleaf',bold:false}],
            [{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi',bold:false}],
            [{
            colSpan:0,
            bold:false,
            ol: termsAndConditionsDataEV
          }],
            [{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.',bold:false}],
            [{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.',bold:false}],
            [{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100',bold:false}],
            [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
            [{text:"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205",bold:false}],
            [{text:"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.",bold:false}],
            [{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96',bold:false}],
            [{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ',bold:false}],
            [{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}],
            [{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ',bold:false}],
            [{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ',bold:false}]
          ].filter(Boolean)
        }
      });
  
    }
  
  
  
    /* ---------------------------------
       FINAL DOC
    ----------------------------------*/
  
    const docDefinition = {
      pageSize: "A1",
      pageOrientation: "landscape",
      pageMargins: PDFSTYLE.pageSetup.pageMargins,
      content: content.filter(Boolean),
      styles: PDFSTYLE.styles
    };
  
    /* ---------------------------------
       CREATE PDF (state reset AFTER)
    ----------------------------------*/
  
    pdfMake.createPdf(docDefinition).open();
  
    setTimeout(() => {
      setCatalogueCarVariant([]);
      setCatalogueCarVariantDiesel([]);
      setCatalogueCarVariantCNG([]);
      setCatalogueCarVariantEV([]);
      setDisablePDFButton(true);
    }, 0);
  }

  async function setReopenTask(e, taskID, taskName) {
    e.preventDefault();
    setReopenFromTaskID(taskID);
    setShowDetailView(false);
    toastr.info('Case will be reopened from ' + taskName);
  }
  async function Truecaller(e) {
    e.preventDefault();
    let number = document.getElementById('customerPhoneNumber').style['border'] = "none"
    let payload = {
      number:mobNumber
    };
    let Truecaller = await axios.post(`${CONSTANTS.API_URL}/api/v1/truecaller`, payload);
    console.log(JSON.parse(JSON.stringify(Truecaller.data)).data,"TruecallerTruecallerTruecaller", Truecaller.data);
    if (Truecaller && Truecaller.data && Truecaller.data.data !== "null" && Truecaller.data.data[0]) {
      setTrueCallerData(Truecaller.data.data)
    }
    // await toggleTrueCallerInfo();
  }
  function toggleTrueCallerInfo() {
    setIsTruecallerDataShown(!isTruecallerDataShown);
  }
  return (
    <div class="profilemodalslide">
      <div class="profile-modal-container pos-relative bg-white overflow-hidden" >
        <div class="profile-modal">
        {/*<div class="m-t-36 cursor-pointer">
          <div class="bg-white flex-col h-64 text-408b8b ">
            <div class=" m-l-136">
              <Plus width="18px" height="18px" fill="#408b8b"/>
            </div>
            <div class="display-flex m-l-95">
            <Briefcase stroke='#408b8b'/>
            <p class="fs-12 m-l-8 p-t-2 text-408b8b">Add New Case</p>
            </div>
          </div>
        </div> */}
          <div class="profile-content-container bg-white m-t-32">
          {isVisitPopupOpen && (
            <div class="form-wizard-container bg-white m-l-95 lh-0.85" style="border:none;box-shadow:none;">
              <form method="POST" id="signup-form" class="signup-form " enctype="multipart/form-data" style="min-height: inherit;">
                {/* Wizard Tab 1 */}
                <fieldset i="" class="wizard-tab">
                  <div class="fieldset-flex m-t-50">
                    <div class="display-flex flex-direction-column">
                      <label class="fs-24 text-408b8b" >Customer Verification</label>
                      <div class="flex-direction-column">
                        <label for="your_review" class="wizard-label p-b-0 text-color-444 fs-16 m-t-40">Enter Mobile Number</label>
                        <div class='display-flex'>
                          <div class='w-209px'>
                          {/*
                            Bug: T1863 - Add New Case, Visit - Enter Mobile Number - Mobile Validation is missing
                            Modification: added maxLength 10
                            By: Arun Singh
                            Date: 20/05/2024
                          */}
                            <input autocomplete="off" class='fs-16 m-t-13'type="text" placeholder="+91-XXXXXXXXXX" id='customerPhoneNumber' autocomplete="off"
                            onInput={(e) => inputMask(e)} maxlength='10'/>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </fieldset>
                {/* Wizard Tab 2 */}
                <fieldset i="" class="wizard-tab" style="display: none;">
                  {isUserFound ? (
                    <div>
                      <div class="fieldset-flex m-t-50">
                        <div class="display-flex flex-direction-column">
                          <label class="modal-label text-center" >Previous Visit Details</label>
                          <figure class="m-t-20">
                            <svg class="animated" id="freepik_stories-usability-testing" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" version="1.1" width="290" height="200" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnsSvgjs="http://svgjs.com/svgjs"><style>{`svg#freepik_stories-usability-testing:not(.animated) .animable {opacity: 0;}`}{`svg#freepik_stories-usability-testing.animated #freepik--magnifying-glass--inject-41 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}  `}  {` @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }   `}  </style><g id="freepik--background-complete--inject-41" class="animable" style="transform-origin: 252.992px 244.07px;"><path d="M94.25,162.32h-4a3.16,3.16,0,0,0-1.22.13,1.95,1.95,0,0,0-1.19,1.5,3.42,3.42,0,0,0,0,.72v.74a3.36,3.36,0,0,1-.05.77,2,2,0,0,1-.9,1.3,1.87,1.87,0,0,1-.8.28c-.29,0-.57,0-.86,0H70.46a2.29,2.29,0,0,1-.58-.06,1.88,1.88,0,0,1-1-.62,2,2,0,0,1-.49-1.09c0-.21,0-.41,0-.61v-.61a3.18,3.18,0,0,0-.12-1.19,1.88,1.88,0,0,0-1.89-1.26H57a6.39,6.39,0,0,0-2.72.51A6.46,6.46,0,0,0,52,164.55a6.21,6.21,0,0,0-1.28,2.58c-.06.24-.08.49-.12.73s0,.41,0,.62V268a6.15,6.15,0,0,0,2.65,5.27,6.43,6.43,0,0,0,4,1.09H94c1.31,0,2.63,0,3.91,0a6.13,6.13,0,0,0,3.51-1.36,6.27,6.27,0,0,0,1.27-1.4,5.93,5.93,0,0,0,.77-1.7,6.44,6.44,0,0,0,.24-1.85v-9.32c0-19.59,0-37.23,0-52s0-26.8,0-35.09V168.7a6.4,6.4,0,0,0-.45-2.5,6,6,0,0,0-1.18-1.85,5.85,5.85,0,0,0-1.41-1.15,5.93,5.93,0,0,0-2.32-.82c-.28,0-.49,0-.63-.06H94.25Z" style="fill: rgb(250, 250, 250); transform-origin: 77.1419px 218.34px;" id="eljqgan4wqh5m" class="animable"></path><path d="M445.92,162.32h-4.05a3.2,3.2,0,0,0-1.22.13,2,2,0,0,0-1.19,1.5,5.62,5.62,0,0,0,0,.72v.74a4,4,0,0,1,0,.77,2,2,0,0,1-.91,1.3,1.83,1.83,0,0,1-.79.28c-.29,0-.57,0-.86,0H422.14a2.41,2.41,0,0,1-.59-.06,1.89,1.89,0,0,1-1-.62,2.1,2.1,0,0,1-.5-1.09c0-.21,0-.41,0-.61v-.61a3.18,3.18,0,0,0-.12-1.19,1.88,1.88,0,0,0-1.89-1.26h-9.34a6.21,6.21,0,0,0-5,2.2,6.21,6.21,0,0,0-1.28,2.58c-.07.24-.08.49-.13.73s0,.41,0,.62V268a6.43,6.43,0,0,0,.24,2,6.17,6.17,0,0,0,2.41,3.31,6.4,6.4,0,0,0,4,1.09H445.7c1.31,0,2.62,0,3.91,0a6.16,6.16,0,0,0,3.51-1.36,6.52,6.52,0,0,0,1.27-1.4,5.93,5.93,0,0,0,.77-1.7,6.44,6.44,0,0,0,.24-1.85v-9.32c0-19.59,0-37.23,0-52s0-26.8,0-35.09c0-1,0-2,0-2.93a6.23,6.23,0,0,0-1.63-4.35,6,6,0,0,0-1.41-1.15,6,6,0,0,0-2.33-.82c-.27,0-.48,0-.63-.06h-3.55Z" style="fill: rgb(250, 250, 250); transform-origin: 428.835px 218.361px;" id="el1nj3u0ci1vm" class="animable"></path><path d="M216.31,82.83a20.16,20.16,0,0,1,.13,5.37L220.58,91l-3,7.69L212.68,98a20.07,20.07,0,0,1-3.7,3.9l1,4.88-7.54,3.35-3-4a19.75,19.75,0,0,1-5.37.13l-2.78,4.14-7.69-3,.72-4.93a20.37,20.37,0,0,1-3.89-3.71l-4.89,1-3.34-7.54,4-3a20.15,20.15,0,0,1-.13-5.37l-4.14-2.77,3-7.7,4.93.72a20,20,0,0,1,3.7-3.89l-1-4.89L190.08,62l3,4a20.59,20.59,0,0,1,5.37-.13l2.78-4.14,7.69,3-.72,4.93a20,20,0,0,1,3.89,3.7l4.89-1,3.34,7.53-4,3Zm-11.83-.06A8.85,8.85,0,1,0,200,94.44,8.83,8.83,0,0,0,204.48,82.77Z" style="fill: rgb(224, 224, 224); fill-rule: evenodd; transform-origin: 196.255px 86.065px;" id="el6icpajmqclo" class="animable"></path><path d="M210.31,38.12a13.64,13.64,0,0,1,.09,3.55l2.73,1.84-2,5.08-3.26-.47a13.24,13.24,0,0,1-2.45,2.57l.64,3.23-5,2.21-2-2.64a13.64,13.64,0,0,1-3.55.09l-1.83,2.73-5.09-2,.48-3.26a13.58,13.58,0,0,1-2.58-2.45l-3.23.64-2.21-5,2.64-2a13.21,13.21,0,0,1-.08-3.55L181,37l2-5.09,3.26.48a13.24,13.24,0,0,1,2.45-2.57L188,26.54l5-2.21,2,2.64a13.22,13.22,0,0,1,3.55-.09l1.84-2.74,5.08,2-.48,3.26a13.29,13.29,0,0,1,2.58,2.45l3.23-.64,2.21,5-2.64,2Zm-7.82,0a5.85,5.85,0,1,0-3,7.72A5.84,5.84,0,0,0,202.49,38.08Z" style="fill: rgb(245, 245, 245); fill-rule: evenodd; transform-origin: 197.065px 40.225px;" id="el9xcy8nh1hq4" class="animable"></path><path d="M352.74,369.07a23.86,23.86,0,0,1,.16,6.31l4.85,3.25-3.48,9-5.78-.84a23.41,23.41,0,0,1-4.34,4.56l1.13,5.74L336.44,401,333,396.34a23.79,23.79,0,0,1-6.3.16l-3.26,4.85-9-3.48.85-5.78a23.74,23.74,0,0,1-4.57-4.34l-5.73,1.13L301,380l4.68-3.49a23.37,23.37,0,0,1-.15-6.3L300.67,367l3.48-9,5.78.85a23.8,23.8,0,0,1,4.35-4.57l-1.13-5.73L322,344.6l3.49,4.68a23.44,23.44,0,0,1,6.31-.15l3.25-4.86,9,3.48-.84,5.78a23.46,23.46,0,0,1,4.56,4.35l5.74-1.13,3.92,8.83-4.69,3.49ZM338.87,369a10.37,10.37,0,1,0-5.27,13.68A10.37,10.37,0,0,0,338.87,369Z" style="fill: rgb(224, 224, 224); fill-rule: evenodd; transform-origin: 329.21px 372.81px;" id="el39vzmcj7klq" class="animable"></path><path d="M329.4,422.62a14.12,14.12,0,0,1,.09,3.67l2.83,1.89-2,5.26-3.37-.49a13.83,13.83,0,0,1-2.53,2.66l.66,3.34-5.15,2.28-2-2.73a13.71,13.71,0,0,1-3.67.09l-1.9,2.83-5.26-2,.5-3.36a13.6,13.6,0,0,1-2.66-2.54l-3.34.66L299.25,429l2.73-2a13.7,13.7,0,0,1-.09-3.67l-2.83-1.9,2-5.25,3.37.49A13.83,13.83,0,0,1,307,414l-.66-3.34,5.15-2.28,2,2.73a13.31,13.31,0,0,1,3.67-.09l1.9-2.83,5.25,2-.49,3.37a13.85,13.85,0,0,1,2.66,2.53l3.34-.66,2.29,5.15-2.73,2Zm-8.08,0a6,6,0,1,0-3.08,8A6.06,6.06,0,0,0,321.32,422.58Z" style="fill: rgb(245, 245, 245); fill-rule: evenodd; transform-origin: 315.69px 424.805px;" id="elefpwj5nxuc" class="animable"></path><path d="M243.44,62.87a11.86,11.86,0,0,1,.08,3.2L246,67.73l-1.77,4.59-2.94-.43a12.5,12.5,0,0,1-2.21,2.33l.57,2.92-4.5,2-1.77-2.38a12.36,12.36,0,0,1-3.21.08L228.5,79.3l-4.59-1.77.43-3A11.88,11.88,0,0,1,222,72.37l-2.92.58-2-4.5,2.38-1.78a12.34,12.34,0,0,1-.08-3.21l-2.47-1.65,1.77-4.6,3,.43a11.83,11.83,0,0,1,2.21-2.32l-.58-2.92,4.5-2,1.78,2.39a11.92,11.92,0,0,1,3.21-.08l1.66-2.47L239,52,238.59,55a12.44,12.44,0,0,1,2.32,2.21l2.92-.57,2,4.5-2.39,1.78Zm-7.06,0a5.28,5.28,0,1,0-2.69,7A5.28,5.28,0,0,0,236.38,62.83Z" style="fill: rgb(235, 235, 235); fill-rule: evenodd; transform-origin: 231.455px 64.77px;" id="ell0fma23m7m" class="animable"></path><path d="M420.91,395.3a19.3,19.3,0,0,1,12-1.46c2.18.36,4.45,1,5.93,2.65s1.77,4.51.07,5.92a5.77,5.77,0,0,1-3.74.95c-3.18,0-6.7-.6-9.23,1.31-1.45,1.09-2.41,2.9-4.14,3.44a4.1,4.1,0,0,1-4.5-2,7,7,0,0,1-.51-5.16A7.88,7.88,0,0,1,420.91,395.3Z" style="fill: rgb(235, 235, 235); transform-origin: 428.293px 400.84px;" id="elfcmbpdauwin" class="animable"></path><path d="M412.54,379.15c2.23,3.19,6.57,2.13,8.59.18s2.86-4.77,3.63-7.46c1.77-6.14,3.56-12.59,2.24-18.85a10.39,10.39,0,0,0-2.41-5.13,5.46,5.46,0,0,0-5.18-1.73c-2.19.58-3.55,2.72-4.54,4.76a44.94,44.94,0,0,0-4.44,19.29c0,3.11.36,6.37,2.11,8.94" style="fill: rgb(235, 235, 235); transform-origin: 418.943px 363.615px;" id="elbxunnsvpck" class="animable"></path><path d="M406.41,383.72a11.61,11.61,0,0,0,1.8-10.68,20.56,20.56,0,0,0-6.32-9.17,34.2,34.2,0,0,0-11.33-6.69,12.07,12.07,0,0,0-5.09-.86,5.36,5.36,0,0,0-4.28,2.58c-1.19,2.28-.05,5,1.19,7.29a86.62,86.62,0,0,0,7.44,11.32c2.23,2.88,4.78,5.72,8.18,7s6.93,1.15,8.73-1.21" style="fill: rgb(235, 235, 235); transform-origin: 394.74px 370.811px;" id="el6umppqgp0rx" class="animable"></path><path d="M412.39,427.26a7.15,7.15,0,0,0,.2-1.45q.15-1.59.39-4a54.23,54.23,0,0,1,.89-5.8,45.6,45.6,0,0,1,2.1-6.85,25.18,25.18,0,0,1,3.5-6.19,13.14,13.14,0,0,1,4.42-3.68,12.32,12.32,0,0,1,3.72-1.15,7.51,7.51,0,0,0,1.45-.21,6.2,6.2,0,0,0-1.47,0,11.42,11.42,0,0,0-3.88,1,13.15,13.15,0,0,0-4.67,3.71,25.06,25.06,0,0,0-3.62,6.32,42.09,42.09,0,0,0-2.09,7,50.86,50.86,0,0,0-.78,5.87c-.12,1.68-.17,3-.19,4A7,7,0,0,0,412.39,427.26Z" style="fill: rgb(224, 224, 224); transform-origin: 420.698px 412.573px;" id="ellemz9edx5j" class="animable"></path><path d="M412.66,424.21a3.16,3.16,0,0,0,0-.67v-1.92c0-1.67,0-4.09.08-7.07.15-6,.66-12.38,1.65-21.43.94-8.51,2.2-18.41,3.53-24.85.29-1.47.58-2.79.85-3.94s.48-2.15.69-3,.33-1.38.45-1.87a3.63,3.63,0,0,0,.12-.66,2.81,2.81,0,0,0-.24.63c-.14.48-.33,1.09-.56,1.84s-.5,1.79-.79,2.94-.62,2.47-.93,3.93a216.85,216.85,0,0,0-3.71,23.06c-1,9.07-1.44,17.33-1.48,23.3,0,3,0,5.41.1,7.08.05.79.09,1.42.12,1.93A2.49,2.49,0,0,0,412.66,424.21Z" style="fill: rgb(224, 224, 224); transform-origin: 416.175px 391.505px;" id="elz95o87e3in" class="animable"></path><path d="M412.7,408.29a12.4,12.4,0,0,0,0-2c-.08-1.29-.25-3.16-.62-5.44a69.6,69.6,0,0,0-1.77-7.93,64.71,64.71,0,0,0-3.31-9.39,50.1,50.1,0,0,0-9.74-15.16,23.94,23.94,0,0,0-2.29-2.13c-.35-.29-.66-.59-1-.83l-.89-.61a12.3,12.3,0,0,0-1.69-1.08,60.51,60.51,0,0,1,5.54,4.94,52.72,52.72,0,0,1,9.5,15.11,73.8,73.8,0,0,1,3.33,9.3c.87,2.91,1.45,5.59,1.89,7.85s.65,4.11.8,5.39A12.35,12.35,0,0,0,412.7,408.29Z" style="fill: rgb(224, 224, 224); transform-origin: 402.065px 386.005px;" id="elglytojsez1" class="animable"></path><polygon points="397.31 436.38 398.9 458.25 426.99 458.25 428.59 436.38 397.31 436.38" style="fill: rgb(224, 224, 224); transform-origin: 412.95px 447.315px;" id="elu3te46jaucd" class="animable"></polygon><rect x="394.59" y="427.76" width="37.34" height="8.62" style="fill: rgb(224, 224, 224); transform-origin: 413.26px 432.07px;" id="eleijlz2gtr5a" class="animable"></rect><polygon points="394.6 457.41 394.6 459.8 396.35 459.8 431.32 459.8 431.32 457.41 394.6 457.41" style="fill: rgb(235, 235, 235); transform-origin: 412.96px 458.605px;" id="eldfa8m7c662" class="animable"></polygon><polygon points="398.07 464 396.35 459.8 429.98 459.8 427.98 464 398.07 464" style="fill: rgb(224, 224, 224); transform-origin: 413.165px 461.9px;" id="elrnellyqazs" class="animable"></polygon><path d="M428.07,443.53a2,2,0,0,1-.14.2l-.42.56-1.63,2.09-.07.09-.07-.1-4-5.55H422l-4,5.6-.13.17-.13-.16-4.7-5.58h.27l-.26.33-4.19,5.26-.14.17-.13-.18-4-5.6h.23L400,446.38l-.08.1-.07-.11-1.53-2.56-.39-.69a1.06,1.06,0,0,1-.12-.24,1,1,0,0,1,.17.22c.11.17.25.39.43.65l1.6,2.52h-.15l4.8-5.62.12-.15.11.16,4,5.57h-.27l4.19-5.27.26-.33.13-.16.14.16,4.68,5.6h-.26c1.44-2,2.79-3.89,4-5.58l.11-.16.12.16,3.93,5.62h-.14l1.7-2,.46-.53C428,443.58,428.06,443.52,428.07,443.53Z" style="fill: rgb(245, 245, 245); transform-origin: 412.94px 443.54px;" id="elm2mnjcwopn" class="animable"></path><path d="M429,436.24c0,.09-7,.17-15.72.17s-15.72-.08-15.72-.17,7-.18,15.72-.18S429,436.14,429,436.24Z" style="fill: rgb(245, 245, 245); transform-origin: 413.28px 436.235px;" id="eltu3yrlwdnkq" class="animable"></path><path d="M430.4,460c0,.1-7.65.18-17.08.18s-17.09-.08-17.09-.18,7.65-.17,17.09-.17S430.4,459.94,430.4,460Z" style="fill: rgb(245, 245, 245); transform-origin: 413.315px 460.005px;" id="el8tf82tur70r" class="animable"></path></g><g id="freepik--Floor--inject-41" class="animable" style="transform-origin: 250px 464.46px;"><path d="M462.5,464.46c0,.15-95.15.26-212.49.26s-212.51-.11-212.51-.26,95.13-.26,212.51-.26S462.5,464.32,462.5,464.46Z" style="fill: rgb(69, 90, 100); transform-origin: 250px 464.46px;" id="eleuwz05ignse" class="animable"></path></g><g id="freepik--Plant--inject-41" class="animable" style="transform-origin: 115.481px 387.996px;"><rect x="88.11" y="417.08" width="56.43" height="7.75" style="fill: rgb(38, 50, 56); transform-origin: 116.325px 420.955px;" id="elwd7er3q4pkc" class="animable"></rect><path d="M144.63,424.93H88V417h56.62Zm-56.42-.19h56.23v-7.56H88.21Z" style="fill: rgb(38, 50, 56); transform-origin: 116.315px 420.965px;" id="eloapm0nh589e" class="animable"></path><polygon points="93.34 422.25 101.46 462.32 131.51 462.32 139.37 424.83 93.34 422.25" style="fill: rgb(38, 50, 56); transform-origin: 116.355px 442.285px;" id="elxa8g81w505" class="animable"></polygon><polygon points="93.34 458.53 97.67 464.49 134.2 464.49 139.37 458.53 93.34 458.53" style="fill: rgb(69, 90, 100); transform-origin: 116.355px 461.51px;" id="eldrecrj0ys3" class="animable"></polygon><path d="M114.2,423.43c-.11,0-.25-18.57-.31-41.46s0-41.46.08-41.46.25,18.56.32,41.46S114.32,423.42,114.2,423.43Z" style="fill: rgb(38, 50, 56); transform-origin: 114.095px 381.97px;" id="ela32wa7e668n" class="animable"></path><path d="M126.77,377a1.45,1.45,0,0,1-.15.43l-.5,1.2c-.11.27-.24.56-.37.87s-.24.68-.38,1-.28.79-.43,1.21-.27.9-.42,1.38a58.53,58.53,0,0,0-1.58,6.91,85.78,85.78,0,0,0-.87,8.64,115.89,115.89,0,0,0,.45,15.78c.18,2,.36,3.64.49,4.77l.15,1.29a2,2,0,0,1,0,.46,2.07,2.07,0,0,1-.1-.45c-.06-.33-.13-.76-.22-1.28-.18-1.12-.41-2.75-.63-4.76a104.16,104.16,0,0,1-.56-15.83,78.24,78.24,0,0,1,.91-8.68,52,52,0,0,1,1.67-6.93c.16-.49.29-.95.45-1.38s.32-.83.46-1.21.29-.72.41-1,.28-.6.41-.86l.57-1.17A2.14,2.14,0,0,1,126.77,377Z" style="fill: rgb(38, 50, 56); transform-origin: 124.167px 398.97px;" id="elb5vews7gvps" class="animable"></path><path d="M125.33,362a4.81,4.81,0,0,1-.18.61c-.14.43-.34,1-.59,1.73-.13.37-.27.79-.43,1.24l-.45,1.5c-.33,1.07-.71,2.29-1.05,3.67-.18.68-.37,1.4-.57,2.14s-.35,1.54-.53,2.35c-.39,1.62-.68,3.37-1,5.2-.62,3.69-1.17,7.77-1.55,12.07s-.51,8.41-.57,12.15,0,7.11.19,9.94c0,1.41.15,2.69.22,3.81s.13,2.09.2,2.88.11,1.36.14,1.81a2.82,2.82,0,0,1,0,.64,6.21,6.21,0,0,1-.1-.63c-.05-.45-.12-1.05-.21-1.81s-.19-1.75-.28-2.87-.2-2.4-.27-3.82c-.19-2.83-.27-6.2-.28-9.95s.18-7.87.54-12.19.94-8.4,1.58-12.09c.38-1.84.68-3.6,1.09-5.21.19-.81.37-1.6.55-2.35s.4-1.46.59-2.15c.36-1.37.76-2.59,1.11-3.66.18-.53.34-1,.49-1.49s.33-.86.47-1.24c.27-.71.49-1.28.66-1.7A3.35,3.35,0,0,1,125.33,362Z" style="fill: rgb(38, 50, 56); transform-origin: 121.675px 392.87px;" id="el4qyf4g37x8p" class="animable"></path><path d="M110.64,426.71a.74.74,0,0,1,0-.22c0-.16,0-.38,0-.64,0-.59-.1-1.41-.17-2.45-.13-2.17-.32-5.25-.56-9-.49-7.63-1.2-18.18-2.48-29.77-.66-5.8-1.42-11.31-2.21-16.3-.42-2.49-.81-4.86-1.24-7.07s-.82-4.26-1.22-6.13-.78-3.56-1.11-5-.65-2.75-.91-3.79-.45-1.81-.59-2.39c0-.26-.1-.46-.14-.63s0-.21,0-.21,0,.07.07.2.11.37.18.62l.66,2.37c.29,1,.63,2.3,1,3.78s.78,3.15,1.17,5,.86,3.91,1.27,6.13.84,4.58,1.27,7.07c.81,5,1.59,10.51,2.25,16.31,1.28,11.61,1.94,22.17,2.36,29.81.21,3.82.35,6.91.44,9.05l.09,2.46v.86Z" style="fill: rgb(38, 50, 56); transform-origin: 105.381px 384.94px;" id="el7z212d61bzl" class="animable"></path><path d="M113.74,349.43c-.24-2.63-2.9-4.61-5.54-4.64a8.74,8.74,0,0,0-6.72,3.65,21.12,21.12,0,0,0-3.23,7.18,48.72,48.72,0,0,0-2,19.1A28.88,28.88,0,0,0,104.21,392,3.25,3.25,0,0,0,107,393.2a3.3,3.3,0,0,0,1.44-.89,42.8,42.8,0,0,0,13.88-32.52,13.17,13.17,0,0,0-1.74-7c-1.35-2-4.49-4.18-6.79-3.37" style="fill: rgb(33, 158, 188); transform-origin: 109.183px 369px;" id="el6ajp6xfmdwu" class="animable"></path><path d="M94,328.37,90.3,335.1c-.08.16-.2.34-.38.35s-.34-.17-.45-.33q-4.91-7.55-9.83-15.09l2.27-1.29Z" style="fill: rgb(33, 158, 188); transform-origin: 86.82px 327.095px;" id="el6vmrllhmzc" class="animable"></path><g id="el4zg7r9fi6gv"><g style="opacity: 0.2; transform-origin: 86.82px 327.095px;" class="animable"><path d="M94,328.37,90.3,335.1c-.08.16-.2.34-.38.35s-.34-.17-.45-.33q-4.91-7.55-9.83-15.09l2.27-1.29Z" id="el3ifk7v7jqhf" class="animable" style="transform-origin: 86.82px 327.095px;"></path></g></g><path d="M114,340.51l-33.55-19.8a1.54,1.54,0,0,1-.81-.82c-.14-.5.24-1,.59-1.35a23.12,23.12,0,0,1,17.93-7,20.49,20.49,0,0,1,16.21,10.08c3.24,5.78,3.34,13.44-.37,18.93" style="fill: rgb(33, 158, 188); transform-origin: 98.2012px 326.026px;" id="elwifuu6p10a" class="animable"></path><path d="M85.26,314.39a2.19,2.19,0,0,1,.44-.05,12.31,12.31,0,0,1,1.27-.06,24.45,24.45,0,0,1,4.65.37,27.18,27.18,0,0,1,21.71,19.64,25.8,25.8,0,0,1,.84,4.6c.06.55,0,.69,0,1a1.77,1.77,0,0,1-.26.73,6.07,6.07,0,0,0,.05-1.69A28,28,0,0,0,87,314.43,16.26,16.26,0,0,1,85.26,314.39Z" style="fill: rgb(38, 50, 56); transform-origin: 99.7283px 327.448px;" id="el79b9j0gl6t5" class="animable"></path><path d="M109.43,326.84a8.15,8.15,0,0,1-1.7.77c-1.06.43-2.56,1-4.23,1.5s-3.2.95-4.32,1.22a8.41,8.41,0,0,1-1.83.35,8.79,8.79,0,0,1,1.76-.62l4.27-1.34,4.26-1.37A10,10,0,0,1,109.43,326.84Z" style="fill: rgb(38, 50, 56); transform-origin: 103.39px 328.76px;" id="elry685z4idcr" class="animable"></path><path d="M104.15,312.65a14.33,14.33,0,0,1,.39,3.75,13.92,13.92,0,0,1-.2,3.75,22.91,22.91,0,0,1-.2-3.74A22.37,22.37,0,0,1,104.15,312.65Z" style="fill: rgb(38, 50, 56); transform-origin: 104.326px 316.4px;" id="el0huch2tx0s1m" class="animable"></path><path d="M80.13,320.34a13.67,13.67,0,0,1,2.44-.86c1.52-.47,3.64-1.07,6-1.64s4.53-1,6.1-1.28a15.18,15.18,0,0,1,2.56-.35,17.43,17.43,0,0,1-2.51.63c-1.55.35-3.69.83-6.06,1.39s-4.48,1.12-6,1.52A19.38,19.38,0,0,1,80.13,320.34Z" style="fill: rgb(38, 50, 56); transform-origin: 88.68px 318.275px;" id="el2ym6emqs1bk" class="animable"></path><path d="M99.82,343.73c-2.89-2.19-5.94-2.62-9.55-2.48A29.21,29.21,0,0,0,79.81,344c-5.66,2.48-11,6.13-14.36,11.3s-4.55,12-2,17.64a2.52,2.52,0,0,0,1.14,1.39,2.73,2.73,0,0,0,1.9-.14c6.43-2.1,12.91-4.22,18.83-7.51s11.3-7.85,14.47-13.83a12,12,0,0,0,1.53-4.59,5.72,5.72,0,0,0-1.48-4.48" style="fill: rgb(33, 158, 188); transform-origin: 81.7141px 357.832px;" id="elkz6wl69cxm" class="animable"></path><path d="M99.88,343.05l-.47.18-1.34.47-1,.32-1.14.45c-.81.33-1.76.66-2.75,1.14l-1.58.72c-.55.25-1.1.56-1.67.86-1.17.57-2.35,1.3-3.61,2a63.16,63.16,0,0,0-7.61,5.65,62.23,62.23,0,0,0-6.58,6.84c-.9,1.15-1.77,2.23-2.49,3.31-.36.54-.74,1-1.06,1.55l-.92,1.47c-.6.93-1.05,1.82-1.48,2.59-.21.39-.41.74-.58,1.07s-.32.65-.45.93l-.63,1.28a2.1,2.1,0,0,1-.25.43,3.36,3.36,0,0,1,.17-.46l.57-1.32.41-.94.56-1.09c.42-.78.85-1.69,1.44-2.63l.9-1.5c.31-.51.68-1,1-1.57.71-1.1,1.58-2.19,2.47-3.35a59.42,59.42,0,0,1,6.6-6.91,60.06,60.06,0,0,1,7.69-5.66c1.27-.74,2.46-1.47,3.64-2,.59-.29,1.14-.6,1.69-.84l1.6-.7c1-.47,2-.78,2.79-1.09.42-.15.8-.3,1.16-.42l1-.29,1.37-.39A1.64,1.64,0,0,1,99.88,343.05Z" style="fill: rgb(38, 50, 56); transform-origin: 82.075px 358.68px;" id="elqnwjkf157xq" class="animable"></path><path d="M77.34,355.25a67.25,67.25,0,0,1-7,2.26,65.59,65.59,0,0,1-7.13,1.88,66.54,66.54,0,0,1,7-2.26A67.56,67.56,0,0,1,77.34,355.25Z" style="fill: rgb(38, 50, 56); transform-origin: 70.275px 357.32px;" id="ely2wuzfniwor" class="animable"></path><path d="M77.05,370.74a10.75,10.75,0,0,1-.16-2.19c0-1.35,0-3.22,0-5.28s.17-3.93.28-5.28a11.55,11.55,0,0,1,.27-2.17,11.87,11.87,0,0,1,0,2.19c0,1.48-.1,3.28-.16,5.27s-.1,3.79-.13,5.27A14.07,14.07,0,0,1,77.05,370.74Z" style="fill: rgb(38, 50, 56); transform-origin: 77.188px 363.28px;" id="el6zghv1o9phl" class="animable"></path><path d="M90.31,364c-.11,0-.46-3.79-.78-8.48S89,347,89.14,347s.46,3.79.79,8.48S90.43,364,90.31,364Z" style="fill: rgb(38, 50, 56); transform-origin: 89.7222px 355.5px;" id="elfbiahpbtel" class="animable"></path><path d="M73.8,346.62a12.9,12.9,0,0,1,2.25-.07c1.39,0,3.3.05,5.42.12s4,.16,5.41.24a11.63,11.63,0,0,1,2.24.22,14.28,14.28,0,0,1-2.25.07c-1.39,0-3.3-.05-5.42-.12s-4-.16-5.41-.24A12.56,12.56,0,0,1,73.8,346.62Z" style="fill: rgb(38, 50, 56); transform-origin: 81.46px 346.873px;" id="elesnu8y07gn9" class="animable"></path><path d="M105.65,392.83a1.57,1.57,0,0,1-.05-.45c0-.34,0-.76-.06-1.29-.05-1.12-.06-2.74,0-4.75s.17-4.39.41-7,.64-5.54,1.18-8.55,1.23-5.86,1.91-8.43,1.42-4.85,2.1-6.75,1.25-3.41,1.69-4.45l.51-1.19a1.87,1.87,0,0,1,.2-.4,1.63,1.63,0,0,1-.12.43c-.12.32-.26.72-.44,1.22-.4,1.05-.94,2.58-1.57,4.48s-1.32,4.19-2,6.75-1.32,5.4-1.87,8.41-.93,5.89-1.21,8.52-.42,5-.5,7-.11,3.62-.1,4.74c0,.52,0,1,0,1.29A2.71,2.71,0,0,1,105.65,392.83Z" style="fill: rgb(38, 50, 56); transform-origin: 109.519px 371.2px;" id="eljdm5flttq4r" class="animable"></path><path d="M107.42,370.86a9.29,9.29,0,0,1-1.34,1.47c-.87.87-2.1,2-3.51,3.26s-2.72,2.31-3.69,3.05a9.59,9.59,0,0,1-1.63,1.14,10.17,10.17,0,0,1,1.45-1.36l3.61-3.13,3.57-3.16A11,11,0,0,1,107.42,370.86Z" style="fill: rgb(38, 50, 56); transform-origin: 102.335px 375.32px;" id="elrgi0e2711qp" class="animable"></path><path d="M118,379.42a16.23,16.23,0,0,1-1.42-2l-3.32-4.83c-1.28-1.82-2.44-3.47-3.38-4.79a16.8,16.8,0,0,1-1.36-2,12.75,12.75,0,0,1,1.59,1.86c.93,1.18,2.17,2.84,3.48,4.73s2.44,3.63,3.23,4.91A13,13,0,0,1,118,379.42Z" style="fill: rgb(38, 50, 56); transform-origin: 113.26px 372.61px;" id="elburi9s074ps" class="animable"></path><path d="M112.47,352.52c.06.09-3.47,2.47-7.88,5.3s-8,5.06-8.09,5,3.47-2.47,7.88-5.31S112.41,352.42,112.47,352.52Z" style="fill: rgb(38, 50, 56); transform-origin: 104.485px 357.669px;" id="elxm8cxa663wc" class="animable"></path><path d="M122.42,363.25a65.38,65.38,0,0,1-5.34-4.93,63.71,63.71,0,0,1-5-5.22,67.72,67.72,0,0,1,5.33,4.94A66,66,0,0,1,122.42,363.25Z" style="fill: rgb(38, 50, 56); transform-origin: 117.25px 358.175px;" id="elrszko6ys6xo" class="animable"></path><path d="M124.92,363l3-.25a15.11,15.11,0,0,0,6.11-1.87,23.78,23.78,0,0,1,2.85-1.44c3.75-1.5,7.92-1.23,12-1.43a49.62,49.62,0,0,0,19-4.86,1.85,1.85,0,0,0,.83-.76c.62-1.13-.53-2.14-1.53-2.75-5.1-3.14-10.29-6.33-16.08-7.89s-12.35-1.29-17.29,2.1c-5.79,4-7.9,12.18-8.88,19.15" style="fill: rgb(33, 158, 188); transform-origin: 146.903px 351.918px;" id="elplil4n4psz" class="animable"></path><path d="M168.77,352.06a2.19,2.19,0,0,1-.52-.24l-1.43-.75c-1.25-.65-3-1.62-5.3-2.7a49.37,49.37,0,0,0-8.21-3.17,27.24,27.24,0,0,0-10.63-.86,18.23,18.23,0,0,0-9.7,4.16,21.76,21.76,0,0,0-5,7.1,58.24,58.24,0,0,0-2.19,5.52c-.23.63-.41,1.14-.54,1.52a4.77,4.77,0,0,1-.21.53,2.25,2.25,0,0,1,.13-.55c.12-.39.27-.91.47-1.55a49.54,49.54,0,0,1,2.09-5.59,21.3,21.3,0,0,1,5.06-7.25,18.42,18.42,0,0,1,9.88-4.29,27,27,0,0,1,10.79.91,47.47,47.47,0,0,1,8.23,3.26c2.26,1.12,4,2.13,5.25,2.82l1.4.82A3.74,3.74,0,0,1,168.77,352.06Z" style="fill: rgb(38, 50, 56); transform-origin: 146.905px 353.462px;" id="elcvkxgm15v6d" class="animable"></path><path d="M161.5,356c-.07.09-4-2.47-8.85-5.72s-8.68-6-8.62-6.06,4,2.47,8.85,5.73S161.56,355.88,161.5,356Z" style="fill: rgb(38, 50, 56); transform-origin: 152.765px 350.111px;" id="elwc2zs2uajpe" class="animable"></path><path d="M157.27,344a9.44,9.44,0,0,1-2.88.52,9.56,9.56,0,0,1-2.94,0,19.74,19.74,0,0,1,2.9-.29A20.38,20.38,0,0,1,157.27,344Z" style="fill: rgb(38, 50, 56); transform-origin: 154.36px 344.317px;" id="el2v4kvkkp7bm" class="animable"></path><path d="M139.93,341.73a7.44,7.44,0,0,1-1.29,2,8.45,8.45,0,0,1-1.65,1.87,7.65,7.65,0,0,1,1.3-2A8.56,8.56,0,0,1,139.93,341.73Z" style="fill: rgb(38, 50, 56); transform-origin: 138.46px 343.665px;" id="elzlocvf8095f" class="animable"></path><path d="M143.48,358.3a10.49,10.49,0,0,1-1.9-1c-1.15-.69-2.69-1.71-4.34-2.91s-3.11-2.34-4.16-3.17a10.32,10.32,0,0,1-1.64-1.41,12,12,0,0,1,1.81,1.19l4.22,3.06c1.65,1.2,3.16,2.25,4.26,3A12.68,12.68,0,0,1,143.48,358.3Z" style="fill: rgb(38, 50, 56); transform-origin: 137.46px 354.055px;" id="elxu0ifcdv36c" class="animable"></path><path d="M129.38,375.9c-2.89-.76-6.33,2.05-6.93,5s.5,5.92,1.79,8.61a43.91,43.91,0,0,0,11.94,15.63,29.5,29.5,0,0,0,18.26,6.72c-1.22-5.67.33-11.59-.35-17.35a22.58,22.58,0,0,0-20-19.8c-1.84-.2-4-.49-4.71,1.21" style="fill: rgb(33, 158, 188); transform-origin: 138.361px 393.208px;" id="elfrlc5xarprr" class="animable"></path><path d="M154.44,411.84a1.58,1.58,0,0,1-.41-.19,7.91,7.91,0,0,1-1.08-.72,11.45,11.45,0,0,1-2.85-3.82c-.46-.89-1-1.86-1.48-2.94s-1-2.22-1.55-3.43a33.94,33.94,0,0,0-1.91-3.67,28.77,28.77,0,0,0-2.63-3.58c-2-2.32-4.1-4.33-5.94-6.25a40.85,40.85,0,0,1-4.52-5.43,19.67,19.67,0,0,1-2.22-4.23,12.32,12.32,0,0,1-.38-1.23,1.64,1.64,0,0,1-.09-.45s.2.59.62,1.63a21.71,21.71,0,0,0,2.3,4.12,42.51,42.51,0,0,0,4.56,5.33c1.85,1.9,4,3.91,6,6.25a29.51,29.51,0,0,1,2.66,3.63,33.8,33.8,0,0,1,1.91,3.73c.53,1.21,1,2.36,1.52,3.44s1,2.05,1.42,3a11.69,11.69,0,0,0,2.7,3.83C153.9,411.53,154.47,411.8,154.44,411.84Z" style="fill: rgb(38, 50, 56); transform-origin: 141.911px 393.87px;" id="elfldr69zmsiw" class="animable"></path><path d="M139.51,407.13a9.09,9.09,0,0,1,.26-1.94c.23-1.19.6-2.83,1.1-4.6s1-3.37,1.47-4.5a8.59,8.59,0,0,1,.79-1.8,11.81,11.81,0,0,1-.52,1.89c-.36,1.15-.85,2.74-1.35,4.51s-.91,3.39-1.21,4.56A9.64,9.64,0,0,1,139.51,407.13Z" style="fill: rgb(38, 50, 56); transform-origin: 141.32px 400.71px;" id="elh1g267uok5k" class="animable"></path><path d="M153.9,393.21a11.11,11.11,0,0,1-2-.47c-1.24-.32-3-.77-4.87-1.2s-3.66-.76-4.92-1a12.69,12.69,0,0,1-2-.45,9.12,9.12,0,0,1,2.08.17c1.28.16,3,.46,5,.89s3.63.92,4.86,1.32A10.47,10.47,0,0,1,153.9,393.21Z" style="fill: rgb(38, 50, 56); transform-origin: 147.005px 391.647px;" id="el8pi3osuprfq" class="animable"></path><path d="M128.79,397.25a12.31,12.31,0,0,1,.31-2.25c.26-1.37.66-3.27,1.2-5.34s1.12-3.92,1.57-5.25a11.78,11.78,0,0,1,.83-2.12,14.93,14.93,0,0,1-.56,2.2c-.38,1.35-.91,3.21-1.45,5.27s-1,3.94-1.31,5.3A12.51,12.51,0,0,1,128.79,397.25Z" style="fill: rgb(38, 50, 56); transform-origin: 130.745px 389.77px;" id="elaoi7nkz3of" class="animable"></path><path d="M147.27,381.08c0,.11-3.62-.18-8.05-.65s-8-.94-8-1.05a77.83,77.83,0,0,1,8,.65C143.7,380.5,147.28,381,147.27,381.08Z" style="fill: rgb(38, 50, 56); transform-origin: 139.245px 380.242px;" id="eliuxl03udt2e" class="animable"></path><path d="M144.63,424.8c0,.11-12.67.2-28.31.2s-28.3-.09-28.3-.2,12.67-.2,28.3-.2S144.63,424.69,144.63,424.8Z" style="fill: rgb(69, 90, 100); transform-origin: 116.325px 424.8px;" id="el5y0b048s31" class="animable"></path><path d="M135.81,441.11c0,.11-8.54.2-19.07.2s-19.07-.09-19.07-.2,8.54-.2,19.07-.2S135.81,441,135.81,441.11Z" style="fill: rgb(69, 90, 100); transform-origin: 116.74px 441.11px;" id="elzlitp9wvnb7" class="animable"></path><path d="M135.48,443.44c0,.12-8.39.21-18.74.21S98,443.56,98,443.44s8.39-.2,18.74-.2S135.48,443.33,135.48,443.44Z" style="fill: rgb(69, 90, 100); transform-origin: 116.74px 443.445px;" id="elg0afic2tiz7" class="animable"></path><path d="M136.14,439.19c0,.11-8.83.2-19.72.2s-19.73-.09-19.73-.2,8.83-.2,19.73-.2S136.14,439.08,136.14,439.19Z" style="fill: rgb(69, 90, 100); transform-origin: 116.415px 439.19px;" id="elwao2sdp7zma" class="animable"></path></g><g id="freepik--Screens--inject-41" class="animable" style="transform-origin: 264.328px 213.028px;"><path d="M149.17,120.31h-6.46a5,5,0,0,0-2,.21,3.06,3.06,0,0,0-1.53,1.36,3.4,3.4,0,0,0-.37,1,7.12,7.12,0,0,0,0,1.14v1.18a5.7,5.7,0,0,1-.08,1.23,3.27,3.27,0,0,1-1.44,2.08A3.1,3.1,0,0,1,136,129c-.46,0-.9,0-1.37,0H111.23a3.27,3.27,0,0,1-.93-.09,3.09,3.09,0,0,1-1.61-1,3.34,3.34,0,0,1-.79-1.75,7.92,7.92,0,0,1,0-1v-1a5,5,0,0,0-.2-1.9,3.08,3.08,0,0,0-1.15-1.51,3,3,0,0,0-1.86-.51H89.76a9.92,9.92,0,0,0-8,3.52,9.88,9.88,0,0,0-2,4.11,11.72,11.72,0,0,0-.2,1.16c0,.33,0,.66,0,1v158.8a10.31,10.31,0,0,0,.4,3.13,9.84,9.84,0,0,0,3.84,5.28,10.23,10.23,0,0,0,6.32,1.73h58.74c2.09,0,4.19,0,6.24,0a9.84,9.84,0,0,0,5.6-2.17,10.21,10.21,0,0,0,2-2.23,9.71,9.71,0,0,0,1.24-2.72,10.52,10.52,0,0,0,.37-3V274.15c0-31.25,0-59.38.05-83s0-42.75.06-56v-4.68a10.17,10.17,0,0,0-.72-4,9.94,9.94,0,0,0-1.87-2.95,9.63,9.63,0,0,0-2.25-1.83,9.44,9.44,0,0,0-3.71-1.31,8.13,8.13,0,0,0-1-.09l-.34,0h-5.32Z" style="fill: rgb(250, 250, 250); transform-origin: 121.99px 209.61px;" id="elqbdugez02ft" class="animable"></path><path d="M154.6,120.42h.34a10,10,0,0,1,1,.08,9.92,9.92,0,0,1,6,3.12,9.84,9.84,0,0,1,1.89,3,10.19,10.19,0,0,1,.74,4c0,1.47,0,3,0,4.68,0,13.22,0,32.34,0,56s0,51.77,0,83v14.86a10.72,10.72,0,0,1-.38,3A10.1,10.1,0,0,1,163,295a10.71,10.71,0,0,1-2.07,2.29,10,10,0,0,1-5.73,2.22c-2.08.06-4.14,0-6.23,0H136.31l-25.93,0h-20A10.5,10.5,0,0,1,84,297.71,10.22,10.22,0,0,1,80,292.28a11,11,0,0,1-.41-3.36V272.31q0-13.17,0-25.94c0-17,0-33.4,0-49s0-30.47,0-44.37q0-10.41,0-20.1v-2.41c0-.4,0-.8.06-1.2s.1-.8.2-1.19a10.08,10.08,0,0,1,2.09-4.2,10.05,10.05,0,0,1,8.09-3.58H105a3.24,3.24,0,0,1,2,.55,3.28,3.28,0,0,1,1.21,1.59,5.49,5.49,0,0,1,.2,2v1a7.26,7.26,0,0,0,0,.94,3.18,3.18,0,0,0,.74,1.67,3,3,0,0,0,1.52.94,3.28,3.28,0,0,0,.89.08H116l13.08,0h5.77c.45,0,.91,0,1.35,0a3,3,0,0,0,1.21-.42,3.17,3.17,0,0,0,1.39-2,5.47,5.47,0,0,0,.08-1.21v-1.18a7.45,7.45,0,0,1,.05-1.16,3.44,3.44,0,0,1,.38-1.06,3.07,3.07,0,0,1,1.58-1.4,4.8,4.8,0,0,1,2-.21h6.44l3.95,0h1.35l-1.35,0H142.86a4.78,4.78,0,0,0-1.94.21,3.1,3.1,0,0,0-1.53,1.36,3.38,3.38,0,0,0-.36,1,7,7,0,0,0-.05,1.14v1.18a5.68,5.68,0,0,1-.07,1.23,3.23,3.23,0,0,1-1.44,2.07,2.94,2.94,0,0,1-1.26.45c-.46,0-.9,0-1.36,0H111.5a3.67,3.67,0,0,1-.93-.09,3.11,3.11,0,0,1-1.61-1,3.37,3.37,0,0,1-.78-1.74,7.92,7.92,0,0,1,0-1v-1a5.05,5.05,0,0,0-.2-1.9,3.1,3.1,0,0,0-1.15-1.5,2.92,2.92,0,0,0-1.85-.51H90.11A9.88,9.88,0,0,0,82.18,124a9.86,9.86,0,0,0-2,4.12c-.1.38-.13.77-.2,1.16s0,.78,0,1.18V288.92a10.66,10.66,0,0,0,.4,3.28,9.9,9.9,0,0,0,3.82,5.28,10.22,10.22,0,0,0,6.31,1.73h20l25.93,0h12.63c2.08,0,4.17,0,6.22,0a9.74,9.74,0,0,0,5.57-2.16,10.44,10.44,0,0,0,2-2.23,9.81,9.81,0,0,0,1.23-2.72,10.19,10.19,0,0,0,.37-3v-3c0-4,0-8,0-11.86,0-31.25,0-59.39,0-83s0-42.75.05-56c0-1.65,0-3.21,0-4.68a10.08,10.08,0,0,0-.73-4,9.8,9.8,0,0,0-1.86-2.94,9.94,9.94,0,0,0-5.94-3.14,6.35,6.35,0,0,0-1-.09Z" style="fill: rgb(38, 50, 56); transform-origin: 122.078px 209.924px;" id="el2mxtu2zkxle" class="animable"></path><path d="M156.52,136.49s-1.64.09-3.66.11-3.66,0-3.66,0,1.63-.09,3.66-.11S156.52,136.45,156.52,136.49Z" style="fill: rgb(38, 50, 56); transform-origin: 152.86px 136.538px;" id="elwsshg302ipq" class="animable"></path><path d="M156.54,138.37s-1.64.09-3.67.1-3.66,0-3.66,0,1.64-.09,3.66-.11S156.54,138.32,156.54,138.37Z" style="fill: rgb(38, 50, 56); transform-origin: 152.875px 138.407px;" id="eld0rv5ftrbtb" class="animable"></path><path d="M156.55,140.24s-1.64.09-3.66.11-3.66,0-3.66,0,1.64-.09,3.66-.11S156.55,140.2,156.55,140.24Z" style="fill: rgb(38, 50, 56); transform-origin: 152.89px 140.288px;" id="elyuc7r6tm9e" class="animable"></path><path d="M89.9,142.38h.15l.43,0,1.56,0,0,0c0-.35,0-.72,0-1.13,0-.21,0-.41,0-.66a.61.61,0,0,1,.53-.48h.74a.6.6,0,0,1,.52.6c0,.53,0,1.08,0,1.66l-.08-.07,2,0-.08.07c0-.79,0-1.61,0-2.46,0-.21,0-.42,0-.62a.63.63,0,0,0-.27-.47l-.87-.85-.83-.82-.4-.4c-.14-.13-.25-.27-.41-.3a.54.54,0,0,0-.45.08c-.12.1-.25.25-.37.36l-.71.72c-.44.46-.91.88-1.24,1.28a1.33,1.33,0,0,0-.1.74v.69c0,.43,0,.8,0,1.12s0,.53,0,.72a1.11,1.11,0,0,1,0,.26,2.17,2.17,0,0,1,0-.24c0-.19,0-.42,0-.7l0-1.13c0-.23,0-.46,0-.71v-.39a.87.87,0,0,1,.11-.41c.37-.45.8-.85,1.25-1.32l.7-.72c.13-.12.23-.25.38-.38a.7.7,0,0,1,.58-.11,1.1,1.1,0,0,1,.47.34l.41.39.83.82.86.85a1.28,1.28,0,0,1,.22.24.65.65,0,0,1,.11.33v.63c0,.84,0,1.67,0,2.46v.08H93.64v-.07c0-.57,0-1.13,0-1.66a.48.48,0,0,0-.4-.48c-.22,0-.49,0-.71,0a.5.5,0,0,0-.43.39c0,.19,0,.43,0,.63,0,.41,0,.78,0,1.13v0H89.9Z" style="fill: rgb(38, 50, 56); transform-origin: 92.92px 139.369px;" id="elr6jn9182z1" class="animable"></path><path d="M139.64,208c0,.28-7.85.51-17.53.51s-17.52-.23-17.52-.51,7.84-.51,17.52-.51S139.64,207.74,139.64,208Z" style="fill: rgb(38, 50, 56); transform-origin: 122.115px 208px;" id="elutw1qrxfgbh" class="animable"></path><g id="elg6vga9qs6b5"><rect x="105.16" y="156.62" width="34.02" height="45.27" style="fill: rgb(33, 158, 188); transform-origin: 122.17px 179.255px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="99.44 196.14 115.37 175.08 125.09 188.37 131.77 181.33 144.71 196.39 99.44 196.14" style="fill: rgb(33, 158, 188); transform-origin: 122.075px 185.735px;" id="eld6kqajkotkv" class="animable"></polygon><path d="M129.33,172.57a3.56,3.56,0,1,1-3.54-3.59A3.56,3.56,0,0,1,129.33,172.57Z" style="fill: rgb(33, 158, 188); transform-origin: 125.77px 172.54px;" id="elt2c18c9jb2f" class="animable"></path><g id="el6w0yh4dj39m"><g style="opacity: 0.2; transform-origin: 122.075px 185.735px;" class="animable"><polygon points="99.44 196.14 115.37 175.08 125.09 188.37 131.77 181.33 144.71 196.39 99.44 196.14" id="el3sr49wudmea" class="animable" style="transform-origin: 122.075px 185.735px;"></polygon></g></g><g id="elbpd30h6dfyv"><g style="opacity: 0.2; transform-origin: 125.77px 172.54px;" class="animable"><path d="M129.33,172.57a3.56,3.56,0,1,1-3.54-3.59A3.56,3.56,0,0,1,129.33,172.57Z" id="el7e9fwf0y2t3" class="animable" style="transform-origin: 125.77px 172.54px;"></path></g></g><path d="M153.28,220.54c0,.29-13.92.52-31.07.52s-31.08-.23-31.08-.52S105,220,122.21,220,153.28,220.26,153.28,220.54Z" style="fill: rgb(38, 50, 56); transform-origin: 122.205px 220.53px;" id="el1aor4ps750h" class="animable"></path><path d="M153.28,229.2c0,.29-13.92.52-31.07.52s-31.08-.23-31.08-.52,13.91-.51,31.08-.51S153.28,228.92,153.28,229.2Z" style="fill: rgb(38, 50, 56); transform-origin: 122.205px 229.205px;" id="elni0byfqvxps" class="animable"></path><path d="M153.28,237.87c0,.28-13.92.51-31.07.51s-31.08-.23-31.08-.51,13.91-.52,31.08-.52S153.28,237.58,153.28,237.87Z" style="fill: rgb(38, 50, 56); transform-origin: 122.205px 237.865px;" id="el9q2b2yl9a2u" class="animable"></path><path d="M153.28,246.53c0,.28-13.92.51-31.07.51s-31.08-.23-31.08-.51S105,246,122.21,246,153.28,246.25,153.28,246.53Z" style="fill: rgb(38, 50, 56); transform-origin: 122.205px 246.52px;" id="elin6irj4lve" class="animable"></path><path d="M153.28,255.19c0,.29-13.92.52-31.07.52s-31.08-.23-31.08-.52,13.91-.51,31.08-.51S153.28,254.91,153.28,255.19Z" style="fill: rgb(38, 50, 56); transform-origin: 122.205px 255.195px;" id="elrpjvcqge8h" class="animable"></path><path d="M139.91,263.1c0,.14-2,.27-5.22.36s-7.69.15-12.62.15-9.38-.05-12.61-.15-5.22-.22-5.22-.36,2-.27,5.22-.36,7.69-.15,12.61-.15,9.39.05,12.62.15S139.91,263,139.91,263.1Z" style="fill: rgb(38, 50, 56); transform-origin: 122.075px 263.1px;" id="elu1icl7ohg4" class="animable"></path><path d="M211.29,105.77h-7.18A5.31,5.31,0,0,0,202,106a3.37,3.37,0,0,0-1.71,1.52,3.49,3.49,0,0,0-.4,1.15,7.62,7.62,0,0,0-.06,1.27c0,.44,0,.88,0,1.33a7.12,7.12,0,0,1-.09,1.37,3.65,3.65,0,0,1-1.6,2.31,3.45,3.45,0,0,1-1.41.5c-.51,0-1,0-1.52,0h-26a4.12,4.12,0,0,1-1-.1,3.49,3.49,0,0,1-1.79-1.11,3.69,3.69,0,0,1-.87-2,7.8,7.8,0,0,1,0-1.08v-1.07a5.77,5.77,0,0,0-.21-2.12,3.41,3.41,0,0,0-1.29-1.68,3.24,3.24,0,0,0-2.06-.57H145.27a10.94,10.94,0,0,0-8.84,3.92,11.15,11.15,0,0,0-2.28,4.59c-.11.42-.14.86-.22,1.29s0,.74-.05,1.11V293.83a11.63,11.63,0,0,0,.44,3.48,11,11,0,0,0,4.27,5.89,11.37,11.37,0,0,0,7,1.94h22.26l28.92,0h14.09c2.32,0,4.65,0,6.93,0a10.9,10.9,0,0,0,6.22-2.41,11.83,11.83,0,0,0,2.25-2.49,11,11,0,0,0,1.37-3,11.86,11.86,0,0,0,.42-3.3V277.34c0-34.85,0-66.23.06-92.59s0-47.68.06-62.42c0-1.85,0-3.59,0-5.22a11.36,11.36,0,0,0-.81-4.46,11,11,0,0,0-2.08-3.28,10.64,10.64,0,0,0-2.5-2.05,10.37,10.37,0,0,0-4.12-1.45,8.9,8.9,0,0,0-1.12-.11l-.38,0h-1.5Z" style="fill: rgb(250, 250, 250); transform-origin: 181.024px 205.434px;" id="elacb5vw467wi" class="animable"></path><path d="M217.28,105.66l.38,0a7.77,7.77,0,0,1,1.12.08,11.15,11.15,0,0,1,6.68,3.48,11.06,11.06,0,0,1,2.1,3.3,11.39,11.39,0,0,1,.83,4.5c0,1.63,0,3.37,0,5.21,0,14.75,0,36.07,0,62.43s0,57.74,0,92.58v16.59a11.67,11.67,0,0,1-.42,3.37,11.28,11.28,0,0,1-1.42,3.12,11.92,11.92,0,0,1-2.3,2.56,11.25,11.25,0,0,1-6.39,2.48c-2.32.07-4.62,0-7,0H145.69a11.77,11.77,0,0,1-7.2-2,11.38,11.38,0,0,1-4.39-6.06,12.19,12.19,0,0,1-.46-3.74V275.06q0-14.69,0-28.93c0-19,0-37.25,0-54.68s0-34,0-49.48q0-11.62,0-22.43v-2.68c0-.45,0-.9.06-1.34s.11-.89.23-1.32a11.21,11.21,0,0,1,2.33-4.69,11.5,11.5,0,0,1,4.1-3.07,11.68,11.68,0,0,1,4.92-.93h16.56a3.48,3.48,0,0,1,2.17.61,3.68,3.68,0,0,1,1.36,1.78,6,6,0,0,1,.22,2.18v1.08a7.26,7.26,0,0,0,0,1,3.46,3.46,0,0,0,.82,1.86,3.35,3.35,0,0,0,1.69,1,3.73,3.73,0,0,0,1,.09h5l14.59,0h6.44c.5,0,1,0,1.5,0a3.25,3.25,0,0,0,1.36-.47,3.55,3.55,0,0,0,1.55-2.23,6.09,6.09,0,0,0,.08-1.35c0-.44,0-.88,0-1.32a8,8,0,0,1,.05-1.29,4,4,0,0,1,.42-1.18,3.55,3.55,0,0,1,1.77-1.57,5.56,5.56,0,0,1,2.2-.23l7.17,0,4.42,0h1.5l-1.5,0H204.19a5.48,5.48,0,0,0-2.16.24,3.32,3.32,0,0,0-1.71,1.52,3.51,3.51,0,0,0-.41,1.15,8.88,8.88,0,0,0,0,1.27v1.32a6.34,6.34,0,0,1-.08,1.37,3.62,3.62,0,0,1-1.61,2.32,3.41,3.41,0,0,1-1.4.5c-.52,0-1,0-1.52,0h-26a4.09,4.09,0,0,1-1-.11,3.43,3.43,0,0,1-1.79-1.1,3.69,3.69,0,0,1-.87-1.95,7.92,7.92,0,0,1,0-1.08V110.1a5.79,5.79,0,0,0-.22-2.12A3.48,3.48,0,0,0,164,106.3a3.37,3.37,0,0,0-2.06-.57H145.35a11,11,0,0,0-8.85,3.93,11.19,11.19,0,0,0-2.27,4.59c-.11.42-.14.86-.22,1.29s0,.87-.06,1.32V142c0,15.49,0,32.05,0,49.48v54.68q0,14.24,0,28.93v18.53a11.8,11.8,0,0,0,.45,3.65,11,11,0,0,0,4.27,5.89,11.33,11.33,0,0,0,7,1.93H168l28.92,0H211c2.33,0,4.66,0,6.94,0a10.93,10.93,0,0,0,6.22-2.41,11.52,11.52,0,0,0,2.24-2.49,10.7,10.7,0,0,0,1.38-3,11.42,11.42,0,0,0,.41-3.29c0-1.13,0-2.24,0-3.36V277.26c0-34.84,0-66.22.05-92.58s0-47.68.07-62.43V117a11.54,11.54,0,0,0-.8-4.46,11.09,11.09,0,0,0-2.08-3.29,10.84,10.84,0,0,0-2.5-2,11,11,0,0,0-5.24-1.56Z" style="fill: rgb(38, 50, 56); transform-origin: 181.013px 205.418px;" id="elks0pm3ygnt" class="animable"></path><path d="M219.42,123.58s-1.83.11-4.08.12-4.09,0-4.09,0,1.83-.1,4.08-.12S219.42,123.54,219.42,123.58Z" style="fill: rgb(38, 50, 56); transform-origin: 215.335px 123.631px;" id="el1shyuj60pkt" class="animable"></path><path d="M219.44,125.67s-1.83.11-4.09.12-4.08,0-4.08-.05,1.82-.1,4.08-.12S219.44,125.63,219.44,125.67Z" style="fill: rgb(38, 50, 56); transform-origin: 215.355px 125.704px;" id="elvjlnfuhtjpd" class="animable"></path><path d="M219.45,127.76s-1.82.11-4.08.12-4.09,0-4.09,0,1.83-.1,4.09-.12S219.45,127.72,219.45,127.76Z" style="fill: rgb(38, 50, 56); transform-origin: 215.365px 127.811px;" id="el2a39silclkh" class="animable"></path><path d="M145.12,130.15h.17l.47,0,1.75,0,0,0c0-.39,0-.81,0-1.26,0-.24,0-.46,0-.73a.68.68,0,0,1,.59-.54,7.65,7.65,0,0,1,.83,0,.67.67,0,0,1,.57.67c0,.59,0,1.21,0,1.84l-.08-.08,2.2,0-.08.09c0-.89,0-1.81,0-2.74v-.7a.69.69,0,0,0-.31-.52l-1-1-.93-.92-.45-.44a1.1,1.1,0,0,0-.46-.34.56.56,0,0,0-.5.1c-.13.11-.28.27-.41.4l-.79.8c-.5.51-1,1-1.39,1.43a1.52,1.52,0,0,0-.11.82v.77c0,.48,0,.9,0,1.25s0,.59,0,.8,0,.29,0,.29,0-.09,0-.26,0-.48,0-.79,0-.78,0-1.26c0-.25,0-.51,0-.79s0-.29,0-.43a.93.93,0,0,1,.12-.46c.41-.5.9-.94,1.4-1.47l.78-.81c.14-.14.26-.27.43-.42a.74.74,0,0,1,.63-.12,1.15,1.15,0,0,1,.53.37l.45.45c.31.29.62.6.93.91l1,1a1.51,1.51,0,0,1,.24.26.63.63,0,0,1,.12.37c0,.23,0,.47,0,.7,0,.94,0,1.86,0,2.75v.08h-.09l-2.2,0h-.08v-.08c0-.64,0-1.26,0-1.85a.52.52,0,0,0-.44-.53c-.26,0-.55,0-.8,0a.55.55,0,0,0-.48.43c0,.22,0,.48,0,.7v1.32h-2.44Z" style="fill: rgb(38, 50, 56); transform-origin: 148.47px 126.763px;" id="elzea7gri6a1n" class="animable"></path><path d="M189.6,141.59a7.38,7.38,0,1,1-7.37-7.37A7.37,7.37,0,0,1,189.6,141.59Z" style="fill: rgb(33, 158, 188); transform-origin: 182.22px 141.6px;" id="elpd36rg0ofn" class="animable"></path><path d="M184.76,144.57H179.7V144a2.53,2.53,0,0,1,2.53-2.53h0a2.53,2.53,0,0,1,2.53,2.53Z" style="fill: rgb(255, 255, 255); transform-origin: 182.23px 143.02px;" id="eljcdq9wzbdy" class="animable"></path><path d="M183.71,140.11a1.49,1.49,0,1,1-1.48-1.49A1.48,1.48,0,0,1,183.71,140.11Z" style="fill: rgb(255, 255, 255); transform-origin: 182.22px 140.11px;" id="elbvo67zt08yi" class="animable"></path><path d="M200.59,161.09c0,.31-8.75.57-19.54.57s-19.55-.26-19.55-.57,8.75-.58,19.55-.58S200.59,160.77,200.59,161.09Z" style="fill: rgb(38, 50, 56); transform-origin: 181.045px 161.085px;" id="elusf2eudhaz" class="animable"></path><g id="eljg0emonfwo"><rect x="145.3" y="176.41" width="25.36" height="33.75" style="fill: rgb(33, 158, 188); transform-origin: 157.98px 193.285px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="141.03 205.87 152.91 190.17 160.15 200.07 165.13 194.83 174.78 206.06 141.03 205.87" style="fill: rgb(33, 158, 188); transform-origin: 157.905px 198.115px;" id="el5fp8jy1obog" class="animable"></polygon><path d="M163.32,188.3a2.66,2.66,0,1,1-2.64-2.67A2.66,2.66,0,0,1,163.32,188.3Z" style="fill: rgb(33, 158, 188); transform-origin: 160.66px 188.29px;" id="el2om6z69r1cd" class="animable"></path><g id="el0synru4iq74d"><g style="opacity: 0.2; transform-origin: 157.905px 198.115px;" class="animable"><polygon points="141.03 205.87 152.91 190.17 160.15 200.07 165.13 194.83 174.78 206.06 141.03 205.87" id="el746fowxthbo" class="animable" style="transform-origin: 157.905px 198.115px;"></polygon></g></g><g id="el1ojdqkpfyuh"><g style="opacity: 0.2; transform-origin: 160.66px 188.29px;" class="animable"><path d="M163.32,188.3a2.66,2.66,0,1,1-2.64-2.67A2.66,2.66,0,0,1,163.32,188.3Z" id="elt2svxmuyimb" class="animable" style="transform-origin: 160.66px 188.29px;"></path></g></g><g id="el0o0pv0z1ntt"><rect x="150.58" y="204.22" width="58.63" height="78.01" style="fill: rgb(33, 158, 188); transform-origin: 179.895px 243.225px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="140.73 272.33 168.18 236.03 184.93 258.93 196.44 246.81 218.74 272.76 140.73 272.33" style="fill: rgb(33, 158, 188); transform-origin: 179.735px 254.395px;" id="ellnmg9h8hc5" class="animable"></polygon><path d="M192.24,231.7a6.14,6.14,0,1,1-6.1-6.17A6.13,6.13,0,0,1,192.24,231.7Z" style="fill: rgb(33, 158, 188); transform-origin: 186.1px 231.67px;" id="eldh00ho3iuuc" class="animable"></path><g id="elkqzdr3wg7y"><g style="opacity: 0.2; transform-origin: 179.735px 254.395px;" class="animable"><polygon points="140.73 272.33 168.18 236.03 184.93 258.93 196.44 246.81 218.74 272.76 140.73 272.33" id="elyu94towd65f" class="animable" style="transform-origin: 179.735px 254.395px;"></polygon></g></g><g id="eln8y3xv92kx"><g style="opacity: 0.2; transform-origin: 186.1px 231.67px;" class="animable"><path d="M192.24,231.7a6.14,6.14,0,1,1-6.1-6.17A6.13,6.13,0,0,1,192.24,231.7Z" id="elegz7khz70fc" class="animable" style="transform-origin: 186.1px 231.67px;"></path></g></g><g id="el74fz5y0cv74"><rect x="189.85" y="176.41" width="25.36" height="33.75" style="fill: rgb(33, 158, 188); transform-origin: 202.53px 193.285px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="185.58 205.87 197.46 190.17 204.7 200.07 209.69 194.83 219.33 206.06 185.58 205.87" style="fill: rgb(33, 158, 188); transform-origin: 202.455px 198.115px;" id="ele4gjsc77x" class="animable"></polygon><circle cx="205.21" cy="188.28" r="2.66" style="fill: rgb(33, 158, 188); transform-origin: 205.21px 188.28px;" id="ellmj1yka0eo" class="animable"></circle><g id="el0wpbllvt4ua"><g style="opacity: 0.2; transform-origin: 202.455px 198.115px;" class="animable"><polygon points="185.58 205.87 197.46 190.17 204.7 200.07 209.69 194.83 219.33 206.06 185.58 205.87" id="elw4u3h5c54rh" class="animable" style="transform-origin: 202.455px 198.115px;"></polygon></g></g><g id="elrnee8fls5g"><g style="opacity: 0.2; transform-origin: 205.21px 188.28px;" class="animable"><circle cx="205.21" cy="188.28" r="2.66" id="elwrz65v4w9bo" class="animable" style="transform-origin: 205.21px 188.28px;"></circle></g></g><path d="M420.84,115.65h-6.43a5.15,5.15,0,0,0-1.94.21,3.16,3.16,0,0,0-1.89,2.4,6.14,6.14,0,0,0-.05,1.14v1.19a5.08,5.08,0,0,1-.08,1.22A3.29,3.29,0,0,1,409,123.9a3.11,3.11,0,0,1-1.26.44c-.46,0-.91,0-1.37,0H383.05a3.37,3.37,0,0,1-.94-.09,3.11,3.11,0,0,1-1.6-1,3.29,3.29,0,0,1-.78-1.75,8,8,0,0,1,0-1v-1a5,5,0,0,0-.19-1.9,3.08,3.08,0,0,0-1.15-1.51,3,3,0,0,0-1.85-.51H361.65a9.84,9.84,0,0,0-7.93,3.52,10,10,0,0,0-2,4.12,11,11,0,0,0-.19,1.15c0,.33,0,.66-.05,1V284.28a10.25,10.25,0,0,0,.4,3.12,9.85,9.85,0,0,0,3.82,5.28,10.2,10.2,0,0,0,6.3,1.74h20l25.93,0h12.64c2.08,0,4.17,0,6.22,0a9.77,9.77,0,0,0,5.57-2.16,10.18,10.18,0,0,0,2-2.24,9.71,9.71,0,0,0,1.24-2.72,10.12,10.12,0,0,0,.37-2.95v-3q0-6,0-11.86c0-31.24,0-59.38,0-83s0-42.76.06-56c0-1.65,0-3.21,0-4.67a10.37,10.37,0,0,0-.73-4,9.91,9.91,0,0,0-4.1-4.78,9.52,9.52,0,0,0-3.7-1.31c-.44-.08-.78-.06-1-.09l-.34,0h-5.31Z" style="fill: rgb(250, 250, 250); transform-origin: 393.754px 205.004px;" id="el9as1ud6gyi7" class="animable"></path><rect x="365.34" y="182.94" width="55.84" height="11.41" style="fill: rgb(235, 235, 235); transform-origin: 393.26px 188.645px;" id="el2ptsqp5ybab" class="animable"></rect><path d="M426.34,115.56h.34a7.72,7.72,0,0,1,1,.08,10,10,0,0,1,6,3.12,10.24,10.24,0,0,1,1.89,3,10.37,10.37,0,0,1,.74,4v4.68c0,13.21,0,32.34,0,56s0,51.77,0,83v14.87a10.37,10.37,0,0,1-.38,3,9.64,9.64,0,0,1-1.27,2.79,10.48,10.48,0,0,1-2.06,2.3,10.08,10.08,0,0,1-5.73,2.22c-2.08.06-4.15,0-6.24,0H362.15a10.54,10.54,0,0,1-6.46-1.78,10.16,10.16,0,0,1-3.93-5.44,10.89,10.89,0,0,1-.42-3.35v-3.35q0-6.68,0-13.26V241.51c0-17,0-33.41,0-49s0-30.47,0-44.37q0-10.43,0-20.1c0-.81,0-1.61,0-2.41,0-.4,0-.8,0-1.2s.1-.8.2-1.19a10,10,0,0,1,10.18-7.78h14.85a3.21,3.21,0,0,1,1.95.55,3.28,3.28,0,0,1,1.21,1.59,5.07,5.07,0,0,1,.2,2v1a7.26,7.26,0,0,0,0,.94,3.05,3.05,0,0,0,.75,1.66,2.84,2.84,0,0,0,1.51.94,3,3,0,0,0,.9.09h4.49l13.08,0h5.77c.45,0,.92,0,1.35,0a2.84,2.84,0,0,0,1.21-.43,3.09,3.09,0,0,0,1.39-2,4.82,4.82,0,0,0,.08-1.2v-1.19a7.39,7.39,0,0,1,.06-1.15,3.32,3.32,0,0,1,.37-1.07,3.18,3.18,0,0,1,1.59-1.4,5.15,5.15,0,0,1,2-.21l6.43,0,4,0h1.35l-1.35,0H414.6a4.76,4.76,0,0,0-1.94.21,3,3,0,0,0-1.53,1.36,3.16,3.16,0,0,0-.36,1,6.14,6.14,0,0,0,0,1.14v1.19a5.7,5.7,0,0,1-.08,1.23,3.25,3.25,0,0,1-1.43,2.07,3,3,0,0,1-1.27.45c-.46,0-.9,0-1.36,0H383.24a4.28,4.28,0,0,1-.94-.09,3.26,3.26,0,0,1-2.38-2.74,6.35,6.35,0,0,1,0-1v-1a5.24,5.24,0,0,0-.19-1.9,3,3,0,0,0-3-2H361.84a10.28,10.28,0,0,0-4.33.83,9.78,9.78,0,0,0-5.64,6.81c-.1.38-.13.77-.2,1.16s-.05.78-.05,1.18v22.51c0,13.9,0,28.74,0,44.37v49q0,12.75,0,25.94v16.61a10.59,10.59,0,0,0,.4,3.27,9.88,9.88,0,0,0,3.83,5.28,10.2,10.2,0,0,0,6.3,1.74h20l25.93,0h12.63c2.09,0,4.17,0,6.22,0a9.77,9.77,0,0,0,5.58-2.16,10.66,10.66,0,0,0,2-2.23,10,10,0,0,0,1.24-2.72,10.92,10.92,0,0,0,.37-3V269.42c0-31.24,0-59.38.05-83s0-42.76.05-56c0-1.66,0-3.22,0-4.68a10.25,10.25,0,0,0-.72-4,9.89,9.89,0,0,0-1.87-2.94,9.26,9.26,0,0,0-2.24-1.84,9.49,9.49,0,0,0-3.69-1.3,6.54,6.54,0,0,0-1-.09Z" style="fill: rgb(38, 50, 56); transform-origin: 393.823px 205.049px;" id="elquw3iq097pd" class="animable"></path><path d="M428.25,131.63s-1.64.09-3.66.11-3.66,0-3.66-.05,1.64-.09,3.66-.11S428.25,131.59,428.25,131.63Z" style="fill: rgb(38, 50, 56); transform-origin: 424.59px 131.661px;" id="el3vs7guf0hz1" class="animable"></path><path d="M428.27,133.5c0,.05-1.64.09-3.66.11s-3.66,0-3.67-.05,1.64-.09,3.67-.1S428.27,133.46,428.27,133.5Z" style="fill: rgb(38, 50, 56); transform-origin: 424.605px 133.537px;" id="el22gdd7gztpy" class="animable"></path><path d="M428.28,135.38s-1.63.09-3.66.11-3.66,0-3.66-.05,1.64-.09,3.66-.11S428.28,135.34,428.28,135.38Z" style="fill: rgb(38, 50, 56); transform-origin: 424.62px 135.411px;" id="elppqzx8ajpi" class="animable"></path><path d="M361.64,137.52s.05,0,.15,0l.42,0,1.57,0,0,0c0-.35,0-.73,0-1.13,0-.22,0-.41,0-.66a.6.6,0,0,1,.52-.48c.25,0,.47,0,.75,0a.6.6,0,0,1,.51.6c0,.53,0,1.08,0,1.65l-.07-.07,2,0-.08.08c0-.79,0-1.62,0-2.46v-.62a.62.62,0,0,0-.28-.47l-.86-.85-.83-.82-.41-.4c-.14-.13-.24-.27-.41-.3a.52.52,0,0,0-.45.08c-.12.1-.25.25-.37.36l-.7.72c-.45.46-.91.88-1.25,1.28a1.42,1.42,0,0,0-.1.74v.69c0,.43,0,.8,0,1.12s0,.53,0,.72v.26a1.1,1.1,0,0,1,0-.24c0-.19,0-.42,0-.71l0-1.12c0-.23,0-.46,0-.71v-.39a.74.74,0,0,1,.11-.41c.36-.45.8-.85,1.25-1.32.22-.24.46-.48.7-.72a4.54,4.54,0,0,1,.38-.38.68.68,0,0,1,.57-.11,1,1,0,0,1,.47.34l.41.39.83.82.87.85a1.74,1.74,0,0,1,.22.24.64.64,0,0,1,.1.33c0,.21,0,.42,0,.63,0,.84,0,1.66,0,2.46v.07h-.08l-2,0h-.07v-.07c0-.58,0-1.13,0-1.66a.48.48,0,0,0-.4-.48h-.72a.48.48,0,0,0-.42.38c0,.2,0,.43,0,.63v1.18h-2.18Z" style="fill: rgb(38, 50, 56); transform-origin: 364.65px 134.504px;" id="elfbf1e04y2iq" class="animable"></path><rect x="365.46" y="199.95" width="55.84" height="11.41" style="fill: rgb(235, 235, 235); transform-origin: 393.38px 205.655px;" id="el8n3miwy0jnd" class="animable"></rect><rect x="365.46" y="216.5" width="55.84" height="11.41" style="fill: rgb(235, 235, 235); transform-origin: 393.38px 222.205px;" id="elhg40rij2hgl" class="animable"></rect><path d="M407.88,250.58h-28a5.71,5.71,0,0,1-5.7-5.71h0a5.7,5.7,0,0,1,5.7-5.7h28a5.7,5.7,0,0,1,5.7,5.7h0A5.71,5.71,0,0,1,407.88,250.58Z" style="fill: rgb(33, 158, 188); transform-origin: 393.88px 244.875px;" id="elch9kbopfe4a" class="animable"></path><path d="M411.25,171.15c0,.28-7.84.51-17.52.51s-17.52-.23-17.52-.51,7.84-.51,17.52-.51S411.25,170.87,411.25,171.15Z" style="fill: rgb(38, 50, 56); transform-origin: 393.73px 171.15px;" id="el3t0rc5alqsl" class="animable"></path><path d="M375.07,103.85h-7.18a5.31,5.31,0,0,0-2.16.23,3.37,3.37,0,0,0-1.71,1.52,3.74,3.74,0,0,0-.4,1.15,6.76,6.76,0,0,0-.05,1.28v1.32a7.12,7.12,0,0,1-.09,1.37,3.65,3.65,0,0,1-1.6,2.31,3.45,3.45,0,0,1-1.41.5c-.51,0-1,0-1.52,0h-26a4.12,4.12,0,0,1-1-.1,3.49,3.49,0,0,1-1.79-1.11,3.77,3.77,0,0,1-.87-2,9.75,9.75,0,0,1,0-1.08v-1.07a5.77,5.77,0,0,0-.21-2.12,3.45,3.45,0,0,0-1.28-1.68,3.33,3.33,0,0,0-2.07-.57H309.05a10.94,10.94,0,0,0-8.84,3.92,11.15,11.15,0,0,0-2.28,4.59c-.11.43-.14.86-.22,1.29s0,.74,0,1.11V291.91a11.32,11.32,0,0,0,.45,3.48,10.94,10.94,0,0,0,4.26,5.89,11.37,11.37,0,0,0,7,1.94h22.26l28.92,0h14.09c2.32,0,4.65,0,6.93,0a10.9,10.9,0,0,0,6.22-2.41,11.57,11.57,0,0,0,2.25-2.49,11,11,0,0,0,1.37-3,11.16,11.16,0,0,0,.42-3.3v-3.35q0-6.7,0-13.23c0-34.85,0-66.23.05-92.59s0-47.68.06-62.42c0-1.85,0-3.59,0-5.22a11.36,11.36,0,0,0-.81-4.46,11,11,0,0,0-2.08-3.28,11,11,0,0,0-6.62-3.5,8.49,8.49,0,0,0-1.12-.1l-.38,0h-1.5Z" style="fill: rgb(250, 250, 250); transform-origin: 344.834px 203.514px;" id="elf9dh9tw3j5l" class="animable"></path><path d="M381.06,104h.38a10.1,10.1,0,0,1,1.12.09,10.47,10.47,0,0,1,4.15,1.43,10.75,10.75,0,0,1,2.53,2,11.06,11.06,0,0,1,2.1,3.3,11.34,11.34,0,0,1,.83,4.49c0,1.64,0,3.38,0,5.22,0,14.74,0,36.07,0,62.43s0,57.74,0,92.58v16.58a11.7,11.7,0,0,1-.42,3.38,11.12,11.12,0,0,1-1.42,3.12,11.89,11.89,0,0,1-2.3,2.56,11.25,11.25,0,0,1-6.39,2.48c-2.32.06-4.62,0-6.95,0H309.47a11.65,11.65,0,0,1-7.2-2,11.32,11.32,0,0,1-4.39-6.05,12.21,12.21,0,0,1-.46-3.75V273.37q0-14.7,0-28.93c0-19,0-37.26,0-54.68s0-34,0-49.49c0-7.74,0-15.23,0-22.42v-2.68c0-.45,0-.9.06-1.35s.12-.88.23-1.31a11.32,11.32,0,0,1,2.33-4.69,11.5,11.5,0,0,1,4.1-3.07,11.68,11.68,0,0,1,4.92-.93h16.56a3.53,3.53,0,0,1,2.18.61,3.72,3.72,0,0,1,1.35,1.78,5.8,5.8,0,0,1,.22,2.18v1.08a7.26,7.26,0,0,0,0,1.05,3.55,3.55,0,0,0,.82,1.85,3.28,3.28,0,0,0,1.69,1,3.37,3.37,0,0,0,1,.1h5l14.59,0H359c.5,0,1,0,1.5,0a3.25,3.25,0,0,0,1.36-.47,3.55,3.55,0,0,0,1.55-2.23,6.81,6.81,0,0,0,.09-1.35v-1.32a6.93,6.93,0,0,1,.06-1.29,3.82,3.82,0,0,1,.41-1.19,3.57,3.57,0,0,1,1.77-1.56,5.58,5.58,0,0,1,2.2-.23l7.17,0,4.42,0h1.5l-1.5,0H368a5.5,5.5,0,0,0-2.16.24,3.32,3.32,0,0,0-1.71,1.52,3.28,3.28,0,0,0-.4,1.15,7.56,7.56,0,0,0-.06,1.27v1.32a6.34,6.34,0,0,1-.08,1.37,3.6,3.6,0,0,1-1.6,2.31,3.36,3.36,0,0,1-1.41.5c-.51,0-1,0-1.52,0H333a3.67,3.67,0,0,1-1-.1,3.5,3.5,0,0,1-1.79-1.1,3.69,3.69,0,0,1-.87-2,7.92,7.92,0,0,1,0-1.08v-1.08a5.79,5.79,0,0,0-.21-2.12,3.51,3.51,0,0,0-1.29-1.68,3.3,3.3,0,0,0-2.06-.57H309.13a11.36,11.36,0,0,0-4.83.92,11,11,0,0,0-6.29,7.6c-.11.42-.14.86-.22,1.29s-.05.87-.06,1.32v2.68c0,7.19,0,14.68,0,22.42v133.1c0,4.89,0,9.83,0,14.79v3.73a11.86,11.86,0,0,0,.45,3.66,11,11,0,0,0,4.27,5.89,11.35,11.35,0,0,0,7,1.93h65.28c2.32,0,4.65,0,6.93,0A10.91,10.91,0,0,0,387.9,301a11.78,11.78,0,0,0,2.25-2.48,11.09,11.09,0,0,0,1.37-3,11.81,11.81,0,0,0,.42-3.3V275.57c0-34.84,0-66.23.05-92.58s.05-47.69.07-62.43v-5.22a11.31,11.31,0,0,0-.8-4.45,11.09,11.09,0,0,0-2.08-3.29,10.84,10.84,0,0,0-2.5-2,10.64,10.64,0,0,0-4.12-1.46,8.49,8.49,0,0,0-1.12-.1Z" style="fill: rgb(38, 50, 56); transform-origin: 344.793px 203.73px;" id="el55r5scn86sc" class="animable"></path><path d="M383.2,121.89s-1.83.1-4.08.12S375,122,375,122s1.83-.1,4.09-.12S383.2,121.84,383.2,121.89Z" style="fill: rgb(38, 50, 56); transform-origin: 379.1px 121.938px;" id="eldncdfygr2ki" class="animable"></path><path d="M383.22,124s-1.83.1-4.09.12-4.08,0-4.08,0,1.83-.1,4.08-.12S383.22,123.93,383.22,124Z" style="fill: rgb(38, 50, 56); transform-origin: 379.135px 124.046px;" id="elbrafcnvntl" class="animable"></path><path d="M383.23,126.07c0,.05-1.82.1-4.08.12s-4.08,0-4.08,0,1.82-.1,4.08-.12S383.23,126,383.23,126.07Z" style="fill: rgb(38, 50, 56); transform-origin: 379.15px 126.116px;" id="elekbioh0vtt" class="animable"></path><path d="M308.9,128.46s.06,0,.17,0l.47,0,1.75,0-.05.05c0-.39,0-.81,0-1.27,0-.23,0-.45,0-.72a.68.68,0,0,1,.59-.54c.28,0,.53,0,.83,0a.68.68,0,0,1,.57.68c0,.59,0,1.2,0,1.84l-.08-.08,2.2,0-.08.09c0-.89,0-1.81,0-2.75V125a.69.69,0,0,0-.31-.52l-1-1-.93-.92-.45-.44c-.15-.15-.28-.31-.46-.34a.59.59,0,0,0-.5.09c-.13.12-.28.28-.41.41l-.79.79c-.5.52-1,1-1.39,1.44a1.51,1.51,0,0,0-.11.82v.77c0,.48,0,.89,0,1.25s0,.58,0,.8a1.43,1.43,0,0,1,0,.29s0-.09,0-.27,0-.47,0-.78,0-.78,0-1.26c0-.25,0-.51,0-.79s0-.29,0-.43a.9.9,0,0,1,.13-.47c.4-.49.89-.94,1.39-1.47l.78-.8a5.75,5.75,0,0,1,.43-.42.75.75,0,0,1,.64-.13,1.28,1.28,0,0,1,.52.38l.45.44.94.92,1,.94a2.21,2.21,0,0,1,.25.27.7.7,0,0,1,.11.37c0,.23,0,.47,0,.7,0,.94,0,1.86,0,2.74v.09h-2.37v-.08c0-.64,0-1.25,0-1.84a.53.53,0,0,0-.44-.54c-.25,0-.55,0-.8,0a.53.53,0,0,0-.47.43,5.45,5.45,0,0,0,0,.7v1.32h0l-1.77,0h-.62Z" style="fill: rgb(38, 50, 56); transform-origin: 312.23px 125.053px;" id="elqpg9aed0s8o" class="animable"></path><g id="ellqajy8e036m"><circle cx="346.1" cy="169.69" r="18.48" style="fill: rgb(33, 158, 188); transform-origin: 346.1px 169.69px; transform: rotate(-81.2deg);" class="animable"></circle></g><path d="M352.44,177.15H339.76v-1.56a6.34,6.34,0,0,1,6.34-6.34h0a6.34,6.34,0,0,1,6.34,6.34Z" style="fill: rgb(255, 255, 255); transform-origin: 346.1px 173.2px;" id="elex67nskg6ab" class="animable"></path><circle cx="346.1" cy="165.97" r="3.73" style="fill: rgb(255, 255, 255); transform-origin: 346.1px 165.97px;" id="elelygiwa1slb" class="animable"></circle><rect x="313.17" y="209.33" width="62.28" height="12.72" style="fill: rgb(235, 235, 235); transform-origin: 344.31px 215.69px;" id="elrud6qrnd0fo" class="animable"></rect><rect x="313.17" y="227.79" width="62.28" height="12.72" style="fill: rgb(235, 235, 235); transform-origin: 344.31px 234.15px;" id="el25i2tm0s4zf" class="animable"></rect><path d="M360.48,265.79H329.22a6.35,6.35,0,0,1-6.36-6.36h0a6.36,6.36,0,0,1,6.36-6.36h31.26a6.36,6.36,0,0,1,6.36,6.36h0A6.36,6.36,0,0,1,360.48,265.79Z" style="fill: rgb(33, 158, 188); transform-origin: 344.85px 259.43px;" id="eluso2duxoyr" class="animable"></path><path d="M364.37,201.67c0,.31-8.75.57-19.54.57s-19.55-.26-19.55-.57,8.75-.58,19.55-.58S364.37,201.35,364.37,201.67Z" style="fill: rgb(38, 50, 56); transform-origin: 344.825px 201.665px;" id="elmfl64rkjyqo" class="animable"></path><path d="M321.77,218.49H319a.48.48,0,0,1-.49-.48h0a1.83,1.83,0,0,1,1.83-1.84h.06a1.84,1.84,0,0,1,1.84,1.84h0A.48.48,0,0,1,321.77,218.49Z" style="fill: rgb(224, 224, 224); transform-origin: 320.375px 217.33px;" id="elg6fkef3bexd" class="animable"></path><path d="M321.49,215.21a1.1,1.1,0,1,1-1.1-1.1A1.09,1.09,0,0,1,321.49,215.21Z" style="fill: rgb(224, 224, 224); transform-origin: 320.39px 215.21px;" id="el2kye2ojvrdp" class="animable"></path><rect x="318.75" y="234.35" width="3.28" height="2.32" style="fill: rgb(224, 224, 224); transform-origin: 320.39px 235.51px;" id="el3fr16nkpf51" class="animable"></rect><path d="M322.4,234.85h-1.1v-.72a.93.93,0,0,0-1.86,0v.72h-1.1v-.72a2,2,0,1,1,4.06,0Z" style="fill: rgb(224, 224, 224); transform-origin: 320.37px 233.475px;" id="elj904hglkgj" class="animable"></path><path d="M309.11,64.81l-10.69,0a8.06,8.06,0,0,0-3.22.35,5,5,0,0,0-2.54,2.26,5.27,5.27,0,0,0-.6,1.71A9.87,9.87,0,0,0,292,71v2a8.79,8.79,0,0,1-.13,2,5.38,5.38,0,0,1-2.38,3.44,5.05,5.05,0,0,1-2.1.75c-.76.06-1.5,0-2.27,0H246.33a5.87,5.87,0,0,1-1.55-.15,5.08,5.08,0,0,1-2.66-1.65,5.35,5.35,0,0,1-1.3-2.9,10.8,10.8,0,0,1-.06-1.6V71.37a8.53,8.53,0,0,0-.32-3.15,5.14,5.14,0,0,0-1.91-2.5,5,5,0,0,0-3.08-.85H210.79a16.36,16.36,0,0,0-13.17,5.84,16.56,16.56,0,0,0-3.39,6.84c-.16.62-.21,1.28-.33,1.92s-.05,1.09-.07,1.64v263.6a17.13,17.13,0,0,0,.66,5.19,16.41,16.41,0,0,0,6.35,8.76,16.94,16.94,0,0,0,10.47,2.88h33.15l43.07,0h21c3.45,0,6.92.06,10.33,0a16.21,16.21,0,0,0,9.26-3.59,17.53,17.53,0,0,0,3.34-3.7,16.18,16.18,0,0,0,2.05-4.52,17.27,17.27,0,0,0,.62-4.91v-5q0-10,0-19.68c0-51.87.05-98.57.07-137.8s.08-71,.1-92.91c0-2.75,0-5.34,0-7.77a17,17,0,0,0-1.2-6.63,16.32,16.32,0,0,0-3.1-4.89,15.55,15.55,0,0,0-3.72-3A15.77,15.77,0,0,0,320.15,65a13.39,13.39,0,0,0-1.67-.15l-.56,0-2.24,0Z" style="fill: rgb(250, 250, 250); transform-origin: 264.064px 213.171px;" id="el3rqu4pt4lyb" class="animable"></path><path d="M318.08,64.87l.57,0a12.19,12.19,0,0,1,1.66.12,15.67,15.67,0,0,1,6.17,2.13,15.91,15.91,0,0,1,3.75,3,16.36,16.36,0,0,1,3.13,4.91,17.12,17.12,0,0,1,1.23,6.67c0,2.43,0,5,0,7.75,0,21.9,0,53.59,0,92.74s0,85.78,0,137.54v24.64a17.71,17.71,0,0,1-.63,5,16.83,16.83,0,0,1-2.1,4.63,17.67,17.67,0,0,1-3.42,3.8,16.64,16.64,0,0,1-9.5,3.69c-3.44.1-6.87,0-10.33,0H287.77l-43,0H211.74a17.41,17.41,0,0,1-10.71-3,16.8,16.8,0,0,1-6.51-9,18.09,18.09,0,0,1-.69-5.56V338.5q0-11.07,0-22,0-21.82,0-43c0-28.17,0-55.34,0-81.23s0-50.49,0-73.51q0-17.26,0-33.32c0-1.33,0-2.66,0-4,0-.66.05-1.33.09-2s.16-1.32.33-2a17,17,0,0,1,3.46-7,16.68,16.68,0,0,1,13.41-5.94l14.32,0h10.27a5.25,5.25,0,0,1,3.24.9,5.44,5.44,0,0,1,2,2.65,8.74,8.74,0,0,1,.33,3.24v1.6a11.61,11.61,0,0,0,0,1.57,5.16,5.16,0,0,0,1.23,2.75,4.86,4.86,0,0,0,2.51,1.56,6.1,6.1,0,0,0,1.48.15h7.45l21.67,0h9.56c.75,0,1.52,0,2.24,0a4.88,4.88,0,0,0,2-.7,5.17,5.17,0,0,0,2.3-3.31,8.93,8.93,0,0,0,.13-2c0-.67,0-1.32,0-2a11.06,11.06,0,0,1,.08-1.91,5.5,5.5,0,0,1,.62-1.76,5.19,5.19,0,0,1,2.63-2.32,8.17,8.17,0,0,1,3.26-.35l10.66,0,6.56,0,2.23,0-2.23,0-6.56,0-10.66,0a8.18,8.18,0,0,0-3.21.34,5.11,5.11,0,0,0-2.54,2.26,5.43,5.43,0,0,0-.59,1.71,9.87,9.87,0,0,0-.08,1.89v2a8.74,8.74,0,0,1-.13,2,5.38,5.38,0,0,1-2.38,3.44,5.08,5.08,0,0,1-2.09.74c-.76.07-1.5,0-2.26,0H246.67a5.76,5.76,0,0,1-1.54-.16,5.13,5.13,0,0,1-2.66-1.64,5.5,5.5,0,0,1-1.3-2.89,12.48,12.48,0,0,1,0-1.61v-1.6a8.75,8.75,0,0,0-.32-3.15,5.11,5.11,0,0,0-1.91-2.49,5,5,0,0,0-3.07-.85h-24.6a16.31,16.31,0,0,0-13.13,5.83,16.34,16.34,0,0,0-3.38,6.82c-.17.63-.22,1.28-.33,1.92s-.08,1.3-.09,2v4q0,16,0,33.32c0,23,0,47.62,0,73.51s0,53.06,0,81.23v43q0,10.91,0,22V344a18.06,18.06,0,0,0,.67,5.43,16.36,16.36,0,0,0,6.34,8.75,16.86,16.86,0,0,0,10.44,2.87h33.07l43,0H308.7c3.45,0,6.91.06,10.31,0a16.11,16.11,0,0,0,9.23-3.58,17.26,17.26,0,0,0,3.34-3.7,16,16,0,0,0,2-4.51,16.83,16.83,0,0,0,.62-4.89v-5q0-9.93,0-19.65c0-51.76.05-98.38.08-137.54s.07-70.84.09-92.74c0-2.74,0-5.32,0-7.75a16.87,16.87,0,0,0-1.2-6.62,16.25,16.25,0,0,0-3.09-4.88,15.81,15.81,0,0,0-3.71-3,15.6,15.6,0,0,0-6.12-2.16,13.42,13.42,0,0,0-1.66-.15Z" style="fill: rgb(38, 50, 56); transform-origin: 264.207px 213.011px;" id="elrbmeuo2mzdf" class="animable"></path><path d="M321.26,91.49c0,.07-2.71.15-6.06.18s-6.07,0-6.07-.08,2.71-.15,6.06-.18S321.26,91.42,321.26,91.49Z" style="fill: rgb(38, 50, 56); transform-origin: 315.195px 91.5407px;" id="el4n452l0qwfo" class="animable"></path><path d="M321.29,94.6c0,.07-2.72.15-6.07.17s-6.07,0-6.07-.07,2.72-.15,6.07-.18S321.29,94.52,321.29,94.6Z" style="fill: rgb(38, 50, 56); transform-origin: 315.22px 94.643px;" id="elt52i37vp4lh" class="animable"></path><path d="M321.31,97.7c0,.07-2.71.15-6.06.18s-6.07,0-6.07-.08,2.71-.15,6.06-.18S321.31,97.63,321.31,97.7Z" style="fill: rgb(38, 50, 56); transform-origin: 315.245px 97.7507px;" id="elq9zpulj044" class="animable"></path><path d="M210.88,101.24h.26l.7,0,2.59-.06-.07.08c0-.58,0-1.21,0-1.88,0-.35,0-.68,0-1.09a1,1,0,0,1,.87-.79c.42,0,.79,0,1.24,0a1,1,0,0,1,.85,1c0,.88,0,1.79,0,2.74l-.12-.12,3.27,0-.13.13q0-2,0-4.08c0-.35,0-.69,0-1a1.08,1.08,0,0,0-.46-.78l-1.43-1.41L217,92.51l-.67-.66c-.23-.22-.41-.45-.67-.5a.9.9,0,0,0-.75.14c-.2.17-.41.41-.61.6l-1.17,1.18c-.74.77-1.51,1.47-2.07,2.13a2.31,2.31,0,0,0-.16,1.22v1.15c0,.71,0,1.33,0,1.86s0,.87,0,1.19a2,2,0,0,1,0,.42s0-.12,0-.39,0-.7,0-1.17,0-1.16,0-1.87c0-.37,0-.76,0-1.17,0-.21,0-.43,0-.64a1.21,1.21,0,0,1,.18-.69c.6-.74,1.32-1.4,2.07-2.18l1.16-1.2c.21-.2.38-.41.63-.62a1.14,1.14,0,0,1,.95-.19,1.75,1.75,0,0,1,.78.56l.67.66c.46.44.92.9,1.39,1.36L220,95.1a2.88,2.88,0,0,1,.36.4,1.06,1.06,0,0,1,.18.55v1c0,1.4,0,2.76,0,4.07v.13h-.13l-3.27,0h-.12v-.12c0-1,0-1.86,0-2.74a.8.8,0,0,0-.66-.79c-.38,0-.82,0-1.19,0a.81.81,0,0,0-.7.64c0,.33,0,.71,0,1v2h-.07l-2.63,0h-.69A1,1,0,0,1,210.88,101.24Z" style="fill: rgb(38, 50, 56); transform-origin: 215.709px 96.1735px;" id="elvswk22vym0f" class="animable"></path><rect x="206.01" y="117.65" width="114.62" height="20.85" rx="8.79" style="fill: rgb(245, 245, 245); transform-origin: 263.32px 128.075px;" id="elv5jcor2zcvs" class="animable"></rect><path d="M311.83,138.5l.66-.05a8.72,8.72,0,0,0,4.65-1.82,8.67,8.67,0,0,0,2.61-3.31,8.24,8.24,0,0,0,.69-2.43,21.46,21.46,0,0,0,.08-2.81,18.67,18.67,0,0,0-.13-3.06,8.8,8.8,0,0,0-1.14-3,8.68,8.68,0,0,0-5.78-4,23.72,23.72,0,0,0-4-.15h-4.23l-90.45.06a8.59,8.59,0,0,0-8.54,7.86c-.08,1,0,2.14,0,3.2a10,10,0,0,0,.32,3.1,8.71,8.71,0,0,0,3.56,4.86,8.29,8.29,0,0,0,2.77,1.18,13.2,13.2,0,0,0,3,.23h17.82l40.66,0,27.41.07,7.46,0,1.93,0,.66,0s-.22,0-.66,0l-1.93,0-7.46,0-27.41.06-40.66,0H215.89a13.12,13.12,0,0,1-3.11-.23,8.83,8.83,0,0,1-2.91-1.24,9,9,0,0,1-3.73-5.1,10.27,10.27,0,0,1-.34-3.21c0-1.08,0-2.12,0-3.23a9,9,0,0,1,9-8.26l90.45.06h4.23a24.6,24.6,0,0,1,4,.17,8.94,8.94,0,0,1,7.09,7.31,19.18,19.18,0,0,1,.12,3.09,23.72,23.72,0,0,1-.1,2.83,8.66,8.66,0,0,1-.72,2.47,8.82,8.82,0,0,1-2.69,3.35,9,9,0,0,1-2.81,1.43,8.8,8.8,0,0,1-1.91.33C312.06,138.51,311.83,138.5,311.83,138.5Z" style="fill: rgb(38, 50, 56); transform-origin: 263.246px 127.862px;" id="el9jt1ndhiv" class="animable"></path><path d="M313.6,127.58s0-.33-.2-.9a3.74,3.74,0,0,0-1.38-2,3.59,3.59,0,1,0,0,5.76,3.71,3.71,0,0,0,1.38-2c.17-.56.16-.9.2-.9s0,.08,0,.24a2.79,2.79,0,0,1-.06.7,3.73,3.73,0,0,1-1.37,2.18,3.9,3.9,0,0,1-3.73.61,4,4,0,0,1,0-7.46,3.92,3.92,0,0,1,3.73.61,3.76,3.76,0,0,1,1.37,2.18,2.79,2.79,0,0,1,.06.7Q313.63,127.58,313.6,127.58Z" style="fill: rgb(38, 50, 56); transform-origin: 309.751px 127.541px;" id="el70msm98r93" class="animable"></path><path d="M315.68,134.09a7.62,7.62,0,0,1-1.85-1.68,7.36,7.36,0,0,1-1.53-2,7.6,7.6,0,0,1,1.85,1.69A7.41,7.41,0,0,1,315.68,134.09Z" style="fill: rgb(38, 50, 56); transform-origin: 313.99px 132.25px;" id="elzrl5ev2s2wn" class="animable"></path><path d="M221.48,126h-2v-.53h4.7V126h-2v5.29h-.62Z" style="fill: rgb(224, 224, 224); transform-origin: 221.83px 128.38px;" id="eljf0ef2s45re" class="animable"></path><path d="M228.35,129.28h-3.66a1.62,1.62,0,0,0,1.72,1.52,1.71,1.71,0,0,0,1.34-.58l.33.39a2.31,2.31,0,0,1-4-1.52,2.11,2.11,0,0,1,2.14-2.22,2.08,2.08,0,0,1,2.11,2.22Zm-3.66-.44h3.1a1.55,1.55,0,0,0-3.1,0Z" style="fill: rgb(224, 224, 224); transform-origin: 226.214px 129.108px;" id="elwf99bsp7rck" class="animable"></path><path d="M232.22,131.28l-1.39-1.83-1.4,1.83h-.66L230.5,129l-1.65-2.13h.67l1.31,1.71,1.31-1.71h.65L231.15,129l1.74,2.24Z" style="fill: rgb(224, 224, 224); transform-origin: 230.83px 129.075px;" id="elg5fwxmlj5ji" class="animable"></path><path d="M236.18,131a1.43,1.43,0,0,1-.93.31,1.16,1.16,0,0,1-1.28-1.27v-2.64h-.78v-.5H234v-1h.59v1h1.33v.5h-1.33V130a.7.7,0,0,0,.76.79,1,1,0,0,0,.65-.22Z" style="fill: rgb(224, 224, 224); transform-origin: 234.685px 128.608px;" id="ela318f8dlxuk" class="animable"></path><path d="M284.19,158.36c0,.12-8.39.21-18.73.21s-18.74-.09-18.74-.21,8.39-.22,18.74-.22S284.19,158.24,284.19,158.36Z" style="fill: rgb(33, 158, 188); transform-origin: 265.455px 158.355px;" id="elnopmyf9wysi" class="animable"></path><path d="M314.07,166.05c0,.12-15.08.21-33.67.21s-33.68-.09-33.68-.21,15.08-.22,33.68-.22S314.07,165.93,314.07,166.05Z" style="fill: rgb(38, 50, 56); transform-origin: 280.395px 166.045px;" id="eljabczboxogi" class="animable"></path><path d="M313.28,171.54c0,.12-14.9.21-33.28.21s-33.28-.09-33.28-.21,14.9-.21,33.28-.21S313.28,171.42,313.28,171.54Z" style="fill: rgb(38, 50, 56); transform-origin: 280px 171.54px;" id="el7owj6d0wj8g" class="animable"></path><path d="M286,176.78c0,.12-8.8.21-19.65.21s-19.65-.09-19.65-.21,8.8-.21,19.65-.21S286,176.66,286,176.78Z" style="fill: rgb(38, 50, 56); transform-origin: 266.35px 176.78px;" id="elziwxofl11p" class="animable"></path><path d="M284.19,200.16c0,.11-8.39.21-18.73.21s-18.74-.1-18.74-.21,8.39-.22,18.74-.22S284.19,200,284.19,200.16Z" style="fill: rgb(33, 158, 188); transform-origin: 265.455px 200.155px;" id="el52fi1sst5v5" class="animable"></path><path d="M314.07,207.85c0,.11-15.08.21-33.67.21s-33.68-.1-33.68-.21,15.08-.22,33.68-.22S314.07,207.73,314.07,207.85Z" style="fill: rgb(38, 50, 56); transform-origin: 280.395px 207.845px;" id="elaaw929p3w8w" class="animable"></path><path d="M313.28,213.34c0,.12-14.9.21-33.28.21s-33.28-.09-33.28-.21,14.9-.22,33.28-.22S313.28,213.22,313.28,213.34Z" style="fill: rgb(38, 50, 56); transform-origin: 280px 213.335px;" id="elq11qoc6yldb" class="animable"></path><path d="M286,218.58c0,.11-8.8.21-19.65.21s-19.65-.1-19.65-.21,8.8-.22,19.65-.22S286,218.46,286,218.58Z" style="fill: rgb(38, 50, 56); transform-origin: 266.35px 218.575px;" id="elbjldm1ag4pn" class="animable"></path><path d="M284.19,242c0,.12-8.39.22-18.73.22s-18.74-.1-18.74-.22,8.39-.21,18.74-.21S284.19,241.84,284.19,242Z" style="fill: rgb(33, 158, 188); transform-origin: 265.455px 242.005px;" id="elyg10t5egk4n" class="animable"></path><path d="M314.07,249.64c0,.12-15.08.22-33.67.22s-33.68-.1-33.68-.22,15.08-.21,33.68-.21S314.07,249.53,314.07,249.64Z" style="fill: rgb(38, 50, 56); transform-origin: 280.395px 249.645px;" id="elgofufyiycqp" class="animable"></path><path d="M313.28,255.14c0,.11-14.9.21-33.28.21s-33.28-.1-33.28-.21,14.9-.22,33.28-.22S313.28,255,313.28,255.14Z" style="fill: rgb(38, 50, 56); transform-origin: 280px 255.135px;" id="eloas5qalyu3" class="animable"></path><path d="M286,260.37c0,.12-8.8.22-19.65.22s-19.65-.1-19.65-.22,8.8-.21,19.65-.21S286,260.26,286,260.37Z" style="fill: rgb(38, 50, 56); transform-origin: 266.35px 260.375px;" id="elq2o1jz9z94j" class="animable"></path><path d="M284.19,283.75c0,.12-8.39.21-18.73.21s-18.74-.09-18.74-.21,8.39-.21,18.74-.21S284.19,283.63,284.19,283.75Z" style="fill: rgb(33, 158, 188); transform-origin: 265.455px 283.75px;" id="ell3jvk82bpws" class="animable"></path><path d="M314.07,291.44c0,.12-15.08.21-33.67.21s-33.68-.09-33.68-.21,15.08-.21,33.68-.21S314.07,291.32,314.07,291.44Z" style="fill: rgb(38, 50, 56); transform-origin: 280.395px 291.44px;" id="el9pzlgz56pko" class="animable"></path><path d="M313.28,296.93c0,.12-14.9.22-33.28.22s-33.28-.1-33.28-.22,14.9-.21,33.28-.21S313.28,296.82,313.28,296.93Z" style="fill: rgb(38, 50, 56); transform-origin: 280px 296.935px;" id="elv6voyh9c5yr" class="animable"></path><path d="M286,302.17c0,.12-8.8.22-19.65.22s-19.65-.1-19.65-.22,8.8-.21,19.65-.21S286,302.05,286,302.17Z" style="fill: rgb(38, 50, 56); transform-origin: 266.35px 302.175px;" id="el3pbsw751ytt" class="animable"></path><path d="M284.19,325.26c0,.11-8.39.21-18.73.21s-18.74-.1-18.74-.21,8.39-.22,18.74-.22S284.19,325.14,284.19,325.26Z" style="fill: rgb(33, 158, 188); transform-origin: 265.455px 325.255px;" id="elpveark2z2vr" class="animable"></path><path d="M314.07,333c0,.11-15.08.21-33.67.21s-33.68-.1-33.68-.21,15.08-.22,33.68-.22S314.07,332.83,314.07,333Z" style="fill: rgb(38, 50, 56); transform-origin: 280.395px 332.995px;" id="elstb2jd29nh" class="animable"></path><path d="M313.28,338.44c0,.12-14.9.21-33.28.21s-33.28-.09-33.28-.21,14.9-.21,33.28-.21S313.28,338.32,313.28,338.44Z" style="fill: rgb(38, 50, 56); transform-origin: 280px 338.44px;" id="el3z8jgd8zfwh" class="animable"></path><path d="M286,343.68c0,.12-8.8.21-19.65.21s-19.65-.09-19.65-.21,8.8-.22,19.65-.22S286,343.56,286,343.68Z" style="fill: rgb(38, 50, 56); transform-origin: 266.35px 343.675px;" id="els3dhkn30q9o" class="animable"></path><g id="elbn2taa9hzde"><rect x="210.32" y="154.34" width="22.94" height="30.52" style="fill: rgb(33, 158, 188); transform-origin: 221.79px 169.6px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="206.46 180.99 217.2 166.79 223.76 175.75 228.26 171 236.99 181.16 206.46 180.99" style="fill: rgb(33, 158, 188); transform-origin: 221.725px 173.975px;" id="el49lrmxqz29j" class="animable"></polygon><path d="M226.62,165.09a2.41,2.41,0,1,1-2.39-2.41A2.4,2.4,0,0,1,226.62,165.09Z" style="fill: rgb(33, 158, 188); transform-origin: 224.21px 165.09px;" id="el8cgyatdrfnm" class="animable"></path><g id="elca2bv8sjk8n"><g style="opacity: 0.2; transform-origin: 221.725px 173.975px;" class="animable"><polygon points="206.46 180.99 217.2 166.79 223.76 175.75 228.26 171 236.99 181.16 206.46 180.99" id="el6c9mwzfm3js" class="animable" style="transform-origin: 221.725px 173.975px;"></polygon></g></g><g id="elzkghscb3xh"><g style="opacity: 0.2; transform-origin: 224.21px 165.09px;" class="animable"><path d="M226.62,165.09a2.41,2.41,0,1,1-2.39-2.41A2.4,2.4,0,0,1,226.62,165.09Z" id="eluclup6l6tnb" class="animable" style="transform-origin: 224.21px 165.09px;"></path></g></g><g id="el6aw9o0guyob"><rect x="210.32" y="195.61" width="22.94" height="30.52" style="fill: rgb(33, 158, 188); transform-origin: 221.79px 210.87px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="206.46 222.25 217.2 208.05 223.76 217.01 228.26 212.27 236.99 222.43 206.46 222.25" style="fill: rgb(33, 158, 188); transform-origin: 221.725px 215.24px;" id="el5xu4xo50qpa" class="animable"></polygon><path d="M226.62,206.36a2.41,2.41,0,1,1-2.39-2.42A2.4,2.4,0,0,1,226.62,206.36Z" style="fill: rgb(33, 158, 188); transform-origin: 224.21px 206.35px;" id="elpvrh4tigd6e" class="animable"></path><g id="eldpnnzeikcqq"><g style="opacity: 0.2; transform-origin: 221.725px 215.24px;" class="animable"><polygon points="206.46 222.25 217.2 208.05 223.76 217.01 228.26 212.27 236.99 222.43 206.46 222.25" id="elxfoxb8kin6" class="animable" style="transform-origin: 221.725px 215.24px;"></polygon></g></g><g id="elkx3znutiipr"><g style="opacity: 0.2; transform-origin: 224.21px 206.35px;" class="animable"><path d="M226.62,206.36a2.41,2.41,0,1,1-2.39-2.42A2.4,2.4,0,0,1,226.62,206.36Z" id="elwfc2ngwre2p" class="animable" style="transform-origin: 224.21px 206.35px;"></path></g></g><g id="elwfm21ri458"><rect x="210.32" y="236.87" width="22.94" height="30.52" style="fill: rgb(33, 158, 188); transform-origin: 221.79px 252.13px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="206.46 263.52 217.2 249.32 223.76 258.28 228.26 253.53 236.99 263.69 206.46 263.52" style="fill: rgb(33, 158, 188); transform-origin: 221.725px 256.505px;" id="elhrgmm9ea3zi" class="animable"></polygon><path d="M226.62,247.63a2.41,2.41,0,1,1-2.39-2.42A2.42,2.42,0,0,1,226.62,247.63Z" style="fill: rgb(33, 158, 188); transform-origin: 224.21px 247.62px;" id="el890hohf2rkb" class="animable"></path><g id="ele2wnl3ngqkv"><g style="opacity: 0.2; transform-origin: 221.725px 256.505px;" class="animable"><polygon points="206.46 263.52 217.2 249.32 223.76 258.28 228.26 253.53 236.99 263.69 206.46 263.52" id="elaxm5z2r32u9" class="animable" style="transform-origin: 221.725px 256.505px;"></polygon></g></g><g id="el6js4gc9z51e"><g style="opacity: 0.2; transform-origin: 224.21px 247.62px;" class="animable"><path d="M226.62,247.63a2.41,2.41,0,1,1-2.39-2.42A2.42,2.42,0,0,1,226.62,247.63Z" id="elxojd3zytmj" class="animable" style="transform-origin: 224.21px 247.62px;"></path></g></g><g id="ele2ww3khgwpc"><rect x="210.32" y="278.14" width="22.94" height="30.52" style="fill: rgb(33, 158, 188); transform-origin: 221.79px 293.4px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="206.46 304.79 217.2 290.59 223.76 299.55 228.26 294.8 236.99 304.96 206.46 304.79" style="fill: rgb(33, 158, 188); transform-origin: 221.725px 297.775px;" id="elzsd5j5x6cw" class="animable"></polygon><path d="M226.62,288.89a2.41,2.41,0,1,1-2.39-2.41A2.4,2.4,0,0,1,226.62,288.89Z" style="fill: rgb(33, 158, 188); transform-origin: 224.21px 288.89px;" id="elwsd9gutu52q" class="animable"></path><g id="elyhpkf3wlyn"><g style="opacity: 0.2; transform-origin: 221.725px 297.775px;" class="animable"><polygon points="206.46 304.79 217.2 290.59 223.76 299.55 228.26 294.8 236.99 304.96 206.46 304.79" id="el9vao7tsxeom" class="animable" style="transform-origin: 221.725px 297.775px;"></polygon></g></g><g id="el2oex21tmzru"><g style="opacity: 0.2; transform-origin: 224.21px 288.89px;" class="animable"><path d="M226.62,288.89a2.41,2.41,0,1,1-2.39-2.41A2.4,2.4,0,0,1,226.62,288.89Z" id="el80djevnwxjx" class="animable" style="transform-origin: 224.21px 288.89px;"></path></g></g><g id="elbidm04qfynd"><rect x="210.32" y="319.2" width="22.94" height="30.52" style="fill: rgb(33, 158, 188); transform-origin: 221.79px 334.46px; transform: rotate(-89.68deg);" class="animable"></rect></g><polygon points="206.46 345.85 217.2 331.65 223.76 340.61 228.26 335.87 236.99 346.02 206.46 345.85" style="fill: rgb(33, 158, 188); transform-origin: 221.725px 338.835px;" id="elq3woupro08p" class="animable"></polygon><path d="M226.62,330a2.41,2.41,0,1,1-2.39-2.42A2.42,2.42,0,0,1,226.62,330Z" style="fill: rgb(33, 158, 188); transform-origin: 224.21px 329.99px;" id="el1batilbo2k6" class="animable"></path><g id="elk0sa1hweva"><g style="opacity: 0.2; transform-origin: 221.725px 338.835px;" class="animable"><polygon points="206.46 345.85 217.2 331.65 223.76 340.61 228.26 335.87 236.99 346.02 206.46 345.85" id="elv26kjtylydr" class="animable" style="transform-origin: 221.725px 338.835px;"></polygon></g></g><g id="el2lvxabzmvl5"><g style="opacity: 0.2; transform-origin: 224.21px 329.99px;" class="animable"><path d="M226.62,330a2.41,2.41,0,1,1-2.39-2.42A2.42,2.42,0,0,1,226.62,330Z" id="elva0wyesury" class="animable" style="transform-origin: 224.21px 329.99px;"></path></g></g><g id="elu3dtfmco488"><circle cx="436.02" cy="118.74" r="10.88" style="fill: rgb(33, 158, 188); transform-origin: 436.02px 118.74px; transform: rotate(-76.78deg);" class="animable"></circle></g><path d="M435.36,122.28a.47.47,0,0,1-.31-.12l-3.67-3a.5.5,0,0,1,.64-.78l3.27,2.7,4.65-5.69a.52.52,0,0,1,.71-.07.5.5,0,0,1,.07.7l-5,6.08a.48.48,0,0,1-.34.18Z" style="fill: rgb(255, 255, 255); transform-origin: 436.013px 118.746px;" id="el4e6u1r9w23h" class="animable"></path><circle cx="389.07" cy="103.82" r="14.92" style="fill: rgb(33, 158, 188); transform-origin: 389.07px 103.82px;" id="elv8d6jaoq4ig" class="animable"></circle><path d="M388.17,109a1,1,0,0,1-.63-.22l-5-4.14a1,1,0,0,1-.14-1.4,1,1,0,0,1,1.41-.14l4.24,3.49L394.21,99a1,1,0,0,1,1.4-.14,1,1,0,0,1,.14,1.41l-6.8,8.33a1.06,1.06,0,0,1-.68.36Z" style="fill: rgb(255, 255, 255); transform-origin: 389.077px 103.819px;" id="el5p6ppjgjwyn" class="animable"></path></g><g id="freepik--magnifying-glass--inject-41" class="animable animator-active" style="transform-origin: 351.512px 293.317px;"><path d="M325.79,306.42a31.08,31.08,0,0,1-22-36c-.28.76-.55,1.54-.78,2.34a31.1,31.1,0,0,0,59.82,17c.23-.8.41-1.61.57-2.41A31.08,31.08,0,0,1,325.79,306.42Z" style="fill: rgb(38, 50, 56); transform-origin: 332.691px 291.105px;" id="els5j8k6zkqsk" class="animable"></path><path d="M341.12,251.46a31.1,31.1,0,0,1,22,36c.28-.77.55-1.55.77-2.35a31.09,31.09,0,1,0-59.81-17c-.23.8-.41,1.6-.57,2.41A31.08,31.08,0,0,1,341.12,251.46Z" style="fill: rgb(69, 90, 100); transform-origin: 334.316px 266.408px;" id="eli7n28ssu57b" class="animable"></path><path d="M364.23,284.91s0-.17.09-.5.17-.83.3-1.44c.07-.32.15-.68.24-1.07s.1-.83.16-1.3a23.41,23.41,0,0,0,.25-3.26,29.76,29.76,0,0,0-1.07-8.87,31,31,0,0,0-16.1-19.68,30.18,30.18,0,0,0-3.64-1.5c-.63-.2-1.26-.45-1.91-.62l-2-.46c-.33-.07-.66-.16-1-.21l-1-.13c-.69-.08-1.38-.19-2.09-.24a32.37,32.37,0,0,0-4.29,0,32.7,32.7,0,0,0-4.35.6c-.72.17-1.43.39-2.16.58a16.87,16.87,0,0,0-2.14.73,34.7,34.7,0,0,0-4.18,1.9,34.27,34.27,0,0,0-3.88,2.62,29.8,29.8,0,0,0-6.56,7,30.63,30.63,0,0,0-5.33,18.72,29.86,29.86,0,0,0,1.92,9.38,32.8,32.8,0,0,0,1.93,4.26,33.84,33.84,0,0,0,2.55,3.82,16.13,16.13,0,0,0,1.44,1.75c.52.54,1,1.11,1.53,1.63a33.12,33.12,0,0,0,3.39,2.8,33.93,33.93,0,0,0,3.63,2.29c.62.32,1.27.59,1.9.89l.95.43c.32.14.65.23,1,.35l1.94.66c.64.19,1.31.32,1.95.48a27.73,27.73,0,0,0,3.88.63,31.07,31.07,0,0,0,24.05-8.27,29.48,29.48,0,0,0,5.57-7,22.61,22.61,0,0,0,1.5-2.91c.2-.43.4-.82.55-1.19l.36-1c.22-.59.38-1.06.5-1.39s.19-.47.19-.47,0,.17-.14.49-.26.8-.45,1.41c-.1.31-.21.65-.34,1s-.34.78-.53,1.21a21.6,21.6,0,0,1-1.46,2.95,29.82,29.82,0,0,1-5.55,7.09,31.23,31.23,0,0,1-24.29,8.48,28.42,28.42,0,0,1-3.93-.63c-.66-.16-1.33-.28-2-.48l-2-.66c-.32-.12-.66-.21-1-.35l-1-.44c-.64-.3-1.3-.57-1.93-.9A34.89,34.89,0,0,1,316,301.8a32.9,32.9,0,0,1-3.45-2.84c-.54-.53-1-1.1-1.56-1.65a16.53,16.53,0,0,1-1.46-1.77,34.53,34.53,0,0,1-2.6-3.88,36.06,36.06,0,0,1-2-4.33,30.19,30.19,0,0,1-2-9.54,30.88,30.88,0,0,1,5.41-19,30.24,30.24,0,0,1,6.68-7.08,34.47,34.47,0,0,1,3.95-2.65,37.39,37.39,0,0,1,4.24-1.93,17.43,17.43,0,0,1,2.18-.73c.74-.19,1.46-.42,2.2-.58a32.15,32.15,0,0,1,4.42-.61,33.26,33.26,0,0,1,4.35,0c.72.05,1.42.17,2.13.25l1,.13c.35.05.69.15,1,.23l2,.46c.66.18,1.3.43,1.94.64a30,30,0,0,1,3.68,1.54,31.25,31.25,0,0,1,16.19,20,29.26,29.26,0,0,1,1,8.94,21.5,21.5,0,0,1-.3,3.28c-.07.47-.11.91-.19,1.31s-.18.74-.25,1.06q-.24.92-.36,1.44C364.28,284.75,364.23,284.91,364.23,284.91Z" style="fill: rgb(38, 50, 56); transform-origin: 334.111px 276.406px;" id="elxnxs1z92lba" class="animable"></path><path d="M352.41,302.64c.4.27,29.84,27.42,40.68,37.58a4.71,4.71,0,0,0,6.51-.06h0a4.71,4.71,0,0,0-.06-6.84L359.13,296Z" style="fill: rgb(38, 50, 56); transform-origin: 376.726px 318.748px;" id="el5s5qq8nloec" class="animable"></path></g><g id="freepik--Character--inject-41" class="animable" style="transform-origin: 260.913px 294.805px;"><path d="M201.15,204.11l.6-2.36a9,9,0,0,0-.1-4.71l-2.47-8.24a3.1,3.1,0,0,0-1.42-1.79c-1.88-1.08-5.59-3.16-5.91-2.9-2.27,1.89,2.81,5.22,2.81,5.22s2,2.19.41,3.81c-1.77,1.84-5.08-2.2-5.08-2.2s.17-.42.33-.34a6.58,6.58,0,0,0,3.19,1.37v-2.68l-3-1.88a3,3,0,0,0-2.23-.4l-1,.23a2.62,2.62,0,0,0-1.64,1.11l-1,1.48-.42.57a1.88,1.88,0,0,0-.2,1.9l.48,1-.66.92a2.83,2.83,0,0,0-.33,2.64l5.07,7,7.5,12.25,8.12-8.72Z" style="fill: rgb(255, 190, 157); transform-origin: 193.762px 200.099px;" id="elmn63mxu3n3f" class="animable"></path><path d="M185.43,196.87a1.57,1.57,0,0,1-.27-.51,1.41,1.41,0,0,1,.24-1.3l0,0,0-.06-.08-.18a12.13,12.13,0,0,0-1.09-2,13.28,13.28,0,0,0,.91,2.07l.09.18v-.11a1.47,1.47,0,0,0-.22,1.47C185.18,196.77,185.42,196.9,185.43,196.87Z" style="fill: rgb(235, 153, 110); transform-origin: 184.83px 194.847px;" id="ell9drt0bvk4l" class="animable"></path><path d="M186.05,187.78a2.28,2.28,0,0,0-.16,1.4,10.75,10.75,0,0,0,1.37,3.23,4.13,4.13,0,0,1,.47.94,2.47,2.47,0,0,1,.06,1,2.48,2.48,0,0,0,.18,1.5,3,3,0,0,0,1,1,1.66,1.66,0,0,1-1.17-.92,2.45,2.45,0,0,1-.27-1.62,2.66,2.66,0,0,0-.07-.89,4.25,4.25,0,0,0-.45-.87,9.48,9.48,0,0,1-1.32-3.35C185.54,188.24,186,187.73,186.05,187.78Z" style="fill: rgb(235, 153, 110); transform-origin: 187.315px 192.313px;" id="el9r9v5nvdxl" class="animable"></path><path d="M190.05,190.82a6.35,6.35,0,0,0-.38-1.12c-.31-.58-.64-1-.57-1.08s.51.3.85.94S190.15,190.86,190.05,190.82Z" style="fill: rgb(235, 153, 110); transform-origin: 189.628px 189.716px;" id="eleq7vzd6j1pw" class="animable"></path><polygon points="203.93 246.01 207.02 249.89 223.08 230.6 202.05 202.94 191.66 211.09 203.93 246.01" style="fill: rgb(69, 90, 100); transform-origin: 207.37px 226.415px;" id="elk6dyib7hktl" class="animable"></polygon><polygon points="275.37 432.66 276.7 464 293.63 463.62 292.36 432.22 275.37 432.66" style="fill: rgb(33, 158, 188); transform-origin: 284.5px 448.11px;" id="el4q7icqeq2jw" class="animable"></polygon><path d="M285,462.63c.14,0-.12-6.87-.58-15.33s-1-15.31-1.1-15.3.12,6.87.59,15.33S284.87,462.64,285,462.63Z" style="fill: rgb(38, 50, 56); transform-origin: 284.167px 447.315px;" id="elclpx7io6yto" class="animable"></path><polygon points="276.61 461.84 293.54 461.41 293.63 463.62 276.7 464 276.61 461.84" style="fill: rgb(38, 50, 56); transform-origin: 285.12px 462.705px;" id="eldjupq7cbw76" class="animable"></polygon><path d="M293.22,453.59s-.13-.27-.46-.67a11.71,11.71,0,0,0-1.58-1.54,12,12,0,0,0-2.82-1.71,9,9,0,0,0-10.44,2.45,7.68,7.68,0,0,0-1.16,1.89,2.27,2.27,0,0,0-.23.78,18.51,18.51,0,0,1,1.66-2.44,9,9,0,0,1,6.22-2.89,10.26,10.26,0,0,1,6.54,2.21C292.42,452.75,293.15,453.65,293.22,453.59Z" style="fill: rgb(38, 50, 56); transform-origin: 284.875px 451.861px;" id="el6lejfrrkxc8" class="animable"></path><g id="el6ku49ky5dt8"><g style="opacity: 0.3; transform-origin: 284.32px 443.03px;" class="animable"><polygon points="292.72 441.15 292.86 444.61 275.89 444.91 275.78 442.31 292.72 441.15" id="el0ge3d1j791qc" class="animable" style="transform-origin: 284.32px 443.03px;"></polygon></g></g><path d="M235.53,434.53l.83,19.08s-19.11,7.25-19.3,10.79l37-.27L254,434.35Z" style="fill: rgb(33, 158, 188); transform-origin: 235.56px 449.375px;" id="el5dhd87gkjra" class="animable"></path><path d="M247.56,452a1.51,1.51,0,0,1,1.06,1.73,1.47,1.47,0,0,1-1.7,1.08A1.6,1.6,0,0,1,245.8,453a1.51,1.51,0,0,1,1.9-.92" style="fill: rgb(224, 224, 224); transform-origin: 247.211px 453.418px;" id="elb8zh9g4q5rr" class="animable"></path><path d="M254.1,464.12v-3l-35.85,1.36s-1.66.73-1.46,1.9Z" style="fill: rgb(38, 50, 56); transform-origin: 235.437px 462.75px;" id="elahgaylp9l2j" class="animable"></path><path d="M236,453.74c0,.18.92.25,1.82.83s1.39,1.34,1.55,1.27-.11-1.12-1.21-1.8S236,453.57,236,453.74Z" style="fill: rgb(38, 50, 56); transform-origin: 237.706px 454.707px;" id="el8ib4ziedtz8" class="animable"></path><path d="M232.12,455.38c0,.18.75.48,1.38,1.25s.81,1.58,1,1.57.29-1-.51-2S232.13,455.21,232.12,455.38Z" style="fill: rgb(38, 50, 56); transform-origin: 233.377px 456.747px;" id="elmhxthsinszi" class="animable"></path><path d="M229.93,460.08c.17,0,.42-.87-.06-1.87s-1.33-1.38-1.4-1.23.45.68.83,1.51S229.75,460.07,229.93,460.08Z" style="fill: rgb(38, 50, 56); transform-origin: 229.306px 458.514px;" id="elrj6nfm7aefc" class="animable"></path><path d="M236.32,449.34c.08.16.91-.1,1.94,0s1.84.38,1.93.22-.68-.8-1.9-.86S236.23,449.19,236.32,449.34Z" style="fill: rgb(38, 50, 56); transform-origin: 238.255px 449.152px;" id="elghfni1tr56f" class="animable"></path><path d="M235.63,445.23a3.44,3.44,0,0,0,1.86,0,8.52,8.52,0,0,0,1.95-.62,7.46,7.46,0,0,0,1.07-.58,2.11,2.11,0,0,0,.56-.44.77.77,0,0,0,.08-1,1,1,0,0,0-.8-.41,2.36,2.36,0,0,0-.7.1,7.52,7.52,0,0,0-1.16.41,6.43,6.43,0,0,0-1.71,1.14c-.86.81-1.15,1.49-1.09,1.53s.5-.52,1.37-1.18a7.56,7.56,0,0,1,1.66-1,7.39,7.39,0,0,1,1.07-.33c.4-.11.74-.12.84.06s0,.09,0,.21a2.09,2.09,0,0,1-.41.32,8.37,8.37,0,0,1-1,.57,10.09,10.09,0,0,1-1.8.71A12.56,12.56,0,0,0,235.63,445.23Z" style="fill: rgb(38, 50, 56); transform-origin: 238.464px 443.771px;" id="elqz0x6l1y97g" class="animable"></path><path d="M235.86,445.49c.07,0,.43-.63.48-1.81a5.77,5.77,0,0,0-.27-2,5.25,5.25,0,0,0-.48-1.13,1.55,1.55,0,0,0-1.2-.94.89.89,0,0,0-.78.53,2.46,2.46,0,0,0-.18.68,3.79,3.79,0,0,0,0,1.26,4.27,4.27,0,0,0,.81,1.93c.73,1,1.5,1.17,1.51,1.11s-.58-.44-1.14-1.36a4.1,4.1,0,0,1-.58-2.84c.06-.39.2-.71.35-.67s.5.29.66.6a7,7,0,0,1,.47,1,6.69,6.69,0,0,1,.38,1.86C236,444.78,235.77,445.46,235.86,445.49Z" style="fill: rgb(38, 50, 56); transform-origin: 234.861px 442.55px;" id="el7ta2jw73fj4" class="animable"></path><g id="eld3sllob2kti"><g style="opacity: 0.3; transform-origin: 245.155px 447.905px;" class="animable"><polygon points="254.11 445.79 254.07 450.02 236.2 450.02 236.2 446.18 254.11 445.79" id="elow31sy7436f" class="animable" style="transform-origin: 245.155px 447.905px;"></polygon></g></g><path d="M314,128.29l2.65,10.28s1,5.68-1.66,5.67c-2.34,0-2.57-3.05-2.57-3.05s1.17-6.22-1.89-5.87c-.43.05-1.55,4.34-2.09,6.52a3.24,3.24,0,0,0,.32,2.36l4.41,7.81a9.37,9.37,0,0,0,3.46,3.47l2.21,1.25.29,4.64,12.41.2-3.78-14.48-1.58-8.83a3,3,0,0,0-2.22-1.65l-1.17-.17-.44-1.12a2,2,0,0,0-1.58-1.22l-.72-.09-1-2.51c-.34-.83-2.77-6.3-3.67-6.29C315.37,125.21,313.35,125.76,314,128.29Z" style="fill: rgb(255, 190, 157); transform-origin: 319.943px 143.39px;" id="elbw0msfjwpew" class="animable"></path><path d="M322.86,140.74a8.28,8.28,0,0,0-.23-1.13,4.32,4.32,0,0,0-1.69-2.15,12,12,0,0,1-.93-2.69,3.32,3.32,0,0,1-.13-1.17s.08.44.27,1.13a16.38,16.38,0,0,0,1,2.6c.18.16.4.32.61.5a3.94,3.94,0,0,1,1.06,1.74,3.1,3.1,0,0,1,.12.85A.9.9,0,0,1,322.86,140.74Z" style="fill: rgb(235, 153, 110); transform-origin: 321.406px 137.17px;" id="elxll8i111xf" class="animable"></path><path d="M324.75,139.69a1.7,1.7,0,0,0-.18-.56,1.46,1.46,0,0,0-1.15-.75h-.07l0-.06-.07-.19a13.35,13.35,0,0,1-.71-2.25,12.34,12.34,0,0,1,.9,2.17l.08.2-.09-.07a1.55,1.55,0,0,1,1.26.89C324.86,139.44,324.78,139.71,324.75,139.69Z" style="fill: rgb(235, 153, 110); transform-origin: 323.685px 137.786px;" id="el8kfmcntm88x" class="animable"></path><path d="M251.69,189.42l22.51-.29L271.69,170s1.54-.33,1.64-8.67.49-22.5.49-22.5h0a29,29,0,0,0-29.12,3.66l-1.24.95Z" style="fill: rgb(255, 190, 157); transform-origin: 258.83px 162.949px;" id="elenv2c5pihg" class="animable"></path><path d="M246.08,153.67c-.14-.06-5.73-1.7-5.55,4s5.87,4.34,5.87,4.18S246.08,153.67,246.08,153.67Z" style="fill: rgb(255, 190, 157); transform-origin: 243.463px 157.756px;" id="el19yy9q5p235" class="animable"></path><path d="M272.85,152.48c.14-.07,5.22-1.44,5,4.26s-5.87,4.35-5.87,4.18S272.85,152.48,272.85,152.48Z" style="fill: rgb(255, 190, 157); transform-origin: 274.918px 156.733px;" id="elzv7p4lfhk7j" class="animable"></path><path d="M244.23,153c.85,4.78.68,7.29,1.47,10.48,1.25,5,3.75,8.92,8.3,11.44s10.7,2.47,14.61-1c2.71-2.38,4.63-5.07,5-8.66s.81-9.94.83-13.54c0-6.51.49-12.73.49-12.73l-18.6-3.37L245.78,142Z" style="fill: rgb(38, 50, 56); transform-origin: 259.58px 156.152px;" id="elrzvzhwuodxc" class="animable"></path><path d="M263.41,177.83a8.38,8.38,0,0,1-6.38-.71c.06-.14,1.43.29,3.18.48A30.84,30.84,0,0,1,263.41,177.83Z" style="fill: rgb(38, 50, 56); transform-origin: 260.22px 177.627px;" id="elglj132wcfhj" class="animable"></path><path d="M245.13,161.15c-.55-4.89-.9-10.49-1.67-15.65-.28-1.94-1-4.73-.8-6.68a16.1,16.1,0,0,1,1.22-5.73,8.05,8.05,0,0,1,12.55-2.53,6,6,0,0,1,11,2.55,4.19,4.19,0,0,1,6.92,4.2,4.09,4.09,0,0,1,2.76,6.27c-.86,1.33-2.41,2.06-3.36,3.32a4.78,4.78,0,0,0-.29,5.15" style="fill: rgb(38, 50, 56); transform-origin: 260.2px 144.482px;" id="el7ywyaspmljm" class="animable"></path><path d="M271,143.46a1.44,1.44,0,0,1-.21.54,3.75,3.75,0,0,1-1.08,1.21,3.88,3.88,0,0,1-2.42.77,4.11,4.11,0,0,1-3-1.4l.39-.1a3.86,3.86,0,0,1-2.48,2.85,4.43,4.43,0,0,1-4.19-.53,6.27,6.27,0,0,1-2.36-3.09l.45,0a5.25,5.25,0,0,1-4.21,2.31,4.83,4.83,0,0,1-3.54-1.45,5,5,0,0,1-1.29-2.18,1.84,1.84,0,0,1-.1-.9s.07.31.27.85a5.18,5.18,0,0,0,1.34,2,4.58,4.58,0,0,0,3.3,1.24,4.81,4.81,0,0,0,3.8-2.14l.28-.43.17.48a5.94,5.94,0,0,0,2.18,2.83,4,4,0,0,0,3.72.49,3.45,3.45,0,0,0,2.22-2.46l.09-.47.3.36a3.81,3.81,0,0,0,2.66,1.32,3.7,3.7,0,0,0,2.25-.61A5.34,5.34,0,0,0,271,143.46Z" style="fill: rgb(69, 90, 100); transform-origin: 258.971px 144.561px;" id="eloliyz3s1htm" class="animable"></path><path d="M270.91,141.2a5.09,5.09,0,0,0-.79-2.07,3.41,3.41,0,0,0-2-1.32,3.5,3.5,0,0,0-2.83.55l-.45.32,0-.56a4.06,4.06,0,0,0-.19-1.64,4.47,4.47,0,0,0-2.28-2.66,4.38,4.38,0,0,0-2.9-.25,6.26,6.26,0,0,0-2.42,1.36,1.71,1.71,0,0,1,.46-.63,4.53,4.53,0,0,1,1.86-1.09,4.61,4.61,0,0,1,3.2.18,4.81,4.81,0,0,1,2.58,2.94,4.64,4.64,0,0,1,.2,1.84l-.4-.23a4,4,0,0,1,3.25-.56,3.66,3.66,0,0,1,2.68,3.2C271,141,270.94,141.21,270.91,141.2Z" style="fill: rgb(69, 90, 100); transform-origin: 264.001px 137.103px;" id="elw9wrvyov75" class="animable"></path><path d="M259.06,141.37c-.07,0,0-.32,0-.78a3.66,3.66,0,0,0-.58-1.69c-.37-.59-.82-1.19-1.07-1.51a.54.54,0,0,0-.6-.11s0-.13.12-.23a.63.63,0,0,1,.7,0,5,5,0,0,1,.65.65,8.39,8.39,0,0,1,.65.88,3.13,3.13,0,0,1,.5,2C259.34,141.14,259.11,141.4,259.06,141.37Z" style="fill: rgb(69, 90, 100); transform-origin: 258.126px 139.158px;" id="elodcqms7y9kd" class="animable"></path><path d="M248,134.2c-.06,0,0-.44.35-1a2.78,2.78,0,0,1,.84-.89,2.2,2.2,0,0,1,1.51-.33,3.61,3.61,0,0,1,2.26,1.41c.42.53.61.89.56.94s-.36-.24-.83-.68a3.86,3.86,0,0,0-2.05-1.15,2.14,2.14,0,0,0-2,.92C248.28,133.86,248.1,134.23,248,134.2Z" style="fill: rgb(69, 90, 100); transform-origin: 250.754px 133.146px;" id="el6t1ch082ea9" class="animable"></path><path d="M250.92,158.38a12.73,12.73,0,0,1-2.65-7.72c.15,0,.45,1.79,1.18,3.91S251.06,158.3,250.92,158.38Z" style="fill: rgb(69, 90, 100); transform-origin: 249.602px 154.52px;" id="eltt7ymarv4n" class="animable"></path><path d="M253.42,159.74a6.73,6.73,0,0,1-1.38-2.59,7,7,0,0,1-.68-2.85,10.81,10.81,0,0,1,1.17,2.67A10.8,10.8,0,0,1,253.42,159.74Z" style="fill: rgb(69, 90, 100); transform-origin: 252.39px 157.02px;" id="ela8er8yuednr" class="animable"></path><path d="M269.08,160.13a10.89,10.89,0,0,1-3.47,9.19A31.51,31.51,0,0,0,268,165,30.52,30.52,0,0,0,269.08,160.13Z" style="fill: rgb(69, 90, 100); transform-origin: 267.376px 164.725px;" id="elmwvnztog3k" class="animable"></path><path d="M271.58,156a7.31,7.31,0,0,1,.36,4.52,7.21,7.21,0,0,1-1.93,4.09,25.14,25.14,0,0,0,1.42-4.19A24.93,24.93,0,0,0,271.58,156Z" style="fill: rgb(69, 90, 100); transform-origin: 271.076px 160.305px;" id="elkwebwf5ml8k" class="animable"></path><polyline points="264.38 313.1 269.85 365.86 273.78 445.32 294.75 445.32 295.32 276.2 235.28 280.49 222.84 369.22 233.62 446.87 256.62 446.87 251.24 373.03 264.38 313.1" style="fill: rgb(38, 50, 56); transform-origin: 259.08px 361.535px;" id="el2ib5ftezua2" class="animable"></polyline><path d="M264.38,313.1a63.57,63.57,0,0,1-8.51,7.66,32.06,32.06,0,0,1,4.08-4A31.26,31.26,0,0,1,264.38,313.1Z" style="fill: rgb(69, 90, 100); transform-origin: 260.125px 316.93px;" id="el592l3hcm444" class="animable"></path><path d="M264.32,312a60.58,60.58,0,0,1,.11-6.77,58.87,58.87,0,0,1,.39-6.76,36.13,36.13,0,0,1,.13,6.78A35.42,35.42,0,0,1,264.32,312Z" style="fill: rgb(69, 90, 100); transform-origin: 264.662px 305.235px;" id="elicuhpyh3h4" class="animable"></path><path d="M271.25,292.35a1.57,1.57,0,0,1,.34,0l1-.06,4-.19,14.22-.6h.24v.25c0,4.43,0,9.45,0,14.76v.46l-.17.06-9.25,3.71-.08,0-.09,0-8.17-2.84-.13,0,0-.13c-.6-4.61-1.1-8.45-1.45-11.2-.16-1.28-.28-2.31-.38-3.08a8.53,8.53,0,0,1-.1-1,2.18,2.18,0,0,1,.07.3c0,.23.08.5.14.83.12.78.28,1.82.49,3.12.41,2.71,1,6.48,1.66,11l-.14-.17,8.19,2.78h-.17l9.24-3.73-.16.24v-.28c0-5.31,0-10.33,0-14.76l.24.23-14.06.35-4,.07h-1.48Z" style="fill: rgb(69, 90, 100); transform-origin: 281.14px 301.12px;" id="el8lpgtuoeojs" class="animable"></path><path d="M241,292.61a1.11,1.11,0,0,1,.31,0l.93-.05,3.6-.11,13-.3H259v.24c-.14,4.38-.3,9.43-.47,14.8v.14l-.11.07-1.5,1-7.6,5-.14.09-.13-.09-8.56-5.21-.11-.07v-.12c.16-4.6.3-8.43.39-11.18.06-1.28.1-2.31.14-3.08a9.34,9.34,0,0,1,.07-1,1,1,0,0,1,0,.3v.83c0,.78,0,1.82,0,3.13,0,2.71-.1,6.5-.17,11.05l-.1-.19,8.6,5.15H249l7.59-5,1.51-1-.12.2c.19-5.37.38-10.42.54-14.8l.23.24-12.83.07h-4.62Z" style="fill: rgb(69, 90, 100); transform-origin: 249.69px 302.82px;" id="eljt5xajwhwmh" class="animable"></path><path d="M288.84,316.51a14.68,14.68,0,0,1-2.84-.09c-1.75-.13-4.17-.37-6.82-.71s-5.05-.73-6.77-1a14.09,14.09,0,0,1-2.77-.64,15.68,15.68,0,0,1,2.82.27l6.79.9,6.78.86A17.07,17.07,0,0,1,288.84,316.51Z" style="fill: rgb(69, 90, 100); transform-origin: 279.24px 315.306px;" id="el279n0lkqlk8" class="animable"></path><path d="M288.35,375.32s-.08.31-.49.67a3.35,3.35,0,0,1-2.15.73,5.07,5.07,0,0,1-3.13-1.2,21.75,21.75,0,0,1-2.86-2.89,39.6,39.6,0,0,1-4.24-6,12.83,12.83,0,0,1-1.33-2.73,29.74,29.74,0,0,1,1.64,2.54,53,53,0,0,0,4.33,5.83,23.55,23.55,0,0,0,2.76,2.85,4.85,4.85,0,0,0,2.84,1.21,3.34,3.34,0,0,0,2-.52C288.15,375.54,288.31,375.3,288.35,375.32Z" style="fill: rgb(69, 90, 100); transform-origin: 281.25px 370.31px;" id="elf1f4lavv9a" class="animable"></path><path d="M246.94,377.18a1.44,1.44,0,0,1-.28.67,4.5,4.5,0,0,1-1.45,1.38,5.55,5.55,0,0,1-2.88.75,6.74,6.74,0,0,1-3.46-1.1,12.19,12.19,0,0,1-4.17-5,10.85,10.85,0,0,1-1-2.47,17.74,17.74,0,0,1,1.36,2.3,13.18,13.18,0,0,0,4.12,4.7,6.5,6.5,0,0,0,3.2,1.06,5.49,5.49,0,0,0,2.69-.59A6.12,6.12,0,0,0,246.94,377.18Z" style="fill: rgb(69, 90, 100); transform-origin: 240.32px 375.695px;" id="el2vu3gvt2x8p" class="animable"></path><path d="M248.28,369.22a5.17,5.17,0,0,1-1.73,1,13.7,13.7,0,0,1-9.47.39,5.36,5.36,0,0,1-1.8-.86,21.35,21.35,0,0,0,6.55,1A22,22,0,0,0,248.28,369.22Z" style="fill: rgb(69, 90, 100); transform-origin: 241.78px 370.246px;" id="ela7hq0lsrox" class="animable"></path><path d="M316.52,183H286s-4.16-2.39-6.17-2a7.92,7.92,0,0,0-3.75,2.55l4.05,33.68,9.9-7.33,36.86-3.83a11.74,11.74,0,0,0,8.42-3.69h0a11.74,11.74,0,0,0,3.11-9.43l-6.82-36.23-14,.47-.55,9.19Z" style="fill: rgb(69, 90, 100); transform-origin: 307.291px 186.975px;" id="eljrl0wllproh" class="animable"></path><path d="M232.36,191.49a18.77,18.77,0,0,0-7.38,8.58c-1.79,4.28-14,25.66-20.38,36.84a10.58,10.58,0,0,0,1.53,12.57h0c3.9,4.07,8.56,2.48,14.25.63,2.55-.83,14-18.44,14-18.44Z" style="fill: rgb(69, 90, 100); transform-origin: 218.79px 221.76px;" id="el3hezhw87jf" class="animable"></path><polygon points="237.68 267.88 230.67 207.57 232.36 191.49 250.2 183.89 273.32 182.37 295.32 184.8 290.18 246.66 295.81 281.55 234.17 284.33 237.68 267.88" style="fill: rgb(69, 90, 100); transform-origin: 263.24px 233.35px;" id="elw1tiv55iwh" class="animable"></polygon><path d="M237.65,267.62c-.15,0-1.82-13.41-3.75-30s-3.37-30-3.23-30.06,1.82,13.42,3.75,30S237.79,267.6,237.65,267.62Z" style="fill: rgb(38, 50, 56); transform-origin: 234.16px 237.59px;" id="elxcwqtjwd2cl" class="animable"></path><path d="M294.87,198.33a2.3,2.3,0,0,1,0,.55c0,.41-.09.92-.14,1.54-.15,1.42-.34,3.35-.58,5.69-.49,4.87-1.15,11.47-1.88,18.77s-1.27,14-1.63,18.78c-.17,2.35-.31,4.28-.41,5.7-.05.63-.09,1.14-.12,1.55a3.25,3.25,0,0,1-.08.54,1.91,1.91,0,0,1,0-.54c0-.42,0-.93,0-1.56,0-1.35.12-3.3.24-5.71.27-4.82.78-11.48,1.48-18.81s1.45-14,2-18.76c.3-2.4.55-4.33.75-5.67.09-.62.17-1.13.23-1.54A2,2,0,0,1,294.87,198.33Z" style="fill: rgb(38, 50, 56); transform-origin: 292.449px 224.89px;" id="elp9ibsx3ndig" class="animable"></path><path d="M284.27,258.38a11.47,11.47,0,0,1-1,1.19,14.35,14.35,0,0,1-1.25,1.31c-.52.48-1.08,1.06-1.78,1.6a26,26,0,0,1-2.32,1.76,32.14,32.14,0,0,1-2.83,1.78,35.26,35.26,0,0,1-14.58,4.35c-1.18.05-2.3.13-3.34.07a28.12,28.12,0,0,1-2.91-.2c-.88-.07-1.67-.25-2.37-.37a14.08,14.08,0,0,1-1.76-.41,8.65,8.65,0,0,1-1.47-.46c0-.12,2.13.54,5.64.87a25.77,25.77,0,0,0,2.87.13c1,.05,2.14-.05,3.3-.11a36.61,36.61,0,0,0,14.39-4.29c1-.59,2-1.11,2.82-1.71s1.63-1.15,2.32-1.69C282.78,260,284.18,258.3,284.27,258.38Z" style="fill: rgb(38, 50, 56); transform-origin: 266.465px 264.419px;" id="eldyibs30ies" class="animable"></path><g id="el2vx2urjteu4"><g style="opacity: 0.3; transform-origin: 264.673px 262.363px;" class="animable"><path d="M251.68,269.64c-3-.86-3.17-3.69-2-4.9s3-1.37,4.71-1.13a23.48,23.48,0,0,0,5,.67c2.74-.18,5-2.09,6.94-4.07s3.71-4.2,6.21-5.34,6-.73,7.3,1.68a5.22,5.22,0,0,1-.3,5,11.52,11.52,0,0,1-3.71,3.64,30.34,30.34,0,0,1-24.12,4.45" id="elz3icmajhv7q" class="animable" style="transform-origin: 264.673px 262.363px;"></path></g></g><path d="M288.13,184.23a8,8,0,0,1,4,3.19,8.15,8.15,0,0,1,1.77,4.81,20.49,20.49,0,0,0-2.19-4.5A20.8,20.8,0,0,0,288.13,184.23Z" style="fill: rgb(38, 50, 56); transform-origin: 291.015px 188.23px;" id="elvikonehuwq" class="animable"></path><path d="M286,183.55a3,3,0,0,0-.5-.3,2.61,2.61,0,0,0-1.66-.11,4.67,4.67,0,0,0-2.28,1.36,24.94,24.94,0,0,1-2.52,2.56,7.41,7.41,0,0,1-4.14,1.27c-1.57.08-3.24-.08-5-.13a99.19,99.19,0,0,0-11.42.25,73.19,73.19,0,0,0-20.2,4.46,61.56,61.56,0,0,0-5.75,2.55l-1.51.8c-.35.18-.54.26-.54.26s.17-.11.52-.3l1.49-.83a60.55,60.55,0,0,1,5.73-2.62,72,72,0,0,1,20.24-4.53A97.15,97.15,0,0,1,269.9,188c1.76.05,3.43.22,5,.15a7.31,7.31,0,0,0,4.07-1.22,28.46,28.46,0,0,0,2.52-2.52,4.57,4.57,0,0,1,2.34-1.35,2.53,2.53,0,0,1,1.69.14A1.57,1.57,0,0,1,286,183.55Z" style="fill: rgb(250, 250, 250); transform-origin: 258.24px 189.748px;" id="elsgihxcoyuzp" class="animable"></path><path d="M292.92,195.91s-.21-.07-.62-.14a6.6,6.6,0,0,0-1.81-.06,10,10,0,0,0-2.76.74,32.42,32.42,0,0,0-3.39,1.74,19.29,19.29,0,0,1-4.25,1.83,27.4,27.4,0,0,1-5.26.85c-3.74.23-7.85.29-12.15.62-8.62.6-16.37,1.64-22,2.55-2.8.45-5,.87-6.6,1.16l-1.79.33-.63.11.62-.15,1.78-.37c1.55-.31,3.8-.76,6.59-1.22,5.58-1,13.34-2,22-2.61,4.31-.34,8.43-.39,12.16-.61a27.66,27.66,0,0,0,5.22-.83,18.82,18.82,0,0,0,4.23-1.79,31.27,31.27,0,0,1,3.42-1.72,10,10,0,0,1,2.8-.71,6,6,0,0,1,1.82.1A2.62,2.62,0,0,1,292.92,195.91Z" style="fill: rgb(250, 250, 250); transform-origin: 262.29px 200.621px;" id="elpxbjdib82a" class="animable"></path><path d="M293.07,212.91s-.78.37-2.22.93a64.21,64.21,0,0,1-6.21,2.07,93.06,93.06,0,0,1-21.35,3.19,197.87,197.87,0,0,1-21.6-.51l-6.54-.51-1.77-.16c-.4,0-.62-.07-.62-.07l.62,0,1.78.12,6.54.44a207.66,207.66,0,0,0,21.58.45,95.57,95.57,0,0,0,21.32-3.12c2.66-.74,4.78-1.46,6.23-2,.72-.26,1.28-.5,1.66-.64Z" style="fill: rgb(250, 250, 250); transform-origin: 262.915px 216.053px;" id="el7mcx3ahj12q" class="animable"></path><path d="M290.73,232.54s-.73.32-2.08.78a41.63,41.63,0,0,1-5.86,1.5,58.67,58.67,0,0,1-8.93.91c-3.38.12-7.1,0-11-.22-7.78-.52-14.82-1.07-19.92-.89-2.55.07-4.61.24-6,.4-.71.07-1.26.16-1.63.2l-.57.07a50.88,50.88,0,0,1,8.22-.81c5.12-.22,12.17.31,19.95.82,3.88.23,7.59.35,11,.24a61.61,61.61,0,0,0,8.91-.86,43.64,43.64,0,0,0,5.87-1.44c.68-.2,1.19-.41,1.55-.52Z" style="fill: rgb(250, 250, 250); transform-origin: 262.735px 234.159px;" id="elgxmbw3df12b" class="animable"></path><path d="M288.83,247.73s-2.83.93-7.5,2c-2.34.55-5.15,1.09-8.29,1.57s-6.6.85-10.26,1.09-7.15.23-10.32.16-6-.3-8.41-.56c-4.77-.5-7.69-1.09-7.69-1.09l.54.06,1.53.22c1.32.2,3.25.43,5.63.66s5.24.42,8.41.51,6.65,0,10.3-.17,7.11-.62,10.25-1.07,5.94-1,8.27-1.52,4.23-1,5.52-1.34l1.49-.39Z" style="fill: rgb(250, 250, 250); transform-origin: 262.595px 250.162px;" id="elud2gae9lluh" class="animable"></path><path d="M290.94,253.28l-.52.2-1.5.54c-1.31.48-3.17,1.24-5.44,2.24s-5,2.26-8,3.51a52.18,52.18,0,0,1-10.22,3.13A85,85,0,0,1,245.88,264c-2.48-.1-4.49-.23-5.88-.32l-1.59-.12c-.37,0-.56,0-.56,0h.56l1.6.08,5.88.25a86.73,86.73,0,0,0,19.33-1.13,53,53,0,0,0,10.19-3.09c3-1.24,5.72-2.49,8-3.47s4.16-1.73,5.47-2.19S290.94,253.28,290.94,253.28Z" style="fill: rgb(250, 250, 250); transform-origin: 264.395px 258.711px;" id="elvjkf5ilhee" class="animable"></path><path d="M294.07,269.84s-.68.46-2,1.21a41,41,0,0,1-5.77,2.64,63.71,63.71,0,0,1-20.59,3.48c-8.19.15-15.59-.5-20.94-.73-2.68-.13-4.84-.2-6.34-.24l-1.73,0-.6,0s.21,0,.6,0h1.73c1.5,0,3.67.06,6.35.18,5.35.18,12.75.81,20.92.66a64.51,64.51,0,0,0,20.55-3.41A41.56,41.56,0,0,0,292,271c.67-.33,1.16-.66,1.51-.84S294.07,269.84,294.07,269.84Z" style="fill: rgb(250, 250, 250); transform-origin: 265.085px 273.516px;" id="elqxgi6wpjjw" class="animable"></path><path d="M303.39,208.78a.94.94,0,0,1,.05-.25c.06-.22.12-.46.19-.71.17-.62.39-1.51.63-2.63a40.39,40.39,0,0,0-.27-17.64c-.26-1.11-.51-2-.7-2.61l-.22-.7L303,184a.72.72,0,0,1,.1.24c.08.21.16.44.25.69.22.6.49,1.48.77,2.59a38,38,0,0,1,.27,17.71c-.25,1.12-.49,2-.69,2.62-.09.25-.16.48-.23.7A1.78,1.78,0,0,1,303.39,208.78Z" style="fill: rgb(250, 250, 250); transform-origin: 304.153px 196.39px;" id="elqh8jjv2xt1" class="animable"></path><path d="M318.2,205.16a.82.82,0,0,1,0-.23c0-.2,0-.42,0-.65,0-.57,0-1.39,0-2.4a37.3,37.3,0,0,0-3.49-15.31c-.43-.91-.81-1.65-1.08-2.14l-.31-.58q-.11-.19-.09-.21a1.8,1.8,0,0,1,.13.19l.34.56c.3.48.69,1.21,1.14,2.12a34.83,34.83,0,0,1,3.5,15.37,23.84,23.84,0,0,1-.1,2.4l-.07.66A1.42,1.42,0,0,1,318.2,205.16Z" style="fill: rgb(250, 250, 250); transform-origin: 315.784px 194.4px;" id="elyg0tkiw235" class="animable"></path><path d="M338.21,198.21s-.07-.06-.19-.2l-.51-.59c-.43-.53-1.08-1.27-1.91-2.15a48.42,48.42,0,0,0-15.34-11c-1.11-.5-2-.88-2.66-1.12l-.73-.28a1.34,1.34,0,0,1-.25-.12,1,1,0,0,1,.27.08l.74.25c.65.21,1.57.57,2.69,1.06a45.58,45.58,0,0,1,15.39,11c.81.9,1.45,1.65,1.86,2.2.18.22.34.43.48.62S338.21,198.21,338.21,198.21Z" style="fill: rgb(250, 250, 250); transform-origin: 327.415px 190.48px;" id="elehlgo3bpjno" class="animable"></path><path d="M333.67,169.88a4,4,0,0,1-.64,0l-1.73,0c-1.46,0-3.48,0-5.72,0s-4.25.12-5.71.2l-1.73.09a4.49,4.49,0,0,1-.64,0,3.94,3.94,0,0,1,.64-.09c.4,0,1-.1,1.72-.16,1.46-.11,3.49-.22,5.72-.26s4.26,0,5.72.06l1.74.1A4,4,0,0,1,333.67,169.88Z" style="fill: rgb(250, 250, 250); transform-origin: 325.585px 169.913px;" id="el5bg46q3x6yp" class="animable"></path><path d="M220.38,209.57a2.48,2.48,0,0,1,.38.39c.22.27.57.64,1,1.09a26,26,0,0,0,3.74,3.11,46.6,46.6,0,0,0,4.18,2.54l1.3.71a2.89,2.89,0,0,1,.47.28,2.25,2.25,0,0,1-.5-.21c-.32-.14-.78-.36-1.34-.65a38.87,38.87,0,0,1-4.23-2.49,23.59,23.59,0,0,1-3.73-3.19,12.78,12.78,0,0,1-1-1.14A3,3,0,0,1,220.38,209.57Z" style="fill: rgb(250, 250, 250); transform-origin: 225.915px 213.63px;" id="elkpvn8i812f8" class="animable"></path><path d="M224.6,201.56s.23.35.7.81a16,16,0,0,0,2,1.59,25.18,25.18,0,0,0,2.21,1.34c.58.32,1,.48.95.51a11.31,11.31,0,0,1-3.27-1.67,11.64,11.64,0,0,1-2-1.67A2.41,2.41,0,0,1,224.6,201.56Z" style="fill: rgb(250, 250, 250); transform-origin: 227.532px 203.685px;" id="elmoivcsbxrxe" class="animable"></path><path d="M231.71,235.68s-.08,0-.22-.09l-.61-.32c-.52-.28-1.27-.71-2.16-1.29a45.23,45.23,0,0,1-6.52-5.17,41.5,41.5,0,0,1-5.43-6.29,23.5,23.5,0,0,1-1.34-2.14l-.33-.6c-.08-.14-.11-.21-.1-.22l.13.2.37.58c.3.51.77,1.23,1.39,2.09a45.5,45.5,0,0,0,5.46,6.23,48.36,48.36,0,0,0,6.45,5.19c.88.6,1.61,1.05,2.12,1.35l.59.35Z" style="fill: rgb(250, 250, 250); transform-origin: 223.354px 227.62px;" id="elmqvtau8cbm" class="animable"></path><path d="M203.93,246a4.94,4.94,0,0,1-.19-1.15,18.87,18.87,0,0,1-.07-3.16,20.46,20.46,0,0,1,3.32-9.83c2.15-3.44,4.12-6.54,5.57-8.77l1.74-2.62a5.76,5.76,0,0,1,.7-.93,5,5,0,0,1-.53,1l-1.6,2.71c-1.37,2.28-3.29,5.4-5.43,8.84a21.21,21.21,0,0,0-3.4,9.59C203.81,244.36,204,246,203.93,246Z" style="fill: rgb(38, 50, 56); transform-origin: 209.317px 232.77px;" id="elicdvemm1xvh" class="animable"></path><path d="M221.43,250.06a12.81,12.81,0,0,1-3.46-.52,16.23,16.23,0,0,1-11.45-11.45,13,13,0,0,1-.51-3.45.92.92,0,0,1,0,.24c0,.15,0,.39.09.69a17.08,17.08,0,0,0,.53,2.48A16.4,16.4,0,0,0,218,249.4a17.44,17.44,0,0,0,2.49.53c.3,0,.53.06.69.09Z" style="fill: rgb(250, 250, 250); transform-origin: 213.72px 242.35px;" id="elikff6wkbavj" class="animable"></path><path d="M211.39,215.92a.74.74,0,0,1-.18.12l-.52.32a21.29,21.29,0,0,0-1.86,1.23A26.51,26.51,0,0,0,199.75,229c-.36.87-.63,1.58-.78,2.09-.07.2-.14.39-.2.58s-.07.19-.08.19a.87.87,0,0,1,0-.21c.05-.18.1-.38.16-.59a18.78,18.78,0,0,1,.73-2.12,25.9,25.9,0,0,1,3.71-6.39,25.54,25.54,0,0,1,5.41-5,17.86,17.86,0,0,1,1.91-1.18l.54-.28C211.32,215.94,211.38,215.91,211.39,215.92Z" style="fill: rgb(250, 250, 250); transform-origin: 205.037px 223.889px;" id="ela2xxrwijdek" class="animable"></path><path d="M205.78,208.52l-.57.2c-.37.11-.9.3-1.54.56a17.9,17.9,0,0,0-4.59,2.78,26,26,0,0,0-3.72,3.9c-.43.54-.77,1-1,1.3a4.16,4.16,0,0,1-.38.47,3.75,3.75,0,0,1,.31-.52c.21-.32.53-.79.94-1.34a22.85,22.85,0,0,1,3.71-4,16.44,16.44,0,0,1,4.67-2.76,14.57,14.57,0,0,1,1.57-.5A3.62,3.62,0,0,1,205.78,208.52Z" style="fill: rgb(250, 250, 250); transform-origin: 199.88px 213.125px;" id="ela4rjao269ee" class="animable"></path></g><defs>     <filter id="active" height="200%">         <feMorphology in="SourceAlpha" result="DILATED" operator="dilate" radius="2"></feMorphology>                <feFlood flood-color="#32DFEC" flood-opacity="1" result="PINK"></feFlood>        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE"></feComposite>        <feMerge>            <feMergeNode in="OUTLINE"></feMergeNode>            <feMergeNode in="SourceGraphic"></feMergeNode>        </feMerge>    </filter>    <filter id="hover" height="200%">        <feMorphology in="SourceAlpha" result="DILATED" operator="dilate" radius="2"></feMorphology>                <feFlood flood-color="#ff0000" flood-opacity="0.5" result="PINK"></feFlood>        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE"></feComposite>        <feMerge>            <feMergeNode in="OUTLINE"></feMergeNode>            <feMergeNode in="SourceGraphic"></feMergeNode>        </feMerge>            <feColorMatrix type="matrix" values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "></feColorMatrix>    </filter></defs></svg>
                          </figure>
                        </div>
                        {
                          previousVisitDetails.customerName ? (
                        <div class="fieldset-content previous-visit-content display-flex flex-direction-column fieldset-forms">
                          <div class="display-flex">
                            { previousVisitDetails.customerName && (
                              <div class="form-flex flex-direction-column align-baseline w-half">
                              <label class="form-group w-full m-b-0" style="height: fit-content;">Customer: </label><a class="form-group w-full fs-1-25rem m-b-15 list-card-value" onClick={() => toggleFeedbackModal()}>{previousVisitDetails.customerName}</a>
                            </div>
                            )}
                            { previousVisitDetails.salesConsultant && (
                              <div class="form-flex flex-direction-column align-baseline w-half">
                              <label class="form-group w-full m-b-0" style="height: fit-content;">Sales Consultant: </label><span class="form-group w-full fs-1-25rem m-b-15 list-card-value">{previousVisitDetails.salesConsultant ? previousVisitDetails.salesConsultant : "Not Assigned"}</span>
                            </div>
                            )}
                          </div>
                          <div class="display-flex">
                            {
                              previousVisitDetails.typeOfVisit === "Commercial" &&  previousVisitDetails.source && (
                                <div class="form-flex flex-direction-column align-baseline w-half">
                                  <label class="form-group w-full m-b-0" style="height: fit-content;">Source: </label><span class="form-group w-full fs-1-25rem m-b-15 list-card-value">{previousVisitDetails.source}</span>
                                </div>
                              )
                            }
                            {
                              previousVisitDetails.typeOfVisit && (
                                <div class="form-flex flex-direction-column align-baseline w-half">
                              <label class="form-group w-full m-b-0" style="height: fit-content;">Type of Visit: </label><span class="form-group w-full fs-1-25rem m-b-15 list-card-value">{previousVisitDetails.typeOfVisit}</span>
                            </div>
                              )
                            }
                          </div>
                          <div class="display-flex">
                            {
                               previousVisitDetails.purpose && (
                                <div class="form-flex flex-direction-column align-baseline w-half">
                                  <label class="form-group w-full m-b-0" style="height: fit-content;">Purpose: </label><span class="form-group w-full fs-1-25rem m-b-15 list-card-value">{previousVisitDetails.purpose}</span>
                                </div>
                              )
                            }
                            {
                              previousVisitDetails.typeOfVisit === "Commercial" &&
                               previousVisitDetails.leadType && (
                                <div class="form-flex flex-direction-column align-baseline w-half">
                                  <label class="form-group w-full m-b-0" style="height: fit-content;">Lead Type: </label><span class="first-letter-capital form-group w-full fs-1-25rem m-b-15 list-card-value">{previousVisitDetails.leadType}</span>
                                </div>
                              )
                            }
                            {
                              previousVisitDetails.typeOfVisit === "Commercial" &&
                               previousVisitDetails.leadSubType && (
                                <div class="form-flex flex-direction-column align-baseline w-half">
                                  <label class="form-group w-full m-b-0" style="height: fit-content;">Lead Sub Type: </label><span class="first-letter-capital form-group w-full fs-1-25rem m-b-15 list-card-value">{previousVisitDetails.leadSubType}</span>
                                </div>
                              )
                            }
                          </div>
                          <div class="display-flex">
                            {
                              previousVisitDetails.typeOfVisit === "Commercial" &&
                               previousVisitDetails.model && (
                                <div class="form-flex flex-direction-column align-baseline w-half">
                                  <label class="form-group w-full m-b-0" style="height: fit-content;">Interested Model: </label><span class="first-letter-capital form-group w-full fs-1-25rem m-b-15 list-card-value">{catalogoueItemList.find((item)=>(item.uuid === previousVisitDetails.model)) && catalogoueItemList.find((item)=>(item.uuid === previousVisitDetails.model)).displayName}</span>
                                </div>
                              )
                            }
                            {
                              previousVisitDetails.typeOfVisit === "Commercial" &&
                               previousVisitDetails.variant && (
                                <div class="form-flex flex-direction-column align-baseline w-half">
                                  <label class="form-group w-full m-b-0" style="height: fit-content;">Interested Variant: </label><span class="first-letter-capital form-group w-full fs-1-25rem m-b-15 list-card-value">{variantList.find((item)=>(item.uuid === previousVisitDetails.variant)) && variantList.find((item)=>(item.uuid === previousVisitDetails.variant)).variant}</span>
                                </div>
                              )
                            }
                          </div>
                          <div class="display-flex">
                            {
                              previousVisitDetails.lastVisitedAt && (
                                <div class="form-flex flex-direction-column align-baseline w-full">
                                <label class="form-group w-full m-b-0" style="height: fit-content;">Last visited On: </label><span class="form-group w-full fs-1-25rem m-b-15 list-card-value">{moment(previousVisitDetails.lastVisitOn).format("LLL")}, at {previousVisitDetails.lastVisitedAt}</span>
                              </div>
                              )
                            }
                            </div>
                          {
                            previousVisitDetails.noOfVisitors && (
                              <div class="form-flex flex-direction-column align-baseline w-half">
                              <label class="form-group w-full m-b-0" style="height: fit-content;">No of Visitors: </label><span class="form-group w-full fs-1-25rem m-b-15 list-card-value">{previousVisitDetails.noOfVisitors}</span>
                            </div>
                            )
                          }
                        </div>
                        ) : (
                          <div class="fieldset-content previous-visit-content display-flex flex-direction-column fieldset-forms">
                            <p>Previous Visit Details not found! Create new visit.</p>
                          </div>
                        )
                      }

                        </div>
                    </div>
                  ) : (
                  <div>
                    <label class="fs-24 text-408b8b " >Customer Verification</label>
                    <div class="fieldset-flex">
                      <div>
                      {
                        /*
                            Modification: Condition for truecaller Data
                            Developer: Manohar sule
                            Date: 30/08/2023
                        */
                      }
                      {
                        isTruecallerDataShown && (
                          <div style='line-height:1.5'>
                            <div id="floatingModal"  style={`display: ${ isTruecallerDataShown ? "block" : "none"}`} >
                              <div class="org-chart-modal-content org-chart-width">
                                <div class="display-flex">
                                  <div class="org-chart-modal-body background-transparent">
                                    <div class="row">
                                    <div class="m-t-50">
                                    <div class="row h-111px w-304px display-flex count-tiles pos-relative" data-label="Truecaller Data" style="padding: 20px; border: 1px solid #002C5F; border-radius:5px">
                                    {
                                      trueCallerData && trueCallerData.length ?
                                      <div>
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex">
                                         <span class="form-label fs-12">Name &nbsp;:&nbsp;</span>
                                        { trueCallerData && trueCallerData.length > 0 && trueCallerData.map((item) => (
                                          <span class="form-label fs-12 text-002C5F">{(item && item.name) ? item.name: "Not Available"}</span>
                                        ))}
                                      </div>
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex">
                                         <span class="form-label fs-12">Mobile &nbsp;:&nbsp;</span>
                                         { trueCallerData && trueCallerData.length > 0 && trueCallerData.map((item) => (
                                           <span class="form-label fs-12 text-002C5F">{(item.phones && item.phones[0]) ? item.phones[0].e164Format: "Not Available"}</span>
                                         ))}
                                      </div>
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex">
                                         <span class="form-label fs-12">City &nbsp;:&nbsp;</span>
                                         { trueCallerData && trueCallerData.length > 0 && trueCallerData.map((item) => (
                                           <span class="form-label fs-12 text-002C5F">{item.addresses[0] && item.addresses[0].city ? item.addresses[0].city: "Not Available"}</span>
                                         ))}
                                      </div>
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex">
                                         <span class="form-label fs-12">Country Code &nbsp;:&nbsp;</span>
                                         { trueCallerData && trueCallerData.length > 0 && trueCallerData.map((item) => (
                                           <span class="form-label fs-12 text-002C5F">{item.addresses[0] && item.addresses[0].countryCode ? item.addresses[0].countryCode:"Not Available" }</span>
                                         ))}
                                      </div>
                                      </div>
                                       : <div> No Data Available</div>
                                    }
                                      {/*<div>
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex">
                                         <span class="form-label fs-12">Name &nbsp;:&nbsp;</span>
                                        { trueCallerData && trueCallerData.length > 0 && trueCallerData.map((item) => (
                                          <span class="form-label fs-12 text-002C5F">{(item && item.name) ? item.name: "Not Available"}</span>
                                        ))}
                                      </div>
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex">
                                         <span class="form-label fs-12">Mobile &nbsp;:&nbsp;</span>
                                         { trueCallerData && trueCallerData.length > 0 && trueCallerData.map((item) => (
                                           <span class="form-label fs-12 text-002C5F">{(item.phones && item.phones[0]) ? item.phones[0].e164Format: "Not Available"}</span>
                                         ))}
                                      </div>
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex">
                                         <span class="form-label fs-12">City &nbsp;:&nbsp;</span>
                                         { trueCallerData && trueCallerData.length > 0 && trueCallerData.map((item) => (
                                           <span class="form-label fs-12 text-002C5F">{item.addresses[0] && item.addresses[0].city ? item.addresses[0].city: "Not Available"}</span>
                                         ))}
                                      </div>
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex">
                                         <span class="form-label fs-12">Country Code &nbsp;:&nbsp;</span>
                                         { trueCallerData && trueCallerData.length > 0 && trueCallerData.map((item) => (
                                           <span class="form-label fs-12 text-002C5F">{item.addresses[0] && item.addresses[0].countryCode ? item.addresses[0].countryCode:"Not Available" }</span>
                                         ))}
                                      </div>
                                      </div>*/}
                                      <div class="m-l-167 h-20px"style="margin-top:-51px">
                                      <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="100px" height="100px" viewBox="0 0 1600.000000 400.000000" preserveAspectRatio="xMidYMid meet" >
                                          <g transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)" fill="blue" stroke="none" style="opacity: 0.3">
                                          <path d="M2042 3352 c-64 -23 -112 -61 -173 -135 -82 -102 -192 -338 -280 -602 -18 -55 -37 -106 -42 -112 -7 -10 -65 -13 -228 -13 -213 0 -218 -1 -245 -23 -20 -18 -27 -33 -28 -65 0 -34 5 -47 33 -76 43 -45 158 -105 281 -147 52 -18 96 -33 97 -34 2 -1 -4 -37 -12 -81 -62 -318 -59 -670 6 -879 71 -230 221 -389 416 -440 75 -20 238 -19 317 1 196 50 376 208 482 426 16 32 31 58 34 58 3 0 4 -46 2 -102 -6 -172 21 -269 90 -334 54 -52 93 -67 160 -62 49 4 64 9 89 35 30 29 31 36 74 315 50 323 61 377 105 503 60 169 109 249 187 305 56 40 95 48 120 23 16 -16 21 -40 26 -124 15 -234 88 -365 226 -406 112 -32 260 9 370 104 l44 37 -7 -49 c-15 -107 -18 -272 -7 -345 24 -158 125 -295 268 -363 65 -31 73 -32 193 -32 110 0 135 3 212 29 48 15 121 47 162 71 l75 43 41 -39 c77 -73 180 -109 316 -109 153 0 304 55 408 150 l56 52 58 -53 c112 -104 218 -139 443 -146 136 -5 166 -3 240 16 157 40 297 121 417 242 109 110 182 241 182 325 0 39 -36 84 -68 84 -10 0 -48 -22 -83 -48 -235 -177 -372 -236 -544 -237 -84 0 -108 4 -152 24 -59 26 -125 91 -148 147 -27 65 -23 71 58 84 554 90 866 327 868 661 1 135 -38 228 -135 324 -109 107 -238 151 -416 141 -136 -7 -214 -27 -326 -81 -286 -139 -469 -477 -514 -950 -6 -66 -15 -140 -21 -165 -23 -103 -93 -160 -194 -160 -94 0 -145 42 -165 137 -9 43 -1 113 65 563 52 349 75 528 70 557 -3 23 -17 53 -30 67 -22 23 -31 26 -97 26 -133 -1 -238 -61 -287 -164 -26 -53 -36 -103 -76 -376 -25 -173 -53 -369 -62 -435 -20 -155 -37 -216 -70 -256 -70 -83 -211 -78 -270 9 -41 62 -40 92 32 604 72 518 74 550 28 595 -23 24 -29 25 -106 21 -101 -6 -168 -33 -225 -91 -55 -56 -69 -93 -98 -260 -35 -200 -80 -288 -169 -328 -74 -34 -132 -20 -162 40 -20 41 -23 165 -9 383 8 111 7 133 -9 173 -23 61 -61 85 -136 85 -128 0 -251 -69 -411 -231 -60 -59 -108 -103 -108 -96 0 7 5 55 12 107 13 111 6 163 -27 196 -47 47 -212 26 -297 -39 -72 -55 -94 -98 -127 -242 -56 -249 -179 -546 -306 -742 -68 -104 -200 -238 -268 -271 -91 -45 -187 -45 -248 0 -17 13 -44 52 -62 88 l-32 65 1 165 c1 172 12 258 61 463 23 100 27 108 47 104 11 -3 102 -13 201 -22 211 -20 247 -15 306 43 35 36 37 42 57 173 28 172 27 184 -3 214 -24 25 -25 25 -226 25 l-201 0 7 27 c8 32 81 183 193 395 110 210 111 251 7 347 -99 91 -233 128 -333 93z m4671 -1273 c55 -15 77 -41 77 -91 0 -56 -33 -120 -83 -164 -61 -52 -207 -119 -326 -148 -135 -34 -144 -34 -137 2 2 15 8 45 11 67 10 56 56 154 95 198 61 70 144 116 245 137 57 11 75 11 118 -1z"/>
                                          <path d="M10620 1960 l0 -1200 250 0 250 0 0 1200 0 1200 -250 0 -250 0 0 -1200z"/>
                                          <path d="M11380 1960 l0 -1200 245 0 245 0 0 1200 0 1200 -245 0 -245 0 0 -1200z"/>
                                          <path d="M8207 2489 c-359 -39 -628 -261 -733 -604 -26 -84 -28 -102 -28 -275 -1 -200 9 -258 61 -388 43 -110 92 -183 177 -267 163 -161 335 -228 586 -227 188 0 346 50 496 157 l64 46 -33 52 c-19 29 -62 97 -97 152 -34 55 -64 102 -66 104 -2 2 -24 -10 -49 -28 -81 -58 -159 -84 -255 -85 -77 -1 -92 2 -152 32 -151 74 -232 235 -231 457 1 213 84 377 224 442 131 62 265 49 376 -34 l33 -24 101 138 c56 76 107 144 113 152 8 11 0 23 -38 57 -126 110 -340 166 -549 143z"/>
                                          <path d="M9579 2490 c-153 -18 -350 -81 -499 -161 -41 -22 -79 -44 -83 -48 -4 -4 31 -80 78 -168 l85 -160 104 52 c57 29 139 62 183 74 88 23 212 28 274 10 50 -16 105 -62 129 -110 22 -43 38 -129 24 -129 -25 -1 -229 -32 -299 -46 -122 -25 -261 -71 -357 -121 -193 -99 -288 -248 -288 -453 0 -146 49 -270 144 -366 137 -137 339 -177 546 -108 90 30 141 59 236 130 39 30 73 54 76 54 3 0 13 -41 24 -90 l18 -90 204 0 204 0 -5 578 c-4 546 -5 582 -25 667 -60 250 -204 408 -426 465 -91 23 -243 32 -347 20z m301 -1093 l0 -153 -52 -44 c-83 -67 -140 -90 -228 -90 -138 0 -205 58 -198 172 8 122 109 197 333 248 44 10 95 19 113 19 l32 1 0 -153z"/>
                                          <path d="M12781 2489 c-276 -42 -516 -239 -621 -510 -51 -132 -63 -208 -63 -374 0 -167 13 -244 63 -374 182 -470 741 -644 1257 -390 56 27 106 56 112 63 9 10 -8 48 -70 160 l-80 146 -42 -24 c-133 -76 -318 -105 -456 -71 -82 20 -174 75 -215 130 -35 45 -83 149 -92 198 l-6 37 511 0 c281 0 511 3 511 8 0 4 5 50 10 102 5 57 5 136 -1 201 -31 356 -215 605 -502 678 -92 24 -232 33 -316 20z m254 -396 c80 -42 129 -119 145 -230 5 -37 10 -71 10 -75 0 -5 -140 -8 -311 -8 l-312 0 7 43 c14 85 72 188 133 234 85 65 239 82 328 36z"/>
                                          <path d="M14675 2489 c-126 -26 -272 -134 -357 -266 -34 -53 -54 -73 -59 -60 0 1 -8 67 -17 147 l-17 145 -202 3 -203 2 0 -850 0 -850 250 0 250 0 0 500 0 501 31 61 c41 81 128 171 198 206 49 24 68 27 151 27 52 0 113 -4 135 -8 l40 -8 38 203 c21 112 37 208 37 215 0 28 -187 50 -275 32z"/>
                                          </g>
                                        </svg>
                                      </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                        )
                      }
                        <div class="form-group m-t-20">
                          <button type="button" id="verify-otp" class="wizard-button bg-white " disabled={isOTPSkipped} onClick={(e) => sendOTP()}>Send Code</button>
                          {/*
                            Modification: Disabled both buttons if otp is skipped
                            By: Devang
                            Date: 23/03/2023
                          */}
                          <button type="button" id="skip-otp" class="wizard-button bg-white m-l-46" disabled={isOTPSkipped} onClick={() => skipOTP()}>Skip Code</button>
                        </div>
                        {/*
                          Bug: Developer Bug - Resend otp text going out of button
                          Modification: Adjusted width of the button
                          By: Devang
                          Date: 05/07/2023
                        */}
                        {/*
                          Bug: while creating the visit button alignment is not proper
                          Modification: added class form-group and remove height and weight
                          By: Masum Raja
                          Date: 08/08/2023
                        */}
                        {(isOtpSend)  && (
                        <div class='form-group'>
                        <label class="wizard-label p-b-0 text-color-444 fs-14">Enter Code</label>
                        <div class="form-group">
                          <input autocomplete="off" class="p-l-5 border-none background-white" type="number" name="otp" id="otp" placeholder="XXXXXX" value={isOTP} onInput={(e) => inputOTP(e)} onkeyup={(e) => keyupOTP(e)} />
                        </div>
                        {(!isOTPValid) && (
                          <div class="form-group ">
                            <button type="button" id="verify-otp" class="wizard-button bg-white" disabled={isOTPSkipped} onClick={() => verifyOTP()}>Verify Code</button>
                            <button type="button" id="resend-otp" class="wizard-button bg-white m-l-46" disabled={resendBtn} onClick={() => resendOTP()}>Resend Code</button>
                          </div>
                        )}
                        </div>
                      )}


                        {/*(!isOTPValid) && (
                          <div class="form-group float-right w-full">
                            <button type="button" id="skip-otp" class="primary-button m-l-5" onClick={() => skipOTP()}>Skip</button>
                          </div>
                        )*/}
                        <div>
                          {(isOTPValid) && (
                            <div class="form-group">
                              <label class="wizard-label fs-14" style="color: green;">Verification successful!</label>
                            </div>
                          )}
                          {(isOTPSubmitted && !isOTPValid) && (
                            <div class="form-group">
                              <label class="wizard-label fs-14" style="color: red;">Verification failed!</label>
                            </div>
                          )}
                          {(isResendOTP && !isOTPSkipped) && (
                            <div class="form-group">
                              <label class="wizard-label fs-14">Verification Code has been sent to your registered mobile number</label>
                            </div>
                          )}
                          {(isOTPSkipped) && (
                            <div class="form-group">
                              <label class="wizard-label color-red fs-14">You have chosen to skip verification</label>
                            </div>
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                )}
                </fieldset>
                {/* Wizard Tab 3 */}
                <fieldset i="" class="wizard-tab lh-0.85" style="display: none;">
                  {isUserFound ? (
                    <div style="height:inherit">
                      <div class="fieldset-flex m-t-50">
                        <div class="display-flex flex-direction-column">
                          <label class="fs-24 text-408b8b" >Customer Details</label>
                        </div>
                        <div class="fieldset-content customerContent font-openSans fieldset-forms" >
                          {
                            /*
                              modification: Remove unnessary truecaller data field from customer details form
                            */
                          }
                          
                          <div class="form-group m-b-5">
                            <p class="fs-12 p-b-5 p-l-2">Customer Type</p>
                            <select disabled class="fs-1rem h-2rem background-white border-none" type="text" value={contactData.type} onChange={(e) => {
                              setIsNextDisable(false)
                              selectCustomerType(e)
                              setContactData({
                                ...contactData,
                                type: e.target.value
                              })
                            }} style="text-shadow:none">
                              <option >Select Customer Type</option>
                              <option selected value="Individual">Individual</option>
                              <option value="Government">Government</option>
                              <option value="Corporate">Corporate</option>
                            </select>
                          </div>
                          {/*
                            Bug: 81	KH_BG_151	Receptionist	Visit Create Showroom Visit - Customer Details - Gender , Age	The top margin is missing as compared to other labels
                            Modification: Removed thee m-b-5 class to remove the unusual gap on gender and age
                            By: Devang
                            Date: 05/07/2023
                          */}
                          <div class="form-row">
                            <div class="form-group" >
                                <div class="display-flex">
                                  <p class="fs-12 p-b-5">Salutation</p><sup class="star-mandatory-entry">*</sup>
                                </div>
                                <select class="fs-1rem h-2rem background-white border-none" type="text" id="salutation" value={contactData && contactData.salutation} onChange={(e) => {
                                  setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    salutation: e.target.value
                                  })
                                }} style="text-shadow:none">
                                  <option  value="Mr.">Mr.</option>
                                  <option value="Ms.">Ms.</option>
                                  <option value="Mrs.">Mrs.</option>
                                  <option value="Dr.">Dr.</option>
                                </select>
                            </div>
                            <div class="form-group">
                              <div class="display-flex">
                                <p class="fs-12 p-b-5">First Name</p><sup class="star-mandatory-entry p-l-2">*</sup>
                              </div>

                                <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="text" name="first_name" value={((contactData && contactData.firstName) ? contactData.firstName : '')} id="first_name" placeholder="First Name" onChange={(e) => {
                                  setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    firstName: e.target.value
                                  })
                              }} required/>
                            </div>
                            <div class="form-group">
                              <div class="display-flex">
                                <p class="fs-12 p-b-5">Last Name</p><sup class="star-mandatory-entry">*</sup>
                              </div>
                              <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="text" name="last_name" value={contactData && contactData.lastName ? contactData.lastName : ''} id="last_name" placeholder="Last Name" onChange={(e) => {
                                setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  lastName: e.target.value
                                })
                              }} />
                            </div>
                          </div>
                          <div class="form-row">
                            <div class="form-group m-b-5">
                              <p class="fs-12 p-b-5">Select Gender</p>
                              <select class="p-l-r-0-2rem  fs-1rem h-2rem background-white border-none" type="text" value={contactData && contactData.gender} onChange={(e) => {
                                setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  gender: e.target.value
                                })
                              }} style="text-shadow:none">
                                <option value='' selected >Select Gender</option>
                                <option value='Male'>Male</option>
                                <option value='Female'>Female</option>
                                <option value='Others'>Others</option>
                              </select>
                            </div>
                            <div class="form-group m-b-5">
                              <p class="fs-12 p-b-5">Age</p>
                              <input autocomplete="off" class="fs-1rem h-2rem background-white border-none p-l-5" type="number" name="age" id="age_deatils" placeholder="Age" value="32" value={contactData && contactData.age} onChange={(e) => {
                                setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  age: e.target.value
                                })
                              }} />
                            </div>
                          </div>
                          <div class="form-group m-b-5">
                            <p class="fs-12 p-b-5">Email</p>
                            <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="email" name="email" id="email_deatils" placeholder="Email" value={contactData && contactData.email} onChange={(e) => {
                              setIsNextDisable(false)
                              setContactData({
                                ...contactData,
                                email: e.target.value
                              })
                            }} />
                          </div>
                          <div class="form-row">
                            <div class="form-group m-b-5">
                                <div class="display-flex">
                                  <p class="fs-12 p-b-5">Mobile Number</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                </div>
                                <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="text" name="phone_number" id="phone_number_deatils" placeholder="xxxxxxxxxx" disabled={contactData.mobile ? true : false} value={contactData && contactData.mobile} onChange={(e) => {
                                  setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  mobile: e.target.value
                                })
                                 if (e.target.value) {
                                   let mobile = document.getElementById("phone_number_deatils");
                                   if (mobile) {
                                     //mobile.style.borderBottom = "1px solid #9e9e9e";
                                   }
                                 }
                              }} required/>
                            </div>
                            {/*
                              modified : Ashutosh G
                              modified : 18/01/2024
                              modification : KH_BG_226 solved (change input type to text for maxlength working and parsing value in onchange)
                            */}
                            <div class="form-group m-b-5">
                              <p class="fs-12 p-b-5">Alternate Mobile Number</p>
                              <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="number" name="phone_number" id="alternativeMobile" placeholder="xxxxxxxxxx" maxlength="10" value={contactData && contactData.alternativeMobile} onChange={(e) => {
                                setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  alternativeMobile: parseInt(e.target.value)
                                })
                              }} />
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  ) : (
                    <div class='lh-0.85'>
                      <label class="fs-24 text-408b8b" >Customer Details</label>
                      
                      {/*
                        By: Yashvi
                        On: 9th July 2024
                        T1925: BG_FN: Create Visit - Customer Details - Not able to click on Next button and user is not navigated to next view i.e. Customer Verification view
                        Modification: Height changed to 370 as there was extra height which was overlapping the next button
                      */}
                      <div class="fieldset-flex m-t-20" style='height:370px'>
                        <div class="fieldset-content fieldset-forms overflow-y ">
                          <div class="form-group">
                            <p class="fs-12 p-b-5 p-l-2">Customer Type</p>
                            <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text" onChange={(e) => {
                              setIsNextDisable(false)
                              selectCustomerType(e)
                              setContactData({
                                ...contactData,
                                type: e.target.value
                              })
                            }} style="text-shadow:none">
                              <option selected>Select Customer Type</option>
                              <option value="Individual">Individual</option>
                              <option value="Government">Government</option>
                              <option value="Corporate">Corporate</option>
                            </select>
                          </div>
                          {/*
                            Bug: 81	KH_BG_151	Receptionist	Visit Create Showroom Visit - Customer Details - Gender , Age	The top margin is missing as compared to other labels
                            Modification: Removed thee m-b-5 class to remove the unusual gap on gender and age
                            By: Devang
                            Date: 05/07/2023
                          */}
                          {customerType === 'Individual' ? (
                            <div class="form-row">
                              <div class="form-group">
                                  <div class="display-flex">
                                    <p class=" fs-12 p-b-5">Salutation</p><sup class="star-mandatory-entry">*</sup>
                                  </div>
                                  <select class="p-l-0  fs-1rem h-2rem background-white border-none" type="text" id="salutation" value={contactData && contactData.salutation} onChange={(e) => {
                                    setIsNextDisable(false)
                                    setContactData({
                                      ...contactData,
                                      salutation: e.target.value
                                    })
                                  }} style="text-shadow:none">
                                    <option value="" selected>Select Salutation</option>
                                    <option  value="Mr.">Mr.</option>
                                    <option value="Ms.">Ms.</option>
                                    <option value="Mrs.">Mrs.</option>
                                    <option value="Dr.">Dr.</option>
                                  </select>
                              </div>
                              <div class="form-group">
                                <div class="display-flex">
                                  <p class="fs-12 p-b-5">First Name</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                </div>
                                  <input autocomplete="off" class="p-l-5  fs-1rem h-2rem background-white border-none" type="text" name="first_name" value={((contactData && contactData.firstName) ? contactData.firstName : '')} id="first_name" placeholder="First Name" onChange={(e) => {
                                    setIsNextDisable(false)
                                    setContactData({
                                      ...contactData,
                                      firstName: e.target.value
                                    })
                                }} required/>
                              </div>
                              <div class="form-group">
                                <div class="display-flex">
                                  <p class="fs-12 p-b-5">Last Name</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                </div>
                                <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="text" name="last_name" value={contactData && contactData.lastName ? contactData.lastName : ''} id="last_name" placeholder="Last Name" onChange={(e) => {
                                  setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    lastName: e.target.value
                                  })
                                }} />
                              </div>
                            </div>
                          ) : (
                            <div class="form-group">
                                <div class="display-flex">
                                  <p class="fs-12 p-b-5">Name</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                </div>
                                <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="text" id="first_name" name="first_name" value={((contactData && contactData.firstName) ? contactData.firstName : '')} placeholder="Name" onChange={(e) => {
                                  setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    firstName: e.target.value
                                  })
                                }} required/>
                            </div>
                          )}
                          <div class="form-row">
                            <div class="form-group">
                              <p class="fs-12 p-b-5 p-l-2">Gender</p>
                              <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text" onChange={(e) => {
                                setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  gender: e.target.value
                                })
                              }} style="text-shadow:none">
                                <option selected>Select Gender</option>
                                <option value='Male'>Male</option>
                                <option value='Female'>Female</option>
                                <option value='Others'>Others</option>
                              </select>
                            </div>
                            <div class="form-group">
                              <p class="fs-12 p-b-5">Age</p>
                              <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="number" name="age" id="age" placeholder="Age" onChange={(e) => {
                                setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  age: e.target.value
                                })
                              }} />
                            </div>
                          </div>
                          <div class="form-group">
                            <p class="fs-12 p-b-5">Email</p>
                            <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="email" name="email" id="email" placeholder="Email" onChange={(e) => {
                              setIsNextDisable(false)
                              setContactData({
                                ...contactData,
                                email: e.target.value
                              })
                            }} />
                          </div>
                          <div class="form-row">
                            <div class="form-group">
                                <div class="display-flex">
                                  {/*
                                    modified : Ashutosh G
                                    modified : 04/12/2023
                                    modification : * removed as per KDMS Flow Walkthrough word
                                  */}
                                  <p class="fs-12 p-b-5">Mobile Number</p>
                                </div>
                                <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="number" name="phone_number" id="phone_number" placeholder="xxxxxxxxxx" value={mobNumber}  disabled={mobNumber ? true : false} onChange={(e) => {
                                  setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    mobile: e.target.value
                                  })
                                }} maxLength='10' required/>
                            </div>
                            {/*
                              modified : Ashutosh G
                              modified : 18/01/2024
                              modification : KH_BG_226 solved (change input type to text for maxlength working and parsing value in onchange)
                            */}
                            <div class="form-group">
                              <p class="fs-12 p-b-5">Alternate Mobile Number</p>
                              <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="number" name="phone_number" id="alternativeMobile" placeholder="xxxxxxxxxx" maxlength="10" value={contactData && contactData.alternativeMobile}
                              onChange={(e) => {
                                setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  alternativeMobile: e.target.value
                                })
                              }}
                            />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  )}
                </fieldset>
                {/* Wizard Tab 4 */}
                <fieldset i="" class="wizard-tab" style="display: none;">
                  {isUserFound ? (
                    <div style="height:inherit">
                      <div class="fieldset-flex m-t-32">
                        <div class="display-flex flex-direction-column">
                          <label class="fs-24 text-408b8b" >Other Details</label>
                        </div>
                        <div class="fieldset-content customerContent font-openSans fieldset-forms" >
                          <div class="form-group m-b-5">
                            <div class="display-flex">
                              <p class="fs-12 p-b-5">Pin Code</p><sup class="star-mandatory-entry p-l-2">*</sup>
                            </div>
                            <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="number" name="Pin Code" id="Pin Code_deatils" placeholder="Pin Code" value={contactData && contactData.pincode} onChange={(e) => {
                              setIsNextDisable(false)
                              setContactData({
                                ...contactData,
                                pincode: e.target.value
                              });
                              getAreaByPincode(e.target.value)
                            }} required/>
                          </div>
                          <div class="form-group">
                            <p class="fs-12 p-b-5">Area</p>
                            <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text"  name="area" value={contactData && contactData.area ? contactData.area : ""} onChange={(e) => {
                              setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  area: e.target.value
                                })
                              }} style="text-shadow:none">
                                <option value=''>Select Area</option>
                                {
                                  areaList.map((area)=>(
                                    <option value={area.officeName} >{area.officeName}</option>
                                  ))
                                }
                            </select>
                          </div>
                          <div class="form-group m-b-5">
                            <p class="fs-12 p-b-5">Address</p>
                            <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="text" name="Address" id="Address_deatils" placeholder="Residential Address" value={contactData && contactData.address} onChange={(e) => {
                              setIsNextDisable(false)
                              setContactData({
                                ...contactData,
                                address: e.target.value
                              })
                            }} />
                          </div>
                          <div class="form-row">
                            <div class="form-group">
                              <p class="fs-12 p-b-5">State</p>
                              <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text"  name="state" value={contactData && contactData.state ? contactData.state : ""} onChange={(e) => {
                                setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    state: e.target.value.split('-')[0] ? e.target.value.split('-')[0] : ''
                                  });
                                  getCityList(e.target.value)
                                }} style="text-shadow:none">
                                  <option value=''>Select State</option>
                                  {
                                    stateList.map((state)=>(
                                      <option value={state.name}>{state.name}</option>
                                    ))
                                  }
                              </select>
                            </div>
                            <div class="form-group">
                              <p class="fs-12 p-b-5">City</p>
                              <select class="p-l-0  fs-1rem h-2rem background-white border-none" type="text"  name="city" value={contactData && contactData.city ? contactData.city : ""} onChange={(e) => {
                                setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    city: e.target.value
                                  })
                                }} style="text-shadow:none">
                                  <option value=''>Select City</option>
                                  {
                                    cityList.map((city)=>(
                                      <option value={city.name} >{city.name}</option>
                                    ))
                                  }
                              </select>
                            </div>
                          </div>
                          <div class="form-row">
                            <div class="form-group m-b-5">
                            <p class="fs-12 p-b-5">Profession</p>
                            <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text"  name="profession" value={contactData && contactData.profession ? contactData.profession : ""} onChange={(e) => {
                              setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  profession: e.target.value
                                })
                              }} style="text-shadow:none">
                                <option value='' selected >Select Profession</option>
                                {
                                  listOfProfessions.map((profession)=>(
                                    <option value={profession} >{profession}</option>
                                  ))
                                }
                            </select>
                            </div>
                            {
                              (contactData && contactData.profession === "Other") && (
                                <div class="form-group m-b-5">
                                <p class="fs-12 m-b-0">Other Profession</p>
                                <input class='p-l-5 'onInput={(e) => {
                                  setContactData({
                                    ...contactData,
                                    otherProfession: e.target.value
                                  })
                                }} autocomplete="off" type="text" />
                                </div>
                              )
                            }

                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <label class="fs-24 text-408b8b" >Customer Verification</label>
                      <div class="m-t-32">
                        <div class="fieldset-content fieldset-forms">
                          <div class="form-group m-b-10">
                            <div class="display-flex">
                              <p class="fs-12 ">Pin Code</p><sup class="star-mandatory-entry">*</sup>
                            </div>
                            <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="number" name="Pin Code" id="Pin Code_deatils" placeholder="Pin Code" value={contactData && contactData.pincode} onChange={(e) => {
                              setIsNextDisable(false)
                              setContactData({
                                ...contactData,
                                pincode: e.target.value
                              });
                              getAreaByPincode(e.target.value)
                            }} required/>
                          </div>
                          <div class="form-group">
                            <p class="fs-12 p-b-5 p-l-2">Area</p>
                            <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text"  name="area" value={contactData && contactData.area ? contactData.area : ""} onChange={(e) => {
                              setIsNextDisable(false)
                                setContactData({
                                  ...contactData,
                                  area: e.target.value
                                })
                              }} style="text-shadow:none">
                                <option value=''>Select Area</option>
                                {
                                  areaList.map((area)=>(
                                    <option value={area.officeName} >{area.officeName}</option>
                                  ))
                                }
                            </select>
                          </div>
                          <div class="form-group m-b-5">
                            <p class="fs-12 p-b-5">Address</p>
                            <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="text" name="Address" id="Address_deatils" placeholder="Residential Address" value={contactData && contactData.address} onChange={(e) => {
                              setIsNextDisable(false)
                              setContactData({
                                ...contactData,
                                address: e.target.value
                              })
                            }} />
                          </div>
                          <div class="form-row">
                            <div class="form-group">
                              <p class="fs-12 p-b-5 p-l-2">State</p>
                              <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text"  name="state" value={contactData && contactData.state ? contactData.state : ""} onChange={(e) => {
                                setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    state: e.target.value.split('-')[0] ? e.target.value.split('-')[0] : ''
                                  });
                                  getCityList(e.target.value)
                                }} style="text-shadow:none">
                                  <option value=''>Select State</option>
                                  {
                                    stateList.map((state)=>(
                                      <option value={state.name}>{state.name}</option>
                                    ))
                                  }
                              </select>
                            </div>
                            <div class="form-group">
                              <p class="fs-12 p-b-5 p-l-2">City</p>
                              <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text"  name="city" value={contactData && contactData.city ? contactData.city : ""} onChange={(e) => {
                                setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    city: e.target.value
                                  })
                                }} style="text-shadow:none">
                                  <option value=''>Select City</option>
                                  {
                                    cityList.map((city)=>(
                                      <option value={city.name} >{city.name}</option>
                                    ))
                                  }
                              </select>
                            </div>
                          </div>
                          <div class="form-row">
                            <div class="form-group">
                              <p class="fs-12 p-b-5 p-l-2">Profession</p>
                              <select class="p-l-0 fs-1rem h-2rem background-white border-none" type="text"  name="profession" value={ contactData && contactData.profession ? contactData.profession : ""} onChange={(e) => {
                                setIsNextDisable(false)
                                  setContactData({
                                    ...contactData,
                                    profession: e.target.value
                                  })
                                }} style="text-shadow:none">
                                  <option value='' selected >Select Profession</option>
                                  {
                                    listOfProfessions.map((profession)=>(
                                      <option value={profession} >{profession}</option>
                                    ))
                                  }
                              </select>
                            </div>
                            {
                              (contactData && contactData.profession === "Other") && (
                                <div class="form-group m-b-5">
                                <p class="fs-12 m-b-0">Other Profession</p>
                                <input class='p-l-5 'onInput={(e) => {
                                  setContactData({
                                    ...contactData,
                                    otherProfession: e.target.value
                                  })
                                }} autocomplete="off" type="text" />
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </fieldset>

                {/* Wizard Tab 5 */}
                <fieldset i="" class="wizard-tab m-r-110" style="display: none;">
                  {isUserFound ? (
                    <div class="m-t-50">
                      <div class="display-flex flex-direction-column">
                        <label class="fs-24 text-408b8b" >Visit Details</label>
                      </div>
                      <div class="create-visit-content font-openSans fieldset-forms min-w-fit-content">
                        <div class="form-group m-b-5">
                        <div class="display-flex">
                            <p class="fs-12 p-b-5 p-l-2">Visitor or Buyer</p><sup class="star-mandatory-entry p-l-2">*</sup>
                          </div>
                            <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="visitType" value={visitType} onChange={e => changeVisitType(e)} style="text-shadow:none">
                              <option value="" selected>Visitor or Buyer?</option>
                              <option value="Commercial">Buyer</option>
                              <option value="Non-Commercial">Visitor</option>
                            </select>
                        </div>
                        <div>
                          {
                            visitType === "Non-Commercial" && (
                              <div>
                                <div class="form-group m-b-10">
                                  <p class="fs-12 p-b-5">Purpose of the Visit</p>
                                  <input autocomplete="off" class="p-l-5 fs-1rem  h-2rem background-white border-none" type="text" id="puropse" placeholder="Purpose of Visit" value={purpose} onChange={e => setPurpose(e.target.value)} />
                                </div>
                                <div class="form-group m-b-10" >
                                  <p class="fs-12 p-b-5 p-l-2">Whom to Visit?</p>
                                  <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="employee" value={employee} onChange={e => setEmployee(e.target.value)} style="text-shadow:none">
                                    <option value="" selected>Whom to Visit?</option>
                                    {usersList.map((user) => (
                                      <option value={user.uuid}>{user.displayName}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )
                          }
                        </div>
                        {
                          visitType === "Commercial" && (
                            <div class="form-group m-b-5">
                              {
                                !selectedCase.uuid && cases.length > 0 && cases.map((caseObj) => (
                                  <div class="row cursor-pointer" onClick={e => {setSelectedCase(caseObj); setShowDetailView(true)}}>
                                    <div class='col-xs-12 col-sm-12 col-md-12 col-lg-12 p-l-0 p-r-5' >
                                      <div class="workspace-cards m-t-0">
                                        <div class="row">
                                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                                            <div class="flex-sb p-b-8 p-t-8">
                                              <div class="flex-sb">
                                                <div class="xs-hide task-list-tags m-l-0 display-flex flex-direction-column p-l-10 p-r-10" style="height: 40px !important" >
                                                  <div class="text fs-14 first-letter-capital task-list-tags-text">
                                                    <span class="text-408b8b">{caseObj.uniqueID}</span><br/>
                                                    <span>Last Updated On: {formatDateTime(caseObj.updatedAt)}</span>
                                                  </div>
                                                </div>
                                                {
                                                  caseObj.currentStage && (
                                                    <div class="xs-hide task-list-tags m-l-0 display-flex flex-direction-column p-l-10 p-r-10" style="height: 40px !important" >
                                                      <div class="text fs-14 first-letter-capital task-list-tags-text">
                                                        {caseObj.currentStage}
                                                      </div>
                                                    </div>
                                                  )
                                                }
                                                {
                                                  caseObj.dynamicProperties_selectedRemarkCategory && caseObj.dynamicProperties_selectedRemarkCategory === "Lost" && (
                                                    <div class="xs-hide task-list-tags m-l-0 display-flex flex-direction-column p-l-10 p-r-10" style="height: 40px !important" >
                                                      <div class="text fs-14 first-letter-capital task-list-tags-text text-color-red">
                                                        LOST
                                                      </div>
                                                    </div>
                                                  )
                                                }
                                                {
                                                  caseObj.currentStage !== "Delivery" && ((caseObj.dynamicProperties_selectedRemarkCategory && caseObj.dynamicProperties_selectedRemarkCategory !== "Lost") || !caseObj.dynamicProperties_selectedRemarkCategory) && (
                                                    <div class="xs-hide task-list-tags m-l-0 display-flex flex-direction-column p-l-10 p-r-10" style="height: 40px !important" >
                                                      <div class="text fs-14 first-letter-capital task-list-tags-text text-408b8b">
                                                        In Progress
                                                      </div>
                                                    </div>
                                                  )
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))
                              }
                            </div>
                          )
                        }
                        {
                          selectedCase && selectedCase.uuid && (
                            <div class="form-group">
                                <button class="primary-button-3 m-t-20" onClick={e => setSelectedCase({})}>Back to Cases</button>
                            </div>
                          )
                        }
                        {
                          selectedCase && selectedCase.uuid && (
                            <div class="form-group">
                              <p class="fs-12 p-b-5">Purpose of the Visit</p>
                              <input autocomplete="off" class="p-l-5 fs-1rem  h-2rem background-white border-none" type="text" id="puropse" placeholder="Purpose of Visit" value={purpose} onChange={e => {setPurpose(e.target.value); setIsSubmitDisable(false)}} />
                            </div>
                          )
                        }
                        {
                          selectedCase && selectedCase.uuid && (
                            <div>
                              <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 justify-center p-l-0">
                                  <div class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 justify-center p-l-0">
                                      <div class="m-t-10 form-flex flex-direction-column align-baseline">
                                        <span class="fs-14 ">Customer Name </span>
                                        <span class={"first-letter-capital list-card-value "}>{selectedCase["dynamicProperties_customerName"]}</span>
                                      </div>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 justify-center p-l-0">
                                      <div class="m-t-10 form-flex flex-direction-column align-baseline">
                                        <span class="fs-14 ">Source </span>
                                        <span class={"first-letter-capital list-card-value "}>{selectedCase["dynamicProperties_source"]}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 justify-center p-l-0">
                                      <div class="m-t-10 form-flex flex-direction-column align-baseline">
                                        <span class="fs-14 ">Model </span>
                                        <span class={"first-letter-capital list-card-value "}>{selectedCase["dynamicProperties_selectedModelName"] ? selectedCase["dynamicProperties_selectedModelName"].toLowerCase(): "--"}</span>
                                      </div>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 justify-center p-l-0">
                                      <div class="m-t-10 form-flex flex-direction-column align-baseline">
                                        <span class="fs-14 ">Variant </span>
                                        <span class={"first-letter-capital list-card-value "}>{selectedCase["dynamicProperties_selectedVariantName"] ? selectedCase["dynamicProperties_selectedVariantName"]: "--"}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {
                                ((selectedCase.currentStage === "Enquiry" || selectedCase.currentStage === "Booking") && (!selectedCase.dynamicProperties_selectedRemarkCategory || selectedCase.dynamicProperties_selectedRemarkCategory !== "Lost")) && (
                                  <div>
                                    <div class="row">
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 justify-center p-l-0">
                                        <div class="row">
                                          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 justify-center p-l-0">
                                            <div class="m-t-10 form-flex flex-direction-column align-baseline">
                                              <span class="fs-14 ">Latest Task</span>
                                              <span class={"first-letter-capital list-card-value "}>{selectedCase.latestTaskName}</span>
                                            </div>
                                          </div>
                                          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 justify-center p-l-0">
                                            <div class="m-t-10 form-flex flex-direction-column align-baseline">
                                              <span class="fs-14 ">Assigned To</span>
                                              <span class={"first-letter-capital list-card-value "}>{selectedCase.latestTaskAssignee}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                (showDetailView && selectedCase.dynamicProperties_selectedRemarkCategory && selectedCase.dynamicProperties_selectedRemarkCategory === "Lost") && (
                                  <div>
                                    <div class="row bor-t-black p-t-5">
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 justify-center p-l-0">
                                        <span>Select the Stage to Reopen the case </span>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 justify-center p-l-0">
                                          {
                                            selectedCase.allTasks.length > 0 && selectedCase.allTasks.map((task) => (
                                              <div class="row bor-t bor-b">
                                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 justify-center p-l-0">
                                                  <div class="m-t-10">
                                                    <span class="fs-14 list-card-value">{task.displayName}</span>
                                                  </div>
                                                </div>
                                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 justify-center p-l-0">
                                                  <div class="m-t-10">
                                                    <span class={"first-letter-capital p-l-5"}>{task.status}</span>
                                                  </div>
                                                </div>
                                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 justify-center p-l-0">
                                                  <div class="m-t-10">
                                                    <button class="primary-button-3 m-t-20" type="button" onClick={(e) => setReopenTask(e, task.uuid, task.displayName)}>Reopen</button>
                                                  </div>
                                                </div>
                                              </div>
                                            ))
                                          }
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          )
                        }

                      </div>
                    </div>
                  ): (
                    <div>
                      <div class="display-flex flex-direction-column">
                        <label class="fs-24 text-408b8b" >Create Showroom Visit</label>
                      </div>
                      <div class="create-visit-content font-openSans fieldset-forms m-t-30">
                        <div class="form-group m-b-10">
                        <div class="display-flex">
                            <p class="fs-12 p-b-5 p-l-2">Visitor or Buyer</p><sup class="star-mandatory-entry">*</sup>
                          </div>
                            <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="visitType" value={visitType} onChange={e => changeVisitType(e)} style="text-shadow:none">
                              <option value="" selected>Visitor or Buyer?</option>
                              <option value="Commercial">Buyer</option>
                              <option value="Non-Commercial">Visitor</option>
                            </select>
                        </div>
                        <div>
                          {
                            visitType === "Non-Commercial" && (
                              <div>
                                <div class="form-group m-b-5">
                                  <input autocomplete="off" class="p-l-5 fs-1rem  h-2rem background-white border-none" type="text" id="puropse" placeholder="Purpose of Visit" value={purpose} onChange={e => setPurpose(e.target.value)} />
                                </div>
                                <div class="form-group m-b-5" >
                                  <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="employee" value={employee} onChange={e => setEmployee(e.target.value)} style="text-shadow:none">
                                    <option value="" selected>Whom to Visit?</option>
                                    {usersList.map((user) => (
                                      <option value={user.uuid}>{user.displayName}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )
                          }
                        </div>
                        <div class="m-b-15">
                          {
                            visitType === "Commercial" && (
                              <div>
                                <div class="display-flex">
                                    <p class="fs-12 p-b-5">Type Of Buyer</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                  </div>
                                <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="typeofBuyer" value={typeofBuyer} onChange={e => {
                                   setIsNextDisable(false)
                                   setTypeOfBuyer(e.target.value)
                                   if (e.target.value) {
                                     let buyer = document.getElementById("typeofBuyer");
                                     if (buyer) {
                                       buyer.style.borderBottom="1px solid #d1d1d1d1";
                                     }
                                   }
                                }} style="text-shadow:none" required>
                                  <option value="" selected>Type of Buyer</option>
                                  <option value="First Time Buyer">First Time Buyer</option>
                                  <option value="Exchange Buyer">Exchange Buyer</option>
                                  <option value="Additional Buyer">Additional Buyer</option>
                                </select>
                              </div>
                            )
                          }
                          {
                            visitType === "Commercial" && (typeofBuyer === "Additional Buyer" || typeofBuyer === "Exchange Buyer") && (
                              <div>
                                  <div class="display-flex m-t-10">
                                    <p class="fs-12 p-b-5">How many existing vehicles?</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                  </div>
                                    <input autocomplete="off" class="p-l-5 fs-1rem  h-2rem background-white border-none" type="number" required name="noOfAdditionalVehicles" id="noOfAdditionalVehicles" placeholder="No of Existing Vehicles" value={noOfAdditionalVehicles} onChange={(e) => {
                                    setIsNextDisable(false)
                                    changeNoOfAdditionalVehicles(e)
                                   if (e.target.value) {
                                     let additionalVehicles = document.getElementById("noOfAdditionalVehicles");
                                     if (additionalVehicles) {
                                       additionalVehicles.style.borderBottom="1px solid #d1d1d1d1";
                                     }
                                   }
                                  }} />

                              </div>
                            )
                          }
                        </div>
                        <div class="form-flex flex_remove">
                          {
                            visitType === "Commercial" && (
                              <div class="form-group m-b-5">
                                  <div class="display-flex">
                                    <p class="fs-12 p-b-5">Source</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                  </div>
                                  <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="source" value={source} onChange={e => {
                                    setIsNextDisable(false)
                                    changeSource(e.target.value)
                                    if (e.target.value) {
                                      let subSourceEle = document.getElementById("source");
                                      if (subSourceEle) {
                                        subSourceEle.style.borderBottom="1px solid #d1d1d1d1";
                                      }
                                    }
                                  }} style="text-shadow:none" required>
                                    <option value="" selected>Select Source</option>
                                    <option value="Walk-in">Walk-in</option>
                                    <option value="CRM">CRM</option>
                                    <option value="Field Generation">Field Generation</option>
                                    <option value="Incoming Call">Incoming Call</option>
                                    <option value="Referrals">Referrals</option>
                                  </select>
                              </div>
                            )
                          }
                          {visitType === "Commercial" && source && (
                              <div class="form-group m-b-5">
                                  <div class="display-flex">
                                    <p class="fs-12 p-b-5">Sub Source</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                  </div>
                                  <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="subSource" value={subSource} onChange={e => {
                                    setIsNextDisable(false)
                                    changeSubSource(e.target.value)
                                   if (e.target.value)  {
                                     let subSourceEle = document.getElementById("subSource");
                                     if (subSourceEle) {
                                       subSourceEle.style.borderBottom="1px solid #d1d1d1d1";
                                     }
                                   }
                                  }}
                                    style="text-shadow:none" required>
                                    <option value="" selected>Select Sub Source</option>
                                    {
                                      subSources && subSources.map((subSourceName) => (
                                        <option value={subSourceName}>{subSourceName}</option>
                                      ))
                                    }
                                  </select>
                              </div>
                            )
                          }
                        </div>
                        <div class="form-flex flex_remove">
                          {visitType === "Commercial" &&
                            <div class="form-group m-b-12 m-t-10">
                              <div class="display-flex">
                                <p class="fs-12 p-b-5">No. of Visitors</p><sup class="star-mandatory-entry p-l-2">*</sup>
                              </div>
                              <input autocomplete="off" class="p-l-5 fs-1rem  h-2rem background-white border-none" type="number" required name="noOfVisitors" id="noOfVisitors" placeholder="No of Visitors" value={noOfVisitors} onKeyDown={blockInvalidNumberChar} onBlur={handleNoOfVisitorsOnBlur} onChange={(e) => {
                              setIsNextDisable(false)
                              changeNoOfVisitors(e)
                             if (e.target.value) {
                               let visitors = document.getElementById("noOfVisitors");
                               if (visitors) {
                                 visitors.style.borderBottom="1px solid #d1d1d1d1";
                               }
                             }
                            }} />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  )}

                </fieldset>
                {/* Wizard Tab 6 */}

                {

                    visitType === "Commercial" && (
                      <fieldset i="" class="wizard-tab" style="display: none;">
                        {/*
                          Bug: T1925: BG_FN: Create Visit - Customer Details - Not able to click on Next button and user is not navigated to next view i.e. Customer Verification view
                          Modification: Removed m-t-50 from below div to handle click on next button on lead details
                          By: Devang
                          Date: 10/07/2024
                        */}
                        <div class="">
                          <div class="display-flex flex-direction-column">
                            <label class="fs-24 text-408b8b" >Lead Details</label>
                          </div>
                          <div class="fieldset-content create-visit-content font-openSans fieldset-forms">
                            <div class="form-flex flex_remove">
                              {
                                visitType === "Commercial" && (
                                  <div class="form-group m-b-5 m-t-20">
                                      <div class="display-flex">
                                        <p class="fs-12 p-b-5 p-l-2">Lead Type</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="orderSource" value={leadType} onChange={e => {
                                        setIsNextDisable(false)
                                        changeLeadType(e.target.value)
                                      if (e.target.value) {
                                        let leadTypeEle = document.getElementById("orderSource");
                                        if (leadTypeEle) {
                                          document.getElementById("orderSource").style.borderBottom="1px solid #d1d1d1d1";
                                        }
                                      }
                                      }}
                                        style="text-shadow:none" required>
                                        <option value="" selected>Select Lead Type</option>
                                        <option value="Vehicle">Vehicle</option>
                                        <option value="Insurance">Insurance</option>
                                        <option value="Finance">Finance</option>
                                        <option value="Service">Service</option>
                                        <option value="Accessories">Accessories</option>
                                        <option value="Other">Other</option>
                                      </select>
                                  </div>
                                )
                              }
                              {visitType === "Commercial" &&
                                leadType && (
                                  <div class="form-group m-b-5 m-t-20 p-l-10">
                                    <p class="fs-12 p-b-5 p-l-2">Lead Sub Type</p>
                                    <select class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="orderSourceSub" value={leadSubType} onChange={e =>  {
                                      setIsNextDisable(false);
                                      setLeadSubType(e.target.value);
                                      console.log(leadSubType, "leadSubType", e.target.value, "e.target.value");
                                      
                                      /*
                                        Bug: Developer Bug - Devang, when switching from fill form of new vehicle to pre-owned vehicle, it shows all fields of new vehicle except model. Actually nothing should be shown because the condition is on model for new vehicle and all other fields have condition of model. So resetted the model and its subordinate fields
                                        By: Devang
                                        Date: 03/07/2023
                                      */
                                      setModel('')
                                      // setFuelTypes([])
                                      setTypeOfFuel('')
                                      setVariantList([])
                                      setVariant('')
                                      // getFuelTypesForSelectedModel(e.target.value)
                                    if (e.target.value) {
                                      let modelEle =  document.getElementById("orderSourceModel");
                                      if (modelEle) {
                                        document.getElementById("orderSourceModel").style.borderBottom="1px solid #d1d1d1d1";
                                      }
                                    }
                                    }} style="text-shadow:none">
                                      <option value="" selected>Select Lead Sub Type</option>
                                      {
                                        leadSubTypes && leadSubTypes.map((subTypeName) => (
                                          <option value={subTypeName}>{subTypeName}</option>
                                        ))
                                      }
                                    </select>
                                  </div>
                                )
                              }
                            </div>
                            {
                            leadSubType && leadSubType !== 'Upcoming Vehicle' && (
                            <div class="form-flex flex_remove m-t-10">
                              {
                                (visitType === "Commercial" && leadType === "Vehicle" && (leadSubType === "New Vehicle")) && (
                                  <div class="form-group m-b-5">
                                      <div class="display-flex">
                                        <p class="fs-12 p-b-5 p-l-2">Model</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <select class="p-l-0 fs-1rem  h-2rem background-white border-none" style="text-transform:capitalize" type="text" id="orderSourceModel" value={model} onChange={e => {
                                        setIsNextDisable(false)
                                        setModel(e.target.value)
                                        // setFuelTypes([])
                                        setTypeOfFuel('')
                                        setVariantList([])
                                        setVariant('')
                                        // getFuelTypesForSelectedModel(e.target.value)
                                        // getVariantDetails(e.target.value)
                                      if (e.target.value) {
                                        let modelEle =  document.getElementById("orderSourceModel");
                                        if (modelEle) {
                                          document.getElementById("orderSourceModel").style.borderBottom="1px solid #d1d1d1d1";
                                        }
                                      }
                                      }} required>
                                        <option class="first-letter-capital" value="" selected>Select Model</option>
                                        {catalogoueItemList.map((item)=>(
                                          <option class="first-letter-capital" value={item.uuid}>{item.displayName.toLowerCase()}</option>
                                        ))}
                                      </select>
                                  </div>
                                )
                              }
                              {
                                (visitType === "Commercial" && leadType === "Vehicle" && (leadSubType === "Pre-owned Vehicle")) && (
                                  <div class="form-group m-b-5">
                                      <div class="display-flex">
                                        <p class="fs-12 p-b-5 p-l-2">Pre-owned Model</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <input autocomplete="off" class="p-l-5 fs-1rem h-2rem background-white border-none" type="text" name="preownedModel" defaultValue={preownedModel} id="preownedModel" placeholder="Pre-owned Model" onChange={(e) => {
                                        setIsNextDisable(false)
                                        setPreownedModel(e.target.value)
                                    }} required/>
                                  </div>
                                )
                              }
                              {
                                visitType === "Commercial" && leadType === "Vehicle" && model && (
                                  <div class="form-group m-b-5 p-l-10">
                                    <p class="fs-12 p-b-5 p-l-2">Fuel Type</p>
                                    <select class="p-l-0 fs-1rem  h-2rem background-white border-none first-letter-capital" type="text" id='typeOfFuel' value={typeOfFuel} onChange={e => {
                                      setIsNextDisable(false)
                                      setTypeOfFuel(e.target.value)
                                      // getVariantForSelectedModel(e.target.value)
                                      getVariantDetailsByFuelType(e.target.value)
                                    }
                                    } style="text-shadow:none">
                                      <option class="first-letter-capital" value="" selected>Select Fuel Type</option>
                                      {
                                        fuelTypes.map((ft) => (
                                          <option class="first-letter-capital" value={ft}>{ft}</option>
                                        ))
                                      }
                                      {/*<option value="CNG">CNG</option>
                                      <option value="Petrol">Petrol</option>
                                      <option value="Diesel">Diesel</option>*/}
                                    </select>
                                  </div>
                                )
                              }
                            </div>
                            )
                            }

                            {visitType === "Commercial" && leadSubType !== 'Upcoming Vehicle' && leadType === "Vehicle" && model && (
                              <div>

                                <div class="form-flex flex_remove m-t-10">
                                {
                                  variantList && (
                                    <div class="form-group m-b-5">
                                    <p class="fs-12 p-b-5">Variant</p>
                                    <select class="p-l-0  fs-1rem  h-2rem background-white border-none" style="text-transform:capitalize" type="text" id='variant' value={variant} onChange={e => {
                                      setIsNextDisable(false)
                                      getSelectedVariantDetails(e.target.value)
                                      setVariant(e.target.value)
                                    }}>
                                      <option value="" selected>Select Variant</option>
                                      {
                                        variantList.map((variant)=>(
                                          <option class="first-letter-capital" value={variant.uuid}>{variant.variantName}</option>
                                        ))
                                      }
                                    </select>
                                  </div>
                                  )
                                }
                                <div class="form-group m-b-5 p-l-10">
                                  <p class="fs-12 p-b-5 p-l-2">Ex. Color</p>
                                  <select class="p-l-0  fs-1rem  h-2rem background-white border-none" style="text-transform:capitalize" type="text" id='exteriorColor' value={exteriorColor} onChange={e => {
                                    setIsNextDisable(false);
                                    setExteriorColor(e.target.value)}}
                                    >
                                    <option class="first-letter-capital" value="" selected>Select Ext. Color</option>
                                    {
                                      selectedVariant.colors && selectedVariant.colors.map((color)=>(
                                        <option class="first-letter-capital" value={selectedVariant.uuid}>{color}</option>
                                      ))
                                    }

                                  </select>
                                </div>
                                </div>

                                {/*
                                  Bug: 23	KH_BG_93	Receptionist	Visit Customer Verification - Int. Color , Remarks	Alignment is not correct for Int. Color & Remarks
                                  Modification: Fixed alignment with padding and commented below empty div that was there taking no space at all and fixed a placeholder
                                  By: Devang
                                  Date: 03/07/2023
                                */}
                                {/*<div class="form-flex flex_remove">
                                </div>*/}
                                <div class="form-flex flex_remove m-t-10">
                                  {/* <div class="form-group m-b-5">
                                    <p class="fs-12 p-b-5 p-l-2">Int. Color</p>
                                    
                                    <select class="p-l-0  fs-1rem  h-2rem background-white border-none" style="text-transform:capitalize" type="text" id='interiorColor' value={interiorColor} onChange={e => {
                                      setIsNextDisable(false);
                                      setInteriorColor(e.target.value)}}
                                      >
                                      <option class="first-letter-capital" value="" selected>Select Int. Color</option>
                                      {
                                        selectedVariant.interiorColors && selectedVariant.interiorColors.map((color)=>(
                                          <option class="first-letter-capital" value={selectedVariant.uuid}>{color.intColrName}</option>
                                        ))
                                      }

                                    </select>
                                  </div> */}
                                  <div class="form-group m-b-5">
                                    <p class="fs-12 p-b-5 p-l-2">Remarks</p>
                                    <textarea class="fs-1rem background-white border-none m-b-0" style='padding:5px; height:auto;' rows="1" cols="75" value={specifications} maxlength="100" placeholder='Enter Remarks' onFocusOut={e =>  {
                                      setIsNextDisable(false)
                                      setSpecifications(e.target.value)
                                    }} ></textarea>
                                  </div>
                                </div>
                              </div>
                            )}
                            {
                              leadSubType && leadSubType === 'Upcoming Vehicle' && (
                                <div class="form-group m-b-5 m-t-10">
                                  <p class="fs-12 p-b-5">Remarks</p>
                                  <textarea class="fs-1rem background-white border-none" style='padding:0.5rem; height:auto;' rows="2" cols="75" value={specifications} maxlength="100" placeholder='Enter Remarks' onFocusOut={e =>  {
                                    setIsNextDisable(false)
                                    setSpecifications(e.target.value)
                                  }} ></textarea>
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </fieldset>

                    )
                }
                {/* Wizard Tab 7 */}

                <fieldset i="" class="wizard-tab m-r-110" style="display: none;">
                  <div class=" m-t-40">
                    <div class="display-flex flex-direction-column">
                      <label class="fs-24 text-408b8b" >Assign Responsible Person</label>
                    </div>
                    {/*
                      Bug: 84	KH_BG_154	Receptionist Visit Assign Responsible Person - Assigned To Dropdownlist	Lable for dropdownlists is not correct (Expected Result - First dropdownlist should have label "Select Assignee Role" and select placholder also - "Select Assignee Role", second dropdownlist should have label "Assign To")
                      Modification: Added a label in between both select inputs and updated the placholder for role select input
                      By: Devang
                      Date: 04/07/2023
                    */}
                    <div class="font-openSans m-t-20">
                      <div class="form-group m-b-5 m-t-10">
                        <div class="display-flex">
                          <p class="fs-12 p-b-5 p-l-2">Select Assignee Role</p><sup class="star-mandatory-entry p-l-2">*</sup>
                        </div>
                        <select class="p-l-0 background-white border-none" type="text" id="employee2" value={assignedTo} onChange={e => {
                          setAssignedTo(e.target.value)
                          getSelectedTypeUserList(e.target.value)
                          if (e.target.value) {
                            // setIsSubmitDisable(false)
                          } else {
                            setIsSubmitDisable(true)
                          }

                        }}
                        style="text-shadow:none"
                        >
                          <option value=''>{'Select Assignee Role'}</option>
                          <option value={'SALES CONSULTANT'}>{'Sales Consultant'}</option>
                          <option value={'TEAM LEADER'}>{'Team Leader'}</option>
                          <option value={'ASST.SALES MANAGER'}>{'Sales Assistant Manager'}</option>
                          <option value={'SALES MANAGER'}>{'Sales Manager'}</option>
                          
                        </select>
                      </div>
                    </div>
                    <div class="font-openSans m-t-15">
                      <div class="form-group m-b-5">
                        <div class="display-flex">
                          <p class="fs-12 p-b-5 p-l-2">Assign To</p><sup class="star-mandatory-entry p-l-2">*</sup>
                        </div>
                        {
                          // assignedTo !== '' && (
                          <select disabled={assignedTo === ''} type="text" id="employee" class="p-l-0 first-letter-capital background-white border-none " onChange={(e => fillAssigneduser(e.target.value))} style="text-shadow:none">
                            <option class="first-letter-capital" value='' selected={assignedTo === ''}>{`Select ${assignedTo ? assignedTo.toLowerCase() : 'Responsible Person' }`}</option>
                            { assignUserList.map((user) => (
                              <option value={user.userID} >{user.userName}</option>
                            ))}
                          </select>
                        // )
                      }
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          )}
          </div>
        </div>
        {/*
          Bug:- T1696
          Modification:- Removed Position Absolute
          By:- Rajkumar Pradhan
          On:- 13-04-2024
        */}
        <div class="display-flex align-center w-full p-l-r-25 p-r-85" style="bottom:10px">
          <div class="display-flex w-full visit-buttons m-l-208 m-b-55" style="justify-content: end">
            <button type="button" id="prevBtn" class="primary-button-3 m-r-5" onclick={(e) => nextPrev(-1,e)}style="display: none;">Previous</button>
            <button type="button" id="nextBtn" class="primary-button-3 " disabled={isNextDisable}  enabled={isOTPSkipped} onclick={(e) => nextPrev(1,e)}>Next</button>
            <button type="button" id="submitBtn" class="primary-button-3 text-black bg-ccc" onclick={(e) => submitForm(e)} style="display: none;" disabled={isSubmitDisable}>Create visit</button>
          </div>
        </div>
        { /*<div class="display-flex align-center pos-absolute w-full p-l-r-25" style="bottom:30px">
          <div class="wizardStepper display-flex w-half m-l-40" style="height:fit-content;justify-content:flex-end;justify-content: end;">
            <span class="step-check" />
            <span class="step-check" />
            <span class="step-check" />
            <span class="step-check" />
            <span class="step-check" />
            <span class="step-check" />
            <span class="step-check" />
          </div>
        </div> */ }
      </div>
    </div>

  );
};

export default Createvisitmodal;
